

  var add = {
    prefix: 'axis',
    iconName: 'add',
    icon: [24, 24, [], "f0000", "M19,11.5v1a.5.5,0,0,1-.5.5H13v5.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V13H5.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V5.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V11h5.5A.5.5,0,0,1,19,11.5Z"]
  };
  
  var addCircle = {
    prefix: 'axis',
    iconName: 'addCircle',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm4,10.5a.5.5,0,0,1-.5.5H13v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V13H8.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V8.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V11h2.5a.5.5,0,0,1,.5.5Z"]
  };
  
  var addCircleOutlined = {
    prefix: 'axis',
    iconName: 'addCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm3.5-9H13V8.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V11H8.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H11v2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V13h2.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,15.5,11Z"]
  };
  
  var addSquare = {
    prefix: 'axis',
    iconName: 'addSquare',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm-3,9.5a.5.5,0,0,1-.5.5H13v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V13H8.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V8.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V11h2.5a.5.5,0,0,1,.5.5Z"]
  };
  
  var addSquareOutlined = {
    prefix: 'axis',
    iconName: 'addSquareOutlined',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V5H19ZM8.5,13H11v2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V13h2.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H13V8.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V11H8.5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,8.5,13Z"]
  };
  
  var appointment = {
    prefix: 'axis',
    iconName: 'appointment',
    icon: [24, 24, [], "f0000", "M19,4H18V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H8V2.5A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Zm0,15H5V8H19Zm-8.41-3.15a.48.48,0,0,0,.7,0l4.25-4.24a.51.51,0,0,0,0-.71L15,10.37a.51.51,0,0,0-.71,0l-3.36,3.36L9.7,12.49a.51.51,0,0,0-.71,0L8.46,13a.5.5,0,0,0,0,.7Z"]
  };
  
  var appointmentCancelled = {
    prefix: 'axis',
    iconName: 'appointmentCancelled',
    icon: [24, 24, [], "f0000", "M21,6a2,2,0,0,0-2-2H18V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H8V2.5A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM19,19H5V8H19Zm-5.76-6,1.61-1.62a.48.48,0,0,0,0-.7l-.53-.53a.48.48,0,0,0-.7,0L12,11.76l-1.62-1.61a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L10.76,13,9.15,14.62a.48.48,0,0,0,0,.7l.53.53a.48.48,0,0,0,.7,0L12,14.24l1.62,1.61a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7Z"]
  };
  
  var archive = {
    prefix: 'axis',
    iconName: 'archive',
    icon: [24, 24, [], "f0000", "M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M15.9,14.3l-3.5,3.5c-0.2,0.2-0.5,0.2-0.7,0c0,0,0,0,0,0l-3.5-3.5c-0.2-0.2-0.2-0.5,0-0.7l0.2-0.2c0.1-0.1,0.2-0.1,0.4-0.1H10V9.5C10,9.2,10.2,9,10.5,9h3C13.8,9,14,9.2,14,9.5v3.8h1.3c0.1,0,0.3,0,0.4,0.1l0.2,0.2C16.1,13.8,16.1,14.1,15.9,14.3z M19,7H5V5h14V7z"]
  };
  
  var autorenew = {
    prefix: 'axis',
    iconName: 'autorenew',
    icon: [24, 24, [], "f0000", "M13.06,1.15,16.6,4.68a.51.51,0,0,1,0,.71L13.06,8.92a.5.5,0,0,1-.71,0l-.2-.2A.49.49,0,0,1,12,8.36V6a6,6,0,0,0-6,6,5.94,5.94,0,0,0,.69,2.79.5.5,0,0,1-.09.59l-.73.73a.5.5,0,0,1-.42.14A.52.52,0,0,1,5.08,16,8,8,0,0,1,12,4V1.71a.49.49,0,0,1,.15-.36l.2-.2A.5.5,0,0,1,13.06,1.15ZM10.94,15.08,7.4,18.61a.51.51,0,0,0,0,.71l3.54,3.53a.5.5,0,0,0,.71,0l.2-.2a.49.49,0,0,0,.15-.36V20A8,8,0,0,0,18.92,8a.52.52,0,0,0-.37-.24.5.5,0,0,0-.42.14l-.74.74a.51.51,0,0,0-.09.59A5.83,5.83,0,0,1,18,12a6,6,0,0,1-6,6V15.64a.49.49,0,0,0-.15-.36l-.2-.2A.5.5,0,0,0,10.94,15.08Z"]
  };
  
  var blockAds = {
    prefix: 'axis',
    iconName: 'blockAds',
    icon: [24, 24, [], "f0000", "M20.12,7.39,16.61,3.88A3,3,0,0,0,14.49,3h-5a3,3,0,0,0-2.12.88L3.88,7.39A3,3,0,0,0,3,9.51v5a3,3,0,0,0,.88,2.12l3.51,3.51A3,3,0,0,0,9.51,21h5a3,3,0,0,0,2.12-.88l3.51-3.51A3,3,0,0,0,21,14.49v-5A3,3,0,0,0,20.12,7.39ZM5,14.49v-5a1,1,0,0,1,.29-.7L8.81,5.29A1,1,0,0,1,9.51,5h5a1,1,0,0,1,.7.29l1.14,1.14-9.9,9.9L5.29,15.19A1,1,0,0,1,5,14.49Zm14,0a1,1,0,0,1-.29.7l-3.52,3.52a1,1,0,0,1-.7.29h-5a1,1,0,0,1-.7-.29L7.67,17.57l9.9-9.9,1.14,1.14a1,1,0,0,1,.29.7Z"]
  };
  
  var bookmark = {
    prefix: 'axis',
    iconName: 'bookmark',
    icon: [24, 24, [], "f0000", "M20,21a1,1,0,0,1-1.53.85l-5.94-3.72a1,1,0,0,0-1.06,0L5.53,21.85A1,1,0,0,1,4,21V4A2,2,0,0,1,6,2H18a2,2,0,0,1,2,2Z"]
  };
  
  var bookmarkOutlined = {
    prefix: 'axis',
    iconName: 'bookmarkOutlined',
    icon: [24, 24, [], "f0000", "M18,4V19.19l-4.41-2.75a3,3,0,0,0-3.18,0L6,19.19V4H18m0-2H6A2,2,0,0,0,4,4V21a1,1,0,0,0,1,1,1,1,0,0,0,.53-.15l5.94-3.72a1,1,0,0,1,1.06,0l5.94,3.72A1,1,0,0,0,19,22a1,1,0,0,0,1-1V4a2,2,0,0,0-2-2Z"]
  };
  
  var bookmarks = {
    prefix: 'axis',
    iconName: 'bookmarks',
    icon: [24, 24, [], "f0000", "M18,21a1,1,0,0,1-1.53.85l-5.94-3.72a1,1,0,0,0-1.06,0L3.53,21.85A1,1,0,0,1,2,21V4A2,2,0,0,1,4,2H16a2,2,0,0,1,2,2ZM21,4H20V20h1a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4Z"]
  };
  
  var bookmarksOutlined = {
    prefix: 'axis',
    iconName: 'bookmarksOutlined',
    icon: [24, 24, [], "f0000", "M4,4H16V19.19l-4.41-2.75a3,3,0,0,0-3.18,0L4,19.19V4M4,2A2,2,0,0,0,2,4V21a1,1,0,0,0,1,1,1,1,0,0,0,.53-.15l5.94-3.72a1,1,0,0,1,1.06,0l5.94,3.72A1,1,0,0,0,17,22a1,1,0,0,0,1-1V4a2,2,0,0,0-2-2ZM21,20a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H20V20Z"]
  };
  
  var browserWindow = {
    prefix: 'axis',
    iconName: 'browserWindow',
    icon: [24, 24, [], "f0000", "M20,6m0,2V18H4V8Zm0-4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"]
  };
  
  var browserWindows = {
    prefix: 'axis',
    iconName: 'browserWindows',
    icon: [24, 24, [], "f0000", "M19,15V5a2,2,0,0,0-2-2H3A2,2,0,0,0,1,5V15a2,2,0,0,0,2,2H17A2,2,0,0,0,19,15ZM3,7H17v8H3ZM21,7V17a2,2,0,0,1-2,2H5a2,2,0,0,0,2,2H19a4,4,0,0,0,4-4V9A2,2,0,0,0,21,7Z"]
  };
  
  var cached = {
    prefix: 'axis',
    iconName: 'cached',
    icon: [24, 24, [], "f0000", "M22.85,11.65l-.2.2a.49.49,0,0,1-.36.15H20A8,8,0,0,1,8,18.92a.52.52,0,0,1-.24-.37.5.5,0,0,1,.14-.42l.73-.73a.5.5,0,0,1,.59-.09A5.94,5.94,0,0,0,12,18a6,6,0,0,0,6-6H15.64a.49.49,0,0,1-.36-.15l-.2-.2a.5.5,0,0,1,0-.71L18.61,7.4a.51.51,0,0,1,.71,0l3.53,3.54A.5.5,0,0,1,22.85,11.65Zm-13.93.7-.2-.2A.49.49,0,0,0,8.36,12H6a6,6,0,0,1,6-6,5.83,5.83,0,0,1,2.79.7.51.51,0,0,0,.59-.09l.74-.74a.5.5,0,0,0,.14-.42A.52.52,0,0,0,16,5.08,8,8,0,0,0,4,12H1.71a.49.49,0,0,0-.36.15l-.2.2a.5.5,0,0,0,0,.71L4.68,16.6a.51.51,0,0,0,.71,0l3.53-3.54A.5.5,0,0,0,8.92,12.35Z"]
  };
  
  var calendar = {
    prefix: 'axis',
    iconName: 'calendar',
    icon: [24, 24, [], "f0000", "M19,4H18V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H8V2.5A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Zm0,15H5V8H19Z"]
  };
  
  var calendarMonth = {
    prefix: 'axis',
    iconName: 'calendarMonth',
    icon: [24, 24, [], "f0000", "M19,4H18V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H8V2.5A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Zm0,15H5V8H19Zm-7.5-7h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,11.5,12Zm4,0h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,15.5,12Zm-8,0h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,12Zm4,4h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,11.5,16Zm-4,0h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,16Z"]
  };
  
  var calendarNote = {
    prefix: 'axis',
    iconName: 'calendarNote',
    icon: [24, 24, [], "f0000", "M19,4H18V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H8V2.5A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Zm0,15H5V8H19ZM7.5,16h5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,16Zm0-4h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,12Z"]
  };
  
  var carouselHorizontal = {
    prefix: 'axis',
    iconName: 'carouselHorizontal',
    icon: [24, 24, [], "f0000", "M18,18V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V18a2,2,0,0,0,2,2h8A2,2,0,0,0,18,18Zm3,0a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H20V18ZM3,6A1,1,0,0,0,2,7V17a1,1,0,0,0,1,1H4V6Z"]
  };
  
  var carouselHorizontalOutlined = {
    prefix: 'axis',
    iconName: 'carouselHorizontalOutlined',
    icon: [24, 24, [], "f0000", "M16,6V18H8V6h8m0-2H8A2,2,0,0,0,6,6V18a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Zm5,14a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H20V18ZM3,6A1,1,0,0,0,2,7V17a1,1,0,0,0,1,1H4V6Z"]
  };
  
  var carouselVertical = {
    prefix: 'axis',
    iconName: 'carouselVertical',
    icon: [24, 24, [], "f0000", "M18,6H6A2,2,0,0,0,4,8v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8A2,2,0,0,0,18,6Zm0-3a1,1,0,0,0-1-1H7A1,1,0,0,0,6,3V4H18ZM6,21a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V20H6Z"]
  };
  
  var carouselVerticalOutlined = {
    prefix: 'axis',
    iconName: 'carouselVerticalOutlined',
    icon: [24, 24, [], "f0000", "M18,8v8H6V8H18m0-2H6A2,2,0,0,0,4,8v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Zm0-3a1,1,0,0,0-1-1H7A1,1,0,0,0,6,3V4H18ZM6,21a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V20H6Z"]
  };
  
  var checkmarkCircle = {
    prefix: 'axis',
    iconName: 'checkmarkCircle',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm4.35,7.73-5.62,5.62a.48.48,0,0,1-.7,0L7.65,13a.5.5,0,0,1,0-.71l.53-.53a.48.48,0,0,1,.7,0l1.5,1.49,4.74-4.74a.5.5,0,0,1,.7,0l.53.53A.5.5,0,0,1,16.35,9.73Z"]
  };
  
  var checkmarkCircleOutlined = {
    prefix: 'axis',
    iconName: 'checkmarkCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM15.82,8.49a.5.5,0,0,0-.7,0l-4.74,4.74-1.5-1.49a.48.48,0,0,0-.7,0l-.53.53a.5.5,0,0,0,0,.71L10,15.35a.48.48,0,0,0,.7,0l5.62-5.62a.5.5,0,0,0,0-.71Z"]
  };
  
  var checkmarkSquare = {
    prefix: 'axis',
    iconName: 'checkmarkSquare',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM16.35,9.73l-5.62,5.62a.48.48,0,0,1-.7,0L7.65,13a.5.5,0,0,1,0-.71l.53-.53a.48.48,0,0,1,.7,0l1.5,1.49,4.74-4.74a.5.5,0,0,1,.7,0l.53.53A.5.5,0,0,1,16.35,9.73Z"]
  };
  
  var checkmarkSquareOutlined = {
    prefix: 'axis',
    iconName: 'checkmarkSquareOutlined',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V5H19Zm-9-3.65a.48.48,0,0,0,.7,0l5.62-5.62a.5.5,0,0,0,0-.71l-.53-.53a.5.5,0,0,0-.7,0l-4.74,4.74-1.5-1.49a.48.48,0,0,0-.7,0l-.53.53a.5.5,0,0,0,0,.71Z"]
  };
  
  var clear = {
    prefix: 'axis',
    iconName: 'clear',
    icon: [24, 24, [], "f0000", "M17.85,16.44a.5.5,0,0,1,0,.71l-.7.7a.5.5,0,0,1-.71,0L12,13.41,7.56,17.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71L10.59,12,6.15,7.56a.5.5,0,0,1,0-.71l.7-.7a.5.5,0,0,1,.71,0L12,10.59l4.44-4.44a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71L13.41,12Z"]
  };
  
  var clearCircle = {
    prefix: 'axis',
    iconName: 'clearCircle',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3.09,11.86a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L12,13.24l-1.86,1.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7L10.76,12,8.91,10.14a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L12,10.76l1.86-1.85a.48.48,0,0,1,.7,0l.53.53a.48.48,0,0,1,0,.7L13.24,12Z"]
  };
  
  var clearCircleOutlined = {
    prefix: 'axis',
    iconName: 'clearCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM15.09,9.44l-.53-.53a.48.48,0,0,0-.7,0L12,10.76,10.14,8.91a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L10.76,12,8.91,13.86a.48.48,0,0,0,0,.7l.53.53a.48.48,0,0,0,.7,0L12,13.24l1.86,1.85a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7L13.24,12l1.85-1.86A.48.48,0,0,0,15.09,9.44Z"]
  };
  
  var clearSquare = {
    prefix: 'axis',
    iconName: 'clearSquare',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM15.09,13.86a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L12,13.24l-1.86,1.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7L10.76,12,8.91,10.14a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L12,10.76l1.86-1.85a.48.48,0,0,1,.7,0l.53.53a.48.48,0,0,1,0,.7L13.24,12Z"]
  };
  
  var clearSquareOutlined = {
    prefix: 'axis',
    iconName: 'clearSquareOutlined',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V5H19ZM8.91,14.56l.53.53a.48.48,0,0,0,.7,0L12,13.24l1.86,1.85a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7L13.24,12l1.85-1.86a.48.48,0,0,0,0-.7l-.53-.53a.48.48,0,0,0-.7,0L12,10.76,10.14,8.91a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L10.76,12,8.91,13.86A.48.48,0,0,0,8.91,14.56Z"]
  };
  
  var columnView = {
    prefix: 'axis',
    iconName: 'columnView',
    icon: [24, 24, [], "f0000", "M22,18V6a2,2,0,0,0-2-2H15a2,2,0,0,0-2,2V18a2,2,0,0,0,2,2h5A2,2,0,0,0,22,18ZM9,20H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H9a2,2,0,0,1,2,2V18A2,2,0,0,1,9,20Z"]
  };
  
  var columnViewOutlined = {
    prefix: 'axis',
    iconName: 'columnViewOutlined',
    icon: [24, 24, [], "f0000", "M20,6V18H15V6h5m0-2H15a2,2,0,0,0-2,2V18a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2ZM9,6V18H4V6H9M9,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H9a2,2,0,0,0,2-2V6A2,2,0,0,0,9,4Z"]
  };
  
  var command = {
    prefix: 'axis',
    iconName: 'command',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM15.85,9.38,9.38,15.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7l6.47-6.47a.48.48,0,0,1,.7,0l.53.53A.48.48,0,0,1,15.85,9.38Z"]
  };
  
  var commandOutlined = {
    prefix: 'axis',
    iconName: 'commandOutlined',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V5H19ZM14.62,8.15a.48.48,0,0,1,.7,0l.53.53a.48.48,0,0,1,0,.7L9.38,15.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7Z"]
  };
  
  var dateRange = {
    prefix: 'axis',
    iconName: 'dateRange',
    icon: [24, 24, [], "f0000", "M21,6a2,2,0,0,0-2-2H18V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H8V2.5A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM19,19H5V8H19Zm-7.5-9a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5Zm-4,2h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,12Zm5,4a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5Zm2.5-.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5Z"]
  };
  
  var done = {
    prefix: 'axis',
    iconName: 'done',
    icon: [24, 24, [], "f0000", "M19.85,7.25,9.25,17.85a.5.5,0,0,1-.71,0L3.15,12.46a.5.5,0,0,1,0-.71l.7-.7a.5.5,0,0,1,.71,0l4.33,4.33,9.55-9.55a.51.51,0,0,1,.71,0l.7.71A.5.5,0,0,1,19.85,7.25Z"]
  };
  
  var drag = {
    prefix: 'axis',
    iconName: 'drag',
    icon: [24, 24, [], "f0000", "M11,6A2,2,0,1,1,9,4,2,2,0,0,1,11,6ZM9,10a2,2,0,1,0,2,2A2,2,0,0,0,9,10Zm0,6a2,2,0,1,0,2,2A2,2,0,0,0,9,16Zm6-8a2,2,0,1,0-2-2A2,2,0,0,0,15,8Zm0,2a2,2,0,1,0,2,2A2,2,0,0,0,15,10Zm0,6a2,2,0,1,0,2,2A2,2,0,0,0,15,16Z"]
  };
  
  var eject = {
    prefix: 'axis',
    iconName: 'eject',
    icon: [24, 24, [], "f0000", "M19,16.5v1a.5.5,0,0,1-.5.5H5.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13A.5.5,0,0,1,19,16.5ZM5.35,13.85a.49.49,0,0,0,.36.15H18.29a.49.49,0,0,0,.36-.15l.2-.2a.5.5,0,0,0,0-.71l-6.5-6.79a.48.48,0,0,0-.7,0l-6.5,6.79a.5.5,0,0,0,0,.71Z"]
  };
  
  var ejectCircle = {
    prefix: 'axis',
    iconName: 'ejectCircle',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm5,13.5a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5Zm-.15-3.85-.2.2a.49.49,0,0,1-.36.15H7.71a.49.49,0,0,1-.36-.15l-.2-.2a.5.5,0,0,1,0-.71l4.5-4.79a.48.48,0,0,1,.7,0l4.5,4.79A.5.5,0,0,1,16.85,11.65Z"]
  };
  
  var ejectCircleOutlined = {
    prefix: 'axis',
    iconName: 'ejectCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm4.5-6h-9a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,16.5,14ZM12.35,6.15a.48.48,0,0,0-.7,0l-4.5,4.79a.5.5,0,0,0,0,.71l.2.2a.49.49,0,0,0,.36.15h8.58a.49.49,0,0,0,.36-.15l.2-.2a.5.5,0,0,0,0-.71Z"]
  };
  
  var event = {
    prefix: 'axis',
    iconName: 'event',
    icon: [24, 24, [], "f0000", "M21,6a2,2,0,0,0-2-2H18V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H8V2.5A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM19,19H5V8H19ZM8,14h2a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v2A1,1,0,0,0,8,14Z"]
  };
  
  var exitFullscreen169 = {
    prefix: 'axis',
    iconName: 'exitFullscreen169',
    icon: [24, 24, [], "f0000", "M19,11h3.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H20V6.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V10A1,1,0,0,0,19,11ZM6,10V6.5A.5.5,0,0,0,5.5,6h-1a.5.5,0,0,0-.5.5V9H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5A1,1,0,0,0,6,10Zm14,7.5V15h2.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19a1,1,0,0,0-1,1v3.5a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,20,17.5ZM4.5,18h1a.5.5,0,0,0,.5-.5V14a1,1,0,0,0-1-1H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H4v2.5A.5.5,0,0,0,4.5,18Z"]
  };
  
  var exitFullscreen11 = {
    prefix: 'axis',
    iconName: 'exitFullscreen11',
    icon: [24, 24, [], "f0000", "M16,9h4.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H17V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V8A1,1,0,0,0,16,9ZM9,8V3.5A.5.5,0,0,0,8.5,3h-1a.5.5,0,0,0-.5.5V7H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H8A1,1,0,0,0,9,8Zm8,12.5V17h3.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H16a1,1,0,0,0-1,1v4.5a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,17,20.5ZM7.5,21h1a.5.5,0,0,0,.5-.5V16a1,1,0,0,0-1-1H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H7v3.5A.5.5,0,0,0,7.5,21Z"]
  };
  
  var exitFullscreen43 = {
    prefix: 'axis',
    iconName: 'exitFullscreen43',
    icon: [24, 24, [], "f0000", "M18,9h3.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19V4.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V8A1,1,0,0,0,18,9ZM6,9A1,1,0,0,0,7,8V4.5A.5.5,0,0,0,6.5,4h-1a.5.5,0,0,0-.5.5V7H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5ZM19,19.5V17h2.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H18a1,1,0,0,0-1,1v3.5a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,19,19.5ZM5.5,20h1a.5.5,0,0,0,.5-.5V16a1,1,0,0,0-1-1H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v2.5A.5.5,0,0,0,5.5,20Z"]
  };
  
  var findReplace = {
    prefix: 'axis',
    iconName: 'findReplace',
    icon: [24, 24, [], "f0000", "M3.29,8.81a.53.53,0,0,1-.1-.42,7,7,0,0,1,12-3.13l1-1a.49.49,0,0,1,.85.35V8.5a.52.52,0,0,1-.5.5H12.61a.5.5,0,0,1-.35-.85l1.46-1.47a5,5,0,0,0-8.53,2A.5.5,0,0,1,4.71,9h-1A.49.49,0,0,1,3.29,8.81ZM20.85,19.44l-4-4a2.44,2.44,0,0,0-.43-.35l-1-.69h0a7,7,0,0,0,1.38-2.8.53.53,0,0,0-.1-.42.49.49,0,0,0-.39-.19h-1a.5.5,0,0,0-.48.36,5,5,0,0,1-8.53,2l1.46-1.47A.5.5,0,0,0,7.39,11H3.5a.52.52,0,0,0-.5.5v3.88a.49.49,0,0,0,.85.35l1-1a7,7,0,0,0,9.52.73l.75,1a2.6,2.6,0,0,0,.3.36l4,4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,20.85,19.44Z"]
  };
  
  var firstPage = {
    prefix: 'axis',
    iconName: 'firstPage',
    icon: [24, 24, [], "f0000", "M17.78,17.15l-.71.7a.5.5,0,0,1-.71,0l-5.14-5.13a.75.75,0,0,1-.22-.53v-.38a.77.77,0,0,1,.22-.53l5.14-5.13a.5.5,0,0,1,.71,0l.71.71a.49.49,0,0,1,0,.7L13.33,12l4.45,4.44A.5.5,0,0,1,17.78,17.15ZM8.5,6h-1a.5.5,0,0,0-.5.5v11a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V6.5A.5.5,0,0,0,8.5,6Z"]
  };
  
  var hashtag = {
    prefix: 'axis',
    iconName: 'hashtag',
    icon: [24, 24, [], "f0000", "M20.5,8h-3L19,3.66A.5.5,0,0,0,18.5,3H17.42a.51.51,0,0,0-.48.34L15.34,8H11.4l1.49-4.34A.5.5,0,0,0,12.42,3H11.34a.51.51,0,0,0-.48.34L9.26,8H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H8.58L7.2,14H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3L5,20.34A.5.5,0,0,0,5.5,21H6.57a.51.51,0,0,0,.48-.34L8.65,16H12.6l-1.49,4.34a.5.5,0,0,0,.47.66h1.07a.51.51,0,0,0,.48-.34L14.73,16H18.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H15.42l1.37-4H20.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,8Zm-7.22,6H9.34l1.37-4h3.95Z"]
  };
  
  var heart = {
    prefix: 'axis',
    iconName: 'heart',
    icon: [24, 24, [], "f0000", "M22,8.5A5.5,5.5,0,0,0,16.5,3,6.36,6.36,0,0,0,12,5.07,6.36,6.36,0,0,0,7.5,3,5.5,5.5,0,0,0,2,8.5C2,12.42,6.75,16.75,9,19l2.28,2.28a.75.75,0,0,0,.53.22h.38a.75.75,0,0,0,.53-.22L15,19C17.25,16.75,22,12.42,22,8.5Z"]
  };
  
  var heartOutlined = {
    prefix: 'axis',
    iconName: 'heartOutlined',
    icon: [24, 24, [], "f0000", "M16.5,3A6.36,6.36,0,0,0,12,5.07,6.36,6.36,0,0,0,7.5,3,5.5,5.5,0,0,0,2,8.5C2,12.42,6.75,16.75,9,19l2.28,2.28a.75.75,0,0,0,.53.22h.38a.75.75,0,0,0,.53-.22L15,19c2.25-2.25,7-6.58,7-10.5A5.5,5.5,0,0,0,16.5,3ZM14.2,17,12,19.17,9.8,17C7.77,15,4,11.26,4,8.5A3.5,3.5,0,0,1,7.5,5h0a5,5,0,0,1,3.71,2.21.77.77,0,0,0,.6.29h.45a.51.51,0,0,0,.4-.2A5.11,5.11,0,0,1,16.47,5h0A3.5,3.5,0,0,1,20,8.5C20,11.26,16.23,15,14.2,17Z"]
  };
  
  var help = {
    prefix: 'axis',
    iconName: 'help',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm2.88-7.94a2.89,2.89,0,0,1-2,2.73L13,12.6a.13.13,0,0,0-.08.12v.78a.5.5,0,0,1-.5.5h-.76a.5.5,0,0,1-.5-.5v-.78a1.88,1.88,0,0,1,1.29-1.78l.95-.31a1.13,1.13,0,0,0,.76-1.07V9A1.12,1.12,0,0,0,13,7.88H11A1.12,1.12,0,0,0,9.88,9v.5a.5.5,0,0,1-.5.5H8.62a.5.5,0,0,1-.5-.5V9A2.88,2.88,0,0,1,11,6.12h2A2.88,2.88,0,0,1,15.88,9Z"]
  };
  
  var helpOutlined = {
    prefix: 'axis',
    iconName: 'helpOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.5-4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,16Zm3.38-7A2.88,2.88,0,0,0,13,6.12H11A2.88,2.88,0,0,0,8.12,9v.5a.5.5,0,0,0,.5.5h.76a.5.5,0,0,0,.5-.5V9A1.12,1.12,0,0,1,11,7.88h2A1.12,1.12,0,0,1,14.12,9v.56a1.13,1.13,0,0,1-.76,1.07l-.95.31a1.88,1.88,0,0,0-1.29,1.78v.78a.5.5,0,0,0,.5.5h.76a.5.5,0,0,0,.5-.5v-.78A.13.13,0,0,1,13,12.6l.95-.31a2.89,2.89,0,0,0,2-2.73Z"]
  };
  
  var history = {
    prefix: 'axis',
    iconName: 'history',
    icon: [24, 24, [], "f0000", "M22,12a9,9,0,0,1-9,9,8.89,8.89,0,0,1-5.16-1.63A.51.51,0,0,1,7.63,19a.5.5,0,0,1,.14-.39l.72-.73a.5.5,0,0,1,.63-.06A6.91,6.91,0,0,0,13,19a7,7,0,1,0-7-7H8.36a.49.49,0,0,1,.36.15l.2.2a.5.5,0,0,1,0,.71L5.39,16.6a.51.51,0,0,1-.71,0L1.15,13.06a.5.5,0,0,1,0-.71l.2-.2A.49.49,0,0,1,1.71,12H4a9,9,0,0,1,18,0ZM13.38,7h-.76a.5.5,0,0,0-.5.5v4.66a.53.53,0,0,0,.15.35l3.29,3.29a.5.5,0,0,0,.71,0l.53-.53a.5.5,0,0,0,0-.71l-2.92-2.92V7.5A.5.5,0,0,0,13.38,7Z"]
  };
  
  var incognito = {
    prefix: 'axis',
    iconName: 'incognito',
    icon: [24, 24, [], "f0000", "M5,7.42l.76-4.58a1,1,0,0,1,1-.84H7.2a2.94,2.94,0,0,1,1.34.32l1.71.83a4,4,0,0,0,3.5,0l1.71-.83A2.94,2.94,0,0,1,16.8,2h.44a1,1,0,0,1,1,.84L19,7.42A.5.5,0,0,1,18.5,8H5.5A.5.5,0,0,1,5,7.42Zm15.84,3.73L20,10.29a1,1,0,0,0-.71-.29H4.71a1,1,0,0,0-.71.29l-.85.86A.5.5,0,0,0,3.5,12h17A.5.5,0,0,0,20.85,11.15ZM17,14a4,4,0,0,0-3.2,1.62,2.92,2.92,0,0,0-3.6,0A4,4,0,1,0,11,18a1,1,0,0,1,2,0,4,4,0,1,0,4-4ZM7,20a2,2,0,1,1,2-2A2,2,0,0,1,7,20Zm10,0a2,2,0,1,1,2-2A2,2,0,0,1,17,20Z"]
  };
  
  var info = {
    prefix: 'axis',
    iconName: 'info',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,13.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm0-6a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Z"]
  };
  
  var infoOutined = {
    prefix: 'axis',
    iconName: 'infoOutined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm1-7.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5Zm0-4a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5Z"]
  };
  
  var key = {
    prefix: 'axis',
    iconName: 'key',
    icon: [24, 24, [], "f0000", "M20,3H18.59a1,1,0,0,0-.7.29l-7.18,7.18A5.4,5.4,0,0,0,8.5,10,5.5,5.5,0,1,0,14,15.5a5.55,5.55,0,0,0-.46-2.2l.88-.88a1,1,0,0,0,.29-.7V11a.75.75,0,0,1,.22-.53l.26-.26a.75.75,0,0,1,.53-.22H17.5a.5.5,0,0,0,.5-.5V7.73a.75.75,0,0,1,.22-.53l.05,0A.49.49,0,0,1,18.63,7H20.5a.5.5,0,0,0,.5-.5V4A1,1,0,0,0,20,3ZM7.44,18.56a2,2,0,1,1,2-2A2,2,0,0,1,7.44,18.56Z"]
  };
  
  var label = {
    prefix: 'axis',
    iconName: 'label',
    icon: [24, 24, [], "f0000", "M20.71,3.41l-.12-.12A1.05,1.05,0,0,0,19.88,3H11.93a2,2,0,0,0-1.42.59L3.29,10.81a1,1,0,0,0,0,1.41l8.49,8.49a1,1,0,0,0,1.41,0l7.22-7.22A2,2,0,0,0,21,12.07V4.12A1.05,1.05,0,0,0,20.71,3.41ZM16,10a2,2,0,1,1,2-2A2,2,0,0,1,16,10Z"]
  };
  
  var labelImportant = {
    prefix: 'axis',
    iconName: 'labelImportant',
    icon: [24, 24, [], "f0000", "M20.71,3.41l-.12-.12a1,1,0,0,0-.7-.29H12a2,2,0,0,0-1.41.58L3.15,11a.49.49,0,0,0-.15.36v.2a.49.49,0,0,0,.15.36l.69.69a1,1,0,0,0,.7.29H10a1,1,0,0,1,.7.3l.12.12a1,1,0,0,1,.3.7v5.44a1,1,0,0,0,.29.7l.69.69a.49.49,0,0,0,.36.15h.2a.49.49,0,0,0,.36-.15l7.42-7.42A2,2,0,0,0,21,12V4.11A1,1,0,0,0,20.71,3.41Zm-4.78,6.65a2,2,0,1,1,2-2A2,2,0,0,1,15.93,10.06Z"]
  };
  
  var labelOff = {
    prefix: 'axis',
    iconName: 'labelOff',
    icon: [24, 24, [], "f0000", "M20.85,19.62a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0l-3.29-3.28-3.14,3.14a1,1,0,0,1-1.41,0L3.29,12.22a1,1,0,0,1,0-1.41L6.43,7.67,3.15,4.38a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0ZM20.71,3.41l-.12-.12A1.05,1.05,0,0,0,19.88,3H11.93a2,2,0,0,0-1.42.59l-1.6,1.6,9.9,9.9,1.6-1.6A2,2,0,0,0,21,12.07V4.12A1.05,1.05,0,0,0,20.71,3.41Z"]
  };
  
  var labelOutlined = {
    prefix: 'axis',
    iconName: 'labelOutlined',
    icon: [24, 24, [], "f0000", "M20.71,3.41l-.12-.12A1.05,1.05,0,0,0,19.88,3H11.93a2,2,0,0,0-1.42.59L3.29,10.81a1,1,0,0,0,0,1.41l8.49,8.49a1,1,0,0,0,1.41,0l7.22-7.22A2,2,0,0,0,21,12.07V4.12A1.05,1.05,0,0,0,20.71,3.41ZM19,12.07l-6.51,6.52L5.41,11.51,11.93,5H19ZM15,11a2,2,0,1,0-2-2A2,2,0,0,0,15,11Z"]
  };
  
  var labels = {
    prefix: 'axis',
    iconName: 'labels',
    icon: [24, 24, [], "f0000", "M19,11.07V3.12a1.05,1.05,0,0,0-.29-.71l-.12-.12A1.05,1.05,0,0,0,17.88,2H9.93a2,2,0,0,0-1.42.59L1.29,9.81a1,1,0,0,0,0,1.41l8.49,8.49a1,1,0,0,0,1.41,0l7.22-7.22A2,2,0,0,0,19,11.07ZM14,9a2,2,0,1,1,2-2A2,2,0,0,1,14,9Zm8.71-2.59-.12-.12A1.05,1.05,0,0,0,21.88,6H21v5.9a2,2,0,0,1-.59,1.42l-7.58,7.57.89.89a.75.75,0,0,0,1.06,0l7-7A4,4,0,0,0,23,11.9V7.12A1.05,1.05,0,0,0,22.71,6.41Z"]
  };
  
  var labelsOutlined = {
    prefix: 'axis',
    iconName: 'labelsOutlined',
    icon: [24, 24, [], "f0000", "M17,4v7.07l-6.51,6.52L3.41,10.51,9.93,4H17m.88-2H9.93a2,2,0,0,0-1.42.59L1.29,9.81a1,1,0,0,0,0,1.41l8.49,8.49a1,1,0,0,0,1.41,0l7.22-7.22A2,2,0,0,0,19,11.07V3.12a1.05,1.05,0,0,0-.29-.71l-.12-.12A1.05,1.05,0,0,0,17.88,2ZM15,8a2,2,0,1,0-2,2A2,2,0,0,0,15,8Zm7.71-1.59-.12-.12A1.05,1.05,0,0,0,21.88,6H21v5.9a2,2,0,0,1-.59,1.42l-7.58,7.57.89.89a.75.75,0,0,0,1.06,0l7-7A4,4,0,0,0,23,11.9V7.12A1.05,1.05,0,0,0,22.71,6.41Z"]
  };
  
  var lastPage = {
    prefix: 'axis',
    iconName: 'lastPage',
    icon: [24, 24, [], "f0000", "M6.22,6.85l.71-.7a.5.5,0,0,1,.71,0l5.14,5.13a.75.75,0,0,1,.22.53v.38a.77.77,0,0,1-.22.53L7.64,17.85a.5.5,0,0,1-.71,0l-.71-.71a.49.49,0,0,1,0-.7L10.67,12,6.22,7.56A.5.5,0,0,1,6.22,6.85ZM15.5,18h1a.5.5,0,0,0,.5-.5V6.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v11A.5.5,0,0,0,15.5,18Z"]
  };
  
  var layout = {
    prefix: 'axis',
    iconName: 'layout',
    icon: [24, 24, [], "f0000", "M10,5V19a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V5A1,1,0,0,1,3,4H9A1,1,0,0,1,10,5Zm5,8H13a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14A1,1,0,0,0,15,13Zm6,0H19a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V14A1,1,0,0,0,21,13Zm0-9H13a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4Z"]
  };
  
  var movePage = {
    prefix: 'axis',
    iconName: 'movePage',
    icon: [24, 24, [], "f0000", "M9,11.5v1a.5.5,0,0,1-.5.5H6v2a.5.5,0,0,1-.85.35l-3-3a.51.51,0,0,1,0-.71l3-3A.5.5,0,0,1,6,9v2H8.5A.5.5,0,0,1,9,11.5ZM9,6h2V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V6h2a.5.5,0,0,0,.36-.85l-3-3a.51.51,0,0,0-.71,0l-3,3A.5.5,0,0,0,9,6Zm6,12H13V15.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V18H9a.5.5,0,0,0-.35.85l3,3a.51.51,0,0,0,.71,0l3-3A.5.5,0,0,0,15,18Zm6.86-6.35-3-3A.5.5,0,0,0,18,9v2H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H18v2a.5.5,0,0,0,.85.35l3-3A.51.51,0,0,0,21.86,11.65Z"]
  };
  
  var multiDirection = {
    prefix: 'axis',
    iconName: 'multiDirection',
    icon: [24, 24, [], "f0000", "M21.86,12.36l-3,3A.5.5,0,0,1,18,15V13H13v5h2a.5.5,0,0,1,.36.85l-3,3a.51.51,0,0,1-.71,0l-3-3A.5.5,0,0,1,9,18h2V13H6v2a.5.5,0,0,1-.85.35l-3-3a.51.51,0,0,1,0-.71l3-3A.5.5,0,0,1,6,9v2h5V6H9a.5.5,0,0,1-.35-.85l3-3a.51.51,0,0,1,.71,0l3,3A.5.5,0,0,1,15,6H13v5h5V9a.5.5,0,0,1,.85-.36l3,3A.51.51,0,0,1,21.86,12.36Z"]
  };
  
  var multiDirectionDiagonal = {
    prefix: 'axis',
    iconName: 'multiDirectionDiagonal',
    icon: [24, 24, [], "f0000", "M18.73,6.69,13.41,12l5.31,5.32,1.42-1.42a.5.5,0,0,1,.85.35V20.5a.52.52,0,0,1-.5.5H16.25a.5.5,0,0,1-.36-.85l1.42-1.42L12,13.41,6.68,18.72,8.1,20.14a.5.5,0,0,1-.35.85H3.5a.52.52,0,0,1-.5-.5V16.25a.5.5,0,0,1,.85-.36l1.42,1.42L10.59,12,5.28,6.68,3.86,8.1A.5.5,0,0,1,3,7.75V3.5A.52.52,0,0,1,3.5,3H7.75a.5.5,0,0,1,.36.85L6.69,5.27,12,10.59l5.32-5.31L15.9,3.86A.5.5,0,0,1,16.25,3H20.5a.52.52,0,0,1,.5.5V7.75a.5.5,0,0,1-.85.36Z"]
  };
  
  var notebookBookmarked = {
    prefix: 'axis',
    iconName: 'notebookBookmarked',
    icon: [24, 24, [], "f0000", "M5,6v5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H7A2,2,0,0,0,5,4H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5Zm8-1.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v7a.5.5,0,0,1-.78.42l-1.94-1.3a.52.52,0,0,0-.56,0l-1.94,1.3A.5.5,0,0,1,13,11.5Z"]
  };
  
  var notice = {
    prefix: 'axis',
    iconName: 'notice',
    icon: [24, 24, [], "f0000", "M12,20.92v.58a.5.5,0,0,1-.5.5H9.57a1,1,0,0,1-.86-.49l-2.28-3.8a2.72,2.72,0,0,1-.36-1H8.51a4.14,4.14,0,0,1,1.57.3l.42,2.75a1,1,0,0,0,.75.57l.33.06A.5.5,0,0,1,12,20.92ZM22,11a4,4,0,0,1-.8,2.4.51.51,0,0,1-.75,0l-.72-.72a.5.5,0,0,1-.06-.63,2,2,0,0,0,0-2.2.5.5,0,0,1,.06-.63l.72-.72a.51.51,0,0,1,.39-.15.54.54,0,0,1,.36.2A4,4,0,0,1,22,11ZM18,3V19a1,1,0,0,1-1,1h-.59a1,1,0,0,1-.7-.29l-3-2.95A6,6,0,0,0,8.51,15H5a3,3,0,0,1-3-3V10A3,3,0,0,1,5,7H8.51a6,6,0,0,0,4.25-1.76l3-2.95a1,1,0,0,1,.7-.29H17A1,1,0,0,1,18,3Z"]
  };
  
  var noticeOutlined = {
    prefix: 'axis',
    iconName: 'noticeOutlined',
    icon: [24, 24, [], "f0000", "M12,20.92v.58a.5.5,0,0,1-.5.5H9.57a1,1,0,0,1-.86-.49l-2.28-3.8a2.72,2.72,0,0,1-.36-1H8.51a4.14,4.14,0,0,1,1.57.3l.42,2.75a1,1,0,0,0,.75.57l.33.06A.5.5,0,0,1,12,20.92ZM22,11a4,4,0,0,1-.8,2.4.51.51,0,0,1-.75,0l-.72-.72a.5.5,0,0,1-.06-.63,2,2,0,0,0,0-2.2.5.5,0,0,1,.06-.63l.72-.72a.51.51,0,0,1,.39-.15.54.54,0,0,1,.36.2A4,4,0,0,1,22,11ZM18,3V19a1,1,0,0,1-1,1h-.59a1,1,0,0,1-.7-.29l-3-2.95A6,6,0,0,0,8.51,15H5a3,3,0,0,1-3-3V10A3,3,0,0,1,5,7H8.51a6,6,0,0,0,4.25-1.76l3-2.95a1,1,0,0,1,.7-.29H17A1,1,0,0,1,18,3ZM16,4.83,14.17,6.66A7.92,7.92,0,0,1,10,8.86v4.28a7.92,7.92,0,0,1,4.17,2.2L16,17.17Z"]
  };
  
  var openInNew = {
    prefix: 'axis',
    iconName: 'openInNew',
    icon: [24, 24, [], "f0000", "M21,13.5V19a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3h5.5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H5V19H19V13.5a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,21,13.5Zm-.22-10-.27-.27A.75.75,0,0,0,20,3H13.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h4.09L9.15,13.44a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0L19,6.42V10.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V4A.75.75,0,0,0,20.78,3.49Z"]
  };
  
  var pages = {
    prefix: 'axis',
    iconName: 'pages',
    icon: [24, 24, [], "f0000", "M15,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H15a2,2,0,0,0,2-2V5A2,2,0,0,0,15,3Zm6,3V18a1,1,0,0,1-1,1H19V5h1A1,1,0,0,1,21,6Z"]
  };
  
  var pagesOutlined = {
    prefix: 'axis',
    iconName: 'pagesOutlined',
    icon: [24, 24, [], "f0000", "M15,5V19H5V5H15m0-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H15a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Zm6,3V18a1,1,0,0,1-1,1H19V5h1A1,1,0,0,1,21,6Z"]
  };
  
  var publish = {
    prefix: 'axis',
    iconName: 'publish',
    icon: [24, 24, [], "f0000", "M19,18.5v1a.5.5,0,0,1-.5.5H5.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13A.5.5,0,0,1,19,18.5ZM6.06,9.85a.49.49,0,0,0,.36.15H9v5.5a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V10h2.58a.49.49,0,0,0,.36-.15l.2-.2a.5.5,0,0,0,0-.71L12.35,3.15a.48.48,0,0,0-.7,0L5.86,8.94a.5.5,0,0,0,0,.71Z"]
  };
  
  var recordScreen = {
    prefix: 'axis',
    iconName: 'recordScreen',
    icon: [24, 24, [], "f0000", "M22,6V8.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V6H17.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H20A2,2,0,0,1,22,6ZM2.5,9h1A.5.5,0,0,0,4,8.5V6H6.5A.5.5,0,0,0,7,5.5v-1A.5.5,0,0,0,6.5,4H4A2,2,0,0,0,2,6V8.5A.5.5,0,0,0,2.5,9Zm19,6h-1a.5.5,0,0,0-.5.5V18H17.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H20a2,2,0,0,0,2-2V15.5A.5.5,0,0,0,21.5,15Zm-15,3H4V15.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V18a2,2,0,0,0,2,2H6.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,6.5,18Zm1-10A1.5,1.5,0,1,0,9,9.5,1.5,1.5,0,0,0,7.5,8Z"]
  };
  
  var refresh = {
    prefix: 'axis',
    iconName: 'refresh',
    icon: [24, 24, [], "f0000", "M20.5,10h-5a.5.5,0,0,1-.5-.5V9.21a.49.49,0,0,1,.15-.36l1.78-1.78A6.93,6.93,0,0,0,12,5a7,7,0,1,0,7,7.47.5.5,0,0,1,.5-.47h1a.52.52,0,0,1,.36.16.5.5,0,0,1,.13.37,9,9,0,1,1-2.62-6.89l1.49-1.49A.49.49,0,0,1,20.21,4h.29a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,20.5,10Z"]
  };
  
  var remainingTime = {
    prefix: 'axis',
    iconName: 'remainingTime',
    icon: [24, 24, [], "f0000", "M2.66,8.43A.46.46,0,0,1,3,8.14a.49.49,0,0,1,.41,0l.89.51a.49.49,0,0,1,.22.61,8.35,8.35,0,0,0-.37,1.41.5.5,0,0,1-.49.42h-1A.52.52,0,0,1,2.22,11a.52.52,0,0,1-.11-.4A9.3,9.3,0,0,1,2.66,8.43ZM4.24,5.7a.48.48,0,0,0-.1.4.47.47,0,0,0,.24.34L5.27,7a.48.48,0,0,0,.63-.11,7,7,0,0,1,.94-.94A.48.48,0,0,0,7,5.27l-.51-.89a.47.47,0,0,0-.34-.24.48.48,0,0,0-.4.1A9.16,9.16,0,0,0,4.24,5.7ZM8.68,4.26a.5.5,0,0,0,.61.22,8.35,8.35,0,0,1,1.41-.37.5.5,0,0,0,.42-.49v-1A.52.52,0,0,0,11,2.22a.52.52,0,0,0-.4-.11,9.3,9.3,0,0,0-2.12.55.46.46,0,0,0-.29.3.49.49,0,0,0,0,.41Zm4.77-2.15a.5.5,0,0,0-.57.5v1a.5.5,0,0,0,.41.5,8,8,0,1,1-9.18,9.18.5.5,0,0,0-.5-.41h-1a.5.5,0,0,0-.5.57A10,10,0,1,0,13.45,2.11Zm-6.95,9a.5.5,0,0,0-.5.5v.76a.5.5,0,0,0,.5.5h5.88a.51.51,0,0,0,.5-.5V6.5a.5.5,0,0,0-.5-.5h-.76a.5.5,0,0,0-.5.5v4.62Z"]
  };
  
  var remove = {
    prefix: 'axis',
    iconName: 'remove',
    icon: [24, 24, [], "f0000", "M5.5,13a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z"]
  };
  
  var removeCircle = {
    prefix: 'axis',
    iconName: 'removeCircle',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM8.5,13a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z"]
  };
  
  var removeCircleOutlined = {
    prefix: 'axis',
    iconName: 'removeCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm3.5-9h-7a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,15.5,11Z"]
  };
  
  var removeSquare = {
    prefix: 'axis',
    iconName: 'removeSquare',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm-3,9.5a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5Z"]
  };
  
  var removeSquareOutlined = {
    prefix: 'axis',
    iconName: 'removeSquareOutlined',
    icon: [24, 24, [], "f0000", "M21,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM19,19H5V5H19ZM8.5,13h7a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-7a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,8.5,13Z"]
  };
  
  var restore = {
    prefix: 'axis',
    iconName: 'restore',
    icon: [24, 24, [], "f0000", "M22,12a9,9,0,0,1-9,9,8.89,8.89,0,0,1-5.16-1.63A.51.51,0,0,1,7.63,19a.5.5,0,0,1,.14-.39l.72-.73a.5.5,0,0,1,.63-.06A6.91,6.91,0,0,0,13,19a7,7,0,1,0-7-7H8.36a.49.49,0,0,1,.36.15l.2.2a.5.5,0,0,1,0,.71L5.39,16.6a.51.51,0,0,1-.71,0L1.15,13.06a.5.5,0,0,1,0-.71l.2-.2A.49.49,0,0,1,1.71,12H4a9,9,0,0,1,18,0Z"]
  };
  
  var search = {
    prefix: 'axis',
    iconName: 'search',
    icon: [24, 24, [], "f0000", "M20.85,19.44l-4-4a2.44,2.44,0,0,0-.43-.35l-1-.69h0A7,7,0,1,0,10,17a7,7,0,0,0,4.37-1.53h0l.75,1a2.6,2.6,0,0,0,.3.36l4,4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,20.85,19.44ZM10,15a5,5,0,1,1,5-5A5,5,0,0,1,10,15Z"]
  };
  
  var settingsBack = {
    prefix: 'axis',
    iconName: 'settingsBack',
    icon: [24, 24, [], "f0000", "M22,12a9,9,0,0,1-9,9,8.89,8.89,0,0,1-5.16-1.63A.51.51,0,0,1,7.63,19a.5.5,0,0,1,.14-.39l.72-.73a.5.5,0,0,1,.63-.06A6.91,6.91,0,0,0,13,19a7,7,0,1,0-7-7H8.36a.49.49,0,0,1,.36.15l.2.2a.5.5,0,0,1,0,.71L5.39,16.6a.51.51,0,0,1-.71,0L1.15,13.06a.5.5,0,0,1,0-.71l.2-.2A.49.49,0,0,1,1.71,12H4a9,9,0,0,1,18,0Zm-7,0a2,2,0,1,0-2,2A2,2,0,0,0,15,12Z"]
  };
  
  var shoppingBasket = {
    prefix: 'axis',
    iconName: 'shoppingBasket',
    icon: [24, 24, [], "f0000", "M22.5,10h-4L12.73,2.3a.77.77,0,0,0-.6-.3h-.26a.77.77,0,0,0-.6.3L5.5,10h-4a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H2l1.71,7.65A3,3,0,0,0,6.6,22H17.4a3,3,0,0,0,2.92-2.35L22,12h.47a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,10ZM8,10l4-5.33L16,10Z"]
  };
  
  var shoppingBasketAdd = {
    prefix: 'axis',
    iconName: 'shoppingBasketAdd',
    icon: [24, 24, [], "f0000", "M8,10l4-5.33L16,10Zm15,.5a.5.5,0,0,0-.5-.5h-4L12.73,2.3a.77.77,0,0,0-.6-.3h-.26a.77.77,0,0,0-.6.3L5.5,10h-4a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H2l1.71,7.65A3,3,0,0,0,6.6,22H17.4a3,3,0,0,0,2.92-2.35L22,12h.47a.5.5,0,0,0,.5-.5Zm-8.5,6.38H12.88V18.5a.5.5,0,0,1-.5.5h-.76a.5.5,0,0,1-.5-.5V16.88H9.5a.5.5,0,0,1-.5-.5v-.76a.5.5,0,0,1,.5-.5h1.62V13.5a.5.5,0,0,1,.5-.5h.76a.5.5,0,0,1,.5.5v1.62H14.5a.5.5,0,0,1,.5.5v.76A.5.5,0,0,1,14.5,16.88Z"]
  };
  
  var shoppingBasketClear = {
    prefix: 'axis',
    iconName: 'shoppingBasketClear',
    icon: [24, 24, [], "f0000", "M22.5,10h-4L12.73,2.3a.77.77,0,0,0-.6-.3h-.26a.77.77,0,0,0-.6.3L5.5,10h-4a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H2l1.71,7.65A3,3,0,0,0,6.6,22H17.4a3,3,0,0,0,2.92-2.35L22,12h.47a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,10Zm-7.65,7.62a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L12,17.24l-1.62,1.61a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7L10.76,16,9.15,14.38a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L12,14.76l1.62-1.61a.48.48,0,0,1,.7,0l.53.53a.48.48,0,0,1,0,.7L13.24,16ZM8,10l4-5.33L16,10Z"]
  };
  
  var shoppingBasketOutlined = {
    prefix: 'axis',
    iconName: 'shoppingBasketOutlined',
    icon: [24, 24, [], "f0000", "M22.5,10h-4L12.73,2.3a.77.77,0,0,0-.6-.3h-.26a.77.77,0,0,0-.6.3L5.5,10h-4a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H2l1.71,7.65A3,3,0,0,0,6.6,22H17.4a3,3,0,0,0,2.92-2.35L22,12h.47a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,10ZM12,4.67,16,10H8Zm6.37,14.55a1,1,0,0,1-1,.78H6.6a1,1,0,0,1-1-.78L4,12H20Z"]
  };
  
  var shoppingBasketRemove = {
    prefix: 'axis',
    iconName: 'shoppingBasketRemove',
    icon: [24, 24, [], "f0000", "M23,10.5a.5.5,0,0,0-.5-.5h-4L12.73,2.3a.77.77,0,0,0-.6-.3h-.26a.77.77,0,0,0-.6.3L5.5,10h-4a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H2l1.71,7.65A3,3,0,0,0,6.6,22H17.4a3,3,0,0,0,2.92-2.35L22,12h.47a.5.5,0,0,0,.5-.5ZM8,10l4-5.33L16,10Zm1.5,6.88a.5.5,0,0,1-.5-.5v-.76a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v.76a.5.5,0,0,1-.5.5Z"]
  };
  
  var shoppingCart = {
    prefix: 'axis',
    iconName: 'shoppingCart',
    icon: [24, 24, [], "f0000", "M20,20a2,2,0,1,1-2-2A2,2,0,0,1,20,20ZM8,18a2,2,0,1,0,2,2A2,2,0,0,0,8,18ZM21.5,4H5.72L5.16,3A2,2,0,0,0,3.42,2H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h.92L7.7,11.49a2.19,2.19,0,0,0,.27.35l-1.86,3.7a.77.77,0,0,0,0,.71l.22.38A.76.76,0,0,0,7,17H19.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H8.62l1-2.09a2.74,2.74,0,0,0,.64.09h6.23A2.94,2.94,0,0,0,19,11.49l2.35-4.13A4.76,4.76,0,0,0,22,5V4.5A.5.5,0,0,0,21.5,4Z"]
  };
  
  var shoppingCartAdd = {
    prefix: 'axis',
    iconName: 'shoppingCartAdd',
    icon: [24, 24, [], "f0000", "M20,20a2,2,0,1,1-2-2A2,2,0,0,1,20,20ZM8,18a2,2,0,1,0,2,2A2,2,0,0,0,8,18ZM21.5,4h-1a.5.5,0,0,0-.5.5V5a2.86,2.86,0,0,1-.36,1.37L17.28,10.5a1,1,0,0,1-.75.5H10.3a1,1,0,0,1-.86-.5L5.16,3A2,2,0,0,0,3.42,2H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h.92L7.7,11.49a2.19,2.19,0,0,0,.27.35l-1.86,3.7a.77.77,0,0,0,0,.71l.22.38A.76.76,0,0,0,7,17H19.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H8.62l1-2.09a2.74,2.74,0,0,0,.64.09h6.23A2.94,2.94,0,0,0,19,11.49l2.35-4.13A4.76,4.76,0,0,0,22,5V4.5A.5.5,0,0,0,21.5,4ZM16,5.38V4.62a.5.5,0,0,0-.5-.5H13.88V2.5a.5.5,0,0,0-.5-.5h-.76a.5.5,0,0,0-.5.5V4.12H10.5a.5.5,0,0,0-.5.5v.76a.5.5,0,0,0,.5.5h1.62V7.5a.5.5,0,0,0,.5.5h.76a.5.5,0,0,0,.5-.5V5.88H15.5A.5.5,0,0,0,16,5.38Z"]
  };
  
  var shoppingCartOff = {
    prefix: 'axis',
    iconName: 'shoppingCartOff',
    icon: [24, 24, [], "f0000", "M3.38,2.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L4.3,5.53l3.4,6a2.19,2.19,0,0,0,.27.35l-1.86,3.7a.77.77,0,0,0,0,.71l.22.38A.76.76,0,0,0,7,17h8.76L17,18.26A2,2,0,1,0,19.74,21l.88.88a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM8.62,15l1-2.09a2.74,2.74,0,0,0,.64.09h1.46l2,2ZM21.5,4H7.71l9,9A2.94,2.94,0,0,0,19,11.49l2.35-4.13A4.76,4.76,0,0,0,22,5V4.5A.5.5,0,0,0,21.5,4ZM8,18a2,2,0,1,0,2,2A2,2,0,0,0,8,18Z"]
  };
  
  var shoppingCartOutlined = {
    prefix: 'axis',
    iconName: 'shoppingCartOutlined',
    icon: [24, 24, [], "f0000", "M21.5,4H5.72L5.16,3A2,2,0,0,0,3.42,2H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h.92L7.7,11.49a2.19,2.19,0,0,0,.27.35l-1.86,3.7a.77.77,0,0,0,0,.71l.22.38A.76.76,0,0,0,7,17H19.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H8.62l1-2.09a2.74,2.74,0,0,0,.64.09h6.23A2.94,2.94,0,0,0,19,11.49l2.35-4.13A4.76,4.76,0,0,0,22,5V4.5A.5.5,0,0,0,21.5,4Zm-4.22,6.5a1,1,0,0,1-.75.5H10.3a1,1,0,0,1-.86-.5L6.87,6H19.79c-.05.12-.09.25-.15.37ZM18,18a2,2,0,1,0,2,2A2,2,0,0,0,18,18ZM8,18a2,2,0,1,0,2,2A2,2,0,0,0,8,18Z"]
  };
  
  var shoppingCartRemove = {
    prefix: 'axis',
    iconName: 'shoppingCartRemove',
    icon: [24, 24, [], "f0000", "M20,20a2,2,0,1,1-2-2A2,2,0,0,1,20,20ZM8,18a2,2,0,1,0,2,2A2,2,0,0,0,8,18ZM22,4.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V5a2.86,2.86,0,0,1-.36,1.37L17.28,10.5a1,1,0,0,1-.75.5H10.3a1,1,0,0,1-.86-.5L5.16,3A2,2,0,0,0,3.42,2H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h.92L7.7,11.49a2.19,2.19,0,0,0,.27.35l-1.86,3.7a.77.77,0,0,0,0,.71l.22.38A.76.76,0,0,0,7,17H19.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H8.62l1-2.09a2.74,2.74,0,0,0,.64.09h6.23A2.94,2.94,0,0,0,19,11.49l2.35-4.13A4.76,4.76,0,0,0,22,5ZM10.5,4.12a.5.5,0,0,0-.5.5v.76a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V4.62a.5.5,0,0,0-.5-.5Z"]
  };
  
  var snooze = {
    prefix: 'axis',
    iconName: 'snooze',
    icon: [24, 24, [], "f0000", "M12,4a9,9,0,1,0,9,9A9,9,0,0,0,12,4Zm0,16a7,7,0,1,1,7-7A7,7,0,0,1,12,20ZM14.5,9h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3.25L9.27,14.71A1,1,0,0,0,9,15.4v1.1a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H11.25l3.48-3.71A1,1,0,0,0,15,10.6V9.5A.5.5,0,0,0,14.5,9ZM6.94,3.06A.24.24,0,0,0,7,2.88a.28.28,0,0,0-.09-.19A3,3,0,0,0,2.69,6.92.28.28,0,0,0,2.88,7a.24.24,0,0,0,.18-.07ZM19,2a3,3,0,0,0-1.92.69.28.28,0,0,0-.09.19.24.24,0,0,0,.07.18l3.88,3.88a.24.24,0,0,0,.18.07.28.28,0,0,0,.19-.09A3,3,0,0,0,19,2Z"]
  };
  
  var snoozeNotification = {
    prefix: 'axis',
    iconName: 'snoozeNotification',
    icon: [24, 24, [], "f0000", "M19.71,15.71l-.83-.83A3,3,0,0,1,18,12.76V10a6,6,0,0,0-1.2-3.6l-.9-1.2A3,3,0,0,0,13.5,4H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4h-.5A3,3,0,0,0,8.1,5.2L7.2,6.4A6,6,0,0,0,6,10v2.76a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,0-.29.7V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.59A1,1,0,0,0,19.71,15.71ZM15,8.37a1,1,0,0,1-.25.66L11,13.25H14.5a.5.5,0,0,1,.5.5v.75a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-.87A1,1,0,0,1,9.25,13L13,8.75H9.5a.5.5,0,0,1-.5-.5V7.5A.5.5,0,0,1,9.5,7h5a.5.5,0,0,1,.5.5ZM12,22a2,2,0,0,0,2-2H10A2,2,0,0,0,12,22Z"]
  };
  
  var sort = {
    prefix: 'axis',
    iconName: 'sort',
    icon: [24, 24, [], "f0000", "M21,11.5v1a.5.5,0,0,1-.5.5H7.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13A.5.5,0,0,1,21,11.5ZM20.5,17h-4a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,17Zm0-12H10a7,7,0,0,0,0,14v2a.5.5,0,0,0,.85.35l3-3a.51.51,0,0,0,0-.71l-3-3A.5.5,0,0,0,10,15v2A5,5,0,0,1,10,7H20.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,5Z"]
  };
  
  var star = {
    prefix: 'axis',
    iconName: 'star',
    icon: [24, 24, [], "f0000", "M2.18,9.86A.49.49,0,0,1,2,9.32l.08-.25a.49.49,0,0,1,.44-.35l6.39-.51,2.45-5.89A.51.51,0,0,1,11.87,2h.26a.49.49,0,0,1,.47.32l2.46,5.89,6.39.51a.49.49,0,0,1,.44.35l.08.25a.49.49,0,0,1-.15.54L17,14l1.48,6.21a.51.51,0,0,1-.19.53L18,20.9a.5.5,0,0,1-.56,0L12,17.6,6.53,20.93a.5.5,0,0,1-.56,0l-.22-.15a.51.51,0,0,1-.19-.53L7,14Z"]
  };
  
  var starHalf = {
    prefix: 'axis',
    iconName: 'starHalf',
    icon: [24, 24, [], "f0000", "M22,9.32l-.08-.25a.49.49,0,0,0-.44-.35l-6.39-.51L12.6,2.32A.49.49,0,0,0,12.13,2h-.26a.51.51,0,0,0-.48.32L8.94,8.21l-6.39.51a.49.49,0,0,0-.44.35L2,9.32a.49.49,0,0,0,.15.54L7,14,5.56,20.22a.51.51,0,0,0,.19.53L6,20.9a.47.47,0,0,0,.3.1.48.48,0,0,0,.26-.07L12,17.6l5.47,3.33a.48.48,0,0,0,.26.07.47.47,0,0,0,.3-.1l.22-.15a.51.51,0,0,0,.19-.53L17,14l4.86-4.15A.49.49,0,0,0,22,9.32Zm-7,4.06,1.12,4.68L12,15.55V5.41l1.86,4.46,4.81.38Z"]
  };
  
  var starOutlined = {
    prefix: 'axis',
    iconName: 'starOutlined',
    icon: [24, 24, [], "f0000", "M12,5.41m1.86,4.46,4.81.38L15,13.38l1.12,4.68L12,15.55,7.87,18.06,9,13.38,5.33,10.25l4.81-.38L12,5.41ZM11.87,2a.51.51,0,0,0-.48.32L8.94,8.21l-6.39.51a.49.49,0,0,0-.44.35L2,9.32a.49.49,0,0,0,.15.54L7,14,5.56,20.22a.51.51,0,0,0,.19.53L6,20.9a.47.47,0,0,0,.3.1.48.48,0,0,0,.26-.07L12,17.6l5.47,3.33a.48.48,0,0,0,.26.07.47.47,0,0,0,.3-.1l.22-.15a.51.51,0,0,0,.19-.53L17,14l4.86-4.15A.49.49,0,0,0,22,9.32l-.08-.25a.49.49,0,0,0-.44-.35l-6.39-.51L12.6,2.32A.49.49,0,0,0,12.13,2Z"]
  };
  
  var subscribe = {
    prefix: 'axis',
    iconName: 'subscribe',
    icon: [24, 24, [], "f0000", "M20,7H4A2,2,0,0,0,2,9V19a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V9A2,2,0,0,0,20,7Zm-4.94,7.62-3.89,2.6A.75.75,0,0,1,10,16.6V11.4a.75.75,0,0,1,1.17-.62l3.89,2.6A.74.74,0,0,1,15.06,14.62ZM17,3H7A2,2,0,0,0,5,5H19A2,2,0,0,0,17,3Z"]
  };
  
  var support = {
    prefix: 'axis',
    iconName: 'support',
    icon: [24, 24, [], "f0000", "M21,13v4a2,2,0,0,1-2,2v1a3,3,0,0,1-3,3H13a1,1,0,0,1-1-1v-.5a.5.5,0,0,1,.5-.5H16a1,1,0,0,0,1-1V19a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1V8A5,5,0,0,0,7,8v3a1,1,0,0,1,1,1v6a1,1,0,0,1-1,1H5a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2V8A7,7,0,0,1,19,8v3A2,2,0,0,1,21,13Z"]
  };
  
  var sync = {
    prefix: 'axis',
    iconName: 'sync',
    icon: [24, 24, [], "f0000", "M11.85,1.35a.49.49,0,0,1,.15.36V4a8,8,0,0,1,6.92,12,.52.52,0,0,1-.37.24.5.5,0,0,1-.42-.14l-.73-.73a.5.5,0,0,1-.09-.59A5.94,5.94,0,0,0,18,12a6,6,0,0,0-6-6V8.36a.49.49,0,0,1-.15.36l-.2.2a.5.5,0,0,1-.71,0L7.4,5.39a.51.51,0,0,1,0-.71l3.54-3.53a.5.5,0,0,1,.71,0Zm1.21,13.73a.5.5,0,0,0-.71,0l-.2.2a.49.49,0,0,0-.15.36V18a6,6,0,0,1-6-6,5.83,5.83,0,0,1,.7-2.79.51.51,0,0,0-.09-.59l-.74-.74a.5.5,0,0,0-.42-.14A.52.52,0,0,0,5.08,8,8,8,0,0,0,12,20v2.29a.49.49,0,0,0,.15.36l.2.2a.5.5,0,0,0,.71,0l3.54-3.53a.51.51,0,0,0,0-.71Z"]
  };
  
  var syncOff = {
    prefix: 'axis',
    iconName: 'syncOff',
    icon: [24, 24, [], "f0000", "M10.05,6.34,8.52,4.81a7.59,7.59,0,0,1,1.88-.64.53.53,0,0,1,.42.1.53.53,0,0,1,.18.39v1a.51.51,0,0,1-.38.49C10.43,6.22,10.24,6.27,10.05,6.34ZM13.5,9h.29a.49.49,0,0,0,.36-.15L15.7,7.3a6,6,0,0,1,2,6.66l1.53,1.53a8,8,0,0,0-2.07-9.62l1.72-1.72A.49.49,0,0,0,19,3.79V3.5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v5A.5.5,0,0,0,13.5,9Zm7.35,10.62L4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L5.77,7a8,8,0,0,0,1.1,11.12L5.15,19.85a.49.49,0,0,0-.15.36v.29a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-5a.5.5,0,0,0-.5-.5h-.29a.49.49,0,0,0-.36.15L8.3,16.7A5.94,5.94,0,0,1,7.2,8.43l8.36,8.37a5.92,5.92,0,0,1-2.18,1,.51.51,0,0,0-.38.49v1a.53.53,0,0,0,.18.39.53.53,0,0,0,.42.1A7.94,7.94,0,0,0,17,18.23l2.63,2.62a.48.48,0,0,0,.7,0l.53-.53A.48.48,0,0,0,20.85,19.62Z"]
  };
  
  var tab = {
    prefix: 'axis',
    iconName: 'tab',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4ZM4,18V7A1,1,0,0,1,5,6h5a1,1,0,0,1,1,1V9a1,1,0,0,0,1,1h8v8Z"]
  };
  
  var tabs = {
    prefix: 'axis',
    iconName: 'tabs',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,14H4V7A1,1,0,0,1,5,6h5a1,1,0,0,1,1,1V9a1,1,0,0,0,1,1h8ZM20,8H13V7a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1Z"]
  };
  
  var time = {
    prefix: 'axis',
    iconName: 'time',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.88-8.36V6.5a.5.5,0,0,0-.5-.5h-.76a.5.5,0,0,0-.5.5v5.66a.53.53,0,0,0,.15.35l4,4a.51.51,0,0,0,.71,0l.53-.53a.51.51,0,0,0,0-.71Z"]
  };
  
  var time20S = {
    prefix: 'axis',
    iconName: 'time20S',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.53-14a.5.5,0,0,0-.53.51v5.52l3.84,3.85a.5.5,0,0,0,.73,0,6,6,0,0,0-4-9.86Z"]
  };
  
  var time30S = {
    prefix: 'axis',
    iconName: 'time30S',
    icon: [24, 24, [], "f0000", "M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M12,20c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8s8,3.6,8,8C20,16.4,16.4,20,12,20z M12.5,6C12.2,6,12,6.2,12,6.5v10.9c0,0.3,0.2,0.5,0.5,0.5c3.1-0.3,5.5-2.8,5.5-6C18,8.9,15.6,6.3,12.5,6z"]
  };
  
  var time40S = {
    prefix: 'axis',
    iconName: 'time40S',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.52-14a.5.5,0,0,0-.52.5v5.53L8.16,15.89a.5.5,0,0,0,0,.73A6,6,0,1,0,12.52,6Z"]
  };
  
  var timer = {
    prefix: 'axis',
    iconName: 'timer',
    icon: [24, 24, [], "f0000", "M19,7.37l1.13-1.13a.5.5,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L17.6,6A9,9,0,0,0,14,4.23V3a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V4.23A9,9,0,0,0,3,13,9.11,9.11,0,0,0,11.74,22,9,9,0,0,0,19,7.37ZM12,20a7,7,0,1,1,7-7A7,7,0,0,1,12,20Zm.38-12h-.76a.5.5,0,0,0-.5.5v5a.5.5,0,0,0,.5.5h.76a.5.5,0,0,0,.5-.5v-5A.5.5,0,0,0,12.38,8Z"]
  };
  
  var timer20S = {
    prefix: 'axis',
    iconName: 'timer20S',
    icon: [24, 24, [], "f0000", "M19,7.37l1.13-1.13a.5.5,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L17.6,6A9,9,0,0,0,14,4.23V3a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V4.23A9,9,0,0,0,3,13,9.11,9.11,0,0,0,11.74,22,9,9,0,0,0,19,7.37ZM12,20a7,7,0,1,1,7-7A7,7,0,0,1,12,20Zm.58-12a.51.51,0,0,0-.58.5V13l3.16,3.16a.51.51,0,0,0,.76-.05A5,5,0,0,0,12.58,8Z"]
  };
  
  var timer30S = {
    prefix: 'axis',
    iconName: 'timer30S',
    icon: [24, 24, [], "f0000", "M19,7.37l1.13-1.13a.5.5,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L17.6,6A9,9,0,0,0,14,4.23V3a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V4.23A9,9,0,0,0,3,13,9.11,9.11,0,0,0,11.74,22,9,9,0,0,0,19,7.37ZM12,20a7,7,0,1,1,7-7A7,7,0,0,1,12,20Zm.58-12a.51.51,0,0,0-.58.5v8.94a.51.51,0,0,0,.58.5,5,5,0,0,0,0-9.94Z"]
  };
  
  var timer40S = {
    prefix: 'axis',
    iconName: 'timer40S',
    icon: [24, 24, [], "f0000", "M19,7.37l1.13-1.13a.5.5,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L17.6,6A9,9,0,0,0,14,4.23V3a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V4.23A9,9,0,0,0,3,13,9.11,9.11,0,0,0,11.74,22,9,9,0,0,0,19,7.37ZM12,20a7,7,0,1,1,7-7A7,7,0,0,1,12,20Zm.53-12a.49.49,0,0,0-.53.5V13L8.84,16.16a.51.51,0,0,0,.06.76,5,5,0,0,0,3.95,1A5,5,0,0,0,12.53,8Z"]
  };
  
  var timerOff = {
    prefix: 'axis',
    iconName: 'timerOff',
    icon: [24, 24, [], "f0000", "M4.38,4.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L5.06,7.3A9,9,0,0,0,17.7,19.94l1.92,1.91a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM12,20a7,7,0,0,1-7-7A6.93,6.93,0,0,1,6.48,8.72l9.8,9.8A6.93,6.93,0,0,1,12,20Zm.32-14a7,7,0,0,1,6.13,9.72l1.49,1.49A9,9,0,0,0,19,7.37l1.13-1.13a.5.5,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L17.6,6A9,9,0,0,0,14,4.23V3a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V4.23a9,9,0,0,0-2.22.83L9.27,6.55A7,7,0,0,1,12.32,6Zm-.7,2a.49.49,0,0,0-.49.41l1.75,1.75V8.5a.5.5,0,0,0-.5-.5Z"]
  };
  
  var turnOff = {
    prefix: 'axis',
    iconName: 'turnOff',
    icon: [24, 24, [], "f0000", "M11,13.5V3.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v10a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,11,13.5Zm7-5.77a.53.53,0,0,0-.36-.17.51.51,0,0,0-.37.15l-.71.71a.51.51,0,0,0,0,.68A5.92,5.92,0,0,1,18,13,6,6,0,0,1,6,13,5.92,5.92,0,0,1,7.45,9.1a.51.51,0,0,0,0-.68l-.71-.71a.51.51,0,0,0-.37-.15A.53.53,0,0,0,6,7.73a8,8,0,1,0,12,0Z"]
  };
  
  var unarchive = {
    prefix: 'axis',
    iconName: 'unarchive',
    icon: [24, 24, [], "f0000", "M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M15.9,13.4l-0.2,0.2c-0.1,0.1-0.2,0.1-0.4,0.1H14v3.8c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-3.8H8.7c-0.1,0-0.3,0-0.4-0.1l-0.2-0.2c-0.2-0.2-0.2-0.5,0-0.7l3.5-3.5c0.2-0.2,0.5-0.2,0.7,0c0,0,0,0,0,0l3.5,3.5C16.1,12.9,16.1,13.2,15.9,13.4z M19,7H5V5h14V7z"]
  };
  
  var update = {
    prefix: 'axis',
    iconName: 'update',
    icon: [24, 24, [], "f0000", "M12.88,7.5v4.14l2.92,2.92a.5.5,0,0,1,0,.71l-.53.53a.5.5,0,0,1-.71,0l-3.29-3.29a.53.53,0,0,1-.15-.35V7.5a.5.5,0,0,1,.5-.5h.76A.5.5,0,0,1,12.88,7.5ZM21,9.5v-5a.5.5,0,0,0-.5-.5h-.29a.49.49,0,0,0-.36.15L18.36,5.64A9,9,0,1,0,21,12.53a.5.5,0,0,0-.13-.37.52.52,0,0,0-.36-.16h-1a.5.5,0,0,0-.5.47A7,7,0,1,1,12,5a6.93,6.93,0,0,1,4.93,2.07L15.15,8.85a.49.49,0,0,0-.15.36V9.5a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,21,9.5Z"]
  };
  
  var vibrations = {
    prefix: 'axis',
    iconName: 'vibrations',
    icon: [24, 24, [], "f0000", "M16,3H8A2,2,0,0,0,6,5V19a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V5A2,2,0,0,0,16,3Zm0,16H8V5h8ZM3.12,7.27a.49.49,0,0,0-.67-.21l-.89.46a.49.49,0,0,0-.22.67L2,9.49l-.91,1.75A1.07,1.07,0,0,0,1,11.7v.58a1,1,0,0,0,.11.46L2,14.5l-.68,1.31a.5.5,0,0,0,.21.67l.89.46a.51.51,0,0,0,.68-.21l.77-1.49A1,1,0,0,0,4,14.78v-.57a1,1,0,0,0-.11-.46L3,12l.91-1.75A1,1,0,0,0,4,9.78V9.21a1,1,0,0,0-.11-.46Zm19.77,4L22,9.49l.68-1.3a.49.49,0,0,0-.22-.67l-.89-.46a.49.49,0,0,0-.67.21l-.77,1.48a1,1,0,0,0-.11.46v.57a1,1,0,0,0,.11.46L21,12l-.91,1.76a1,1,0,0,0-.11.46v.57a1,1,0,0,0,.11.46l.77,1.49a.51.51,0,0,0,.68.21l.89-.46a.5.5,0,0,0,.21-.67L22,14.5l.91-1.76a1,1,0,0,0,.11-.46V11.7A1.07,1.07,0,0,0,22.89,11.24Z"]
  };
  
  var vibrationsOff = {
    prefix: 'axis',
    iconName: 'vibrationsOff',
    icon: [24, 24, [], "f0000", "M4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L6,7.24V19a2,2,0,0,0,2,2h8a2,2,0,0,0,2-1.78l1.64,1.63a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM16,19H8V9.24l8,8ZM3.1,7.27a.49.49,0,0,0-.67-.21l-.89.46a.49.49,0,0,0-.22.67L2,9.49l-.91,1.75A1.07,1.07,0,0,0,1,11.7v.58a1,1,0,0,0,.11.46L2,14.5l-.68,1.31a.5.5,0,0,0,.21.67l.89.46a.51.51,0,0,0,.68-.21l.77-1.49A1,1,0,0,0,4,14.78v-.57a1,1,0,0,0-.11-.46L3,12l.91-1.75A1,1,0,0,0,4,9.78V9.21a1,1,0,0,0-.11-.46Zm19.79,4L22,9.49l.68-1.3a.49.49,0,0,0-.22-.67l-.89-.46a.49.49,0,0,0-.67.21l-.77,1.48a1,1,0,0,0-.11.46v.57a1,1,0,0,0,.11.46L21,12l-.91,1.76a1,1,0,0,0-.11.46v.57a1,1,0,0,0,.11.46l.77,1.49a.51.51,0,0,0,.68.21l.89-.46a.5.5,0,0,0,.21-.67L22,14.5l.91-1.76a1,1,0,0,0,.11-.46V11.7A1.07,1.07,0,0,0,22.89,11.24ZM16,5v7.29l2,2V5a2,2,0,0,0-2-2H8a1.94,1.94,0,0,0-1,.28L8.71,5Z"]
  };
  
  var watchLater = {
    prefix: 'axis',
    iconName: 'watchLater',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm4.51,14-.53.53a.51.51,0,0,1-.71,0l-4-4a.49.49,0,0,1-.15-.36V6.5a.5.5,0,0,1,.5-.5h.76a.5.5,0,0,1,.5.5v5.14l3.63,3.63A.51.51,0,0,1,16.51,16Z"]
  };
  
  var youtubeSearch = {
    prefix: 'axis',
    iconName: 'youtubeSearch',
    icon: [24, 24, [], "f0000", "M21.85,20.15l-.7.7a.5.5,0,0,1-.71,0l-4-4a2.6,2.6,0,0,1-.3-.36l-.75-1A7,7,0,0,1,11,17a6.91,6.91,0,0,1-3-.69A.49.49,0,0,1,7.7,16a.51.51,0,0,1,.14-.44l.76-.76a.51.51,0,0,1,.54-.11A5,5,0,1,0,6,10H7.75a.5.5,0,0,1,.35.85L5.36,13.6a.51.51,0,0,1-.71,0L1.9,10.85A.5.5,0,0,1,2.26,10H4a7,7,0,1,1,12.43,4.41h0l1,.69a2.44,2.44,0,0,1,.43.35l4,4A.5.5,0,0,1,21.85,20.15Z"]
  };
  
  var batteryAlert = {
    prefix: 'axis',
    iconName: 'batteryAlert',
    icon: [24, 24, [], "f0000", "M17,6a2,2,0,0,0-2-2H14V3a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V4H9A2,2,0,0,0,7,6V20a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2ZM13,16.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-.22-3.72a.25.25,0,0,1-.25.22H11.47a.25.25,0,0,1-.25-.22l-.4-3.22a.5.5,0,0,1,.5-.56h1.36a.5.5,0,0,1,.5.56Z"]
  };
  
  var error = {
    prefix: 'axis',
    iconName: 'error',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,13.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-.22-3.72a.25.25,0,0,1-.25.22H11.47a.25.25,0,0,1-.25-.22l-.4-3.22a.5.5,0,0,1,.5-.56h1.36a.5.5,0,0,1,.5.56Z"]
  };
  
  var errorOutlined = {
    prefix: 'axis',
    iconName: 'errorOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.5-6h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,14Zm.18-6H11.32a.5.5,0,0,0-.5.56l.4,3.22a.25.25,0,0,0,.25.22h1.06a.25.25,0,0,0,.25-.22l.4-3.22A.5.5,0,0,0,12.68,8Z"]
  };
  
  var messageFailed = {
    prefix: 'axis',
    iconName: 'messageFailed',
    icon: [24, 24, [], "f0000", "M18,2H6A4,4,0,0,0,2,6V21.5a.5.5,0,0,0,.5.5.49.49,0,0,0,.35-.15l3-3A3,3,0,0,1,8,18H18a4,4,0,0,0,4-4V6A4,4,0,0,0,18,2ZM13,13.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-.22-3.72a.25.25,0,0,1-.25.22H11.47a.25.25,0,0,1-.25-.22l-.4-3.22a.5.5,0,0,1,.5-.56h1.36a.5.5,0,0,1,.5.56Z"]
  };
  
  var messageFailedOutlined = {
    prefix: 'axis',
    iconName: 'messageFailedOutlined',
    icon: [24, 24, [], "f0000", "M18,2H6A4,4,0,0,0,2,6V21.5a.5.5,0,0,0,.5.5.49.49,0,0,0,.35-.15l3-3A3,3,0,0,1,8,18H18a4,4,0,0,0,4-4V6A4,4,0,0,0,18,2Zm0,14H8a5,5,0,0,0-3.54,1.46L4,17.88V6A2,2,0,0,1,6,4H18a2,2,0,0,1,2,2v8A2,2,0,0,1,18,16Zm-5.5-4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,12Zm-1-2h1.06a.25.25,0,0,0,.25-.22l.4-3.22a.5.5,0,0,0-.5-.56H11.32a.5.5,0,0,0-.5.56l.4,3.22A.25.25,0,0,0,11.47,10Z"]
  };
  
  var newRelease = {
    prefix: 'axis',
    iconName: 'newRelease',
    icon: [24, 24, [], "f0000", "M21.61,13.16a3.2,3.2,0,0,1,0-2.32l.17-.46a3.27,3.27,0,0,0-1.71-4.15L19.62,6A3.31,3.31,0,0,1,18,4.38l-.2-.45a3.26,3.26,0,0,0-4.15-1.71l-.46.17A3.3,3.3,0,0,1,12,2.6a3.3,3.3,0,0,1-1.16-.21l-.46-.17A3.26,3.26,0,0,0,6.23,3.93L6,4.38A3.31,3.31,0,0,1,4.38,6l-.45.2a3.27,3.27,0,0,0-1.71,4.15l.17.46a3.2,3.2,0,0,1,0,2.32l-.17.46a3.27,3.27,0,0,0,1.71,4.15l.45.2A3.31,3.31,0,0,1,6,19.62l.2.45a3.26,3.26,0,0,0,4.15,1.71l.46-.17a3.31,3.31,0,0,1,2.32,0l.46.17a3.26,3.26,0,0,0,4.15-1.71l.2-.45A3.31,3.31,0,0,1,19.62,18l.45-.2a3.27,3.27,0,0,0,1.71-4.15ZM13,15.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-.22-3.72a.25.25,0,0,1-.25.22H11.47a.25.25,0,0,1-.25-.22l-.4-3.22a.5.5,0,0,1,.5-.56h1.36a.5.5,0,0,1,.5.56Z"]
  };
  
  var newReleaseOutlined = {
    prefix: 'axis',
    iconName: 'newReleaseOutlined',
    icon: [24, 24, [], "f0000", "M21.61,13.16a3.2,3.2,0,0,1,0-2.32l.17-.46a3.27,3.27,0,0,0-1.71-4.15L19.62,6A3.31,3.31,0,0,1,18,4.38l-.2-.45a3.26,3.26,0,0,0-4.15-1.71l-.46.17A3.3,3.3,0,0,1,12,2.6a3.3,3.3,0,0,1-1.16-.21l-.46-.17A3.26,3.26,0,0,0,6.23,3.93L6,4.38A3.31,3.31,0,0,1,4.38,6l-.45.2a3.27,3.27,0,0,0-1.71,4.15l.17.46a3.2,3.2,0,0,1,0,2.32l-.17.46a3.27,3.27,0,0,0,1.71,4.15l.45.2A3.31,3.31,0,0,1,6,19.62l.2.45a3.26,3.26,0,0,0,4.15,1.71l.46-.17a3.31,3.31,0,0,1,2.32,0l.46.17a3.26,3.26,0,0,0,4.15-1.71l.2-.45A3.31,3.31,0,0,1,19.62,18l.45-.2a3.27,3.27,0,0,0,1.71-4.15Zm-2.35,2.78-.46.21a5.3,5.3,0,0,0-2.66,2.66l-.19.44a1.27,1.27,0,0,1-1.16.75,1.45,1.45,0,0,1-.48-.09l-.43-.16A5.06,5.06,0,0,0,12,19.4a5,5,0,0,0-1.85.34l-.49.17a1.17,1.17,0,0,1-.45.09,1.25,1.25,0,0,1-1.15-.74l-.21-.46a5.3,5.3,0,0,0-2.66-2.66L4.75,16a1.29,1.29,0,0,1-.66-1.64l.16-.43a5.16,5.16,0,0,0,0-3.73l-.17-.49a1.25,1.25,0,0,1,.65-1.6l.46-.21A5.3,5.3,0,0,0,7.86,5.19l.19-.44A1.27,1.27,0,0,1,9.21,4a1.45,1.45,0,0,1,.48.09l.43.16A5.06,5.06,0,0,0,12,4.6a5,5,0,0,0,1.85-.34l.49-.17A1.17,1.17,0,0,1,14.79,4a1.25,1.25,0,0,1,1.15.74l.21.46a5.3,5.3,0,0,0,2.66,2.66l.44.19a1.29,1.29,0,0,1,.66,1.64l-.16.43a5.16,5.16,0,0,0,0,3.73l.17.49A1.25,1.25,0,0,1,19.26,15.94ZM12.5,14h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,14Zm.18-6H11.32a.5.5,0,0,0-.5.56l.4,3.22a.25.25,0,0,0,.25.22h1.06a.25.25,0,0,0,.25-.22l.4-3.22A.5.5,0,0,0,12.68,8Z"]
  };
  
  var notificationAdd = {
    prefix: 'axis',
    iconName: 'notificationAdd',
    icon: [24, 24, [], "f0000", "M19.71,15.71l-.83-.83A3,3,0,0,1,18,12.76V10a6,6,0,0,0-1.2-3.6l-.9-1.2A3,3,0,0,0,13.5,4H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4h-.5A3,3,0,0,0,8.1,5.2L7.2,6.4A6,6,0,0,0,6,10v2.76a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,0-.29.7V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.59A1,1,0,0,0,19.71,15.71ZM14.5,11.88H12.88V13.5a.5.5,0,0,1-.5.5h-.76a.5.5,0,0,1-.5-.5V11.88H9.5a.5.5,0,0,1-.5-.5v-.76a.5.5,0,0,1,.5-.5h1.62V8.5a.5.5,0,0,1,.5-.5h.76a.5.5,0,0,1,.5.5v1.62H14.5a.5.5,0,0,1,.5.5v.76A.5.5,0,0,1,14.5,11.88ZM12,22a2,2,0,0,0,2-2H10A2,2,0,0,0,12,22Z"]
  };
  
  var notifications = {
    prefix: 'axis',
    iconName: 'notifications',
    icon: [24, 24, [], "f0000", "M10,20h4a2,2,0,0,1-4,0Zm9.71-4.29-.83-.83A3,3,0,0,1,18,12.76V10a6,6,0,0,0-1.2-3.6l-.9-1.2A3,3,0,0,0,13.5,4H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4h-.5A3,3,0,0,0,8.1,5.2L7.2,6.4A6,6,0,0,0,6,10v2.76a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,0-.29.7V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.59A1,1,0,0,0,19.71,15.71Z"]
  };
  
  var notificationsAlert = {
    prefix: 'axis',
    iconName: 'notificationsAlert',
    icon: [24, 24, [], "f0000", "M19.71,15.71l-.83-.83A3,3,0,0,1,18,12.76V10a6,6,0,0,0-1.2-3.6l-.9-1.2A3,3,0,0,0,13.5,4H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4h-.5A3,3,0,0,0,8.1,5.2L7.2,6.4A6,6,0,0,0,6,10v2.76a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,0-.29.7V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.59A1,1,0,0,0,19.71,15.71ZM13,14.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-.22-3.72a.25.25,0,0,1-.25.22H11.47a.25.25,0,0,1-.25-.22l-.4-3.22a.5.5,0,0,1,.5-.56h1.36a.5.5,0,0,1,.5.56ZM12,22a2,2,0,0,0,2-2H10A2,2,0,0,0,12,22Z"]
  };
  
  var notificationsOff = {
    prefix: 'axis',
    iconName: 'notificationsOff',
    icon: [24, 24, [], "f0000", "M10,20h4a2,2,0,0,1-4,0Zm8-10a6,6,0,0,0-1.2-3.6l-.9-1.2A3,3,0,0,0,13.5,4H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4h-.5A2.92,2.92,0,0,0,9,4.43l9,9Zm2.85,8.79L5.38,3.32a.5.5,0,0,0-.7,0l-.53.53a.5.5,0,0,0,0,.71l2.6,2.6A5.88,5.88,0,0,0,6,10v2.76a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,0-.29.7V17a1,1,0,0,0,1,1H17.59l2,2a.5.5,0,0,0,.7,0l.53-.53A.5.5,0,0,0,20.85,18.79Z"]
  };
  
  var notificationsOn = {
    prefix: 'axis',
    iconName: 'notificationsOn',
    icon: [24, 24, [], "f0000", "M10,20h4a2,2,0,0,1-4,0Zm8.88-5.12A3,3,0,0,1,18,12.76V10a6,6,0,0,0-1.2-3.6l-.9-1.2A3,3,0,0,0,13.5,4H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4h-.5A3,3,0,0,0,8.1,5.2L7.2,6.4A6,6,0,0,0,6,10v2.76a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,0-.29.7V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.59a1,1,0,0,0-.29-.7ZM5.59,5.21a.36.36,0,0,0-.06-.5l-1-.78a.4.4,0,0,0-.3-.09A.37.37,0,0,0,4,4,10.05,10.05,0,0,0,2,9.47a.47.47,0,0,0,.14.37.48.48,0,0,0,.36.16h1A.51.51,0,0,0,4,9.52,8.12,8.12,0,0,1,5.59,5.21ZM20,4a.38.38,0,0,0-.27-.16.44.44,0,0,0-.31.09l-1,.78a.36.36,0,0,0-.06.5A8.12,8.12,0,0,1,20,9.52a.5.5,0,0,0,.49.48h1a.5.5,0,0,0,.36-.16A.55.55,0,0,0,22,9.47,10.13,10.13,0,0,0,20,4Z"]
  };
  
  var notificationsOnOutlined = {
    prefix: 'axis',
    iconName: 'notificationsOnOutlined',
    icon: [24, 24, [], "f0000", "M18.88,14.88A3,3,0,0,1,18,12.76V10a6,6,0,0,0-1.2-3.6l-.9-1.2A3,3,0,0,0,13.5,4H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4h-.5A3,3,0,0,0,8.1,5.2L7.2,6.4A6,6,0,0,0,6,10v2.76a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,0-.29.7V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.59a1,1,0,0,0-.29-.7ZM16,16H8V10a4,4,0,0,1,.8-2.4l.9-1.2a1,1,0,0,1,.8-.4h3a1,1,0,0,1,.8.4l.9,1.2A4,4,0,0,1,16,10Zm-4,6a2,2,0,0,0,2-2H10A2,2,0,0,0,12,22ZM5.59,5.21a.36.36,0,0,0-.06-.5l-1-.78a.4.4,0,0,0-.3-.09A.37.37,0,0,0,4,4,10.05,10.05,0,0,0,2,9.47a.47.47,0,0,0,.14.37.48.48,0,0,0,.36.16h1A.51.51,0,0,0,4,9.52,8.12,8.12,0,0,1,5.59,5.21ZM20,4a.38.38,0,0,0-.27-.16.44.44,0,0,0-.31.09l-1,.78a.36.36,0,0,0-.06.5A8.12,8.12,0,0,1,20,9.52a.5.5,0,0,0,.49.48h1a.5.5,0,0,0,.36-.16A.55.55,0,0,0,22,9.47,10.13,10.13,0,0,0,20,4Z"]
  };
  
  var notificationsOutlined = {
    prefix: 'axis',
    iconName: 'notificationsOutlined',
    icon: [24, 24, [], "f0000", "M19.71,15.71l-.83-.83A3,3,0,0,1,18,12.76V10a6,6,0,0,0-1.2-3.6l-.9-1.2A3,3,0,0,0,13.5,4H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4h-.5A3,3,0,0,0,8.1,5.2L7.2,6.4A6,6,0,0,0,6,10v2.76a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,0-.29.7V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.59A1,1,0,0,0,19.71,15.71ZM16,16H8V10a4,4,0,0,1,.8-2.4l.9-1.2a1,1,0,0,1,.8-.4h3a1,1,0,0,1,.8.4l.9,1.2A4,4,0,0,1,16,10Zm-6,4h4a2,2,0,0,1-4,0Z"]
  };
  
  var report = {
    prefix: 'axis',
    iconName: 'report',
    icon: [24, 24, [], "f0000", "M21,9.51a3,3,0,0,0-.88-2.12L16.61,3.88A3,3,0,0,0,14.49,3h-5a3,3,0,0,0-2.12.88L3.88,7.39A3,3,0,0,0,3,9.51v5a3,3,0,0,0,.88,2.12l3.51,3.51A3,3,0,0,0,9.51,21h5a3,3,0,0,0,2.12-.88l3.51-3.51A3,3,0,0,0,21,14.49Zm-8,6a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-.22-3.72a.25.25,0,0,1-.25.22H11.47a.25.25,0,0,1-.25-.22l-.4-3.22a.5.5,0,0,1,.5-.56h1.36a.5.5,0,0,1,.5.56Z"]
  };
  
  var reportOutlined = {
    prefix: 'axis',
    iconName: 'reportOutlined',
    icon: [24, 24, [], "f0000", "M20.12,7.39,16.61,3.88A3,3,0,0,0,14.49,3h-5a3,3,0,0,0-2.12.88L3.88,7.39A3,3,0,0,0,3,9.51v5a3,3,0,0,0,.88,2.12l3.51,3.51A3,3,0,0,0,9.51,21h5a3,3,0,0,0,2.12-.88l3.51-3.51A3,3,0,0,0,21,14.49v-5A3,3,0,0,0,20.12,7.39ZM19,14.49a1,1,0,0,1-.29.7l-3.52,3.52a1,1,0,0,1-.7.29h-5a1,1,0,0,1-.7-.29L5.29,15.19a1,1,0,0,1-.29-.7v-5a1,1,0,0,1,.29-.7L8.81,5.29A1,1,0,0,1,9.51,5h5a1,1,0,0,1,.7.29l3.52,3.52a1,1,0,0,1,.29.7ZM12.5,14h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,14Zm.18-6H11.32a.5.5,0,0,0-.5.56l.4,3.22a.25.25,0,0,0,.25.22h1.06a.25.25,0,0,0,.25-.22l.4-3.22A.5.5,0,0,0,12.68,8Z"]
  };
  
  var securityWarning = {
    prefix: 'axis',
    iconName: 'securityWarning',
    icon: [24, 24, [], "f0000", "M20.12,5.12,16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09V7.24A3,3,0,0,0,20.12,5.12ZM13,15.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-.22-3.72a.25.25,0,0,1-.25.22H11.47a.25.25,0,0,1-.25-.22l-.4-3.22a.5.5,0,0,1,.5-.56h1.36a.5.5,0,0,1,.5.56Z"]
  };
  
  var securityWarningOutlined = {
    prefix: 'axis',
    iconName: 'securityWarningOutlined',
    icon: [24, 24, [], "f0000", "M21,7.24a3,3,0,0,0-.88-2.12L16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09Zm-2,5.85a5.93,5.93,0,0,1-2.32,4.73L12.6,21H11.4L7.32,17.82A5.93,5.93,0,0,1,5,13.09V7.24a1,1,0,0,1,.29-.7L8.83,3h6.34l3.54,3.54a1,1,0,0,1,.29.7ZM12.5,14h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,14Zm.18-6H11.32a.5.5,0,0,0-.5.56l.4,3.22a.25.25,0,0,0,.25.22h1.06a.25.25,0,0,0,.25-.22l.4-3.22A.5.5,0,0,0,12.68,8Z"]
  };
  
  var warning = {
    prefix: 'axis',
    iconName: 'warning',
    icon: [24, 24, [], "f0000", "M22.9,19.63,12.81,2.37A.76.76,0,0,0,12.16,2h-.3a.76.76,0,0,0-.65.37L1.1,19.63a.79.79,0,0,0,0,.76l.14.23a.73.73,0,0,0,.65.38H22.11a.73.73,0,0,0,.65-.38l.14-.23A.79.79,0,0,0,22.9,19.63ZM13,16.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm-.22-3.72a.25.25,0,0,1-.25.22H11.47a.25.25,0,0,1-.25-.22l-.4-3.22a.5.5,0,0,1,.5-.56h1.36a.5.5,0,0,1,.5.56Z"]
  };
  
  var warningOutlined = {
    prefix: 'axis',
    iconName: 'warningOutlined',
    icon: [24, 24, [], "f0000", "M22.9,19.63,12.81,2.37A.76.76,0,0,0,12.16,2h-.3a.76.76,0,0,0-.65.37L1.1,19.63a.79.79,0,0,0,0,.76l.14.23a.73.73,0,0,0,.65.38H22.11a.73.73,0,0,0,.65-.38l.14-.23A.79.79,0,0,0,22.9,19.63ZM3.79,19,12,5l8.2,14Zm8.71-4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,15ZM10.82,9.56l.4,3.22a.25.25,0,0,0,.25.22h1.06a.25.25,0,0,0,.25-.22l.4-3.22a.5.5,0,0,0-.5-.56H11.32A.5.5,0,0,0,10.82,9.56Z"]
  };
  
  var arrowBackward = {
    prefix: 'axis',
    iconName: 'arrowBackward',
    icon: [24, 24, [], "f0000", "M22,11.5v1a.5.5,0,0,1-.5.5H5.33l4.45,4.44a.5.5,0,0,1,0,.71l-.71.7a.5.5,0,0,1-.71,0L2.22,12.72A.75.75,0,0,1,2,12.19v-.38a.77.77,0,0,1,.22-.53L8.36,5.15a.5.5,0,0,1,.71,0l.71.71a.49.49,0,0,1,0,.7L5.33,11H21.5A.5.5,0,0,1,22,11.5Z"]
  };
  
  var arrowDoublesidedHorizontal = {
    prefix: 'axis',
    iconName: 'arrowDoublesidedHorizontal',
    icon: [24, 24, [], "f0000", "M18,11V9a.5.5,0,0,1,.85-.36l3,3a.51.51,0,0,1,0,.71l-3,3A.5.5,0,0,1,18,15V13H6v2a.5.5,0,0,1-.85.35l-3-3a.51.51,0,0,1,0-.71l3-3A.5.5,0,0,1,6,9v2Z"]
  };
  
  var arrowDoublesidedVertical = {
    prefix: 'axis',
    iconName: 'arrowDoublesidedVertical',
    icon: [24, 24, [], "f0000", "M13,18h2a.5.5,0,0,1,.36.85l-3,3a.51.51,0,0,1-.71,0l-3-3A.5.5,0,0,1,9,18h2V6H9a.5.5,0,0,1-.35-.85l3-3a.51.51,0,0,1,.71,0l3,3A.5.5,0,0,1,15,6H13Z"]
  };
  
  var arrowDownward = {
    prefix: 'axis',
    iconName: 'arrowDownward',
    icon: [24, 24, [], "f0000", "M12.5,2a.5.5,0,0,1,.5.5V18.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71l-6.13,6.14a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L5.15,15.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L11,18.67V2.5a.5.5,0,0,1,.5-.5Z"]
  };
  
  var arrowDropDownCircle = {
    prefix: 'axis',
    iconName: 'arrowDropDownCircle',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3.36,8.85-3,3a.51.51,0,0,1-.71,0l-3-3A.5.5,0,0,1,9,10h6A.5.5,0,0,1,15.36,10.85Z"]
  };
  
  var arrowDropDownCircleOutlined = {
    prefix: 'axis',
    iconName: 'arrowDropDownCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,4a8,8,0,1,1-8,8,8,8,0,0,1,8-8m0-2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3,8H9a.5.5,0,0,0-.36.85l3,3a.51.51,0,0,0,.71,0l3-3A.5.5,0,0,0,15,10Z"]
  };
  
  var arrowDropUpCircle = {
    prefix: 'axis',
    iconName: 'arrowDropUpCircle',
    icon: [24, 24, [], "f0000", "M12,22A10,10,0,1,0,2,12,10,10,0,0,0,12,22ZM8.64,12.15l3-3a.51.51,0,0,1,.71,0l3,3A.5.5,0,0,1,15,13H9A.5.5,0,0,1,8.64,12.15Z"]
  };
  
  var arrowDropUpCircleOutlined = {
    prefix: 'axis',
    iconName: 'arrowDropUpCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,4a8,8,0,1,1-8,8,8,8,0,0,1,8-8m0-2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM9,13h6a.5.5,0,0,0,.36-.85l-3-3a.51.51,0,0,0-.71,0l-3,3A.5.5,0,0,0,9,13Z"]
  };
  
  var arrowForward = {
    prefix: 'axis',
    iconName: 'arrowForward',
    icon: [24, 24, [], "f0000", "M2,12.5v-1a.5.5,0,0,1,.5-.5H18.67L14.22,6.56a.5.5,0,0,1,0-.71l.71-.7a.5.5,0,0,1,.71,0l6.14,6.13a.75.75,0,0,1,.22.53v.38a.77.77,0,0,1-.22.53l-6.14,6.13a.5.5,0,0,1-.71,0l-.71-.71a.49.49,0,0,1,0-.7L18.67,13H2.5A.5.5,0,0,1,2,12.5Z"]
  };
  
  var arrowLargeBackward = {
    prefix: 'axis',
    iconName: 'arrowLargeBackward',
    icon: [24, 24, [], "f0000", "M10.94,4.86a.5.5,0,0,1,.71,0l.2.2a.49.49,0,0,1,.15.36V9h7.5a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5H12v3.58a.49.49,0,0,1-.15.36l-.2.2a.5.5,0,0,1-.71,0L4.15,12.35a.48.48,0,0,1,0-.7Z"]
  };
  
  var arrowLargeBackwardOutlined = {
    prefix: 'axis',
    iconName: 'arrowLargeBackwardOutlined',
    icon: [24, 24, [], "f0000", "M10.5,13a.5.5,0,0,0-.5.5v1.88L6.62,12,10,8.62V10.5a.5.5,0,0,0,.5.5H18v2ZM4.15,11.65a.48.48,0,0,0,0,.7l6.79,6.79a.5.5,0,0,0,.71,0l.2-.2a.49.49,0,0,0,.15-.36V15h7.5a.5.5,0,0,0,.5-.5v-5a.5.5,0,0,0-.5-.5H12V5.42a.49.49,0,0,0-.15-.36l-.2-.2a.5.5,0,0,0-.71,0Z"]
  };
  
  var arrowLargeDownward = {
    prefix: 'axis',
    iconName: 'arrowLargeDownward',
    icon: [24, 24, [], "f0000", "M4.86,13.06a.5.5,0,0,1,0-.71l.2-.2A.49.49,0,0,1,5.42,12H9V4.5A.5.5,0,0,1,9.5,4h5a.5.5,0,0,1,.5.5V12h3.58a.49.49,0,0,1,.36.15l.2.2a.5.5,0,0,1,0,.71l-6.79,6.79a.48.48,0,0,1-.7,0Z"]
  };
  
  var arrowLargeDownwardOutlined = {
    prefix: 'axis',
    iconName: 'arrowLargeDownwardOutlined',
    icon: [24, 24, [], "f0000", "M13,13.5a.5.5,0,0,0,.5.5h1.88L12,17.38,8.62,14H10.5a.5.5,0,0,0,.5-.5V6h2Zm-1.35,6.35a.48.48,0,0,0,.7,0l6.79-6.79a.5.5,0,0,0,0-.71l-.2-.2a.49.49,0,0,0-.36-.15H15V4.5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5V12H5.42a.49.49,0,0,0-.36.15l-.2.2a.5.5,0,0,0,0,.71Z"]
  };
  
  var arrowLargeForward = {
    prefix: 'axis',
    iconName: 'arrowLargeForward',
    icon: [24, 24, [], "f0000", "M13.06,19.14a.5.5,0,0,1-.71,0l-.2-.2a.49.49,0,0,1-.15-.36V15H4.5a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,4.5,9H12V5.42a.49.49,0,0,1,.15-.36l.2-.2a.5.5,0,0,1,.71,0l6.79,6.79a.48.48,0,0,1,0,.7Z"]
  };
  
  var arrowLargeForwardOutlined = {
    prefix: 'axis',
    iconName: 'arrowLargeForwardOutlined',
    icon: [24, 24, [], "f0000", "M13.5,11a.5.5,0,0,0,.5-.5V8.62L17.38,12,14,15.38V13.5a.5.5,0,0,0-.5-.5H6V11Zm6.35,1.35a.48.48,0,0,0,0-.7L13.06,4.86a.5.5,0,0,0-.71,0l-.2.2a.49.49,0,0,0-.15.36V9H4.5a.5.5,0,0,0-.5.5v5a.5.5,0,0,0,.5.5H12v3.58a.49.49,0,0,0,.15.36l.2.2a.5.5,0,0,0,.71,0Z"]
  };
  
  var arrowLargeUpward = {
    prefix: 'axis',
    iconName: 'arrowLargeUpward',
    icon: [24, 24, [], "f0000", "M19.14,10.94a.5.5,0,0,1,0,.71l-.2.2a.49.49,0,0,1-.36.15H15v7.5a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5V12H5.42a.49.49,0,0,1-.36-.15l-.2-.2a.5.5,0,0,1,0-.71l6.79-6.79a.48.48,0,0,1,.7,0Z"]
  };
  
  var arrowLargeUpwardOutlined = {
    prefix: 'axis',
    iconName: 'arrowLargeUpwardOutlined',
    icon: [24, 24, [], "f0000", "M11,10.5a.5.5,0,0,0-.5-.5H8.62L12,6.62,15.38,10H13.5a.5.5,0,0,0-.5.5V18H11Zm-6.29.79a.51.51,0,0,0,.15.36l.2.2a.49.49,0,0,0,.36.15H9v7.5a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V12h3.58a.49.49,0,0,0,.36-.15l.2-.2a.51.51,0,0,0,.15-.36.49.49,0,0,0-.15-.35L12.35,4.15a.48.48,0,0,0-.7,0L4.86,10.94a.49.49,0,0,0-.15.35Z"]
  };
  
  var arrowLeftCircle = {
    prefix: 'axis',
    iconName: 'arrowLeftCircle',
    icon: [24, 24, [], "f0000", "M22,12A10,10,0,1,0,12,22,10,10,0,0,0,22,12Zm-9.85,3.36-3-3a.51.51,0,0,1,0-.71l3-3A.5.5,0,0,1,13,9v6A.5.5,0,0,1,12.15,15.36Z"]
  };
  
  var arrowLeftCircleOutlined = {
    prefix: 'axis',
    iconName: 'arrowLeftCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,4a8,8,0,1,1-8,8,8,8,0,0,1,8-8m0-2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,13V9a.5.5,0,0,0-.85-.36l-3,3a.51.51,0,0,0,0,.71l3,3A.5.5,0,0,0,13,15Z"]
  };
  
  var arrowLongDown = {
    prefix: 'axis',
    iconName: 'arrowLongDown',
    icon: [24, 24, [], "f0000", "M12.5,2a.5.5,0,0,1,.5.5V18h2a.5.5,0,0,1,.35.85l-3,3a.51.51,0,0,1-.71,0l-3-3A.5.5,0,0,1,9,18h2V2.5a.5.5,0,0,1,.5-.5Z"]
  };
  
  var arrowLongLeft = {
    prefix: 'axis',
    iconName: 'arrowLongLeft',
    icon: [24, 24, [], "f0000", "M22,11.5v1a.5.5,0,0,1-.5.5H6v2a.5.5,0,0,1-.85.35l-3-3a.51.51,0,0,1,0-.71l3-3A.5.5,0,0,1,6,9v2H21.5A.5.5,0,0,1,22,11.5Z"]
  };
  
  var arrowLongRight = {
    prefix: 'axis',
    iconName: 'arrowLongRight',
    icon: [24, 24, [], "f0000", "M2,12.5v-1a.5.5,0,0,1,.5-.5H18V9a.5.5,0,0,1,.85-.35l3,3a.51.51,0,0,1,0,.71l-3,3A.5.5,0,0,1,18,15V13H2.5A.5.5,0,0,1,2,12.5Z"]
  };
  
  var arrowLongUp = {
    prefix: 'axis',
    iconName: 'arrowLongUp',
    icon: [24, 24, [], "f0000", "M12.5,22h-1a.5.5,0,0,1-.5-.5V6H9a.5.5,0,0,1-.35-.85l3-3a.51.51,0,0,1,.71,0l3,3A.5.5,0,0,1,15,6H13V21.5A.5.5,0,0,1,12.5,22Z"]
  };
  
  var arrowRightCircle = {
    prefix: 'axis',
    iconName: 'arrowRightCircle',
    icon: [24, 24, [], "f0000", "M2,12A10,10,0,1,0,12,2,10,10,0,0,0,2,12Zm9.85-3.36,3,3a.51.51,0,0,1,0,.71l-3,3A.5.5,0,0,1,11,15V9A.5.5,0,0,1,11.85,8.64Z"]
  };
  
  var arrowRightCircleOutlined = {
    prefix: 'axis',
    iconName: 'arrowRightCircleOutlined',
    icon: [24, 24, [], "f0000", "M12,4a8,8,0,1,1-8,8,8,8,0,0,1,8-8m0-2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM11,9v6a.5.5,0,0,0,.85.36l3-3a.51.51,0,0,0,0-.71l-3-3A.5.5,0,0,0,11,9Z"]
  };
  
  var arrowUpward = {
    prefix: 'axis',
    iconName: 'arrowUpward',
    icon: [24, 24, [], "f0000", "M12.5,22h-1a.5.5,0,0,1-.5-.5V5.33L6.56,9.78a.5.5,0,0,1-.71,0l-.7-.71a.5.5,0,0,1,0-.71l6.13-6.14A.75.75,0,0,1,11.81,2h.38a.77.77,0,0,1,.53.22l6.13,6.14a.5.5,0,0,1,0,.71l-.71.71a.49.49,0,0,1-.7,0L13,5.33V21.5A.5.5,0,0,1,12.5,22Z"]
  };
  
  var backUi = {
    prefix: 'axis',
    iconName: 'backUi',
    icon: [24, 24, [], "f0000", "M17.17,20.08a.5.5,0,0,1,0,.71l-1.06,1.06a.48.48,0,0,1-.7,0L6.22,12.66A.75.75,0,0,1,6,12.13v-.26a.75.75,0,0,1,.22-.53l9.19-9.19a.48.48,0,0,1,.7,0l1.06,1.06a.5.5,0,0,1,0,.71L9.09,12Z"]
  };
  
  var arrowDropDown = {
    prefix: 'axis',
    iconName: 'arrowDropDown',
    icon: [24, 24, [], "f0000", "M7.86,11.06a.5.5,0,0,1,0-.71l.2-.2A.49.49,0,0,1,8.42,10h7.16a.49.49,0,0,1,.36.15l.2.2a.5.5,0,0,1,0,.71l-3.79,3.79a.48.48,0,0,1-.7,0Z"]
  };
  
  var arrowLeft = {
    prefix: 'axis',
    iconName: 'arrowLeft',
    icon: [24, 24, [], "f0000", "M12.94,7.86a.5.5,0,0,1,.71,0l.2.2a.49.49,0,0,1,.15.36v7.16a.49.49,0,0,1-.15.36l-.2.2a.5.5,0,0,1-.71,0L9.15,12.35a.48.48,0,0,1,0-.7Z"]
  };
  
  var arrowRight = {
    prefix: 'axis',
    iconName: 'arrowRight',
    icon: [24, 24, [], "f0000", "M11.06,16.14a.5.5,0,0,1-.71,0l-.2-.2a.49.49,0,0,1-.15-.36V8.42a.49.49,0,0,1,.15-.36l.2-.2a.5.5,0,0,1,.71,0l3.79,3.79a.48.48,0,0,1,0,.7Z"]
  };
  
  var arrowDropUp = {
    prefix: 'axis',
    iconName: 'arrowDropUp',
    icon: [24, 24, [], "f0000", "M16.14,12.94a.5.5,0,0,1,0,.71l-.2.2a.49.49,0,0,1-.36.15H8.42a.49.49,0,0,1-.36-.15l-.2-.2a.5.5,0,0,1,0-.71l3.79-3.79a.48.48,0,0,1,.7,0Z"]
  };
  
  var downKey = {
    prefix: 'axis',
    iconName: 'downKey',
    icon: [24, 24, [], "f0000", "M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z"]
  };
  
  var leftKey = {
    prefix: 'axis',
    iconName: 'leftKey',
    icon: [24, 24, [], "f0000", "M8.22,12.72A.75.75,0,0,1,8,12.19v-.38a.77.77,0,0,1,.22-.53l5.14-5.13a.5.5,0,0,1,.71,0l.71.71a.49.49,0,0,1,0,.7L10.33,12l4.45,4.44a.5.5,0,0,1,0,.71l-.71.7a.5.5,0,0,1-.71,0Z"]
  };
  
  var rightKey = {
    prefix: 'axis',
    iconName: 'rightKey',
    icon: [24, 24, [], "f0000", "M15.78,11.28a.75.75,0,0,1,.22.53v.38a.77.77,0,0,1-.22.53l-5.14,5.13a.5.5,0,0,1-.71,0l-.71-.71a.49.49,0,0,1,0-.7L13.67,12,9.22,7.56a.5.5,0,0,1,0-.71l.71-.7a.5.5,0,0,1,.71,0Z"]
  };
  
  var upKey = {
    prefix: 'axis',
    iconName: 'upKey',
    icon: [24, 24, [], "f0000", "M11.28,8.22A.75.75,0,0,1,11.81,8h.38a.77.77,0,0,1,.53.22l5.13,5.14a.5.5,0,0,1,0,.71l-.71.71a.49.49,0,0,1-.7,0L12,10.33,7.56,14.78a.5.5,0,0,1-.71,0l-.7-.71a.5.5,0,0,1,0-.71Z"]
  };
  
  var unfoldLess = {
    prefix: 'axis',
    iconName: 'unfoldLess',
    icon: [24, 24, [], "f0000", "M16.85,18.44a.48.48,0,0,1,0,.7l-.71.71a.5.5,0,0,1-.7,0L12,16.4,8.56,19.85a.5.5,0,0,1-.71,0l-.7-.71a.48.48,0,0,1,0-.7l4.13-4.15a.75.75,0,0,1,.53-.22h.38a.77.77,0,0,1,.53.22ZM11.28,9.78a.77.77,0,0,0,.53.22h.38a.75.75,0,0,0,.53-.22l4.13-4.14a.5.5,0,0,0,0-.71l-.7-.71a.5.5,0,0,0-.71,0L12,7.67,8.56,4.23a.49.49,0,0,0-.7,0l-.71.71a.5.5,0,0,0,0,.71Z"]
  };

  var caretLeft = {
    prefix: 'axis',
    iconName: 'caretLeft',
    icon: [24, 24, [], "f0000", "M12.94,7.86a.5.5,0,0,1,.71,0l.2.2a.49.49,0,0,1,.15.36v7.16a.49.49,0,0,1-.15.36l-.2.2a.5.5,0,0,1-.71,0L9.15,12.35a.48.48,0,0,1,0-.7Z"]
  };

  var caretRight = {
    prefix: 'axis',
    iconName: 'caretRight',
    icon: [24, 24, [], "f0000", "M11.06,16.14a.5.5,0,0,1-.71,0l-.2-.2a.49.49,0,0,1-.15-.36V8.42a.49.49,0,0,1,.15-.36l.2-.2a.5.5,0,0,1,.71,0l3.79,3.79a.48.48,0,0,1,0,.7Z"]
  };

  var chevronLeft = {
    prefix: 'axis',
    iconName: 'chevronLeft',
    icon: [24, 24, [], "f0000", "M8.22,12.72A.75.75,0,0,1,8,12.19v-.38a.77.77,0,0,1,.22-.53l5.14-5.13a.5.5,0,0,1,.71,0l.71.71a.49.49,0,0,1,0,.7L10.33,12l4.45,4.44a.5.5,0,0,1,0,.71l-.71.7a.5.5,0,0,1-.71,0Z"]
  };

  var chevronRight = {
    prefix: 'axis',
    iconName: 'chevronRight',
    icon: [24, 24, [], "f0000", "M15.78,11.28a.75.75,0,0,1,.22.53v.38a.77.77,0,0,1-.22.53l-5.14,5.13a.5.5,0,0,1-.71,0l-.71-.71a.49.49,0,0,1,0-.7L13.67,12,9.22,7.56a.5.5,0,0,1,0-.71l.71-.7a.5.5,0,0,1,.71,0Z"]
  };
  
  var doubleCaretHorizontal = {
    prefix: 'axis',
    iconName: 'doubleCaretHorizontal',
    icon: [24, 24, [], "f0000", "M15.06,16.14a.5.5,0,0,1-.71,0l-.2-.2a.49.49,0,0,1-.15-.36V8.42a.49.49,0,0,1,.15-.36l.2-.2a.5.5,0,0,1,.71,0l3.79,3.79a.48.48,0,0,1,0,.7ZM8.94,7.86a.5.5,0,0,1,.71,0l.2.2a.49.49,0,0,1,.15.36v7.16a.49.49,0,0,1-.15.36l-.2.2a.5.5,0,0,1-.71,0L5.15,12.35a.48.48,0,0,1,0-.7Z"]
  };
  
  var doubleCaretVertical = {
    prefix: 'axis',
    iconName: 'doubleCaretVertical',
    icon: [24, 24, [], "f0000", "M16.14,8.94a.5.5,0,0,1,0,.71l-.2.2a.49.49,0,0,1-.36.15H8.42a.49.49,0,0,1-.36-.15l-.2-.2a.5.5,0,0,1,0-.71l3.79-3.79a.48.48,0,0,1,.7,0ZM7.86,15.06a.5.5,0,0,1,0-.71l.2-.2A.49.49,0,0,1,8.42,14h7.16a.49.49,0,0,1,.36.15l.2.2a.5.5,0,0,1,0,.71l-3.79,3.79a.48.48,0,0,1-.7,0Z"]
  };
  
  var downUi = {
    prefix: 'axis',
    iconName: 'downUi',
    icon: [24, 24, [], "f0000", "M20.08,6.83a.5.5,0,0,1,.71,0l1.06,1.06a.48.48,0,0,1,0,.7l-9.19,9.19a.75.75,0,0,1-.53.22h-.26a.75.75,0,0,1-.53-.22L2.15,8.59a.48.48,0,0,1,0-.7L3.21,6.83a.5.5,0,0,1,.71,0L12,14.91Z"]
  };
  
  var unfoldMore = {
    prefix: 'axis',
    iconName: 'unfoldMore',
    icon: [24, 24, [], "f0000", "M7.15,8.07a.5.5,0,0,1,0-.71l4.13-4.14A.75.75,0,0,1,11.81,3h.38a.77.77,0,0,1,.53.22l4.13,4.14a.5.5,0,0,1,0,.71l-.71.71a.49.49,0,0,1-.7,0L12,5.33,8.56,8.78a.5.5,0,0,1-.71,0Zm9,7.15a.5.5,0,0,0-.71,0L12,18.67,8.56,15.23a.49.49,0,0,0-.7,0l-.71.71a.5.5,0,0,0,0,.71l4.13,4.14a.77.77,0,0,0,.53.22h.38a.75.75,0,0,0,.53-.22l4.13-4.14a.5.5,0,0,0,0-.71Z"]
  };
  
  var nextUi = {
    prefix: 'axis',
    iconName: 'nextUi',
    icon: [24, 24, [], "f0000", "M6.83,3.92a.5.5,0,0,1,0-.71L7.89,2.15a.48.48,0,0,1,.7,0l9.19,9.19a.75.75,0,0,1,.22.53v.26a.75.75,0,0,1-.22.53L8.59,21.85a.48.48,0,0,1-.7,0L6.83,20.79a.5.5,0,0,1,0-.71L14.91,12Z"]
  };
  
  var pullRightLeft = {
    prefix: 'axis',
    iconName: 'pullRightLeft',
    icon: [24, 24, [], "f0000", "M15.93,7.15a.5.5,0,0,1,.71,0l4.14,4.13a.75.75,0,0,1,.22.53v.38a.77.77,0,0,1-.22.53l-4.14,4.13a.5.5,0,0,1-.71,0l-.71-.71a.49.49,0,0,1,0-.7L18.67,12,15.22,8.56a.5.5,0,0,1,0-.71Zm-7.15,9a.5.5,0,0,0,0-.71L5.33,12,8.77,8.56a.49.49,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L3.22,11.28a.77.77,0,0,0-.22.53v.38a.75.75,0,0,0,.22.53l4.14,4.13a.5.5,0,0,0,.71,0Z"]
  };
  
  var subdirectoryLeft = {
    prefix: 'axis',
    iconName: 'subdirectoryLeft',
    icon: [24, 24, [], "f0000", "M20.5,3h-1a.5.5,0,0,0-.5.5V14H6.33l3.44-3.44a.49.49,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L3.22,14.28a.77.77,0,0,0-.22.53v.38a.75.75,0,0,0,.22.53l5.14,5.13a.5.5,0,0,0,.71,0l.71-.7a.5.5,0,0,0,0-.71L6.33,16H19a2,2,0,0,0,2-2V3.5A.5.5,0,0,0,20.5,3ZM5.33,15Z"]
  };
  
  var subdirectoryRight = {
    prefix: 'axis',
    iconName: 'subdirectoryRight',
    icon: [24, 24, [], "f0000", "M3.5,3a.5.5,0,0,0-.5.5V14a2,2,0,0,0,2,2H17.67l-3.45,3.44a.5.5,0,0,0,0,.71l.71.7a.5.5,0,0,0,.71,0l5.14-5.13a.75.75,0,0,0,.22-.53v-.38a.77.77,0,0,0-.22-.53L15.64,9.15a.5.5,0,0,0-.71,0l-.71.71a.49.49,0,0,0,0,.7L17.67,14H5V3.5A.5.5,0,0,0,4.5,3ZM18.67,15Z"]
  };
  
  var upUi = {
    prefix: 'axis',
    iconName: 'upUi',
    icon: [24, 24, [], "f0000", "M3.92,17.17a.5.5,0,0,1-.71,0L2.15,16.11a.48.48,0,0,1,0-.7l9.19-9.19A.75.75,0,0,1,11.87,6h.26a.75.75,0,0,1,.53.22l9.19,9.19a.48.48,0,0,1,0,.7l-1.06,1.06a.5.5,0,0,1-.71,0L12,9.09Z"]
  };
  
  var commentVsOutlined = {
    prefix: 'axis',
    iconName: 'commentVsOutlined',
    icon: [24, 24, [], "f0000", "M20 4C20 2.93913 19.5786 1.92172 18.8284 1.17157C18.0783 0.421427 17.0609 0 16 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4V19.5C0 19.6326 0.0526785 19.7598 0.146447 19.8536C0.240215 19.9473 0.367392 20 0.5 20C0.565397 19.9996 0.630057 19.9862 0.690167 19.9604C0.750277 19.9346 0.804623 19.8971 0.85 19.85L3.85 16.85C4.13434 16.5732 4.47078 16.3555 4.83983 16.2096C5.20889 16.0637 5.60322 15.9924 6 16H16C17.0609 16 18.0783 15.5786 18.8284 14.8284C19.5786 14.0783 20 13.0609 20 12V4ZM16 14H6C5.34295 13.9988 4.69211 14.1272 4.08469 14.3777C3.47728 14.6282 2.92519 14.996 2.46 15.46L2 15.88V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H16C16.5304 2 17.0391 2.21071 17.4142 2.58579C17.7893 2.96086 18 3.46957 18 4V12C18 12.5304 17.7893 13.0391 17.4142 13.4142C17.0391 13.7893 16.5304 14 16 14ZM4.5 11H11.5C11.6326 11 11.7598 10.9473 11.8536 10.8536C11.9473 10.7598 12 10.6326 12 10.5V9.5C12 9.36739 11.9473 9.24021 11.8536 9.14645C11.7598 9.05268 11.6326 9 11.5 9H4.5C4.36739 9 4.24021 9.05268 4.14645 9.14645C4.05268 9.24021 4 9.36739 4 9.5V10.5C4 10.6326 4.05268 10.7598 4.14645 10.8536C4.24021 10.9473 4.36739 11 4.5 11ZM4.5 7H15.5C15.6326 7 15.7598 6.94732 15.8536 6.85355C15.9473 6.75979 16 6.63261 16 6.5V5.5C16 5.36739 15.9473 5.24021 15.8536 5.14645C15.7598 5.05268 15.6326 5 15.5 5H4.5C4.36739 5 4.24021 5.05268 4.14645 5.14645C4.05268 5.24021 4 5.36739 4 5.5V6.5C4 6.63261 4.05268 6.75979 4.14645 6.85355C4.24021 6.94732 4.36739 7 4.5 7Z"]
  };
  
  var foldersLabeled = {
    prefix: 'axis',
    iconName: 'foldersLabeled',
    icon: [24, 24, [], "f0000", "M9.17 5L10.29 6.12C10.8521 6.68277 11.6146 6.9993 12.41 7H17V16H3V5H9.17ZM9.59 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H17C17.5304 18 18.0391 17.7893 18.4142 17.4142C18.7893 17.0391 19 16.5304 19 16V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H12.41C12.1477 4.9989 11.8963 4.89474 11.71 4.71L10.29 3.29C10.1037 3.10526 9.85234 3.0011 9.59 3ZM21 9V18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0391 19.7893 19.5304 20 19 20H5C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H19C20.0609 22 21.0783 21.5786 21.8284 20.8284C22.5786 20.0783 23 19.0609 23 18V11C23 10.4696 22.7893 9.96086 22.4142 9.58579C22.0391 9.21071 21.5304 9 21 9Z"]
  };
  
  var document = {
    prefix: 'axis',
    iconName: 'document',
    icon: [24, 24, [], "f0000", "M18 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H13.17C13.4339 22.0002 13.6953 21.9482 13.939 21.8469C14.1827 21.7457 14.4039 21.5972 14.59 21.41L19.41 16.59C19.5972 16.4039 19.7457 16.1827 19.8469 15.939C19.9482 15.6953 20.0002 15.4339 20 15.17V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM13 20.18V16C13 15.7348 13.1054 15.4804 13.2929 15.2929C13.4804 15.1054 13.7348 15 14 15H18.18L13 20.18Z"]
  };
  
  var documentOutlined = {
    prefix: 'axis',
    iconName: 'documentOutlined',
    icon: [24, 24, [], "f0000", "M18 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H12.76C13.5554 21.9993 14.3179 21.6828 14.88 21.12L19.12 16.88C19.6828 16.3179 19.9993 15.5554 20 14.76V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM6 4H18V14H13C12.7348 14 12.4804 14.1054 12.2929 14.2929C12.1054 14.4804 12 14.7348 12 15V20H6V4Z"]
  };
  
  var documentText = {
    prefix: 'axis',
    iconName: 'documentText',
    icon: [24, 24, [], "f0000", "M18 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H13.17C13.4339 22.0002 13.6953 21.9482 13.939 21.8469C14.1827 21.7457 14.4039 21.5972 14.59 21.41L19.41 16.59C19.5972 16.4039 19.7457 16.1827 19.8469 15.939C19.9482 15.6953 20.0002 15.4339 20 15.17V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM7 6.5C7 6.36739 7.05268 6.24021 7.14645 6.14645C7.24021 6.05268 7.36739 6 7.5 6H16.5C16.6326 6 16.7598 6.05268 16.8536 6.14645C16.9473 6.24021 17 6.36739 17 6.5V7.5C17 7.63261 16.9473 7.75979 16.8536 7.85355C16.7598 7.94732 16.6326 8 16.5 8H7.5C7.36739 8 7.24021 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5V6.5ZM12.5 12H7.5C7.36739 12 7.24021 11.9473 7.14645 11.8536C7.05268 11.7598 7 11.6326 7 11.5V10.5C7 10.3674 7.05268 10.2402 7.14645 10.1464C7.24021 10.0527 7.36739 10 7.5 10H12.5C12.6326 10 12.7598 10.0527 12.8536 10.1464C12.9473 10.2402 13 10.3674 13 10.5V11.5C13 11.6326 12.9473 11.7598 12.8536 11.8536C12.7598 11.9473 12.6326 12 12.5 12ZM13 20.18V16C13 15.7348 13.1054 15.4804 13.2929 15.2929C13.4804 15.1054 13.7348 15 14 15H18.18L13 20.18Z"]
  };
  
  var documentTextOutlined = {
    prefix: 'axis',
    iconName: 'documentTextOutlined',
    icon: [24, 24, [], "f0000", "M18 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H12.76C13.5554 21.9993 14.3179 21.6828 14.88 21.12L19.12 16.88C19.6828 16.3179 19.9993 15.5554 20 14.76V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM18 14H13C12.7348 14 12.4804 14.1054 12.2929 14.2929C12.1054 14.4804 12 14.7348 12 15V20H6V4H18V14ZM8.5 8H15.5C15.6326 8 15.7598 7.94732 15.8536 7.85355C15.9473 7.75979 16 7.63261 16 7.5V6.5C16 6.36739 15.9473 6.24021 15.8536 6.14645C15.7598 6.05268 15.6326 6 15.5 6H8.5C8.36739 6 8.24021 6.05268 8.14645 6.14645C8.05268 6.24021 8 6.36739 8 6.5V7.5C8 7.63261 8.05268 7.75979 8.14645 7.85355C8.24021 7.94732 8.36739 8 8.5 8ZM8.5 12H12.5C12.6326 12 12.7598 11.9473 12.8536 11.8536C12.9473 11.7598 13 11.6326 13 11.5V10.5C13 10.3674 12.9473 10.2402 12.8536 10.1464C12.7598 10.0527 12.6326 10 12.5 10H8.5C8.36739 10 8.24021 10.0527 8.14645 10.1464C8.05268 10.2402 8 10.3674 8 10.5V11.5C8 11.6326 8.05268 11.7598 8.14645 11.8536C8.24021 11.9473 8.36739 12 8.5 12Z"]
  };
  
  var documents = {
    prefix: 'axis',
    iconName: 'documents',
    icon: [24, 24, [], "f0000", "M11.59 18.41L16.41 13.59C16.5972 13.4039 16.7457 13.1827 16.8469 12.939C16.9482 12.6953 17.0002 12.4339 17 12.17V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H4C3.46957 1 2.96086 1.21071 2.58579 1.58579C2.21071 1.96086 2 2.46957 2 3V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H10.17C10.4339 19.0002 10.6953 18.9482 10.939 18.8469C11.1827 18.7457 11.4039 18.5972 11.59 18.41ZM10 13C10 12.7348 10.1054 12.4804 10.2929 12.2929C10.4804 12.1054 10.7348 12 11 12H15.18L10 17.18V13ZM19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H6C6 21.5304 6.21071 22.0391 6.58579 22.4142C6.96086 22.7893 7.46957 23 8 23H17C18.0609 23 19.0783 22.5786 19.8284 21.8284C20.5786 21.0783 21 20.0609 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5Z"]
  };
  
  var documentsOutlined = {
    prefix: 'axis',
    iconName: 'documentsOutlined',
    icon: [24, 24, [], "f0000", "M11.88 18.12L16.12 13.88C16.6828 13.3179 16.9993 12.5554 17 11.76V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H4C3.46957 1 2.96086 1.21071 2.58579 1.58579C2.21071 1.96086 2 2.46957 2 3V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H9.76C10.5554 18.9993 11.3179 18.6828 11.88 18.12ZM9 12V17H4V3H15V11H10C9.73478 11 9.48043 11.1054 9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12ZM19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H6C6 21.5304 6.21071 22.0391 6.58579 22.4142C6.96086 22.7893 7.46957 23 8 23H17C18.0609 23 19.0783 22.5786 19.8284 21.8284C20.5786 21.0783 21 20.0609 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5Z"]
  };
  
  var file = {
    prefix: 'axis',
    iconName: 'file',
    icon: [24, 24, [], "f0000", "M6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2H10.83C10.5661 1.99979 10.3047 2.05182 10.061 2.15308C9.81732 2.25434 9.59606 2.40283 9.41 2.59L4.59 7.41C4.40283 7.59606 4.25434 7.81732 4.15308 8.06103C4.05182 8.30475 3.99979 8.56609 4 8.83V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22ZM11 3.82V8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9H5.82L11 3.82Z"]
  };
  
  var fileAdd = {
    prefix: 'axis',
    iconName: 'fileAdd',
    icon: [24, 24, [], "f0000", "M18 2H10.83C10.5661 1.99979 10.3047 2.05182 10.061 2.15308C9.81732 2.25434 9.59606 2.40283 9.41 2.59L4.59 7.41C4.40283 7.59606 4.25434 7.81732 4.15308 8.06103C4.05182 8.30475 3.99979 8.56609 4 8.83V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM5.82 9L11 3.82V8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9H5.82ZM14.5 15.88H12.88V17.5C12.88 17.6326 12.8273 17.7598 12.7336 17.8536C12.6398 17.9473 12.5126 18 12.38 18H11.62C11.4874 18 11.3602 17.9473 11.2664 17.8536C11.1727 17.7598 11.12 17.6326 11.12 17.5V15.88H9.5C9.36739 15.88 9.24021 15.8273 9.14645 15.7336C9.05268 15.6398 9 15.5126 9 15.38V14.62C9 14.4874 9.05268 14.3602 9.14645 14.2664C9.24021 14.1727 9.36739 14.12 9.5 14.12H11.12V12.5C11.12 12.3674 11.1727 12.2402 11.2664 12.1464C11.3602 12.0527 11.4874 12 11.62 12H12.38C12.5126 12 12.6398 12.0527 12.7336 12.1464C12.8273 12.2402 12.88 12.3674 12.88 12.5V14.12H14.5C14.6326 14.12 14.7598 14.1727 14.8536 14.2664C14.9473 14.3602 15 14.4874 15 14.62V15.38C15 15.5126 14.9473 15.6398 14.8536 15.7336C14.7598 15.8273 14.6326 15.88 14.5 15.88Z"]
  };
  
  var fileAddOutlined = {
    prefix: 'axis',
    iconName: 'fileAddOutlined',
    icon: [24, 24, [], "f0000", "M18 2H11.24C10.4446 2.0007 9.68207 2.31723 9.12 2.88L4.88 7.12C4.31723 7.68207 4.0007 8.44462 4 9.24V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM18 20H6V10H11C11.2652 10 11.5196 9.89464 11.7071 9.70711C11.8946 9.51957 12 9.26522 12 9V4H18V20ZM15 15.38V14.62C15 14.4874 14.9473 14.3602 14.8536 14.2664C14.7598 14.1727 14.6326 14.12 14.5 14.12H12.88V12.5C12.88 12.3674 12.8273 12.2402 12.7336 12.1464C12.6398 12.0527 12.5126 12 12.38 12H11.62C11.4874 12 11.3602 12.0527 11.2664 12.1464C11.1727 12.2402 11.12 12.3674 11.12 12.5V14.12H9.5C9.36739 14.12 9.24021 14.1727 9.14645 14.2664C9.05268 14.3602 9 14.4874 9 14.62V15.38C9 15.5126 9.05268 15.6398 9.14645 15.7336C9.24021 15.8273 9.36739 15.88 9.5 15.88H11.12V17.5C11.12 17.6326 11.1727 17.7598 11.2664 17.8536C11.3602 17.9473 11.4874 18 11.62 18H12.38C12.5126 18 12.6398 17.9473 12.7336 17.8536C12.8273 17.7598 12.88 17.6326 12.88 17.5V15.88H14.5C14.6326 15.88 14.7598 15.8273 14.8536 15.7336C14.9473 15.6398 15 15.5126 15 15.38Z"]
  };
  
  var fileOutlined = {
    prefix: 'axis',
    iconName: 'fileOutlined',
    icon: [24, 24, [], "f0000", "M6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2H11.24C10.4446 2.0007 9.68207 2.31723 9.12 2.88L4.88 7.12C4.31723 7.68207 4.0007 8.44462 4 9.24V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22ZM18 20H6V10H11C11.2652 10 11.5196 9.89464 11.7071 9.70711C11.8946 9.51957 12 9.26522 12 9V4H18V20Z"]
  };
  
  var fileText = {
    prefix: 'axis',
    iconName: 'fileText',
    icon: [24, 24, [], "f0000", "M4 20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2H10.83C10.5661 1.99979 10.3047 2.05182 10.061 2.15308C9.81732 2.25434 9.59606 2.40283 9.41 2.59L4.59 7.41C4.40283 7.59606 4.25434 7.81732 4.15308 8.06103C4.05182 8.30475 3.99979 8.56609 4 8.83V20ZM13 17.5C13 17.6326 12.9473 17.7598 12.8536 17.8536C12.7598 17.9473 12.6326 18 12.5 18H7.5C7.36739 18 7.24022 17.9473 7.14645 17.8536C7.05268 17.7598 7 17.6326 7 17.5V16.5C7 16.3674 7.05268 16.2402 7.14645 16.1464C7.24022 16.0527 7.36739 16 7.5 16H12.5C12.6326 16 12.7598 16.0527 12.8536 16.1464C12.9473 16.2402 13 16.3674 13 16.5V17.5ZM17 13.5C17 13.6326 16.9473 13.7598 16.8536 13.8536C16.7598 13.9473 16.6326 14 16.5 14H7.5C7.36739 14 7.24022 13.9473 7.14645 13.8536C7.05268 13.7598 7 13.6326 7 13.5V12.5C7 12.3674 7.05268 12.2402 7.14645 12.1464C7.24022 12.0527 7.36739 12 7.5 12H16.5C16.6326 12 16.7598 12.0527 16.8536 12.1464C16.9473 12.2402 17 12.3674 17 12.5V13.5ZM5.82 9L11 3.82V8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9H5.82Z"]
  };
  
  var fileTextOutlined = {
    prefix: 'axis',
    iconName: 'fileTextOutlined',
    icon: [24, 24, [], "f0000", "M18 2H11.24C10.4446 2.0007 9.68207 2.31723 9.12 2.88L4.88 7.12C4.31723 7.68207 4.0007 8.44462 4 9.24V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM18 20H6V10H11C11.2652 10 11.5196 9.89464 11.7071 9.70711C11.8946 9.51957 12 9.26522 12 9V4H18V20ZM8 12.5V13.5C8 13.6326 8.05268 13.7598 8.14645 13.8536C8.24021 13.9473 8.36739 14 8.5 14H15.5C15.6326 14 15.7598 13.9473 15.8536 13.8536C15.9473 13.7598 16 13.6326 16 13.5V12.5C16 12.3674 15.9473 12.2402 15.8536 12.1464C15.7598 12.0527 15.6326 12 15.5 12H8.5C8.36739 12 8.24021 12.0527 8.14645 12.1464C8.05268 12.2402 8 12.3674 8 12.5ZM12.5 16H8.5C8.36739 16 8.24021 16.0527 8.14645 16.1464C8.05268 16.2402 8 16.3674 8 16.5V17.5C8 17.6326 8.05268 17.7598 8.14645 17.8536C8.24021 17.9473 8.36739 18 8.5 18H12.5C12.6326 18 12.7598 17.9473 12.8536 17.8536C12.9473 17.7598 13 17.6326 13 17.5V16.5C13 16.3674 12.9473 16.2402 12.8536 16.1464C12.7598 16.0527 12.6326 16 12.5 16Z"]
  };
  
  var files = {
    prefix: 'axis',
    iconName: 'files',
    icon: [24, 24, [], "f0000", "M17 17V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H8.83C8.56609 0.999792 8.30475 1.05182 8.06103 1.15308C7.81732 1.25434 7.59606 1.40283 7.41 1.59L2.59 6.41C2.40283 6.59606 2.25434 6.81732 2.15308 7.06103C2.05182 7.30474 1.99979 7.56609 2 7.83V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H15C15.5304 19 16.0391 18.7893 16.4142 18.4142C16.7893 18.0391 17 17.5304 17 17ZM9 7C9 7.26522 8.89464 7.51957 8.70711 7.70711C8.51957 7.89464 8.26522 8 8 8H3.82L9 2.82V7ZM19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H6C6 21.5304 6.21071 22.0391 6.58579 22.4142C6.96086 22.7893 7.46957 23 8 23H17C18.0609 23 19.0783 22.5786 19.8284 21.8284C20.5786 21.0783 21 20.0609 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5Z"]
  };
  
  var fileLabeled = {
    prefix: 'axis',
    iconName: 'fileLabeled',
    icon: [24, 24, [], "f0000", "M15 1H8.83C8.56609 0.999792 8.30475 1.05182 8.06103 1.15308C7.81732 1.25434 7.59606 1.40283 7.41 1.59L2.59 6.41C2.40283 6.59606 2.25434 6.81732 2.15308 7.06103C2.05182 7.30474 1.99979 7.56609 2 7.83V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H15C15.5304 19 16.0391 18.7893 16.4142 18.4142C16.7893 18.0391 17 17.5304 17 17V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1ZM3.82 8L9 2.82V7C9 7.26522 8.89464 7.51957 8.70711 7.70711C8.51957 7.89464 8.26522 8 8 8H3.82ZM14 13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H5.5C5.36739 14 5.24022 13.9473 5.14645 13.8536C5.05268 13.7598 5 13.6326 5 13.5V12.5C5 12.3674 5.05268 12.2402 5.14645 12.1464C5.24022 12.0527 5.36739 12 5.5 12H13.5C13.6326 12 13.7598 12.0527 13.8536 12.1464C13.9473 12.2402 14 12.3674 14 12.5V13.5ZM19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H6C6 21.5304 6.21071 22.0391 6.58579 22.4142C6.96086 22.7893 7.46957 23 8 23H17C18.0609 23 19.0783 22.5786 19.8284 21.8284C20.5786 21.0783 21 20.0609 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5Z"]
  };
  
  var fileLabeledOutlined = {
    prefix: 'axis',
    iconName: 'fileLabeledOutlined',
    icon: [24, 24, [], "f0000", "M17 17V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H9.24C8.44462 1.0007 7.68207 1.31723 7.12 1.88L2.88 6.12C2.31723 6.68207 2.0007 7.44462 2 8.24V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H15C15.5304 19 16.0391 18.7893 16.4142 18.4142C16.7893 18.0391 17 17.5304 17 17ZM4 9H9C9.26522 9 9.51957 8.89464 9.70711 8.70711C9.89464 8.51957 10 8.26522 10 8V3H15V17H4V9ZM12.5 12H6.5C6.36739 12 6.24021 12.0527 6.14645 12.1464C6.05268 12.2402 6 12.3674 6 12.5V13.5C6 13.6326 6.05268 13.7598 6.14645 13.8536C6.24021 13.9473 6.36739 14 6.5 14H12.5C12.6326 14 12.7598 13.9473 12.8536 13.8536C12.9473 13.7598 13 13.6326 13 13.5V12.5C13 12.3674 12.9473 12.2402 12.8536 12.1464C12.7598 12.0527 12.6326 12 12.5 12ZM19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H6C6 21.5304 6.21071 22.0391 6.58579 22.4142C6.96086 22.7893 7.46957 23 8 23H17C18.0609 23 19.0783 22.5786 19.8284 21.8284C20.5786 21.0783 21 20.0609 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5Z"]
  };
  
  var filesOutlined = {
    prefix: 'axis',
    iconName: 'filesOutlined',
    icon: [24, 24, [], "f0000", "M17 17V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H9.24C8.44462 1.0007 7.68207 1.31723 7.12 1.88L2.88 6.12C2.31723 6.68207 2.0007 7.44462 2 8.24V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H15C15.5304 19 16.0391 18.7893 16.4142 18.4142C16.7893 18.0391 17 17.5304 17 17ZM4 9H9C9.26522 9 9.51957 8.89464 9.70711 8.70711C9.89464 8.51957 10 8.26522 10 8V3H15V17H4V9ZM19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H6C6 21.5304 6.21071 22.0391 6.58579 22.4142C6.96086 22.7893 7.46957 23 8 23H17C18.0609 23 19.0783 22.5786 19.8284 21.8284C20.5786 21.0783 21 20.0609 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5Z"]
  };
  
  var folder = {
    prefix: 'axis',
    iconName: 'folder',
    icon: [24, 24, [], "f0000", "M20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6Z"]
  };
  
  var folderAdd = {
    prefix: 'axis',
    iconName: 'folderAdd',
    icon: [24, 24, [], "f0000", "M20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6ZM13 13.5C13 13.6326 12.9473 13.7598 12.8536 13.8536C12.7598 13.9473 12.6326 14 12.5 14H10V16.5C10 16.6326 9.94732 16.7598 9.85355 16.8536C9.75979 16.9473 9.63261 17 9.5 17H8.5C8.36739 17 8.24021 16.9473 8.14645 16.8536C8.05268 16.7598 8 16.6326 8 16.5V14H5.5C5.36739 14 5.24021 13.9473 5.14645 13.8536C5.05268 13.7598 5 13.6326 5 13.5V12.5C5 12.3674 5.05268 12.2402 5.14645 12.1464C5.24021 12.0527 5.36739 12 5.5 12H8V9.5C8 9.36739 8.05268 9.24021 8.14645 9.14645C8.24021 9.05268 8.36739 9 8.5 9H9.5C9.63261 9 9.75979 9.05268 9.85355 9.14645C9.94732 9.24021 10 9.36739 10 9.5V12H12.5C12.6326 12 12.7598 12.0527 12.8536 12.1464C12.9473 12.2402 13 12.3674 13 12.5V13.5Z"]
  };
  
  var fileBookmarked = {
    prefix: 'axis',
    iconName: 'fileBookmarked',
    icon: [24, 24, [], "f0000", "M20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6ZM11 14.5C11.0011 14.5913 10.9771 14.6811 10.9308 14.7597C10.8844 14.8383 10.8174 14.9027 10.7371 14.946C10.6567 14.9893 10.5661 15.0097 10.4749 15.0051C10.3838 15.0006 10.2956 14.9711 10.22 14.92L8.28 13.62C8.19638 13.5666 8.09923 13.5382 8 13.5382C7.90077 13.5382 7.80361 13.5666 7.72 13.62L5.78 14.92C5.70439 14.9711 5.61624 15.0006 5.52509 15.0051C5.43394 15.0097 5.34327 14.9893 5.26292 14.946C5.18256 14.9027 5.11558 14.8383 5.06923 14.7597C5.02289 14.6811 4.99895 14.5913 5 14.5V7.5C5 7.36739 5.05268 7.24021 5.14645 7.14645C5.24021 7.05268 5.36739 7 5.5 7H10.5C10.6326 7 10.7598 7.05268 10.8536 7.14645C10.9473 7.24021 11 7.36739 11 7.5V14.5Z"]
  };
  
  var folderLabeled = {
    prefix: 'axis',
    iconName: 'folderLabeled',
    icon: [24, 24, [], "f0000", "M20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6ZM11 16.5C11 16.6326 10.9473 16.7598 10.8536 16.8536C10.7598 16.9473 10.6326 17 10.5 17H5.5C5.36739 17 5.24021 16.9473 5.14645 16.8536C5.05268 16.7598 5 16.6326 5 16.5V15.5C5 15.3674 5.05268 15.2402 5.14645 15.1464C5.24021 15.0527 5.36739 15 5.5 15H10.5C10.6326 15 10.7598 15.0527 10.8536 15.1464C10.9473 15.2402 11 15.3674 11 15.5V16.5ZM13 12.5C13 12.6326 12.9473 12.7598 12.8536 12.8536C12.7598 12.9473 12.6326 13 12.5 13H5.5C5.36739 13 5.24021 12.9473 5.14645 12.8536C5.05268 12.7598 5 12.6326 5 12.5V11.5C5 11.3674 5.05268 11.2402 5.14645 11.1464C5.24021 11.0527 5.36739 11 5.5 11H12.5C12.6326 11 12.7598 11.0527 12.8536 11.1464C12.9473 11.2402 13 11.3674 13 11.5V12.5Z"]
  };
  
  var folderLabeledOutlined = {
    prefix: 'axis',
    iconName: 'folderLabeledOutlined',
    icon: [24, 24, [], "f0000", "M20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6ZM20 18H4V6H11.17L12.3 7.12C12.8596 7.68033 13.6181 7.99666 14.41 8H20V18ZM12 14.5V15.5C12 15.6326 11.9473 15.7598 11.8536 15.8536C11.7598 15.9473 11.6326 16 11.5 16H6.5C6.36739 16 6.24021 15.9473 6.14645 15.8536C6.05268 15.7598 6 15.6326 6 15.5V14.5C6 14.3674 6.05268 14.2402 6.14645 14.1464C6.24021 14.0527 6.36739 14 6.5 14H11.5C11.6326 14 11.7598 14.0527 11.8536 14.1464C11.9473 14.2402 12 14.3674 12 14.5ZM14 10.5V11.5C14 11.6326 13.9473 11.7598 13.8536 11.8536C13.7598 11.9473 13.6326 12 13.5 12H6.5C6.36739 12 6.24021 11.9473 6.14645 11.8536C6.05268 11.7598 6 11.6326 6 11.5V10.5C6 10.3674 6.05268 10.2402 6.14645 10.1464C6.24021 10.0527 6.36739 10 6.5 10H13.5C13.6326 10 13.7598 10.0527 13.8536 10.1464C13.9473 10.2402 14 10.3674 14 10.5Z"]
  };
  
  var folderOpened = {
    prefix: 'axis',
    iconName: 'folderOpened',
    icon: [24, 24, [], "f0000", "M20 8V18H4V8H20ZM11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4Z"]
  };
  
  var folderOpenedLabeled = {
    prefix: 'axis',
    iconName: 'folderOpenedLabeled',
    icon: [24, 24, [], "f0000", "M22 8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8ZM20 18H4V8H20V18ZM6.5 16H11.5C11.6326 16 11.7598 15.9473 11.8536 15.8536C11.9473 15.7598 12 15.6326 12 15.5V14.5C12 14.3674 11.9473 14.2402 11.8536 14.1464C11.7598 14.0527 11.6326 14 11.5 14H6.5C6.36739 14 6.24021 14.0527 6.14645 14.1464C6.05268 14.2402 6 14.3674 6 14.5V15.5C6 15.6326 6.05268 15.7598 6.14645 15.8536C6.24021 15.9473 6.36739 16 6.5 16ZM6.5 12H13.5C13.6326 12 13.7598 11.9473 13.8536 11.8536C13.9473 11.7598 14 11.6326 14 11.5V10.5C14 10.3674 13.9473 10.2402 13.8536 10.1464C13.7598 10.0527 13.6326 10 13.5 10H6.5C6.36739 10 6.24021 10.0527 6.14645 10.1464C6.05268 10.2402 6 10.3674 6 10.5V11.5C6 11.6326 6.05268 11.7598 6.14645 11.8536C6.24021 11.9473 6.36739 12 6.5 12Z"]
  };
  
  var folderOutlined = {
    prefix: 'axis',
    iconName: 'folderOutlined',
    icon: [24, 24, [], "f0000", "M11.17 6L12.3 7.12C12.8596 7.68033 13.6181 7.99666 14.41 8H20V18H4V6H11.17ZM11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4Z"]
  };
  
  var folderPhoto = {
    prefix: 'axis',
    iconName: 'folderPhoto',
    icon: [24, 24, [], "f0000", "M20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6ZM9.5 7C9.79667 7 10.0867 7.08797 10.3334 7.2528C10.58 7.41762 10.7723 7.65189 10.8858 7.92597C10.9994 8.20006 11.0291 8.50166 10.9712 8.79264C10.9133 9.08361 10.7704 9.35088 10.5607 9.56066C10.3509 9.77044 10.0836 9.9133 9.79264 9.97118C9.50166 10.0291 9.20006 9.99935 8.92597 9.88582C8.65189 9.77229 8.41762 9.58003 8.2528 9.33335C8.08797 9.08668 8 8.79667 8 8.5C8 8.10218 8.15804 7.72064 8.43934 7.43934C8.72064 7.15804 9.10218 7 9.5 7ZM19 16.5C19 16.6326 18.9473 16.7598 18.8536 16.8536C18.7598 16.9473 18.6326 17 18.5 17H5.5C5.36739 17 5.24021 16.9473 5.14645 16.8536C5.05268 16.7598 5 16.6326 5 16.5V16.16C4.99964 16.0501 5.03866 15.9436 5.11 15.86L8 12.19C8.04299 12.1369 8.09603 12.0928 8.15609 12.0602C8.21615 12.0276 8.28204 12.0071 8.35 12C8.4243 11.9991 8.49785 12.0149 8.56531 12.046C8.63278 12.0771 8.69245 12.1229 8.74 12.18L10.19 13.93C10.236 13.9863 10.294 14.0317 10.3597 14.0628C10.4254 14.094 10.4973 14.1101 10.57 14.11C10.6475 14.1092 10.7238 14.0908 10.7931 14.0562C10.8624 14.0215 10.9229 13.9715 10.97 13.91L13.85 10.19C13.8977 10.1296 13.9585 10.0809 14.0278 10.0473C14.0971 10.0138 14.173 9.99639 14.25 9.99639C14.327 9.99639 14.4029 10.0138 14.4722 10.0473C14.5415 10.0809 14.6023 10.1296 14.65 10.19L18.9 15.86C18.9643 15.9469 18.9993 16.0519 19 16.16V16.5Z"]
  };
  
  var folderShared = {
    prefix: 'axis',
    iconName: 'folderShared',
    icon: [24, 24, [], "f0000", "M20 6H14.83C14.5661 6.00021 14.3047 5.94818 14.061 5.84692C13.8173 5.74566 13.5961 5.59717 13.41 5.41L12.59 4.59C12.4039 4.40283 12.1827 4.25434 11.939 4.15308C11.6953 4.05182 11.4339 3.99979 11.17 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6ZM9 9C9.39556 9 9.78224 9.1173 10.1111 9.33706C10.44 9.55682 10.6964 9.86918 10.8478 10.2346C10.9991 10.6001 11.0387 11.0022 10.9616 11.3902C10.8844 11.7781 10.6939 12.1345 10.4142 12.4142C10.1345 12.6939 9.77814 12.8844 9.39018 12.9616C9.00222 13.0387 8.60009 12.9991 8.23463 12.8478C7.86918 12.6964 7.55682 12.44 7.33706 12.1111C7.1173 11.7822 7 11.3956 7 11C7 10.4696 7.21071 9.96086 7.58579 9.58579C7.96086 9.21071 8.46957 9 9 9ZM12.5 17H5.5C5.41503 17.0002 5.33141 16.9787 5.25705 16.9376C5.18269 16.8964 5.12003 16.8371 5.075 16.765C5.02996 16.6929 5.00404 16.6106 4.99966 16.5257C4.99529 16.4409 5.01261 16.3563 5.05 16.28L5.78 14.83C5.90434 14.5809 6.09554 14.3714 6.33219 14.2248C6.56885 14.0782 6.84162 14.0004 7.12 14H10.88C11.1584 14.0004 11.4312 14.0782 11.6678 14.2248C11.9045 14.3714 12.0957 14.5809 12.22 14.83L13 16.28C13.0399 16.3602 13.0575 16.4497 13.051 16.539C13.0445 16.6284 13.0141 16.7144 12.963 16.7879C12.9119 16.8615 12.842 16.92 12.7605 16.9573C12.6791 16.9947 12.5891 17.0094 12.5 17Z"]
  };
  
  var folderSpecial = {
    prefix: 'axis',
    iconName: 'folderSpecial',
    icon: [24, 24, [], "f0000", "M20 6H14.41C14.1477 5.9989 13.8963 5.89474 13.71 5.71L12.29 4.29C12.1037 4.10526 11.8523 4.0011 11.59 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8C22 7.46957 21.7893 6.96086 21.4142 6.58579C21.0391 6.21071 20.5304 6 20 6ZM13.91 12.14L11.91 13.84L12.52 16.38C12.5436 16.4756 12.5384 16.5761 12.5051 16.6687C12.4718 16.7614 12.4118 16.8422 12.3328 16.9009C12.2537 16.9597 12.1591 16.9938 12.0608 16.9989C11.9624 17.0041 11.8648 16.9801 11.78 16.93L9.54 15.56L7.3 16.93C7.21451 16.9784 7.11687 17.001 7.01881 16.9953C6.92075 16.9895 6.82645 16.9555 6.74724 16.8974C6.66803 16.8393 6.60728 16.7596 6.57229 16.6678C6.5373 16.576 6.52956 16.4761 6.55 16.38L7.16 13.84L5.16 12.14C5.08455 12.0762 5.02969 11.9915 5.00234 11.8966C4.97499 11.8016 4.97638 11.7007 5.00634 11.6066C5.0363 11.5124 5.09347 11.4293 5.17066 11.3676C5.24784 11.3059 5.34156 11.2685 5.44 11.26L8.05 11.06L9.05 8.63C9.08842 8.53981 9.15251 8.4629 9.2343 8.40884C9.31609 8.35478 9.41196 8.32596 9.51 8.32596C9.60804 8.32596 9.70391 8.35478 9.7857 8.40884C9.86749 8.4629 9.93158 8.53981 9.97 8.63L10.97 11.06L13.57 11.26C13.6735 11.2568 13.7754 11.2859 13.8617 11.3431C13.948 11.4004 14.0144 11.483 14.0517 11.5796C14.089 11.6762 14.0954 11.7819 14.0701 11.8823C14.0447 11.9827 13.9887 12.0728 13.91 12.14Z"]
  };
  
  var folders = {
    prefix: 'axis',
    iconName: 'folders',
    icon: [24, 24, [], "f0000", "M17 18C17.5304 18 18.0391 17.7893 18.4142 17.4142C18.7893 17.0391 19 16.5304 19 16V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H12.41C12.1477 4.9989 11.8963 4.89474 11.71 4.71L10.29 3.29C10.1037 3.10526 9.85234 3.0011 9.59 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H17ZM21 9V18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0391 19.7893 19.5304 20 19 20H5C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H19C20.0609 22 21.0783 21.5786 21.8284 20.8284C22.5786 20.0783 23 19.0609 23 18V11C23 10.4696 22.7893 9.96086 22.4142 9.58579C22.0391 9.21071 21.5304 9 21 9Z"]
  };
  
  var pdf = {
    prefix: 'axis',
    iconName: 'pdf',
    icon: [24, 24, [], "f0000", "M4.80002 1.875C4.47006 1.875 4.125 2.16705 4.125 2.625V21.375C4.125 21.8329 4.47006 22.125 4.80002 22.125H19.2C19.5299 22.125 19.875 21.8329 19.875 21.375V6.75H15.6562C15.2938 6.75 15 6.45621 15 6.09375V1.875H4.80002ZM4.80002 0.75C3.80589 0.75 3 1.58945 3 2.625V21.375C3 22.4106 3.80589 23.25 4.80002 23.25H19.2C20.1941 23.25 21 22.4106 21 21.375V6.44238C21 6.24875 20.9251 6.06262 20.791 5.923L16.0464 0.980621C15.905 0.833313 15.7096 0.75 15.5054 0.75H4.80002ZM13.4621 14.2727C14.3405 14.2531 16.034 14.3291 16.4229 15.1042C16.4986 15.2552 16.5862 15.5657 16.3221 15.9497C16.1389 16.216 15.882 16.3753 15.5793 16.4104C15.0512 16.4715 14.438 16.1249 14.0598 15.7854C14.0109 15.7426 13.6529 15.4268 13.1823 14.9604C12.3284 15.0031 11.4069 15.1499 10.5961 15.3949C10.3889 15.7876 10.1781 16.1537 9.97202 16.4751C9.68037 16.93 9.40498 17.2873 9.15358 17.537C8.45457 18.2312 7.87065 18.079 7.60464 17.5145C7.44228 17.1698 7.47015 16.7733 7.67926 16.4536C8.21068 15.6412 9.22243 15.1383 10.1135 14.837C10.4871 14.1026 10.842 13.2884 11.1211 12.5143C10.8992 12.1637 10.723 11.8181 10.6236 11.4969C10.2277 10.2183 10.5935 9.28546 11.1388 9.05695C11.4511 8.92603 11.9009 8.9913 12.2267 9.56754C12.4858 10.0258 12.3691 10.9866 11.8798 12.425C12.3339 13.0768 12.9433 13.7461 13.4621 14.2727ZM8.28891 17.3221C8.33492 17.3154 8.68428 17.2247 9.41309 16.0782C9.47507 15.9807 9.53751 15.8789 9.60013 15.7735C8.97679 16.0697 8.51445 16.4274 8.25714 16.8207C8.17776 16.942 8.16673 17.0985 8.22826 17.2291C8.25655 17.2891 8.27966 17.3139 8.28891 17.3221ZM11.4172 9.67868C11.4137 9.67868 11.4106 9.67923 11.4079 9.68042C11.2497 9.7467 10.9797 10.3256 11.2812 11.2992C11.3143 11.4063 11.358 11.5172 11.4108 11.6312C11.7255 10.5502 11.7052 10.0374 11.6261 9.89731C11.5417 9.74808 11.4558 9.67868 11.4172 9.67868ZM11.5992 13.1938C11.418 13.6594 11.2146 14.1307 11 14.5852C11.5035 14.467 12.0372 14.3798 12.5676 14.3275C12.2421 13.9782 11.904 13.5908 11.5992 13.1938ZM15.4996 15.7374C15.5695 15.7291 15.6613 15.7027 15.7529 15.5695C15.789 15.5172 15.8275 15.4461 15.8066 15.4045C15.7332 15.2584 15.2421 15.0197 14.1892 14.9608L14.1668 14.9595C14.378 15.1572 14.5122 15.2753 14.5182 15.2805L14.522 15.2838C14.6673 15.4139 15.1601 15.7776 15.4996 15.7374Z"]
  };
  
  var clap = {
    prefix: 'axis',
    iconName: 'clap',
    icon: [24, 24, [], "f0000", "M3.5,14.24v4.1a1.62,1.62,0,0,0,0,.22l-.63-.62A3.29,3.29,0,0,1,2,15.51v-4.1c0-1.9,1.37-3.2,1.73-5.24h0l.45-2.59a.5.5,0,0,1,.58-.4A1.5,1.5,0,0,1,6,4.28a.94.94,0,0,1,0,.41l-1,5.85A5.49,5.49,0,0,0,3.5,14.24ZM15,2.71a1,1,0,0,0-1.42-1.42l-4,4a3,3,0,0,1,.94,1.88Zm5.34,10.38-2,2a.5.5,0,0,1-.7,0,.5.5,0,0,1,0-.71l4.12-4.12a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L16.17,13a.5.5,0,0,1-.7,0,.5.5,0,0,1,0-.71L20.78,7a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0l-5.31,5.31a.5.5,0,1,1-.71-.71L18,5.54a1,1,0,1,0-1.42-1.42L9,11.66V7.45A1.49,1.49,0,0,0,7.76,6a.5.5,0,0,0-.58.4L6.73,9C6.37,11,5,12.34,5,14.24v4.1a3.29,3.29,0,0,0,.88,2.43l1.36,1.35A3,3,0,0,0,9.36,23h.05a6.06,6.06,0,0,0,2.91-.75l3.09-1.72a5.07,5.07,0,0,0,1.11-.84l5.19-5.18a1,1,0,0,0-1.42-1.42Z"]
  };
  
  var expressionless = {
    prefix: 'axis',
    iconName: 'expressionless',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm2.5-6h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,14.5,14ZM11,10.5v-1a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3A.5.5,0,0,0,11,10.5ZM16.5,9h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,16.5,9Z"]
  };
  
  var faceFemale = {
    prefix: 'axis',
    iconName: 'faceFemale',
    icon: [24, 24, [], "f0000", "M20.66,19.43a.48.48,0,0,0,0-.7A2,2,0,0,1,20,17.27V8a6,6,0,0,0-6-6H10A6,6,0,0,0,4,8v9.27a2,2,0,0,1-.63,1.46.48.48,0,0,0,0,.7A2,2,0,0,0,4.73,20H6.55c.15.14.29.27.45.4l.36.29A6,6,0,0,0,11.1,22h1.8a6,6,0,0,0,3.74-1.31L17,20.4c.16-.13.3-.26.45-.4h1.82A2,2,0,0,0,20.66,19.43ZM18,14.16a6,6,0,0,1-2.25,4.68l-.36.29A4,4,0,0,1,12.9,20H11.1a4,4,0,0,1-2.49-.87l-.36-.29A6,6,0,0,1,6,14.16V9.74a8,8,0,0,0,4.52-3.11A10,10,0,0,0,18,10Zm-3.58,1.92a.23.23,0,0,0-.18-.08H9.76a.23.23,0,0,0-.18.08.25.25,0,0,0-.06.2,2.5,2.5,0,0,0,5,0A.25.25,0,0,0,14.42,16.08ZM9.48,11.5A1.49,1.49,0,0,0,8,12.7a.25.25,0,0,0,.24.3H10.7a.22.22,0,0,0,.19-.09A.27.27,0,0,0,11,12.7,1.51,1.51,0,0,0,9.48,11.5Zm5,0a1.51,1.51,0,0,0-1.48,1.2.27.27,0,0,0,.06.21.22.22,0,0,0,.19.09h2.45a.22.22,0,0,0,.19-.09A.23.23,0,0,0,16,12.7,1.49,1.49,0,0,0,14.53,11.5Z"]
  };
  
  var faceMale = {
    prefix: 'axis',
    iconName: 'faceMale',
    icon: [24, 24, [], "f0000", "M4.5,2a.5.5,0,0,0-.5.53A6,6,0,0,0,4.81,5,6,6,0,0,0,4,8v6.16A8,8,0,0,0,7,20.4l.36.29A6,6,0,0,0,11.1,22h1.8a6,6,0,0,0,3.74-1.31L17,20.4a8,8,0,0,0,3-6.24V8a6,6,0,0,0-6-6ZM18,14.16a6,6,0,0,1-2.25,4.68l-.36.29A4,4,0,0,1,12.9,20H11.1a4,4,0,0,1-2.49-.87l-.36-.29A6,6,0,0,1,6,14.16V9.74a8,8,0,0,0,4.52-3.11A10,10,0,0,0,18,10ZM9.48,11.5A1.49,1.49,0,0,0,8,12.7a.25.25,0,0,0,.24.3H10.7a.23.23,0,0,0,.19-.09A.27.27,0,0,0,11,12.7,1.51,1.51,0,0,0,9.48,11.5Zm5,0a1.51,1.51,0,0,0-1.48,1.2.27.27,0,0,0,.06.21.23.23,0,0,0,.19.09h2.45a.23.23,0,0,0,.19-.09A.27.27,0,0,0,16,12.7,1.51,1.51,0,0,0,14.53,11.5Zm0,4.78a.25.25,0,0,0-.06-.2.23.23,0,0,0-.18-.08H9.76a.23.23,0,0,0-.18.08.25.25,0,0,0-.06.2,2.5,2.5,0,0,0,5,0Z"]
  };
  
  var frowning = {
    prefix: 'axis',
    iconName: 'frowning',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm-1.5-9a.5.5,0,0,0,.5-.5V10a2,2,0,0,0-4,0v.5a.5.5,0,0,0,.5.5ZM15,8a2,2,0,0,0-2,2v.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V10A2,2,0,0,0,15,8Zm-3,5a4,4,0,0,0-4,3.43.49.49,0,0,0,.12.4.49.49,0,0,0,.38.17h6.92a.49.49,0,0,0,.38-.17.49.49,0,0,0,.12-.4A4,4,0,0,0,12,13Z"]
  };
  
  var gestureHand1f = {
    prefix: 'axis',
    iconName: 'gestureHand1f',
    icon: [24, 24, [], "f0000", "M21,13.74v1.67a6,6,0,0,1-.79,3L17.58,23a2,2,0,0,1-1.74,1H11.7a2,2,0,0,1-1.25-.44L7.36,20.37a6,6,0,0,1-.67-.84L5.57,17.86A2.94,2.94,0,0,0,4,16.68l-1.34-.45h0l-.36-.12A.49.49,0,0,1,2,15.63v-.14A1.49,1.49,0,0,1,3.5,14h.84a4,4,0,0,1,1.28.2L8,15V2.5a1.5,1.5,0,0,1,3,0v8a.5.5,0,0,0,1,0V8h3.26a3,3,0,0,1,2.12.88l2.74,2.74A3,3,0,0,1,21,13.74Z"]
  };
  
  var gestureHand2f = {
    prefix: 'axis',
    iconName: 'gestureHand2f',
    icon: [24, 24, [], "f0000", "M15,10.5a.5.5,0,0,0,1,0V8.1a3,3,0,0,1,1.38.78l2.74,2.74A3,3,0,0,1,21,13.74v1.67a6,6,0,0,1-.79,3L17.58,23a2,2,0,0,1-1.74,1H11.7a2,2,0,0,1-1.25-.44L7.36,20.37a6,6,0,0,1-.67-.84L5.57,17.86A2.94,2.94,0,0,0,4,16.68l-1.34-.45h0l-.36-.12A.49.49,0,0,1,2,15.63v-.14A1.49,1.49,0,0,1,3.5,14h.84a4,4,0,0,1,1.28.2L8,15V2.5a1.5,1.5,0,0,1,3,0v8a.5.5,0,0,0,1,0v-9a1.5,1.5,0,0,1,3,0Z"]
  };
  
  var gestureHover1f = {
    prefix: 'axis',
    iconName: 'gestureHover1f',
    icon: [24, 24, [], "f0000", "M11.49,24a3,3,0,0,1-2.12-.88L5.75,19.5A5,5,0,0,1,4,15.7V14a2,2,0,0,1,2-2H6v1.65a2,2,0,0,0,.69,1.51l.31.31V2.5a1.5,1.5,0,0,1,3,0v8a.5.5,0,0,0,1,0V8h3.26a3,3,0,0,1,2.12.88l2.74,2.74A3,3,0,0,1,20,13.74v1.67a6,6,0,0,1-.79,3L16.58,23a2,2,0,0,1-1.74,1Z"]
  };
  
  var gestureScrollDown = {
    prefix: 'axis',
    iconName: 'gestureScrollDown',
    icon: [24, 24, [], "f0000", "M18,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,15V4A1,1,0,0,1,9,4v6.5a.5.5,0,0,0,1,0V8.74h2.25a3,3,0,0,1,2.13.88l2.73,2.72A3.09,3.09,0,0,1,18,14.47ZM18.5,1a.5.5,0,0,0-.5.5V7h-.94a.5.5,0,0,0-.36.85l2,2a.37.37,0,0,0,.53,0l2-2A.49.49,0,0,0,21,7H20V1.5a.5.5,0,0,0-.5-.5Z"]
  };
  
  var gestureScrollDown2f = {
    prefix: 'axis',
    iconName: 'gestureScrollDown2f',
    icon: [24, 24, [], "f0000", "M17.11,12.34A3.09,3.09,0,0,1,18,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,15V4A1,1,0,0,1,9,4v6.5a.5.5,0,0,0,1,0V3a1,1,0,0,1,2,0v7.5a.5.5,0,0,0,1,0V8.84a3,3,0,0,1,1.38.78ZM18.5,1a.5.5,0,0,0-.5.5V7h-.94a.5.5,0,0,0-.36.85l2,2a.37.37,0,0,0,.53,0l2-2A.49.49,0,0,0,21,7H20V1.5a.5.5,0,0,0-.5-.5Z"]
  };
  
  var gestureScrollUp = {
    prefix: 'axis',
    iconName: 'gestureScrollUp',
    icon: [24, 24, [], "f0000", "M18,14.74a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,15V4A1,1,0,0,1,9,4v6.5a.5.5,0,0,0,1,0V8.74h2.25a3,3,0,0,1,2.13.88l2.73,2.72A3.09,3.09,0,0,1,18,14.47ZM19.5,10a.5.5,0,0,0,.5-.5V4H21a.49.49,0,0,0,.35-.85l-2-2a.37.37,0,0,0-.53,0l-2,2a.5.5,0,0,0,.36.85H18V9.5a.5.5,0,0,0,.5.5Z"]
  };
  
  var gestureScrollUp2f = {
    prefix: 'axis',
    iconName: 'gestureScrollUp2f',
    icon: [24, 24, [], "f0000", "M17.11,12.34A3.09,3.09,0,0,1,18,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,15V4A1,1,0,0,1,9,4v6.5a.5.5,0,0,0,1,0V3a1,1,0,0,1,2,0v7.5a.5.5,0,0,0,1,0V8.84a3,3,0,0,1,1.38.78ZM19.5,10a.5.5,0,0,0,.5-.5V4H21a.49.49,0,0,0,.35-.85l-2-2a.37.37,0,0,0-.53,0l-2,2a.5.5,0,0,0,.36.85H18V9.5a.5.5,0,0,0,.5.5Z"]
  };
  
  var gestureScrollUpDown = {
    prefix: 'axis',
    iconName: 'gestureScrollUpDown',
    icon: [24, 24, [], "f0000", "M18,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,15V4A1,1,0,0,1,9,4v6.5a.5.5,0,0,0,1,0V8.74h2.25a3,3,0,0,1,2.13.88l2.73,2.72A3.09,3.09,0,0,1,18,14.47ZM21,8H20V4H21a.49.49,0,0,0,.35-.85l-2-2a.37.37,0,0,0-.53,0l-2,2a.5.5,0,0,0,.36.85H18V8h-.94a.5.5,0,0,0-.36.85l2.05,2a.37.37,0,0,0,.53,0l2-2A.5.5,0,0,0,21,8Z"]
  };
  
  var gestureScrollUpDown2f = {
    prefix: 'axis',
    iconName: 'gestureScrollUpDown2f',
    icon: [24, 24, [], "f0000", "M21.31,8.85l-2,2a.37.37,0,0,1-.53,0l-2.05-2A.5.5,0,0,1,17.06,8H18V4h-.94a.5.5,0,0,1-.36-.85l2-2a.37.37,0,0,1,.53,0l2,2A.49.49,0,0,1,21,4H20V8H21A.5.5,0,0,1,21.31,8.85Zm-6.93.77A3,3,0,0,0,13,8.84V10.5a.5.5,0,0,1-1,0V3a1,1,0,0,0-2,0v7.5a.5.5,0,0,1-1,0V4A1,1,0,0,0,7,4V15L4.11,12.15A1.52,1.52,0,0,0,2.21,12a.51.51,0,0,0-.12.7L3.6,14.85c1.18,1.69,1.14,3.56,2.48,4.91l2.38,2.36a3,3,0,0,0,2.12.88h2.57a3,3,0,0,0,2.12-.88l0,0a6,6,0,0,0,1.52-2.59l1-3.39A4.87,4.87,0,0,0,18,14.74v-.27a3.09,3.09,0,0,0-.89-2.13Z"]
  };
  
  var gestureSwipeLeft = {
    prefix: 'axis',
    iconName: 'gestureSwipeLeft',
    icon: [24, 24, [], "f0000", "M18,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,15V4A1,1,0,0,1,9,4v6.5a.5.5,0,0,0,1,0V8.74h2.25a3,3,0,0,1,2.13.88l2.73,2.72A3.09,3.09,0,0,1,18,14.47ZM21.5,5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H16v-1a.51.51,0,0,0-.86-.36l-2,2a.37.37,0,0,0,0,.53l2,2.05A.51.51,0,0,0,16,5.94V5Z"]
  };
  
  var gestureSwipeLeft2f = {
    prefix: 'axis',
    iconName: 'gestureSwipeLeft2f',
    icon: [24, 24, [], "f0000", "M17,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H9.58a3,3,0,0,1-2.12-.88L5.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L1.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L6,15V4A1,1,0,0,1,8,4v6.5a.5.5,0,0,0,1,0V3a1,1,0,0,1,2,0v7.5a.5.5,0,0,0,1,0V8.84a3,3,0,0,1,1.38.78l2.73,2.72A3.09,3.09,0,0,1,17,14.47ZM21.5,5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H16v-1a.51.51,0,0,0-.86-.36l-2,2a.37.37,0,0,0,0,.53l2,2.05A.51.51,0,0,0,16,5.94V5Z"]
  };
  
  var gestureSwipeLeftRight = {
    prefix: 'axis',
    iconName: 'gestureSwipeLeftRight',
    icon: [24, 24, [], "f0000", "M18,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,15V4A1,1,0,0,1,9,4v6.5a.5.5,0,0,0,1,0V8.74h2.25a3,3,0,0,1,2.13.88l2.73,2.72A3.09,3.09,0,0,1,18,14.47ZM21.89,3.72l-2-2a.51.51,0,0,0-.86.36V3H15v-1a.49.49,0,0,0-.85-.35l-2,2a.39.39,0,0,0,0,.53l2,2A.5.5,0,0,0,15,5.94V5h4v.94a.51.51,0,0,0,.86.36l2-2A.37.37,0,0,0,21.89,3.72Z"]
  };
  
  var gestureSwipeLeftRight2f = {
    prefix: 'axis',
    iconName: 'gestureSwipeLeftRight2f',
    icon: [24, 24, [], "f0000", "M17,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H9.58a3,3,0,0,1-2.12-.88L5.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L1.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L6,15V4A1,1,0,0,1,8,4v6.5a.5.5,0,0,0,1,0V3a1,1,0,0,1,2,0v7.5a.5.5,0,0,0,1,0V8.84a3,3,0,0,1,1.38.78l2.73,2.72A3.09,3.09,0,0,1,17,14.47ZM22.89,3.72l-2-2a.51.51,0,0,0-.86.36V3H16v-1a.49.49,0,0,0-.85-.35l-2,2a.39.39,0,0,0,0,.53l2,2A.5.5,0,0,0,16,5.94V5h4v.94a.51.51,0,0,0,.86.36l2-2A.37.37,0,0,0,22.89,3.72Z"]
  };
  
  var gestureSwipeRight = {
    prefix: 'axis',
    iconName: 'gestureSwipeRight',
    icon: [24, 24, [], "f0000", "M18,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,15V4A1,1,0,0,1,9,4v6.5a.5.5,0,0,0,1,0V8.74h2.25a3,3,0,0,1,2.13.88l2.73,2.72A3.09,3.09,0,0,1,18,14.47Zm-5-10a.5.5,0,0,0,.5.5H19v.94a.51.51,0,0,0,.86.36l2-2a.37.37,0,0,0,0-.53l-2-2a.51.51,0,0,0-.86.36V3H13.5a.5.5,0,0,0-.5.5Z"]
  };
  
  var gestureSwipeRight2f = {
    prefix: 'axis',
    iconName: 'gestureSwipeRight2f',
    icon: [24, 24, [], "f0000", "M17,14.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H9.58a3,3,0,0,1-2.12-.88L5.08,19.76c-1.34-1.35-1.3-3.22-2.48-4.91L1.09,12.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L6,15V4A1,1,0,0,1,8,4v6.5a.5.5,0,0,0,1,0V3a1,1,0,0,1,2,0v7.5a.5.5,0,0,0,1,0V8.84a3,3,0,0,1,1.38.78l2.73,2.72A3.09,3.09,0,0,1,17,14.47Zm-4-10a.5.5,0,0,0,.5.5H19v.94a.51.51,0,0,0,.86.36l2-2a.37.37,0,0,0,0-.53l-2-2a.51.51,0,0,0-.86.36V3H13.5a.5.5,0,0,0-.5.5Z"]
  };
  
  var handBasic = {
    prefix: 'axis',
    iconName: 'handBasic',
    icon: [24, 24, [], "f0000", "M21,5.5v9.91a6,6,0,0,1-.79,3L17.58,23a2,2,0,0,1-1.74,1H10.48a4,4,0,0,1-2.6-1L3.75,19.5A5,5,0,0,1,2,15.7V10a1,1,0,0,1,.91-1A2,2,0,0,1,5,11v2.65a2,2,0,0,0,.69,1.51l.31.27V2.5a1.5,1.5,0,0,1,3,0v8a.5.5,0,0,0,1,0v-9a1.5,1.5,0,0,1,3,0v9a.5.5,0,0,0,1,0v-8a1.5,1.5,0,0,1,3,0v8a.5.5,0,0,0,1,0v-5a1.5,1.5,0,0,1,3,0Z"]
  };
  
  var handDraw = {
    prefix: 'axis',
    iconName: 'handDraw',
    icon: [24, 24, [], "f0000", "M18,13.47v.27a4.87,4.87,0,0,1-.19,1.37l-1,3.39a6,6,0,0,1-1.52,2.59l0,0a3,3,0,0,1-2.12.88H10.58a3,3,0,0,1-2.12-.88L6.08,18.76c-1.34-1.35-1.3-3.22-2.48-4.91L2.09,11.7a.51.51,0,0,1,.12-.7,1.52,1.52,0,0,1,1.9.15L7,14V3A1,1,0,0,1,9,3V9.5a.5.5,0,0,0,1,0V7.74h2.25a3,3,0,0,1,2.13.88l2.73,2.72A3.09,3.09,0,0,1,18,13.47ZM10.5,4h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,10.5,4Zm3.67.59.15.14a.5.5,0,0,0,.71,0l.81-.81a.34.34,0,0,0,0-.49l-.25-.26a3.84,3.84,0,0,0-1.28-.84.37.37,0,0,0-.31,0,.39.39,0,0,0-.17.26l-.16,1.27a.53.53,0,0,0,.22.48A1.23,1.23,0,0,1,14.17,4.59ZM21.5,6h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,6Zm-3.67-.59-.15-.14a.5.5,0,0,0-.71,0l-.81.81a.34.34,0,0,0,0,.49l.25.26a3.82,3.82,0,0,0,1.35.87.32.32,0,0,0,.3,0,.32.32,0,0,0,.17-.25l.16-1.26a.51.51,0,0,0-.23-.48A1.7,1.7,0,0,1,17.83,5.41Z"]
  };
  
  var handMetalHorns = {
    prefix: 'axis',
    iconName: 'handMetalHorns',
    icon: [24, 24, [], "f0000", "M22,5.5v9.9c0,1.1-0.3,2.1-0.8,3L18.6,23c-0.4,0.6-1,1-1.7,1h-4.1c-0.5,0-0.9-0.2-1.2-0.4l-3.7-3c-0.5-0.4-0.9-0.8-1.2-1.4l-0.9-1.4c-0.4-0.6-0.9-1-1.6-1.1l-1.3-0.5l0,0l-0.4-0.1C2.1,16,2,15.8,2,15.6v-0.1C2,14.7,2.7,14,3.5,14c0,0,0,0,0,0h0.8c0.4,0,0.9,0.1,1.3,0.2L8,15V2.5C8,1.7,8.7,1,9.5,1S11,1.7,11,2.5v8c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V9c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v1.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-5C19,4.7,19.7,4,20.5,4S22,4.7,22,5.5z"]
  };
  
  var handMiddleFinger = {
    prefix: 'axis',
    iconName: 'handMiddleFinger',
    icon: [24, 24, [], "f0000", "M20,12.74v2.67a6,6,0,0,1-.79,3L16.58,23a2,2,0,0,1-1.74,1H11.49a3,3,0,0,1-2.12-.88L5.75,19.5A5,5,0,0,1,4,15.7V14a2,2,0,0,1,2-2H6v1.65a2,2,0,0,0,.69,1.51l.31.31V10A2,2,0,0,1,9,8h1V10.5a.5.5,0,0,0,1,0v-9a1.5,1.5,0,0,1,3,0v9a.5.5,0,0,0,1,0V8h.48a3,3,0,0,1,1.9.86l1.74,1.74A3,3,0,0,1,20,12.74Z"]
  };
  
  var handOk = {
    prefix: 'axis',
    iconName: 'handOk',
    icon: [24, 24, [], "f0000", "M20,5.89l-1.81,6.76a4.07,4.07,0,0,0-.14,1V22a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1v-.11a1.51,1.51,0,0,0-.78-1.32L6,18.83a4,4,0,0,1-1.95-2.51l-1-4a1,1,0,0,1,.61-1.2,2,2,0,0,1,2.54,1.39l.3,1.11a1,1,0,0,0,.72.71l1.19.3a2,2,0,0,0,2.3-1.09l.24-.51a2,2,0,0,0-.81-2.58l-.32-.18A2,2,0,0,0,8.29,10L4.89,11a1.5,1.5,0,1,1-.78-2.9l4.2-1.13a3,3,0,0,1,2.28.3l.66.39a.5.5,0,1,0,.5-.86l-1.65-1L9.09,3a1.5,1.5,0,0,1,1.14-2,1.57,1.57,0,0,1,1.71,1l2.4,6.61a.5.5,0,0,0,.94-.34L14,4.82V2.5a1.5,1.5,0,0,1,3,0v5a.5.5,0,0,0,1,0V4.09a1.49,1.49,0,0,1,.89,0A1.51,1.51,0,0,1,20,5.89Z"]
  };
  
  var handPiece = {
    prefix: 'axis',
    iconName: 'handPiece',
    icon: [24, 24, [], "f0000", "M11.49,24a3,3,0,0,1-2.12-.88L5.75,19.5A5,5,0,0,1,4,15.7V14a2,2,0,0,1,2-2H6v1.65a2,2,0,0,0,.69,1.51l.31.31V10.76L5.66,3.14a1.5,1.5,0,1,1,2.95-.52l1.41,8a.49.49,0,0,0,.49.41.48.48,0,0,0,.47-.4l1.41-8a1.5,1.5,0,1,1,2.95.52L14.48,8a3,3,0,0,1,1.9.86l2.74,2.74A3,3,0,0,1,20,13.74v1.67a6,6,0,0,1-.79,3L16.58,23a2,2,0,0,1-1.74,1Z"]
  };
  
  var handWave = {
    prefix: 'axis',
    iconName: 'handWave',
    icon: [24, 24, [], "f0000", "M18.71,12.09a1,1,0,0,1,0,1.42l-5.19,5.18a5.07,5.07,0,0,1-1.11.84L9.32,21.25A6,6,0,0,1,6.41,22h0a3,3,0,0,1-2.12-.88L2.88,19.77A3.29,3.29,0,0,1,2,17.34v-4.1C2,11.34,3.37,10,3.73,8l.45-2.59A.5.5,0,0,1,4.76,5,1.49,1.49,0,0,1,6,6.45v4.21l7.37-7.37a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42L10.34,9.14a.5.5,0,1,0,.71.71l5.31-5.31a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-5.31,5.31a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0l4.12-4.12a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-4.12,4.12a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0l2-2A1,1,0,0,1,18.71,12.09Zm3.16,3.59a.52.52,0,0,0-.37-.16h-1A.5.5,0,0,0,20,16a4.51,4.51,0,0,1-4,4,.49.49,0,0,0-.45.5v1a.52.52,0,0,0,.16.37.53.53,0,0,0,.38.13A6.5,6.5,0,0,0,22,16.06.53.53,0,0,0,21.87,15.68ZM7.65,5A4.34,4.34,0,0,1,10,4a.49.49,0,0,0,.45-.5v-1a.52.52,0,0,0-.16-.37A.53.53,0,0,0,9.94,2,6.44,6.44,0,0,0,6.31,3.49,3.54,3.54,0,0,1,7.65,5Z"]
  };
  
  var neutralFace = {
    prefix: 'axis',
    iconName: 'neutralFace',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM15,8a2,2,0,0,0-2,2v.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V10A2,2,0,0,0,15,8Zm-4,2.5V10a2,2,0,0,0-4,0v.5a.5.5,0,0,0,.5.5h3A.5.5,0,0,0,11,10.5ZM14.5,14h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,14.5,14Z"]
  };
  
  var protection = {
    prefix: 'axis',
    iconName: 'protection',
    icon: [24, 24, [], "f0000", "M20.71,12.29a1,1,0,0,0-1.42,0L16,15.59h0A2.5,2.5,0,0,1,13.5,18h-4a.5.5,0,0,1,0-1h4l.23,0h0A1.49,1.49,0,0,0,15,15.35,1.57,1.57,0,0,0,13.4,14H8.71a3.32,3.32,0,0,0-2.59.91L3.29,17.82a1,1,0,0,0,0,1.41l2.48,2.48a1,1,0,0,0,1.41,0L8.6,20.29A1,1,0,0,1,9.3,20h4.08a2.51,2.51,0,0,0,1.77-.73l5.56-5.56A1,1,0,0,0,20.71,12.29ZM3.29,11.71a1,1,0,0,0,1.42,0L8,8.41H8A2.5,2.5,0,0,1,10.5,6h4a.5.5,0,0,1,0,1h-4l-.23,0h0A1.49,1.49,0,0,0,9,8.65,1.57,1.57,0,0,0,10.6,10h4.69a3.32,3.32,0,0,0,2.59-.91l2.83-2.91a1,1,0,0,0,0-1.41L18.23,2.29a1,1,0,0,0-1.41,0L15.4,3.71a1,1,0,0,1-.7.29H10.62a2.51,2.51,0,0,0-1.77.73L3.29,10.29A1,1,0,0,0,3.29,11.71Z"]
  };
  
  var sad = {
    prefix: 'axis',
    iconName: 'sad',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM15,8a2,2,0,0,0-2,2v.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V10A2,2,0,0,0,15,8Zm-4.5,3a.5.5,0,0,0,.5-.5V10a2,2,0,0,0-4,0v.5a.5.5,0,0,0,.5.5ZM12,13a5.51,5.51,0,0,0-4.46,2.29.49.49,0,0,0-.08.39A.51.51,0,0,0,7.7,16l.87.51a.51.51,0,0,0,.65-.13,3.47,3.47,0,0,1,5.56,0,.51.51,0,0,0,.65.13L16.3,16a.51.51,0,0,0,.24-.33.49.49,0,0,0-.08-.39A5.51,5.51,0,0,0,12,13Z"]
  };
  
  var slap = {
    prefix: 'axis',
    iconName: 'slap',
    icon: [24, 24, [], "f0000", "M14.59,15.38a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0l2-2a1,1,0,0,1,1.42,1.42l-5.19,5.18a5.07,5.07,0,0,1-1.11.84L9.32,23.25A6,6,0,0,1,6.41,24h0a3,3,0,0,1-2.12-.88L2.88,21.77A3.29,3.29,0,0,1,2,19.34V14.07a4,4,0,0,1,1.17-2.83l4-4a.51.51,0,0,1,.71,0,1.51,1.51,0,0,1,0,2.12L6.71,10.53a2,2,0,0,0-.58,1.41v.59h0l7.24-7.24a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42l-4.44,4.43a.5.5,0,1,0,.71.71l5.31-5.31a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-5.31,5.31a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0l4.12-4.12a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41ZM15.5,4h1a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v2A.5.5,0,0,0,15.5,4Zm5.8-.6-.7-.7a.5.5,0,0,0-.71,0L18.47,4.11a.51.51,0,0,0,0,.71l.71.71a.51.51,0,0,0,.71,0L21.3,4.11A.5.5,0,0,0,21.3,3.4ZM22.5,7h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,7Z"]
  };
  
  var slightlySmilling = {
    prefix: 'axis',
    iconName: 'slightlySmilling',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM15,8a2,2,0,0,0-2,2v.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V10A2,2,0,0,0,15,8Zm-4.5,3a.5.5,0,0,0,.5-.5V10a2,2,0,0,0-4,0v.5a.5.5,0,0,0,.5.5Zm5.8,3-.87-.51a.51.51,0,0,0-.65.13,3.48,3.48,0,0,1-5.56,0,.51.51,0,0,0-.65-.13L7.7,14a.51.51,0,0,0-.24.33.49.49,0,0,0,.08.39,5.49,5.49,0,0,0,8.92,0,.49.49,0,0,0,.08-.39A.51.51,0,0,0,16.3,14Z"]
  };
  
  var smile = {
    prefix: 'axis',
    iconName: 'smile',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm4-6.43a.49.49,0,0,0-.12-.4.49.49,0,0,0-.38-.17H8.54a.49.49,0,0,0-.38.17.49.49,0,0,0-.12.4,4,4,0,0,0,7.92,0ZM15,8a2,2,0,0,0-2,2v.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V10A2,2,0,0,0,15,8Zm-4,2.5V10a2,2,0,0,0-4,0v.5a.5.5,0,0,0,.5.5h3A.5.5,0,0,0,11,10.5Z"]
  };
  
  var thumbsDown = {
    prefix: 'axis',
    iconName: 'thumbsDown',
    icon: [24, 24, [], "f0000", "M19,4.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v9a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5ZM4,14H9L7.45,17.11a4.15,4.15,0,0,0-.45,2v.37A1.5,1.5,0,0,0,8.5,21h.14a.5.5,0,0,0,.47-.34l.6-1.78a2,2,0,0,1,1.15-1.22l.43-.17a4.06,4.06,0,0,0,1.9-1.6l1.22-2a2,2,0,0,1,1.7-.94H17V5h-.59A3.41,3.41,0,0,1,14,4h0a3.41,3.41,0,0,0-2.41-1H5.35A2,2,0,0,0,3.5,4.26L2.43,6.93A6.06,6.06,0,0,0,2,9.16V12A2,2,0,0,0,4,14Z"]
  };
  
  var thumbsUp = {
    prefix: 'axis',
    iconName: 'thumbsUp',
    icon: [24, 24, [], "f0000", "M5,19.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-9a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5ZM20,10H15l1.55-3.11a4.15,4.15,0,0,0,.45-2V4.5A1.5,1.5,0,0,0,15.5,3h-.14a.5.5,0,0,0-.47.34l-.6,1.78a2,2,0,0,1-1.15,1.22l-.43.17a4.06,4.06,0,0,0-1.9,1.6l-1.22,2a2,2,0,0,1-1.7.94H7v8h.59A3.41,3.41,0,0,1,10,20h0a3.41,3.41,0,0,0,2.41,1h6.24a2,2,0,0,0,1.85-1.26l1.07-2.67A6.06,6.06,0,0,0,22,14.84V12A2,2,0,0,0,20,10Z"]
  };
  
  var thumbsUpDown = {
    prefix: 'axis',
    iconName: 'thumbsUpDown',
    icon: [24, 24, [], "f0000", "M1.57,14.42l1.72-1.76a4.74,4.74,0,0,1,1.34-1l.77-.39a2.06,2.06,0,0,0,.9-.9l.42-.85A1,1,0,0,1,7.62,9H8a1,1,0,0,1,1,1v.35a3.93,3.93,0,0,1-.21,1.27L8,14h3.5A1.5,1.5,0,0,1,13,15.5v2.56a3.92,3.92,0,0,1-.42,1.78l-1,2.05A2,2,0,0,1,9.76,23H4.91a3.11,3.11,0,0,1-1.67-.5l-1.35-.91A2,2,0,0,1,1,19.93V15.82A2,2,0,0,1,1.57,14.42ZM23,8.18V4.07a2,2,0,0,0-.89-1.66L20.76,1.5A3.11,3.11,0,0,0,19.09,1H14.24a2,2,0,0,0-1.79,1.11l-1,2.05A3.92,3.92,0,0,0,11,5.94V8.5A1.5,1.5,0,0,0,12.5,10H16l-.79,2.38A3.93,3.93,0,0,0,15,13.65V14a1,1,0,0,0,1,1h.38a1,1,0,0,0,.9-.55l.42-.85a2.06,2.06,0,0,1,.9-.9l.77-.39a4.74,4.74,0,0,0,1.34-1l1.72-1.76A2,2,0,0,0,23,8.18Z"]
  };
  
  var wink = {
    prefix: 'axis',
    iconName: 'wink',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM15,8a2,2,0,0,0-2,2v.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V10A2,2,0,0,0,15,8Zm1.3,6-.87-.51a.51.51,0,0,0-.65.13,3.48,3.48,0,0,1-5.56,0,.51.51,0,0,0-.65-.13L7.7,14a.51.51,0,0,0-.24.33.49.49,0,0,0,.08.39,5.49,5.49,0,0,0,8.92,0,.49.49,0,0,0,.08-.39A.51.51,0,0,0,16.3,14Zm-5.8-3a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5Z"]
  };
  
  var bloodTransfusion = {
    prefix: 'axis',
    iconName: 'bloodTransfusion',
    icon: [24, 24, [], "f0000", "M19.5,11h-1a.5.5,0,0,0-.5.5V19a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V18h1a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H12A2,2,0,0,0,8,4H6A2,2,0,0,0,4,6V16a2,2,0,0,0,2,2H7v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V18h2v1a3,3,0,0,0,3,3h3a3,3,0,0,0,3-3V11.5A.5.5,0,0,0,19.5,11ZM6,16V6h8V16Zm4-3a2,2,0,0,0,2-2,6.27,6.27,0,0,0-2-3h0a6.09,6.09,0,0,0-2,3A2,2,0,0,0,10,13Z"]
  };
  
  var coronaVirus = {
    prefix: 'axis',
    iconName: 'coronaVirus',
    icon: [24, 24, [], "f0000", "M21.5,10h-1a.5.5,0,0,0-.5.5.5.5,0,0,1-.5.5H18.32a.51.51,0,0,1-.49-.38,5.76,5.76,0,0,0-.73-1.77.49.49,0,0,1,.08-.61L18,7.4a.51.51,0,0,1,.71,0,.48.48,0,0,0,.7,0l.71-.7a.5.5,0,0,0,0-.71L18,3.87a.5.5,0,0,0-.71,0l-.7.71a.48.48,0,0,0,0,.7.51.51,0,0,1,0,.71l-.84.83a.49.49,0,0,1-.61.08A6,6,0,0,0,13,6.09V4.5a.5.5,0,0,1,.5-.5.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5.5.5,0,0,1,.5.5V5.68a.51.51,0,0,1-.38.49,5.76,5.76,0,0,0-1.77.73.49.49,0,0,1-.61-.08L7.4,6a.51.51,0,0,1,0-.71.48.48,0,0,0,0-.7l-.7-.71a.5.5,0,0,0-.71,0L3.87,6a.5.5,0,0,0,0,.71l.71.7a.48.48,0,0,0,.7,0A.51.51,0,0,1,6,7.4l.83.84a.49.49,0,0,1,.08.61,5.76,5.76,0,0,0-.73,1.77.51.51,0,0,1-.49.38H4.5a.5.5,0,0,1-.5-.5.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5.5.5,0,0,1,.5-.5H5.68a.51.51,0,0,1,.49.38,5.76,5.76,0,0,0,.73,1.77.49.49,0,0,1-.08.61L6,16.6a.51.51,0,0,1-.71,0,.48.48,0,0,0-.7,0l-.71.7a.5.5,0,0,0,0,.71L6,20.13a.5.5,0,0,0,.71,0l.7-.71a.48.48,0,0,0,0-.7.51.51,0,0,1,0-.71l.84-.83a.49.49,0,0,1,.61-.08,5.76,5.76,0,0,0,1.77.73.51.51,0,0,1,.38.49V19.5a.5.5,0,0,1-.5.5.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5.5.5,0,0,1-.5-.5V18.32a.51.51,0,0,1,.38-.49,5.76,5.76,0,0,0,1.77-.73.49.49,0,0,1,.61.08l.84.83a.51.51,0,0,1,0,.71.48.48,0,0,0,0,.7l.7.71a.5.5,0,0,0,.71,0L20.13,18a.5.5,0,0,0,0-.71l-.71-.7a.48.48,0,0,0-.7,0,.51.51,0,0,1-.71,0l-.83-.84a.49.49,0,0,1-.08-.61,5.76,5.76,0,0,0,.73-1.77.51.51,0,0,1,.49-.38H19.5a.5.5,0,0,1,.5.5.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,21.5,10Zm-11,2A1.5,1.5,0,1,1,12,10.5,1.5,1.5,0,0,1,10.5,12Z"]
  };
  
  var coronaVirusStop = {
    prefix: 'axis',
    iconName: 'coronaVirusStop',
    icon: [24, 24, [], "f0000", "M20.85,20.62a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L15,17.21a6.12,6.12,0,0,1-1.59.62.51.51,0,0,0-.38.49V19.5a.5.5,0,0,0,.5.5.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5.5.5,0,0,0,.5-.5V18.32a.51.51,0,0,0-.38-.49,5.76,5.76,0,0,1-1.77-.73.49.49,0,0,0-.61.08L7.4,18a.51.51,0,0,0,0,.71.48.48,0,0,1,0,.7l-.7.71a.5.5,0,0,1-.71,0L3.87,18a.5.5,0,0,1,0-.71l.71-.7a.48.48,0,0,1,.7,0,.51.51,0,0,0,.71,0l.83-.84a.49.49,0,0,0,.08-.61,5.76,5.76,0,0,1-.73-1.77A.51.51,0,0,0,5.68,13H4.5a.5.5,0,0,0-.5.5.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5.5.5,0,0,0,.5.5H5.68a.51.51,0,0,0,.49-.38A5.74,5.74,0,0,1,6.8,9L3.15,5.38a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0ZM21.5,10h-1a.5.5,0,0,0-.5.5.5.5,0,0,1-.5.5H18.32a.51.51,0,0,1-.49-.38,5.76,5.76,0,0,0-.73-1.77.49.49,0,0,1,.08-.61L18,7.4a.51.51,0,0,1,.71,0,.48.48,0,0,0,.7,0l.71-.7a.5.5,0,0,0,0-.71L18,3.87a.5.5,0,0,0-.71,0l-.7.71a.48.48,0,0,0,0,.7.51.51,0,0,1,0,.71l-.84.83a.49.49,0,0,1-.61.08,5.76,5.76,0,0,0-1.77-.73A.51.51,0,0,1,13,5.68V4.5a.5.5,0,0,1,.5-.5.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5.5.5,0,0,1,.5.5V5.68a.51.51,0,0,1-.38.49,5.52,5.52,0,0,0-1.27.47l8,8a5.52,5.52,0,0,0,.47-1.27.51.51,0,0,1,.49-.38H19.5a.5.5,0,0,1,.5.5.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,21.5,10Z"]
  };
  
  var coverSafetyGlasses = {
    prefix: 'axis',
    iconName: 'coverSafetyGlasses',
    icon: [24, 24, [], "f0000", "M22.53,10.75l-2.6-5.6A2,2,0,0,0,18.11,4H16.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1.61l1.73,3.71-4.22-.38c-1.2-.11-2.41-.17-3.62-.17s-2.42.06-3.62.17l-4.22.38L5.89,6H7.5A.5.5,0,0,0,8,5.5v-1A.5.5,0,0,0,7.5,4H5.89A2,2,0,0,0,4.07,5.15l-2.6,5.6A5,5,0,0,0,1,12.86v.59a5.67,5.67,0,0,0,.1,1.09l.53,2.88A3,3,0,0,0,4.6,20H8.75a2,2,0,0,0,1.8-1.11l.17-.34a1,1,0,0,1,.9-.55h.76a1,1,0,0,1,.9.55l.16.32A2,2,0,0,0,15.24,20H19.4a3,3,0,0,0,3-2.58l.53-2.88a5.67,5.67,0,0,0,.1-1.09v-.59A5,5,0,0,0,22.53,10.75ZM21,13.82l-.6,3.24v.08a1,1,0,0,1-1,.86H15.24l-.45-.89A2,2,0,0,0,13,16H11a2,2,0,0,0-1.79,1.11L8.76,18H4.6a1,1,0,0,1-1-.86v-.08L3,13.82v-.08a1,1,0,0,1,.91-1l4.65-.42c1.14-.1,2.3-.16,3.44-.16s2.3.06,3.44.16l4.65.42a1,1,0,0,1,.91,1Z"]
  };
  
  var disinfectant = {
    prefix: 'axis',
    iconName: 'disinfectant',
    icon: [24, 24, [], "f0000", "M15.26,8.87a1,1,0,0,0-1-.87H11a1,1,0,0,0-1,1v.76a3,3,0,0,1-.88,2.12L7.88,13.12A3,3,0,0,0,7,15.24V22a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1.13ZM14,19H9.5a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h4.12a.51.51,0,0,1,.5.43l.4,3A.51.51,0,0,1,14,19ZM7,2.5v-1A.5.5,0,0,1,7.5,1h4.79a2.94,2.94,0,0,1,1.34.32l1.09.54a.51.51,0,0,1,.28.45V3.5a.5.5,0,0,1-.5.5H14a1,1,0,0,0-1,1V6H11V3.92A6.84,6.84,0,0,1,9.74,5.55L8.36,6.86a.5.5,0,0,1-.7,0L7.14,6.3a.5.5,0,0,1,0-.7L8.53,4.28A5,5,0,0,0,9.48,3h-2A.5.5,0,0,1,7,2.5Z"]
  };
  
  var faceMask = {
    prefix: 'axis',
    iconName: 'faceMask',
    icon: [24, 24, [], "f0000", "M20.5,6a.5.5,0,0,0-.5.5V8h-.3a1,1,0,0,1-.62-.22L16,5.31A6,6,0,0,0,12.25,4h-.5A6,6,0,0,0,8,5.31L4.92,7.78A1,1,0,0,1,4.3,8H4V6.5A.5.5,0,0,0,3.5,6h-1a.5.5,0,0,0-.5.5v4.63A5,5,0,0,0,3.78,15l4.47,3.89A5,5,0,0,0,11.45,20h1.1a5,5,0,0,0,3.22-1.17L20.21,15A5,5,0,0,0,22,11.13V6.5a.5.5,0,0,0-.5-.5ZM11,13.5v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,11,13.5Zm0-6v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,11,7.5Zm0,10v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,11,17.5Z"]
  };
  
  var faceMaskOutlined = {
    prefix: 'axis',
    iconName: 'faceMaskOutlined',
    icon: [24, 24, [], "f0000", "M20.5,6a.5.5,0,0,0-.5.5V8h-.3a1,1,0,0,1-.62-.22L16,5.31A6,6,0,0,0,12.25,4h-.5A6,6,0,0,0,8,5.31L4.92,7.78A1,1,0,0,1,4.3,8H4V6.5A.5.5,0,0,0,3.5,6h-1a.5.5,0,0,0-.5.5v4.63A5,5,0,0,0,3.78,15l4.47,3.89A5,5,0,0,0,11.45,20h1.1a5,5,0,0,0,3.22-1.17L20.21,15A5,5,0,0,0,22,11.13V6.5a.5.5,0,0,0-.5-.5ZM20,11.13a3,3,0,0,1-1.08,2.3L14.47,17.3A2.9,2.9,0,0,1,13,18V16.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V18a3,3,0,0,1-1.46-.64L5.08,13.43A3,3,0,0,1,4,11.13V10h.3a3,3,0,0,0,1.87-.66L9.26,6.88A3.91,3.91,0,0,1,11,6.08V7.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V6.08a3.91,3.91,0,0,1,1.74.8l3.09,2.46A3,3,0,0,0,19.7,10H20ZM11,13.5v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,11,13.5Z"]
  };
  
  var glove = {
    prefix: 'axis',
    iconName: 'glove',
    icon: [24, 24, [], "f0000", "M21.71,10.68a1,1,0,1,0-1.42-1.42l-2,2a.5.5,0,0,1-.7,0,.5.5,0,0,1,0-.71l3.12-3.12a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L16.17,9.14a.5.5,0,0,1-.7,0,.5.5,0,0,1,0-.71l4.31-4.31a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L14.05,7a.5.5,0,0,1-.71-.71L17,2.71a1,1,0,0,0-1.42-1.42L10,6.83V2.62A1.49,1.49,0,0,0,8.76,1.18a.5.5,0,0,0-.58.4L7.73,4.17C7.37,6.21,6,7.51,6,9.41v1.32A3,3,0,0,1,4.94,13L2.35,15.21A1,1,0,0,0,2,16v.61a1,1,0,0,0,.54.89,3.3,3.3,0,0,1,1.3.72c.74.75.39,1.1,1.13,1.84s1.1.39,1.84,1.14a3.21,3.21,0,0,1,.72,1.29,1,1,0,0,0,.89.54H9a1,1,0,0,0,.7-.29l12-12h0Z"]
  };
  
  var handDisinfection = {
    prefix: 'axis',
    iconName: 'handDisinfection',
    icon: [24, 24, [], "f0000", "M20.71,12.29a1,1,0,0,0-1.42,0L16,15.59h0A2.5,2.5,0,0,1,13.5,18h-4a.5.5,0,0,1,0-1h4l.23,0h0A1.49,1.49,0,0,0,15,15.35,1.57,1.57,0,0,0,13.4,14H8.71a3.32,3.32,0,0,0-2.59.91L3.29,17.82a1,1,0,0,0,0,1.41l2.48,2.48a1,1,0,0,0,1.41,0L8.6,20.29A1,1,0,0,1,9.3,20h4.08a2.51,2.51,0,0,0,1.77-.73l5.56-5.56A1,1,0,0,0,20.71,12.29ZM15,12a2,2,0,0,0,2-2,6.27,6.27,0,0,0-2-3h0a6.09,6.09,0,0,0-2,3A2,2,0,0,0,15,12ZM8.48,2h.06a.33.33,0,0,1,.23.1C9.52,2.94,11,4.52,11,5.5a2.5,2.5,0,0,1-5,0C6,4.53,7.46,3,8.22,2.12A.32.32,0,0,1,8.48,2Z"]
  };
  
  var lungs = {
    prefix: 'axis',
    iconName: 'lungs',
    icon: [24, 24, [], "f0000", "M19.73,10.47A11.88,11.88,0,0,1,21,15.83V20a1,1,0,0,1-1,1h-.34a4,4,0,0,1-2.83-1.17l-1.49-1.49A8,8,0,0,1,13,12.69V10a1,1,0,0,0-2,0v2.69a8,8,0,0,1-2.34,5.65L7.17,19.83A4,4,0,0,1,4.34,21H4a1,1,0,0,1-1-1V15.83a11.88,11.88,0,0,1,1.27-5.36L6.45,6.11A2,2,0,0,1,8.24,5h.35a1,1,0,0,1,.7.29l.86.86a.49.49,0,0,0,.54.1A.48.48,0,0,0,11,5.79V3.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V5.79a.48.48,0,0,0,.31.46.49.49,0,0,0,.54-.1l.86-.86a1,1,0,0,1,.7-.29h.35a2,2,0,0,1,1.79,1.11Z"]
  };
  
  var microscope = {
    prefix: 'axis',
    iconName: 'microscope',
    icon: [24, 24, [], "f0000", "M4,17.5v-1a.5.5,0,0,1,.5-.5H9.77l-1,2H4.5A.5.5,0,0,1,4,17.5ZM20,13v8a1,1,0,0,1-1,1H4.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H10l3.72-7.45a1,1,0,0,1,.9-.55H16V10a3,3,0,0,0-3-3H10v4a1,1,0,0,1-1,1H8v1.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V12H5a1,1,0,0,1-1-1V3A1,1,0,0,1,5,2H9a1,1,0,0,1,1,1V5h3a5,5,0,0,1,5,5v2h1A1,1,0,0,1,20,13ZM8,4H6v6H8ZM18,17.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,18,17.5Z"]
  };
  
  var quarantine = {
    prefix: 'axis',
    iconName: 'quarantine',
    icon: [24, 24, [], "f0000", "M19,21a1,1,0,0,0,1-1V13h1.5a.5.5,0,0,0,.5-.5V11.41a1,1,0,0,0-.29-.7L14.29,3.29a1,1,0,0,0-.7-.29H10.41a1,1,0,0,0-.7.29L2.29,10.71a1,1,0,0,0-.29.7V12.5a.5.5,0,0,0,.5.5H4v7a1,1,0,0,0,1,1ZM12,7.75A2.25,2.25,0,1,1,9.75,10,2.24,2.24,0,0,1,12,7.75ZM16.25,18H7.75a.75.75,0,0,1-.67-1.09L8,15.1A2,2,0,0,1,9.77,14h4.46A2,2,0,0,1,16,15.1l.9,1.81A.75.75,0,0,1,16.25,18Z"]
  };
  
  var quarantineOutlined = {
    prefix: 'axis',
    iconName: 'quarantineOutlined',
    icon: [24, 24, [], "f0000", "M19,21a1,1,0,0,0,1-1V14h1.5a.5.5,0,0,0,.5-.5V11.41a1,1,0,0,0-.29-.7L14.29,3.29a1,1,0,0,0-.7-.29H10.41a1,1,0,0,0-.7.29L2.29,10.71a1,1,0,0,0-.29.7V13.5a.5.5,0,0,0,.5.5H4v6a1,1,0,0,0,1,1ZM6,19V12.5a.5.5,0,0,0-.5-.5H4.05a.89.89,0,0,1,.24-.46L10.83,5h2.34l6.54,6.54A.89.89,0,0,1,20,12H18.5a.5.5,0,0,0-.5.5V19Zm8-8a2,2,0,1,1-2-2A2,2,0,0,1,14,11ZM8.05,16.28l.73-1.45A1.5,1.5,0,0,1,10.12,14h3.76a1.5,1.5,0,0,1,1.34.83L16,16.28a.5.5,0,0,1-.45.72h-7A.5.5,0,0,1,8.05,16.28Z"]
  };
  
  var respirator = {
    prefix: 'axis',
    iconName: 'respirator',
    icon: [24, 24, [], "f0000", "M20,9.41l1.85-1.85a.5.5,0,0,0,0-.71l-.7-.7a.5.5,0,0,0-.71,0L18.32,8.26c-.21-.11-.41-.22-.64-.32a6.09,6.09,0,0,1-2-1.45L14.34,5a3,3,0,0,0-2.28-1h-.12A3,3,0,0,0,9.66,5L8.32,6.49a6,6,0,0,1-2,1.45c-.23.1-.43.21-.64.32L3.56,6.15a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71L4,9.41a5.33,5.33,0,0,0-2,3.95C2,17,6.49,20,12,20s10-3,10-6.64A5.33,5.33,0,0,0,20,9.41ZM12,18c-4.34,0-8-2.13-8-4.64C4,12,5.17,10.64,7.14,9.76A7.92,7.92,0,0,0,9.81,7.83l1.33-1.49a1.09,1.09,0,0,1,.8-.34h.12a1.09,1.09,0,0,1,.8.34l1.33,1.49a8.21,8.21,0,0,0,2.67,1.93c2,.88,3.14,2.23,3.14,3.6C20,15.87,16.34,18,12,18Zm1.5-6h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,13.5,12Zm0,4h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,13.5,16Z"]
  };
  
  var saline = {
    prefix: 'axis',
    iconName: 'saline',
    icon: [24, 24, [], "f0000", "M19.5,11h-1a.5.5,0,0,0-.5.5V19a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V18h1a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H12A2,2,0,0,0,8,4H6A2,2,0,0,0,4,6V16a2,2,0,0,0,2,2H7v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V18h2v1a3,3,0,0,0,3,3h3a3,3,0,0,0,3-3V11.5A.5.5,0,0,0,19.5,11ZM6,16V14H7.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H6V10H7.5A.5.5,0,0,0,8,9.5v-1A.5.5,0,0,0,7.5,8H6V6h8V16Z"]
  };
  
  var soap = {
    prefix: 'axis',
    iconName: 'soap',
    icon: [24, 24, [], "f0000", "M17,10V9a1,1,0,0,0-1-1H12a1,1,0,0,0-1,1v1a2,2,0,0,0-2,2v9a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V12A2,2,0,0,0,17,10Zm0,7.5a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5ZM9.24,4a2,2,0,0,0-1.41.59L6.56,5.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71L6.41,3.17A4,4,0,0,1,9.24,2H16.5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H15V6H13V4ZM7,10a2,2,0,0,1-4,0A6.09,6.09,0,0,1,5,7H5A6.27,6.27,0,0,1,7,10Z"]
  };
  
  var thermometer = {
    prefix: 'axis',
    iconName: 'thermometer',
    icon: [24, 24, [], "f0000", "M19,15.89a8.08,8.08,0,0,0-.84-3.58l-.95-1.89A2,2,0,0,1,17,9.53V4a2,2,0,0,0-2-2H6A1,1,0,0,0,5,3V7.28a1,1,0,0,0,.68,1L9.43,9.48a4,4,0,0,1,2.31,2l.72,1.44a8,8,0,0,1,.74,2.27l.59,3.55a4,4,0,0,0,1.12,2.17l.5.5a2,2,0,0,0,1.42.59H18a1,1,0,0,0,1-1ZM15,8H11.32L9,7.23V4h6Zm-4.33,5.82A5.4,5.4,0,0,1,11.11,15H9a1,1,0,0,1-1-1V11.11l.76.25a2,2,0,0,1,1.19,1Z"]
  };
  
  var vaccine = {
    prefix: 'axis',
    iconName: 'vaccine',
    icon: [24, 24, [], "f0000", "M20.85,6.68,17.32,3.15a.5.5,0,0,0-.71,0l-.71.7a.51.51,0,0,0,0,.71L17,5.62l-2.2,2.21L12.28,5.35a.5.5,0,0,0-.7,0l-.71.71a.5.5,0,0,0,0,.71l.71.7-6.7,6.7a2,2,0,0,0-.48,2.06l.42,1.24L2.15,20.15A.5.5,0,0,0,2.5,21H3.7a1.05,1.05,0,0,0,.71-.29L6.09,19l1.68.57a2.05,2.05,0,0,0,.64.11,2,2,0,0,0,1.42-.59l6.7-6.7.7.71a.5.5,0,0,0,.71,0l.71-.71a.5.5,0,0,0,0-.7L16.17,9.24,18.38,7,19.44,8.1a.51.51,0,0,0,.71,0l.7-.71A.5.5,0,0,0,20.85,6.68ZM13.12,13H8.88L13,8.91l0,0L15.11,11Z"]
  };
  
  var washingHands = {
    prefix: 'axis',
    iconName: 'washingHands',
    icon: [24, 24, [], "f0000", "M21.71,13.09a1,1,0,0,1,0,1.42l-5.19,5.18a5.07,5.07,0,0,1-1.11.84l-3.09,1.72A6.06,6.06,0,0,1,9.41,23H9.36a3,3,0,0,1-2.12-.88L5.88,20.77A3.29,3.29,0,0,1,5,18.34v-4.1C5,12.34,6.37,11,6.73,9l.45-2.59A.5.5,0,0,1,7.76,6,1.49,1.49,0,0,1,9,7.45v4.21l7.53-7.54A1,1,0,1,1,18,5.54l-4.61,4.6a.5.5,0,1,0,.71.71l5.31-5.31a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-5.31,5.31a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0l4.12-4.12a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-4.12,4.12a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0l2-2A1,1,0,0,1,21.71,13.09ZM4.93,10.54,6,4.69a.94.94,0,0,0,0-.41,1.5,1.5,0,0,0-1.19-1.1.5.5,0,0,0-.58.4L3.73,6.17h0C3.37,8.21,2,9.51,2,11.41v4.1a3.29,3.29,0,0,0,.88,2.43l.63.62a1.62,1.62,0,0,1,0-.22v-4.1A5.49,5.49,0,0,1,4.93,10.54ZM12,6a2,2,0,0,0,2-2,6.27,6.27,0,0,0-2-3h0a6.09,6.09,0,0,0-2,3A2,2,0,0,0,12,6Z"]
  };
  
  var alt = {
    prefix: 'axis',
    iconName: 'alt',
    icon: [24, 24, [], "f0000", "M22,17.5v1a.5.5,0,0,1-.5.5h-5a2,2,0,0,1-1.67-.89L7.46,7h-5A.5.5,0,0,1,2,6.5v-1A.5.5,0,0,1,2.5,5h5a2,2,0,0,1,1.67.89L16.54,17h5A.5.5,0,0,1,22,17.5ZM21.5,5h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,5Z"]
  };
  
  var backspace = {
    prefix: 'axis',
    iconName: 'backspace',
    icon: [24, 24, [], "f0000", "M21,4H10.33a2,2,0,0,0-1.42.59L2.29,11.21a1,1,0,0,0-.29.7v.18a1,1,0,0,0,.29.7l6.62,6.62a2,2,0,0,0,1.42.59H21a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4Zm-3.91,9.86a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L14,13.24l-1.86,1.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7L12.76,12l-1.85-1.86a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L14,10.76l1.86-1.85a.48.48,0,0,1,.7,0l.53.53a.48.48,0,0,1,0,.7L15.24,12Z"]
  };
  
  var backspaceOutlined = {
    prefix: 'axis',
    iconName: 'backspaceOutlined',
    icon: [24, 24, [], "f0000", "M21,4H10.33a2,2,0,0,0-1.42.59L2.29,11.21a1,1,0,0,0-.29.7v.18a1,1,0,0,0,.29.7l6.62,6.62a2,2,0,0,0,1.42.59H21a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4ZM20,18H10.33l-6-6,6-6H20Zm-9.09-3.44.53.53a.48.48,0,0,0,.7,0L14,13.24l1.86,1.85a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7L15.24,12l1.85-1.86a.48.48,0,0,0,0-.7l-.53-.53a.48.48,0,0,0-.7,0L14,10.76,12.14,8.91a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L12.76,12l-1.85,1.86A.48.48,0,0,0,10.91,14.56Z"]
  };
  
  var capsLock = {
    prefix: 'axis',
    iconName: 'capsLock',
    icon: [24, 24, [], "f0000", "M6.85,12.85l-.7-.71a.48.48,0,0,1,0-.7l5.13-5.15a.75.75,0,0,1,.53-.22h.38a.77.77,0,0,1,.53.22l5.13,5.15a.48.48,0,0,1,0,.7l-.71.71a.5.5,0,0,1-.7,0L12,8.4,7.56,12.85A.5.5,0,0,1,6.85,12.85ZM6,16.5v1a.5.5,0,0,0,.5.5h11a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H6.5A.5.5,0,0,0,6,16.5Z"]
  };
  
  var commandKey = {
    prefix: 'axis',
    iconName: 'commandKey',
    icon: [24, 24, [], "f0000", "M17.5,14H16V10h1.5A3.5,3.5,0,1,0,14,6.5V8H10V6.5A3.5,3.5,0,1,0,6.5,10H8v4H6.5A3.5,3.5,0,1,0,10,17.5V16h4v1.5A3.5,3.5,0,1,0,17.5,14ZM16,6.5A1.5,1.5,0,1,1,17.5,8H16ZM6.5,8A1.5,1.5,0,1,1,8,6.5V8ZM8,17.5A1.5,1.5,0,1,1,6.5,16H8ZM10,14V10h4v4Zm7.5,5A1.5,1.5,0,0,1,16,17.5V16h1.5a1.5,1.5,0,0,1,0,3Z"]
  };
  
  var enter = {
    prefix: 'axis',
    iconName: 'enter',
    icon: [24, 24, [], "f0000", "M21,6.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V11H6.33L9.77,7.56a.49.49,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L3.22,11.28a.77.77,0,0,0-.22.53v.38a.75.75,0,0,0,.22.53l5.14,5.13a.5.5,0,0,0,.71,0l.71-.7a.5.5,0,0,0,0-.71L6.33,13H19a2,2,0,0,0,2-2ZM5.33,12Z"]
  };
  
  var keyboardBrightness1 = {
    prefix: 'axis',
    iconName: 'keyboardBrightness1',
    icon: [24, 24, [], "f0000", "M23,15.5v1a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h3A.5.5,0,0,1,23,15.5ZM4.5,15h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,4.5,15Zm12,0h-9a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,16.5,15Zm-5-6h1a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v3A.5.5,0,0,0,11.5,9ZM7.4,10,5.28,7.87a.48.48,0,0,0-.7,0l-.71.71a.48.48,0,0,0,0,.7L6,11.4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,7.4,10ZM20.13,8.58l-.71-.71a.48.48,0,0,0-.7,0L16.6,10a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l2.12-2.12A.48.48,0,0,0,20.13,8.58Z"]
  };
  
  var keyboardBrightness2 = {
    prefix: 'axis',
    iconName: 'keyboardBrightness2',
    icon: [24, 24, [], "f0000", "M21,15.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,21,15.5ZM4.5,15h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,4.5,15Zm12,0h-9a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,16.5,15Zm-5-6h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,11.5,9ZM18,9.28a.51.51,0,0,0-.71,0l-.7.71a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l.71-.7a.51.51,0,0,0,0-.71ZM7.4,10l-.7-.71a.51.51,0,0,0-.71,0L5.28,10a.51.51,0,0,0,0,.71l.71.7a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,7.4,10Z"]
  };
  
  var spaceBar = {
    prefix: 'axis',
    iconName: 'spaceBar',
    icon: [24, 24, [], "f0000", "M5,15V11.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V15a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V11.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V15Z"]
  };
  
  var tabKey = {
    prefix: 'axis',
    iconName: 'tabKey',
    icon: [24, 24, [], "f0000", "M2.5,13H14.67l-3.45,3.44a.5.5,0,0,0,0,.71l.71.7a.5.5,0,0,0,.71,0l5.14-5.13a.75.75,0,0,0,.22-.53v-.38a.77.77,0,0,0-.22-.53L12.64,6.15a.5.5,0,0,0-.71,0l-.71.71a.49.49,0,0,0,0,.7L14.67,11H2.5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,2.5,13Zm13.17-1ZM22,17.5V6.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v11a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,22,17.5Z"]
  };
  
  var beijing = {
    prefix: 'axis',
    iconName: 'beijing',
    icon: [24, 24, [], "f0000", "M23,19.28l-1.87-3.73a1,1,0,0,0-.89-.55H19V13h1.88a2,2,0,0,0,1.41-.59l.56-.56A.5.5,0,0,0,22.5,11H18V9h1.88a2,2,0,0,0,1.41-.59l.56-.56A.5.5,0,0,0,21.5,7H19a2,2,0,0,1-2-2V4.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,1-.5.5h-5A.5.5,0,0,1,9,5.5v-1A.5.5,0,0,0,8.5,4h-1a.5.5,0,0,0-.5.5V5A2,2,0,0,1,5,7H2.5a.5.5,0,0,0-.35.85l.56.56A2,2,0,0,0,4.12,9H6v2H1.5a.5.5,0,0,0-.35.85l.56.56A2,2,0,0,0,3.12,13H5v2H3.81a1,1,0,0,0-.89.55L1.05,19.28A.5.5,0,0,0,1.5,20h21A.5.5,0,0,0,23,19.28ZM16,9v2H8V9ZM7,13H17v2H7Z"]
  };
  
  var bratislava = {
    prefix: 'axis',
    iconName: 'bratislava',
    icon: [24, 24, [], "f0000", "M23,6.7a1.94,1.94,0,0,0-.46-1.26L20.72,3.27A.74.74,0,0,0,20.15,3h-.3a.74.74,0,0,0-.57.27L18,4.8,16.72,3.27A.74.74,0,0,0,16.15,3h-.3a.74.74,0,0,0-.57.27L13.46,5.44A1.94,1.94,0,0,0,13,6.7V8H7V6.7a1.94,1.94,0,0,0-.46-1.26L4.72,3.27A.74.74,0,0,0,4.15,3h-.3a.74.74,0,0,0-.57.27L1.46,5.44A1.94,1.94,0,0,0,1,6.7V20a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1ZM19,12h2v7H19Zm-2,7H3V7H5V9.5a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,.5-.5V7h2m2,3V7h2v3ZM5.5,14h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,5.5,14Zm8,0h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,13.5,14Zm-4,0h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,9.5,14Z"]
  };
  
  var broadleafTree = {
    prefix: 'axis',
    iconName: 'broadleafTree',
    icon: [24, 24, [], "f0000", "M13.16,17.91l.29,3.55A.49.49,0,0,1,13,22H11a.49.49,0,0,1-.49-.54l.29-3.55a8,8,0,1,1,2.32,0Z"]
  };
  
  var broadleafTreeOutlined = {
    prefix: 'axis',
    iconName: 'broadleafTreeOutlined',
    icon: [24, 24, [], "f0000", "M20,10a8,8,0,1,0-9.16,7.91l-.29,3.55A.49.49,0,0,0,11,22H13a.49.49,0,0,0,.49-.54l-.29-3.55A8,8,0,0,0,20,10Zm-8,6a6,6,0,1,1,6-6A6,6,0,0,1,12,16Z"]
  };
  
  var cafe = {
    prefix: 'axis',
    iconName: 'cafe',
    icon: [24, 24, [], "f0000", "M19,5H17V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V5.46a5.46,5.46,0,0,0,.1,1.07l1.45,8A3,3,0,0,0,7.5,17h5a3,3,0,0,0,2.95-2.46L16.09,11H19a2,2,0,0,0,2-2V7A2,2,0,0,0,19,5Zm0,4H16.45l.37-2H19ZM17.5,19H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h14a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,17.5,19Z"]
  };
  
  var cafeOutlined = {
    prefix: 'axis',
    iconName: 'cafeOutlined',
    icon: [24, 24, [], "f0000", "M19,5H17V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V5.46a5.46,5.46,0,0,0,.1,1.07l1.45,8A3,3,0,0,0,7.5,17h5a3,3,0,0,0,2.95-2.46L16.09,11H19a2,2,0,0,0,2-2V7A2,2,0,0,0,19,5Zm-4,.46a4.17,4.17,0,0,1-.06.71l-1.46,8a1,1,0,0,1-1,.82h-5a1,1,0,0,1-1-.82l-1.46-8A4.17,4.17,0,0,1,5,5.46V5H15ZM19,9H16.45l.37-2H19ZM17.5,19H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h14a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,17.5,19Z"]
  };
  
  var cairo = {
    prefix: 'axis',
    iconName: 'cairo',
    icon: [24, 24, [], "f0000", "M22.86,18.45l-5.71-7.14a.75.75,0,0,0-.6-.31h-.32a.78.78,0,0,0-.61.31l-1.83,2.3L10,8.31A.75.75,0,0,0,9.36,8H9.05a.77.77,0,0,0-.61.31L1.14,18.45a.74.74,0,0,0,0,.81l.21.36A.74.74,0,0,0,2,20H22a.74.74,0,0,0,.65-.38l.21-.36A.74.74,0,0,0,22.86,18.45ZM3.93,18l5.28-7.33L11.49,18ZM18,8a2,2,0,1,0-2-2A2,2,0,0,0,18,8Z"]
  };
  
  var castl = {
    prefix: 'axis',
    iconName: 'castl',
    icon: [24, 24, [], "f0000", "M20,3.5V8.76a3,3,0,0,1-.88,2.12l-1.83,1.83a1,1,0,0,0-.29.7V20.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5V16.41a1,1,0,0,0-.29-.7l-.42-.42a1,1,0,0,0-.7-.29H11.41a1,1,0,0,0-.7.29l-.42.42a1,1,0,0,0-.29.7V20.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5V13.41a1,1,0,0,0-.29-.7L4.88,10.88A3,3,0,0,1,4,8.76V3.5A.5.5,0,0,1,4.5,3h2a.5.5,0,0,1,.5.5v2a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v2a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,1,.5-.5h2A.5.5,0,0,1,20,3.5Z"]
  };
  
  var city = {
    prefix: 'axis',
    iconName: 'city',
    icon: [24, 24, [], "f0000", "M23,19.5a.5.5,0,0,0-.5-.5H20V8a1,1,0,0,0-1-1H15V4a1,1,0,0,0-1-1H10A1,1,0,0,0,9,4v7H5a1,1,0,0,0-1,1v7H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5ZM16.5,9h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,16.5,9Zm0,4h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,16.5,13Zm0,4h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,16.5,17Zm-5-8h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,11.5,9Zm0,4h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,11.5,13ZM13,5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,13,5.5ZM7.5,19h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,7.5,19Zm0-4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,7.5,15ZM11,18.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,11,18.5Z"]
  };
  
  var clinic = {
    prefix: 'axis',
    iconName: 'clinic',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM18,13.5a.5.5,0,0,1-.5.5H14v3.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5V14H6.5a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5H10V6.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5V10h3.5a.5.5,0,0,1,.5.5Z"]
  };
  
  var company = {
    prefix: 'axis',
    iconName: 'company',
    icon: [24, 24, [], "f0000", "M22.5,19H19V4a1,1,0,0,0-1-1H6A1,1,0,0,0,5,4V19H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,19Zm-6-8h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,16.5,11Zm-8,0h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,7.5,9h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,8.5,11ZM9,13.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,9,13.5Zm6.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,15.5,13Zm1-6h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,16.5,7ZM9,5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,7,6.5v-1A.5.5,0,0,1,7.5,5h1A.5.5,0,0,1,9,5.5ZM7.5,17h9a.5.5,0,0,1,.5.5V19H7V17.5A.5.5,0,0,1,7.5,17Zm5-6h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,12.5,11Zm-1,2h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,11.5,13Zm1-6h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,12.5,7Z"]
  };
  
  var conifer = {
    prefix: 'axis',
    iconName: 'conifer',
    icon: [24, 24, [], "f0000", "M18.91,17.38l-.14.25a.76.76,0,0,1-.65.37h-5l.28,3.46A.49.49,0,0,1,13,22H11a.49.49,0,0,1-.49-.54L10.83,18h-5a.76.76,0,0,1-.65-.37l-.14-.25c-.14-.24-.14-.52.27-1.22L7.79,12H7.17a.76.76,0,0,1-.65-.37l-.14-.25c-.14-.24-.14-.52.27-1.22l4.56-7.79A.74.74,0,0,1,11.86,2h.28a.74.74,0,0,1,.64.37l4.65,8c.32.54.32.82.18,1.06l-.14.25a.76.76,0,0,1-.65.37H16.2l2.53,4.32C19.05,16.86,19.05,17.14,18.91,17.38Z"]
  };
  
  var coniferOutlined = {
    prefix: 'axis',
    iconName: 'coniferOutlined',
    icon: [24, 24, [], "f0000", "M18.73,16.32,16.2,12h.62a.76.76,0,0,0,.65-.37l.14-.25c.14-.24.14-.52-.18-1.06L12.78,2.37A.74.74,0,0,0,12.14,2h-.28a.74.74,0,0,0-.65.37L6.65,10.16c-.41.7-.41,1-.27,1.22l.14.25a.76.76,0,0,0,.65.37h.62L5.35,16.16c-.41.7-.41,1-.27,1.22l.14.25a.76.76,0,0,0,.65.37h5l-.28,3.46A.49.49,0,0,0,11,22H13a.49.49,0,0,0,.49-.54L13.17,18h5a.76.76,0,0,0,.65-.37l.14-.25C19.05,17.14,19.05,16.86,18.73,16.32ZM7.77,16l3.29-5.62a.26.26,0,0,0-.22-.38H9.06L12,5l2.93,5H13.15a.25.25,0,0,0-.21.38L16.23,16Z"]
  };
  
  var direction = {
    prefix: 'axis',
    iconName: 'direction',
    icon: [24, 24, [], "f0000", "M22.71,11.21,12.79,1.29a1,1,0,0,0-.7-.29h-.18a1,1,0,0,0-.7.29L1.29,11.21a1,1,0,0,0-.29.7v.18a1,1,0,0,0,.29.7l9.92,9.92a1,1,0,0,0,.7.29h.18a1,1,0,0,0,.7-.29l9.92-9.92a1,1,0,0,0,.29-.7v-.18A1,1,0,0,0,22.71,11.21Zm-4.85.14-3,3A.5.5,0,0,1,14,14V12H9v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V11a1,1,0,0,1,1-1h6V8a.5.5,0,0,1,.85-.35l3,3A.51.51,0,0,1,17.86,11.35Z"]
  };
  
  var dubai = {
    prefix: 'axis',
    iconName: 'dubai',
    icon: [24, 24, [], "f0000", "M19.5,21H18a19.45,19.45,0,0,0-2.64-10H17.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H13.93A11,11,0,0,0,8,5.23V1.5A.5.5,0,0,0,7.5,1h-1a.5.5,0,0,0-.5.5V9H4.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H6V21H4.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,19.5,21ZM9.4,15H15a17.79,17.79,0,0,1,.56,2h-6Zm4.79-2h-5L9,11h4A14.55,14.55,0,0,1,14.19,13ZM8,7.29A8.61,8.61,0,0,1,11.13,9H8ZM9.8,19h6.09c.06.65.11,1.32.11,2H10Z"]
  };
  
  var earthEast = {
    prefix: 'axis',
    iconName: 'earthEast',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18A8,8,0,0,1,11,4.07V4.5a.5.5,0,0,1-.5.5.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.48.48,0,0,1,.5.48.51.51,0,0,0,.5.52A1.5,1.5,0,0,1,16,9.5V11h1a1,1,0,0,0,1-1V9h1.41A7.9,7.9,0,0,1,20,12,8,8,0,0,1,12,20Zm2-10V9.5a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,1-.5-.5.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V9a1,1,0,0,1-1,1,1,1,0,0,0-1,1v1a1,1,0,0,0,1,1H9.59a1,1,0,0,1,.7.29l.42.42a1,1,0,0,1,.29.7V17a1,1,0,0,0,1,1h.5a.5.5,0,0,0,.5-.5.5.5,0,0,1,.5-.5A1.5,1.5,0,0,0,15,15.5v-2a.49.49,0,0,1,.45-.5.52.52,0,0,0,.55-.48V11H15A1,1,0,0,1,14,10Z"]
  };
  
  var earthWest = {
    prefix: 'axis',
    iconName: 'earthWest',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm6,15.27V17a1,1,0,0,0-1-1h-.5a.5.5,0,0,1-.5-.5.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.5-.5.5.5,0,0,0-.5-.5H12v1.5a.51.51,0,0,0,.52.5.48.48,0,0,1,.48.5v3.43A8.26,8.26,0,0,1,12,20,8,8,0,0,1,5.08,8H5.5a.5.5,0,0,1,.5.5V11a1,1,0,0,0,1,1h.5a.5.5,0,0,1,.5.5V13a1,1,0,0,0,1,1h3V12.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1,0-1H11a1,1,0,0,0,1-1V9a1,1,0,0,1,1-1h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H6.73A8,8,0,0,1,18,17.27Z"]
  };
  
  var education = {
    prefix: 'axis',
    iconName: 'education',
    icon: [24, 24, [], "f0000", "M22,9.92V20.5a.5.5,0,0,1-.5.5h-.75a.5.5,0,0,1-.5-.5V11.6l-7.14,5.14a1.49,1.49,0,0,1-.84.26h-.54a1.49,1.49,0,0,1-.84-.26L2.22,10.49A.49.49,0,0,1,2,10.08V9.92a.49.49,0,0,1,.22-.41l8.67-6.25A1.49,1.49,0,0,1,11.73,3h.54a1.49,1.49,0,0,1,.84.26l8.67,6.25A.49.49,0,0,1,22,9.92Zm-9.73,8.83h-.54a3.33,3.33,0,0,1-1.87-.59L6,15.37V17c0,2.21,2.69,4,6,4s6-1.79,6-4V15.37l-3.9,2.81A3.25,3.25,0,0,1,12.27,18.75Z"]
  };
  
  var educationOutlined = {
    prefix: 'axis',
    iconName: 'educationOutlined',
    icon: [24, 24, [], "f0000", "M21.78,9.51,13.11,3.26A1.49,1.49,0,0,0,12.27,3h-.54a1.49,1.49,0,0,0-.84.26L2.22,9.51A.49.49,0,0,0,2,9.92v.16a.49.49,0,0,0,.22.41l8.67,6.25a1.49,1.49,0,0,0,.84.26h.54a1.49,1.49,0,0,0,.84-.26l7.14-5.14v8.9a.5.5,0,0,0,.5.5h.75a.5.5,0,0,0,.5-.5V9.92A.49.49,0,0,0,21.78,9.51ZM12.11,15H11.9L5,10l6.93-5h.21L19,10Zm.16,3.75h-.54a3.33,3.33,0,0,1-1.87-.59L6,15.37V17c0,2.21,2.69,4,6,4s6-1.79,6-4V15.37l-3.9,2.81A3.25,3.25,0,0,1,12.27,18.75Z"]
  };
  
  var factory = {
    prefix: 'axis',
    iconName: 'factory',
    icon: [24, 24, [], "f0000", "M7.5,20h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,7.5,20Zm0-4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,7.5,16Zm5,4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,12.5,20Zm0-4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,12.5,16Zm5,4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,20Zm0-4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,16Zm3-13a1,1,0,0,0-1-1H16.53a1,1,0,0,0-1,1l-.25,8L14,11.77V9.5a.5.5,0,0,0-.5-.5h0a1,1,0,0,0-.55.17L9,11.77V9.5A.5.5,0,0,0,8.5,9h0a1,1,0,0,0-.55.17L3.22,12.29a.5.5,0,0,0-.22.42V20H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H21Z"]
  };
  
  var gasStation = {
    prefix: 'axis',
    iconName: 'gasStation',
    icon: [24, 24, [], "f0000", "M20.56,7.22,16.48,3.15a.48.48,0,0,0-.7,0l-.36.35a.51.51,0,0,0,0,.71L17.5,6.29V8.66a1.5,1.5,0,0,0,.44,1.06l1.56,1.57V17.5a1,1,0,0,1-2,0V13a2,2,0,0,0-2-2H14V5a2,2,0,0,0-2-2H6A2,2,0,0,0,4,5V19a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V12.5h1.5a.5.5,0,0,1,.5.5v4.5a2.5,2.5,0,0,0,5,0V8.29A1.54,1.54,0,0,0,20.56,7.22ZM12,9H6V5h6Z"]
  };
  
  var globe = {
    prefix: 'axis',
    iconName: 'globe',
    icon: [24, 24, [], "f0000", "M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Zm6.92,8H16.35a14.12,14.12,0,0,0-1.18-5.23A7,7,0,0,1,18.92,11Zm-6.47,8L12,19l-.45,0c-.91-.57-2-2.76-2.14-6h5.18C14.41,16.22,13.36,18.41,12.45,19Zm-3-8c.18-3.22,1.23-5.41,2.14-6L12,5l.45,0c.91.57,2,2.76,2.14,6ZM8.83,5.77A14.12,14.12,0,0,0,7.65,11H5.08A7,7,0,0,1,8.83,5.77ZM5.08,13H7.65a14.12,14.12,0,0,0,1.18,5.23A7,7,0,0,1,5.08,13Zm10.09,5.23A14.12,14.12,0,0,0,16.35,13h2.57A7,7,0,0,1,15.17,18.23Z"]
  };
  
  var gym = {
    prefix: 'axis',
    iconName: 'gym',
    icon: [24, 24, [], "f0000", "M20.71,7.78a1,1,0,0,1,.29.71V9.66a1,1,0,0,1-.29.7L19.05,12a1,1,0,0,1-.71.29H17.17a1,1,0,0,1-.71-.29l-1.53-1.53-4.44,4.44L12,16.46a1,1,0,0,1,.29.71v1.17a1,1,0,0,1-.29.71l-1.66,1.66a1,1,0,0,1-.7.29H8.49a1,1,0,0,1-.71-.29L6.24,19.17,4.56,20.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71l1.68-1.68L3.29,16.22A1,1,0,0,1,3,15.51V14.34a1,1,0,0,1,.29-.7L5,12a1,1,0,0,1,.71-.29H6.83a1,1,0,0,1,.71.29l1.53,1.53,4.44-4.44L12,7.54a1,1,0,0,1-.29-.71V5.66A1,1,0,0,1,12,5l1.66-1.66a1,1,0,0,1,.7-.29h1.17a1,1,0,0,1,.71.29l1.54,1.54,1.68-1.68a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71L19.17,6.24Z"]
  };
  
  var hospital = {
    prefix: 'axis',
    iconName: 'hospital',
    icon: [24, 24, [], "f0000", "M21.5,19H19V10a1,1,0,0,0-1-1H17V4a1,1,0,0,0-1-1H8A1,1,0,0,0,7,4V9H6a1,1,0,0,0-1,1v9H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h19a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,19Zm-13,0h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,8.5,19Zm0-4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,8.5,15Zm4,4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,12.5,19Zm0-4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,12.5,15Zm2-6.12H12.88V10.5a.5.5,0,0,1-.5.5h-.76a.5.5,0,0,1-.5-.5V8.88H9.5a.5.5,0,0,1-.5-.5V7.62a.5.5,0,0,1,.5-.5h1.62V5.5a.5.5,0,0,1,.5-.5h.76a.5.5,0,0,1,.5.5V7.12H14.5a.5.5,0,0,1,.5.5v.76A.5.5,0,0,1,14.5,8.88ZM16.5,19h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,16.5,19Zm0-4h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,16.5,15Z"]
  };
  
  var hotel = {
    prefix: 'axis',
    iconName: 'hotel',
    icon: [24, 24, [], "f0000", "M22,19.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V16H4v3.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V4.5A.5.5,0,0,1,2.5,4h1a.5.5,0,0,1,.5.5V13H21a1,1,0,0,1,1,1ZM20,8H12a2,2,0,0,0-2,2v1.5a.5.5,0,0,0,.5.5h11a.5.5,0,0,0,.5-.5V10A2,2,0,0,0,20,8ZM5.5,12h3a.5.5,0,0,0,.5-.5V11a2,2,0,0,0-4,0v.5A.5.5,0,0,0,5.5,12Z"]
  };
  
  var locationOff = {
    prefix: 'axis',
    iconName: 'locationOff',
    icon: [24, 24, [], "f0000", "M4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L5.77,7a7.84,7.84,0,0,0-1.7,4H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H4.07A8,8,0,0,0,11,19.93V21.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19.93a7.84,7.84,0,0,0,4-1.7l2.63,2.62a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM12,18a6,6,0,0,1-6-6A5.92,5.92,0,0,1,7.19,8.43l8.38,8.38A5.92,5.92,0,0,1,12,18Zm9.5-7H19.93A8,8,0,0,0,13,4.07V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4.07a7.75,7.75,0,0,0-2.48.74L10,6.33A5.76,5.76,0,0,1,12,6a6,6,0,0,1,6,6,5.76,5.76,0,0,1-.33,2l1.52,1.52A7.75,7.75,0,0,0,19.93,13H21.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11Z"]
  };
  
  var locationSearch = {
    prefix: 'axis',
    iconName: 'locationSearch',
    icon: [24, 24, [], "f0000", "M21.5,11H19.93A8,8,0,0,0,13,4.07V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4.07A8,8,0,0,0,4.07,11H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H4.07A8,8,0,0,0,11,19.93V21.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19.93A8,8,0,0,0,19.93,13H21.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11ZM12,18a6,6,0,1,1,6-6A6,6,0,0,1,12,18Z"]
  };
  
  var machuPicchu = {
    prefix: 'axis',
    iconName: 'machuPicchu',
    icon: [24, 24, [], "f0000", "M22.23,13.84a1,1,0,0,0-1-.84H19.76l-.53-3.16a1,1,0,0,0-1-.84H16V5h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H8V9H5.76a1,1,0,0,0-1,.84L4.24,13H2.76a1,1,0,0,0-1,.84L1,18.42A.5.5,0,0,0,1.5,19H8v1.5a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5V19h6.5a.5.5,0,0,0,.49-.58ZM17.73,13H14.8l-.4-2h3ZM10,9V6.41a1,1,0,0,1,.29-.7l.42-.42a1,1,0,0,1,.7-.29h1.18a1,1,0,0,1,.7.29l.42.42a1,1,0,0,1,.29.7V9ZM6.6,11h3l-.4,2H6.27ZM3.27,17l.33-2H8.8l-.4,2ZM10,19l1.6-8h.72L14,19Zm5.56-2-.4-2h5.2l.33,2Z"]
  };
  
  var map = {
    prefix: 'axis',
    iconName: 'map',
    icon: [24, 24, [], "f0000", "M20.5,3h-.3a2,2,0,0,0-.77.15L15,5,10.75,3.23A3,3,0,0,0,9.6,3H8.4a3,3,0,0,0-1.15.23L3.62,4.74A1,1,0,0,0,3,5.67V20.5a.5.5,0,0,0,.5.5h.3a2,2,0,0,0,.77-.15L9,19l4.25,1.77A3,3,0,0,0,14.4,21h1.2a3,3,0,0,0,1.15-.23l3.63-1.51a1,1,0,0,0,.62-.93V3.5A.5.5,0,0,0,20.5,3ZM14,18.92,9.77,17.15,9,16.83V5h.6a1,1,0,0,1,.38.08l4.25,1.77.77.32V19h-.6A1,1,0,0,1,14,18.92Z"]
  };
  
  var map2d = {
    prefix: 'axis',
    iconName: 'map2d',
    icon: [24, 24, [], "f0000", "M4.00541 12.7135C4.2467 15.2337 5.81513 17.3652 8.00692 18.3974L8.89838 17.5126L11.4521 20.0664L11.0097 20.0865C6.79373 20.0865 3.34184 16.8424 3 12.7135H4.00541ZM10.5674 4.02011L11.0098 4C15.2258 4 18.6776 7.24411 19.0128 11.3663H18.0074C17.7728 8.84605 16.2044 6.7213 14.0126 5.68238L13.1211 6.57384L10.5674 4.02011ZM7 14.4176V15H10.4699V14.2617H8.18125L9.24355 12.9041C9.57168 12.4858 9.77129 12.226 9.84238 12.1248C9.91621 12.0237 10.0037 11.8828 10.1049 11.7024C10.3346 11.2949 10.4494 10.8834 10.4494 10.4678C10.4494 10.0549 10.3496 9.71858 10.15 9.45881C9.87656 9.10061 9.42949 8.92151 8.80879 8.92151C8.19082 8.92151 7.73281 9.09514 7.43477 9.44241C7.20508 9.71038 7.0752 10.0481 7.04512 10.4555L7.86543 10.5211C7.89824 10.3461 7.9625 10.1807 8.0582 10.0248C8.21406 9.78147 8.45332 9.65979 8.77598 9.65979C9.29551 9.65979 9.55527 9.91545 9.55527 10.4268C9.55527 10.6865 9.48281 10.9682 9.33789 11.2717C9.1957 11.5752 8.97285 11.9198 8.66934 12.3053L7 14.4176ZM11.4424 9.00354V15H13.4152C14.9355 15.0164 15.6766 14.2481 15.6383 12.6949V11.3045C15.6383 10.826 15.585 10.4446 15.4783 10.1602C15.3744 9.87307 15.198 9.62834 14.9492 9.426C14.7633 9.27561 14.55 9.1676 14.3094 9.10198C14.0715 9.03635 13.7734 9.00354 13.4152 9.00354H11.4424ZM13.2594 14.274H12.3406V9.72952H13.2594C13.7953 9.72952 14.1754 9.8553 14.3996 10.1069C14.6266 10.3584 14.74 10.785 14.74 11.3865V12.617C14.74 13.2377 14.6102 13.6821 14.3504 13.95C14.1426 14.166 13.7789 14.274 13.2594 14.274Z"]
  };
  
  var map3d = {
    prefix: 'axis',
    iconName: 'map3d',
    icon: [24, 24, [], "f0000", "M5.00541 12.7135C5.2467 15.2337 6.81513 17.3652 9.00692 18.3974L9.89838 17.5126L12.4521 20.0664L12.0097 20.0865C7.79373 20.0865 4.34184 16.8424 4 12.7135H5.00541ZM11.5674 4.02011L12.0098 4C16.2258 4 19.6776 7.24411 20.0128 11.3663H19.0074C18.7728 8.84605 17.2044 6.7213 15.0126 5.68238L14.1211 6.57384L11.5674 4.02011ZM9.12383 11.5676V12.273H9.66113C9.90996 12.273 10.1287 12.3373 10.3174 12.4658C10.6127 12.6682 10.7604 12.9771 10.7604 13.3928C10.7604 13.6963 10.6824 13.9437 10.5266 14.1352C10.368 14.3293 10.1246 14.4264 9.79648 14.4264C9.24961 14.4264 8.93379 14.1666 8.84902 13.6471L8 13.7496C8.09297 14.6902 8.70137 15.1605 9.8252 15.1605C10.4951 15.1605 10.9805 14.9814 11.2812 14.6232C11.5301 14.3279 11.6545 13.9273 11.6545 13.4215C11.6545 12.9238 11.5219 12.5328 11.2566 12.2484C11.1582 12.1391 10.9996 12.027 10.7809 11.9121C11.0461 11.759 11.232 11.5854 11.3387 11.3912C11.448 11.1971 11.5027 10.9373 11.5027 10.6119C11.5027 10.1225 11.377 9.73828 11.1254 9.45937C10.8465 9.15312 10.4186 9 9.8416 9C8.82441 9 8.26523 9.45391 8.16406 10.3617L8.95977 10.4273C9.00352 10.2059 9.09785 10.035 9.24277 9.91465C9.39043 9.79434 9.57637 9.73418 9.80059 9.73418C10.0549 9.73418 10.2531 9.81348 10.3953 9.97207C10.5375 10.1307 10.6086 10.3535 10.6086 10.6406C10.6086 10.925 10.5184 11.1506 10.3379 11.3174C10.1574 11.4842 9.91406 11.5676 9.60781 11.5676H9.12383ZM12.5326 9.08203V15.0785H14.5055C16.0258 15.0949 16.7668 14.3266 16.7285 12.7734V11.383C16.7285 10.9045 16.6752 10.523 16.5686 10.2387C16.4646 9.95156 16.2883 9.70684 16.0395 9.50449C15.8535 9.3541 15.6402 9.24609 15.3996 9.18047C15.1617 9.11484 14.8637 9.08203 14.5055 9.08203H12.5326ZM14.3496 14.3525H13.4309V9.80801H14.3496C14.8855 9.80801 15.2656 9.93379 15.4898 10.1854C15.7168 10.4369 15.8303 10.8635 15.8303 11.465V12.6955C15.8303 13.3162 15.7004 13.7605 15.4406 14.0285C15.2328 14.2445 14.8691 14.3525 14.3496 14.3525Z"]
  };
  
  var mapOutlined = {
    prefix: 'axis',
    iconName: 'mapOutlined',
    icon: [24, 24, [], "f0000", "M20.5,3h-.3a2,2,0,0,0-.77.15L15,5,10.75,3.23A3,3,0,0,0,9.6,3H8.4a3,3,0,0,0-1.15.23L3.62,4.74A1,1,0,0,0,3,5.67V20.5a.5.5,0,0,0,.5.5h.3a2,2,0,0,0,.77-.15L9,19l4.25,1.77A3,3,0,0,0,14.4,21h1.2a3,3,0,0,0,1.15-.23l3.63-1.51a1,1,0,0,0,.62-.93V3.5A.5.5,0,0,0,20.5,3ZM5,6.33,8,5.08V17.25L5,18.5Zm5,10.92V5.08l4,1.67V18.92Zm9,.42-3,1.25V6.75L19,5.5Z"]
  };
  
  var mapZoomOut = {
    prefix: 'axis',
    iconName: 'mapZoomOut',
    icon: [24, 24, [], "f0000", "M9.85,8.44a.5.5,0,0,1,0,.71l-.7.7a.5.5,0,0,1-.71,0L5.28,6.68,3.86,8.1A.5.5,0,0,1,3,7.75V3.5A.52.52,0,0,1,3.5,3H7.75a.5.5,0,0,1,.36.85L6.69,5.27Zm-.7,5.71a.5.5,0,0,0-.71,0L5.27,17.31,3.85,15.89a.5.5,0,0,0-.85.36V20.5a.52.52,0,0,0,.5.5H7.75a.5.5,0,0,0,.35-.85L6.68,18.72l3.17-3.16a.5.5,0,0,0,0-.71Zm11,1.75-1.42,1.42-3.16-3.17a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71l3.16,3.17-1.42,1.42a.5.5,0,0,0,.36.85H20.5a.52.52,0,0,0,.5-.5V16.25A.5.5,0,0,0,20.14,15.9ZM20.5,3H16.25a.5.5,0,0,0-.35.85l1.42,1.42L14.15,8.44a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l3.17-3.16,1.42,1.42A.5.5,0,0,0,21,7.75V3.5A.52.52,0,0,0,20.5,3Z"]
  };
  
  var museum = {
    prefix: 'axis',
    iconName: 'museum',
    icon: [24, 24, [], "f0000", "M4.5,17h15a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5H18V7h1.5a.5.5,0,0,0,.5-.5V4.67a1,1,0,0,0-.62-.92L13,1.15A2,2,0,0,0,12.22,1h-.44a2,2,0,0,0-.76.15l-6.4,2.6A1,1,0,0,0,4,4.67V6.5a.5.5,0,0,0,.5.5H6v7H4.5a.5.5,0,0,0-.5.5v2A.5.5,0,0,0,4.5,17ZM13,7h3v7H13ZM8,7h3v7H8ZM20.5,19H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,19Z"]
  };
  
  var myLocation = {
    prefix: 'axis',
    iconName: 'myLocation',
    icon: [24, 24, [], "f0000", "M21.5,11H19.93A8,8,0,0,0,13,4.07V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4.07A8,8,0,0,0,4.07,11H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H4.07A8,8,0,0,0,11,19.93V21.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19.93A8,8,0,0,0,19.93,13H21.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11ZM12,18a6,6,0,1,1,6-6A6,6,0,0,1,12,18Zm0-8a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z"]
  };
  
  var navigate = {
    prefix: 'axis',
    iconName: 'navigate',
    icon: [24, 24, [], "f0000", "M19,19.93a.51.51,0,0,1-.12.54l-.38.38a.49.49,0,0,1-.68,0,8.43,8.43,0,0,0-11.58,0,.49.49,0,0,1-.68,0l-.38-.38A.51.51,0,0,1,5,19.93L11.38,3.32A.51.51,0,0,1,11.85,3h.3a.51.51,0,0,1,.47.32Z"]
  };
  
  var navigateOutlined = {
    prefix: 'axis',
    iconName: 'navigateOutlined',
    icon: [24, 24, [], "f0000", "M12,7.3l3.82,10a10.1,10.1,0,0,0-7.64,0L12,7.3M12.15,3h-.3a.51.51,0,0,0-.47.32L5,19.93a.51.51,0,0,0,.12.54l.38.38a.49.49,0,0,0,.35.15.46.46,0,0,0,.33-.13A8.61,8.61,0,0,1,12,18.56a8.61,8.61,0,0,1,5.79,2.31.46.46,0,0,0,.33.13.49.49,0,0,0,.35-.15l.38-.38a.51.51,0,0,0,.12-.54L12.62,3.32A.51.51,0,0,0,12.15,3Z"]
  };
  
  var neighborhood = {
    prefix: 'axis',
    iconName: 'neighborhood',
    icon: [24, 24, [], "f0000", "M23.5,19H22V15.29a1,1,0,0,0-.45-.84l-2-1.37a.57.57,0,0,0-.28-.08h-.45a.57.57,0,0,0-.28.08l-1.5,1V6.62a1,1,0,0,0-.44-.83l-4-2.71A.57.57,0,0,0,12.23,3h-.45a.57.57,0,0,0-.28.08l-4,2.7A1,1,0,0,0,7,6.62v7.46l-1.49-1A.57.57,0,0,0,5.23,13H4.78a.57.57,0,0,0-.28.08l-2,1.37a1,1,0,0,0-.45.84V19H.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h23a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,23.5,19ZM6,18.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm5,0a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm0-4a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm0-4a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,9.5,9h1a.5.5,0,0,1,.5.5Zm4,8a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm0-4a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm0-4a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm5,8a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Z"]
  };
  
  var newYork = {
    prefix: 'axis',
    iconName: 'newYork',
    icon: [24, 24, [], "f0000", "M4,3.5A1.5,1.5,0,0,1,5.5,2V1.35A.35.35,0,0,1,5.85,1,2,2,0,0,1,7.5,3a2,2,0,0,1-2,2A1.5,1.5,0,0,1,4,3.5Zm6,7.12v1.67A1.71,1.71,0,0,0,11.71,14h.58A1.71,1.71,0,0,0,14,12.29V10.62l1.79-1.29a.51.51,0,0,0,.12-.7l-.29-.42a.51.51,0,0,0-.7-.12L14,8.71a.79.79,0,0,1-1.23-.64l0-1.58a.51.51,0,0,0-.5-.49h-.52a.51.51,0,0,0-.5.49l0,1.58A.79.79,0,0,1,10,8.71l-.91-.62a.51.51,0,0,0-.7.12l-.29.42a.51.51,0,0,0,.12.7Zm10.78,8.93A.75.75,0,0,0,21,19v-.38a.75.75,0,0,0-.22-.53l-1.4-1.4a1,1,0,0,0-1.42,0l-1,1a2,2,0,0,0-.58-1.32l-.77-.77A2,2,0,0,0,14.22,15H10.37a3,3,0,0,1-2.3-1.08l-.61-.73a3,3,0,0,1-.65-1.42L6.18,8H6.5A.5.5,0,0,0,7,7.5v-1A.5.5,0,0,0,6.5,6h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h.65l.68,4.09a5.09,5.09,0,0,0,1.09,2.38l.08.09v1.91a1,1,0,0,0,.23.64L8,19.23V22.5a.5.5,0,0,0,.5.5h8.41a1,1,0,0,0,.71-.29Z"]
  };
  
  var paris = {
    prefix: 'axis',
    iconName: 'paris',
    icon: [24, 24, [], "f0000", "M19.88,22.36a30.81,30.81,0,0,1-3-4.36h.62a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H15.84A30.23,30.23,0,0,1,14,11h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a30,30,0,0,1-.44-3.29c0-.23,0-.47,0-.71h.46a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H13V1.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V3h-.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H11c0,.24,0,.48,0,.71A30,30,0,0,1,10.48,9h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H10a30.23,30.23,0,0,1-1.84,5H6.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h.62a30.81,30.81,0,0,1-3,4.36.47.47,0,0,0-.12.32v.07a.25.25,0,0,0,.25.25H6.47a1,1,0,0,0,.82-.43c.33-.48.64-1,.93-1.46a4.44,4.44,0,0,1,7.56,0c.29.5.6,1,.93,1.46a1,1,0,0,0,.82.43h2.22a.25.25,0,0,0,.25-.25v-.07A.47.47,0,0,0,19.88,22.36Zm-7-6.36H11.08a.25.25,0,0,1-.23-.33c.25-.67.47-1.34.68-2a.49.49,0,0,1,.94,0c.21.68.43,1.35.68,2A.25.25,0,0,1,12.92,16Z"]
  };
  
  var parking = {
    prefix: 'axis',
    iconName: 'parking',
    icon: [24, 24, [], "f0000", "M18,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V4A2,2,0,0,0,18,2Zm-2,9a3,3,0,0,1-3,3H10v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-9A.5.5,0,0,1,8.5,7H13a3,3,0,0,1,3,3ZM13,9H10v3h3a1,1,0,0,0,1-1V10A1,1,0,0,0,13,9Z"]
  };
  
  var parkingOutlined = {
    prefix: 'axis',
    iconName: 'parkingOutlined',
    icon: [24, 24, [], "f0000", "M18,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V4A2,2,0,0,0,18,2Zm0,18H6V4H18ZM8.5,17h1a.5.5,0,0,0,.5-.5V14h3a3,3,0,0,0,3-3V10a3,3,0,0,0-3-3H8.5a.5.5,0,0,0-.5.5v9A.5.5,0,0,0,8.5,17ZM10,9h3a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1H10Z"]
  };
  
  var pharmacy = {
    prefix: 'axis',
    iconName: 'pharmacy',
    icon: [24, 24, [], "f0000", "M20.71,9.48a2,2,0,0,0,.29-1V8a1,1,0,0,0-1-1H18.14L19,3.89a.5.5,0,0,0-.35-.61l-1-.26a.51.51,0,0,0-.62.35L16.06,7H4A1,1,0,0,0,3,8v.45a2,2,0,0,0,.29,1L5.38,13a2,2,0,0,1,0,2.06L3.29,18.52a2,2,0,0,0-.29,1V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1v-.45a2,2,0,0,0-.29-1L18.62,15a2,2,0,0,1,0-2.06ZM15,14.38a.5.5,0,0,1-.5.5H12.88V16.5a.5.5,0,0,1-.5.5h-.76a.5.5,0,0,1-.5-.5V14.88H9.5a.5.5,0,0,1-.5-.5v-.76a.5.5,0,0,1,.5-.5h1.62V11.5a.5.5,0,0,1,.5-.5h.76a.5.5,0,0,1,.5.5v1.62H14.5a.5.5,0,0,1,.5.5Z"]
  };
  
  var pharmacyOutlined = {
    prefix: 'axis',
    iconName: 'pharmacyOutlined',
    icon: [24, 24, [], "f0000", "M20.71,9.48a2,2,0,0,0,.29-1V8a1,1,0,0,0-1-1H18.14L19,3.89a.5.5,0,0,0-.35-.61l-1-.26a.51.51,0,0,0-.62.35L16.06,7H4A1,1,0,0,0,3,8v.45a2,2,0,0,0,.29,1L5.38,13a2,2,0,0,1,0,2.06L3.29,18.52a2,2,0,0,0-.29,1V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1v-.45a2,2,0,0,0-.29-1L18.62,15a2,2,0,0,1,0-2.06ZM16.9,16.06,18.67,19H5.33L7.1,16.06a4,4,0,0,0,0-4.12L5.33,9H18.67L16.9,11.94A4,4,0,0,0,16.9,16.06Zm-2.4-2.94H12.88V11.5a.5.5,0,0,0-.5-.5h-.76a.5.5,0,0,0-.5.5v1.62H9.5a.5.5,0,0,0-.5.5v.76a.5.5,0,0,0,.5.5h1.62V16.5a.5.5,0,0,0,.5.5h.76a.5.5,0,0,0,.5-.5V14.88H14.5a.5.5,0,0,0,.5-.5v-.76A.5.5,0,0,0,14.5,13.12Z"]
  };
  
  var pin = {
    prefix: 'axis',
    iconName: 'pin',
    icon: [24, 24, [], "f0000", "M20.34,9.14l-1.44.51a2,2,0,0,0-1,.78l-2.13,3.2a3,3,0,0,0-.52,1.69v1.49a1,1,0,0,1-.29.71l-.42.41a1,1,0,0,1-1.41,0L6.07,10.86a1,1,0,0,1,0-1.41L6.48,9a1,1,0,0,1,.71-.29H8.68a3,3,0,0,0,1.69-.52l3.2-2.13a2,2,0,0,0,.78-1l.51-1.44a1,1,0,0,1,1.65-.37l4.2,4.2A1,1,0,0,1,20.34,9.14ZM4.43,17.44a3,3,0,0,0-.67,1L3,20.27a.5.5,0,0,0,.11.54l0,0a.5.5,0,0,0,.54.11l1.81-.72a3,3,0,0,0,1-.67l2.91-2.91L7.35,14.52Z"]
  };
  
  var pinOutlined = {
    prefix: 'axis',
    iconName: 'pinOutlined',
    icon: [24, 24, [], "f0000", "M20.71,7.49l-4.2-4.2a1,1,0,0,0-.7-.29,1,1,0,0,0-1,.66L14.35,5.1a2,2,0,0,1-.78,1l-3.2,2.13a3,3,0,0,1-1.69.52H7.19A1,1,0,0,0,6.48,9l-.41.42a1,1,0,0,0,0,1.41l7.07,7.07a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l.42-.41a1,1,0,0,0,.29-.71V15.32a3,3,0,0,1,.52-1.69l2.13-3.2a2,2,0,0,1,1-.78l1.44-.51A1,1,0,0,0,20.71,7.49ZM16.54,8.87l-3.85,5.79L9.34,11.31l5.79-3.85L16.49,6.1,17.9,7.51ZM4.43,17.44a3,3,0,0,0-.67,1L3,20.27a.5.5,0,0,0,.11.54l0,0a.5.5,0,0,0,.54.11l1.81-.72a3,3,0,0,0,1-.67l2.91-2.91L7.35,14.52Z"]
  };
  
  var poi = {
    prefix: 'axis',
    iconName: 'poi',
    icon: [24, 24, [], "f0000", "M12,2a8,8,0,0,0-8,8c0,6.22,5.05,6.17,6.26,9.78l.51,1.54a1,1,0,0,0,1,.68h.56a1,1,0,0,0,1-.68l.51-1.54C15,16.17,20,16.22,20,10A8,8,0,0,0,12,2Zm0,11a3,3,0,1,1,3-3A3,3,0,0,1,12,13Z"]
  };
  
  var poiAdd = {
    prefix: 'axis',
    iconName: 'poiAdd',
    icon: [24, 24, [], "f0000", "M16,10.5a.5.5,0,0,1-.5.5H13v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V11H8.5a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,8.5,9H11V6.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V9h2.5a.5.5,0,0,1,.5.5ZM12,2a8,8,0,0,0-8,8c0,6.22,5.05,6.17,6.26,9.78l.51,1.54a1,1,0,0,0,1,.68h.56a1,1,0,0,0,1-.68l.51-1.54C15,16.17,20,16.22,20,10a8,8,0,0,0-8-8Z"]
  };
  
  var poiAddOutlined = {
    prefix: 'axis',
    iconName: 'poiAddOutlined',
    icon: [24, 24, [], "f0000", "M16,9.5v1a.5.5,0,0,1-.5.5H13v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V11H8.5a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,8.5,9H11V6.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V9h2.5A.5.5,0,0,1,16,9.5ZM12,4a6,6,0,0,0-6,6c0,2.8,1.18,3.74,2.82,5A9.17,9.17,0,0,1,12,18.73,9.25,9.25,0,0,1,15.18,15C16.82,13.74,18,12.8,18,10a6,6,0,0,0-6-6m0-2a8,8,0,0,1,8,8c0,6.22-5.05,6.17-6.26,9.78l-.51,1.54a1,1,0,0,1-1,.68h-.56a1,1,0,0,1-1-.68l-.51-1.54C9.05,16.17,4,16.22,4,10a8,8,0,0,1,8-8Z"]
  };
  
  var poiDelete = {
    prefix: 'axis',
    iconName: 'poiDelete',
    icon: [24, 24, [], "f0000", "M15.09,11.86a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L12,11.24l-1.86,1.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7L10.76,10,8.91,8.14a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L12,8.76l1.86-1.85a.48.48,0,0,1,.7,0l.53.53a.48.48,0,0,1,0,.7L13.24,10ZM12,2a8,8,0,0,0-8,8c0,6.22,5.05,6.17,6.26,9.78l.51,1.54a1,1,0,0,0,1,.68h.56a1,1,0,0,0,1-.68l.51-1.54C15,16.17,20,16.22,20,10a8,8,0,0,0-8-8Z"]
  };
  
  var poiDeleteOutlined = {
    prefix: 'axis',
    iconName: 'poiDeleteOutlined',
    icon: [24, 24, [], "f0000", "M15.09,8.14,13.24,10l1.85,1.86a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L12,11.24l-1.86,1.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7L10.76,10,8.91,8.14a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L12,8.76l1.86-1.85a.48.48,0,0,1,.7,0l.53.53A.48.48,0,0,1,15.09,8.14ZM12,4a6,6,0,0,0-6,6c0,2.8,1.18,3.74,2.82,5A9.17,9.17,0,0,1,12,18.73,9.25,9.25,0,0,1,15.18,15C16.82,13.74,18,12.8,18,10a6,6,0,0,0-6-6m0-2a8,8,0,0,1,8,8c0,6.22-5.05,6.17-6.26,9.78l-.51,1.54a1,1,0,0,1-1,.68h-.56a1,1,0,0,1-1-.68l-.51-1.54C9.05,16.17,4,16.22,4,10a8,8,0,0,1,8-8Z"]
  };
  
  var poiOutlined = {
    prefix: 'axis',
    iconName: 'poiOutlined',
    icon: [24, 24, [], "f0000", "M14,10a2,2,0,1,1-2-2A2,2,0,0,1,14,10ZM12,4a6,6,0,0,0-6,6c0,2.8,1.18,3.74,2.82,5A9.17,9.17,0,0,1,12,18.73,9.25,9.25,0,0,1,15.18,15C16.82,13.74,18,12.8,18,10a6,6,0,0,0-6-6m0-2a8,8,0,0,1,8,8c0,6.22-5.05,6.17-6.26,9.78l-.51,1.54a1,1,0,0,1-1,.68h-.56a1,1,0,0,1-1-.68l-.51-1.54C9.05,16.17,4,16.22,4,10a8,8,0,0,1,8-8Z"]
  };
  
  var poiRemove = {
    prefix: 'axis',
    iconName: 'poiRemove',
    icon: [24, 24, [], "f0000", "M8.5,11a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,8.5,9h7a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5ZM12,2a8,8,0,0,0-8,8c0,6.22,5.05,6.17,6.26,9.78l.51,1.54a1,1,0,0,0,1,.68h.56a1,1,0,0,0,1-.68l.51-1.54C15,16.17,20,16.22,20,10a8,8,0,0,0-8-8Z"]
  };
  
  var poiRemoveOutlined = {
    prefix: 'axis',
    iconName: 'poiRemoveOutlined',
    icon: [24, 24, [], "f0000", "M16,9.5v1a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,8.5,9h7A.5.5,0,0,1,16,9.5ZM12,4a6,6,0,0,0-6,6c0,2.8,1.18,3.74,2.82,5A9.17,9.17,0,0,1,12,18.73,9.25,9.25,0,0,1,15.18,15C16.82,13.74,18,12.8,18,10a6,6,0,0,0-6-6m0-2a8,8,0,0,1,8,8c0,6.22-5.05,6.17-6.26,9.78l-.51,1.54a1,1,0,0,1-1,.68h-.56a1,1,0,0,1-1-.68l-.51-1.54C9.05,16.17,4,16.22,4,10a8,8,0,0,1,8-8Z"]
  };
  
  var poiUser = {
    prefix: 'axis',
    iconName: 'poiUser',
    icon: [24, 24, [], "f0000", "M12,4.75A2.25,2.25,0,1,1,9.75,7,2.24,2.24,0,0,1,12,4.75ZM12,16a6,6,0,0,1-4.86-2.51l.69-1.39A2,2,0,0,1,9.62,11h4.76a2,2,0,0,1,1.79,1.1l.69,1.39A6,6,0,0,1,12,16ZM12,2a8,8,0,0,0-8,8c0,6.22,5.05,6.17,6.26,9.78l.51,1.54a1,1,0,0,0,1,.68h.56a1,1,0,0,0,1-.68l.51-1.54C15,16.17,20,16.22,20,10A8,8,0,0,0,12,2Z"]
  };
  
  var pyramid = {
    prefix: 'axis',
    iconName: 'pyramid',
    icon: [24, 24, [], "f0000", "M21.82,14.35,12.65,3.76a.73.73,0,0,0-.56-.26h-.18a.71.71,0,0,0-.56.26L2.18,14.33a.78.78,0,0,0-.18.49v.66a2.39,2.39,0,0,0,.69.61l8,4.59a2.32,2.32,0,0,0,1.18.32h.34a2.32,2.32,0,0,0,1.18-.32l8-4.6a2.15,2.15,0,0,0,.46-.35.73.73,0,0,0,.23-.54v-.35A.72.72,0,0,0,21.82,14.35ZM13,18.58V7.22l6.55,7.57Z"]
  };
  
  var restaurant = {
    prefix: 'axis',
    iconName: 'restaurant',
    icon: [24, 24, [], "f0000", "M12,2.5v8.26a3,3,0,0,1-.88,2.12l-.83.83a1,1,0,0,1-.7.29H9v7.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V14H6.41a1,1,0,0,1-.7-.29l-.83-.83A3,3,0,0,1,4,10.76V2.5A.5.5,0,0,1,4.5,2h.75a.5.5,0,0,1,.5.5v7a.5.5,0,0,0,.5.5h.37a.5.5,0,0,0,.5-.5v-7a.5.5,0,0,1,.5-.5h.76a.5.5,0,0,1,.5.5v7a.5.5,0,0,0,.5.5h.37a.5.5,0,0,0,.5-.5v-7a.5.5,0,0,1,.5-.5h.75A.5.5,0,0,1,12,2.5Zm8,0a.5.5,0,0,0-.5-.5H19a4,4,0,0,0-4,4v7a1,1,0,0,0,1,1h2v7.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5Z"]
  };
  
  var rome = {
    prefix: 'axis',
    iconName: 'rome',
    icon: [24, 24, [], "f0000", "M22,14H17.14l-1.62-3.79A2,2,0,0,0,13.68,9H9.15L7.1,4.21A2,2,0,0,0,5.26,3H1.5a.5.5,0,0,0-.5.5v17a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5V15A1,1,0,0,0,22,14ZM5,19H3V17a1,1,0,0,1,2,0Zm0-5H3V12a1,1,0,0,1,2,0ZM5,9H3V7A1,1,0,0,1,5,7ZM9,19H7V17a1,1,0,0,1,2,0Zm0-5H7V12a1,1,0,0,1,2,0Zm4,5H11V17a1,1,0,0,1,2,0Zm0-5H11V12a1,1,0,0,1,2,0Zm4,5H15V17a1,1,0,0,1,2,0Zm4,0H19V17a1,1,0,0,1,2,0Z"]
  };
  
  var rotate360 = {
    prefix: 'axis',
    iconName: 'rotate360',
    icon: [24, 24, [], "f0000", "M12,4C6.48,4,2,7.13,2,11a6.4,6.4,0,0,0,3.43,5.28,9,9,0,0,0,4.68,1.22H11v2a.5.5,0,0,0,.85.35l3-3a.5.5,0,0,0,0-.7l-3-3a.5.5,0,0,0-.85.35v2h-.89a7,7,0,0,1-3.64-.93A4.45,4.45,0,0,1,4,11c0-2.71,3.66-5,8-5s8,2.29,8,5a4.35,4.35,0,0,1-2.3,3.45.49.49,0,0,0-.15.68l.53.86a.51.51,0,0,0,.69.16A6.27,6.27,0,0,0,22,11C22,7.13,17.52,4,12,4Z"]
  };
  
  var route = {
    prefix: 'axis',
    iconName: 'route',
    icon: [24, 24, [], "f0000", "M11,13.5a4.5,4.5,0,1,0-6.87,3.82A2,2,0,0,1,5,18.38l.31.94a1,1,0,0,0,1,.68h.56a1,1,0,0,0,1-.68L8,18.38a2,2,0,0,1,.83-1.06A4.5,4.5,0,0,0,11,13.5Zm-4.5,2a2,2,0,1,1,2-2A2,2,0,0,1,6.5,15.5ZM17.24,9.42a2,2,0,0,1,.73,1l.42,1.25a.5.5,0,0,0,.47.34h.28a.5.5,0,0,0,.47-.34L20,10.41a2,2,0,0,1,.73-1,3,3,0,1,0-3.52,0ZM19,6a1,1,0,1,1-1,1A1,1,0,0,1,19,6Zm-3,6-.5-.43h.68a.25.25,0,0,0,.2-.1.27.27,0,0,0,0-.23l-.31-.92a.51.51,0,0,0-.47-.34H13.93a1,1,0,0,0-.91.6l-.08.19a1,1,0,0,0,.19,1.08L18.7,18H10.89a1,1,0,0,0-1,.68l-.22.66a.5.5,0,0,0,.47.66H20.92a1,1,0,0,0,.92-.61l.08-.19a1,1,0,0,0-.19-1.08Z"]
  };
  
  var routeDashed = {
    prefix: 'axis',
    iconName: 'routeDashed',
    icon: [24, 24, [], "f0000", "M10.5,5H8.82a3,3,0,1,0,0,2H10.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,10.5,5ZM6,7A1,1,0,1,1,7,6,1,1,0,0,1,6,7Zm-.33,4.23a4,4,0,0,0-2.44,2.44.25.25,0,0,0,0,.22.26.26,0,0,0,.21.11H5a.47.47,0,0,0,.39-.2,2.52,2.52,0,0,1,.4-.4A.47.47,0,0,0,6,13V11.47a.26.26,0,0,0-.11-.21A.25.25,0,0,0,5.67,11.23Zm-.27,5A.47.47,0,0,0,5,16H3.47a.26.26,0,0,0-.21.11.25.25,0,0,0,0,.22,4,4,0,0,0,2.44,2.44.25.25,0,0,0,.22,0A.26.26,0,0,0,6,18.53V17a.47.47,0,0,0-.2-.39A2.52,2.52,0,0,1,5.4,16.2Zm5.1.8h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,10.5,17Zm0-6h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,10.5,11Zm3-4h2a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,13.5,7Zm0,6h2a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,13.5,13Zm4.83-.23a4,4,0,0,0,2.44-2.44.25.25,0,0,0,0-.22.26.26,0,0,0-.21-.11H19a.47.47,0,0,0-.39.2,2.52,2.52,0,0,1-.4.4A.47.47,0,0,0,18,11v1.54a.26.26,0,0,0,.11.21A.25.25,0,0,0,18.33,12.77Zm.27-5A.47.47,0,0,0,19,8h1.54a.26.26,0,0,0,.21-.11.25.25,0,0,0,0-.22,4,4,0,0,0-2.44-2.44.25.25,0,0,0-.22,0,.26.26,0,0,0-.11.21V7a.47.47,0,0,0,.2.39A2.52,2.52,0,0,1,18.6,7.8ZM18,15a3,3,0,0,0-2.82,2H13.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1.68A3,3,0,1,0,18,15Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,18,19Z"]
  };
  
  var sanFrancisco = {
    prefix: 'axis',
    iconName: 'sanFrancisco',
    icon: [24, 24, [], "f0000", "M22.7,11.87a.3.3,0,0,0,.21,0,.25.25,0,0,0,.09-.2V10.54a.5.5,0,0,0-.36-.48A5.07,5.07,0,0,1,19,5.12V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V5.12a5,5,0,1,1-10,0V3.5A.5.5,0,0,0,6.5,3h-1a.5.5,0,0,0-.5.5V5.12a5.07,5.07,0,0,1-3.64,4.94.5.5,0,0,0-.36.48v1.08a.25.25,0,0,0,.09.2.3.3,0,0,0,.21,0A6.83,6.83,0,0,0,5,9.81V13H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v4H4.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H7V15H17v4h-.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19V15h3.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19V9.81A6.83,6.83,0,0,0,22.7,11.87ZM7,13V9.83a6.85,6.85,0,0,0,10,0V13Z"]
  };
  
  var shop = {
    prefix: 'axis',
    iconName: 'shop',
    icon: [24, 24, [], "f0000", "M4,4.5v-1A.5.5,0,0,1,4.5,3h15a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H4.5A.5.5,0,0,1,4,4.5Zm17.79,6.08-1.51-3a1,1,0,0,0-.9-.55H4.62a1,1,0,0,0-.9.55l-1.51,3a2,2,0,0,0-.21.89V12a1,1,0,0,0,1,1H4v7a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V15.25a.25.25,0,0,1,.25-.25h3.5a.25.25,0,0,1,.25.25V20a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V13h1a1,1,0,0,0,1-1v-.53A2,2,0,0,0,21.79,10.58Z"]
  };
  
  var shopOutlined = {
    prefix: 'axis',
    iconName: 'shopOutlined',
    icon: [24, 24, [], "f0000", "M21.79,10.58l-1.51-3a1,1,0,0,0-.9-.55H4.62a1,1,0,0,0-.9.55l-1.51,3a2,2,0,0,0-.21.89V12a1,1,0,0,0,1,1H4v7a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V17.25a.25.25,0,0,1,.25-.25h1.5a.25.25,0,0,1,.25.25V20a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V13h1a1,1,0,0,0,1-1v-.53A2,2,0,0,0,21.79,10.58ZM18,19H15V16a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1v3H6V13H18ZM4.5,5h15a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H4.5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,4.5,5Z"]
  };
  
  var shopping = {
    prefix: 'axis',
    iconName: 'shopping',
    icon: [24, 24, [], "f0000", "M20,7H17A5,5,0,0,0,7,7H4A1,1,0,0,0,3,8V20a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V8A1,1,0,0,0,20,7ZM9,10.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,7.5,9h1a.5.5,0,0,1,.5.5ZM12,4a3,3,0,0,1,3,3H9A3,3,0,0,1,12,4Zm5,6.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Z"]
  };
  
  var shoppingIcon = {
    prefix: 'axis',
    iconName: 'shoppingIcon',
    icon: [24, 24, [], "f0000", "M21,8a1,1,0,0,0-1-1H17A5,5,0,0,0,7,7H4A1,1,0,0,0,3,8V20a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM12,4a3,3,0,0,1,3,3H9A3,3,0,0,1,12,4Zm7,16H5V9H7v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V9h6v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V9h2Z"]
  };
  
  var singapore = {
    prefix: 'axis',
    iconName: 'singapore',
    icon: [24, 24, [], "f0000", "M22.5,18H20V8h1.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19V4.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V6H7V4.5A.5.5,0,0,0,6.5,4h-1a.5.5,0,0,0-.5.5V6H1.5a.5.5,0,0,0-.35.85l.56.56A2,2,0,0,0,3.12,8H4V18H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,18ZM16,18H14V8h2ZM8,8h2V18H8Z"]
  };
  
  var spa = {
    prefix: 'axis',
    iconName: 'spa',
    icon: [24, 24, [], "f0000", "M12,11.38A12.48,12.48,0,0,0,7.6,8.71a12.06,12.06,0,0,1,3.62-6.47A.89.89,0,0,1,11.84,2h.32a.89.89,0,0,1,.62.24A12.06,12.06,0,0,1,16.4,8.71,12.48,12.48,0,0,0,12,11.38Zm9.75-.93-.19-.2A.77.77,0,0,0,21,10,10.56,10.56,0,0,0,13.1,13.1,11.32,11.32,0,0,0,12,14.42a11.32,11.32,0,0,0-1.1-1.32A10.56,10.56,0,0,0,3,10a.77.77,0,0,0-.55.24l-.19.2A.73.73,0,0,0,2,11,10.59,10.59,0,0,0,12,22,10.59,10.59,0,0,0,22,11,.73.73,0,0,0,21.75,10.45Z"]
  };
  
  var spaOutlined = {
    prefix: 'axis',
    iconName: 'spaOutlined',
    icon: [24, 24, [], "f0000", "M21.75,10.45l-.19-.2A.77.77,0,0,0,21,10h-.39a10.68,10.68,0,0,0-4,.78,12,12,0,0,0-3.83-8.54A.89.89,0,0,0,12.16,2h-.32a.89.89,0,0,0-.62.24,12,12,0,0,0-3.83,8.54,10.68,10.68,0,0,0-4-.78H3a.77.77,0,0,0-.55.24l-.19.2A.73.73,0,0,0,2,11,10.59,10.59,0,0,0,12,22,10.59,10.59,0,0,0,22,11,.73.73,0,0,0,21.75,10.45ZM9.38,11A9.87,9.87,0,0,1,12,4.29,9.87,9.87,0,0,1,14.62,11c0,.3,0,.59,0,.88A10.65,10.65,0,0,0,13.1,13.1,11.32,11.32,0,0,0,12,14.42a11.32,11.32,0,0,0-1.1-1.32,10.65,10.65,0,0,0-1.48-1.22C9.4,11.59,9.38,11.3,9.38,11Zm8.11,6.5A8.61,8.61,0,0,1,12,20a8.59,8.59,0,0,1-8-8,8.56,8.56,0,0,1,5.47,2.5,8.83,8.83,0,0,1,.89,1.07l.71,1a1,1,0,0,0,.81.42h.2a1,1,0,0,0,.81-.42l.71-1a8.83,8.83,0,0,1,.89-1.07A8.56,8.56,0,0,1,20,12,8.6,8.6,0,0,1,17.49,17.5Z"]
  };
  
  var sydney = {
    prefix: 'axis',
    iconName: 'sydney',
    icon: [24, 24, [], "f0000", "M22.5,18H21.07L23,10.86a.57.57,0,0,0-.43-.72,8.55,8.55,0,0,0-1.5-.14,8,8,0,0,0-3.18.67,5.44,5.44,0,0,0-.15-.7A8,8,0,0,0,10,4a8.55,8.55,0,0,0-1.5.14A.58.58,0,0,0,8,4.86L9,8.63A8,8,0,0,0,6,8a8.55,8.55,0,0,0-1.5.14A.58.58,0,0,0,4,8.86l.91,3.4A7.68,7.68,0,0,0,3,12a8.55,8.55,0,0,0-1.5.14.58.58,0,0,0-.43.72L2.4,18H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,18Zm-18,0L3.4,14a5.93,5.93,0,0,1,2.16.59l.27,1a.5.5,0,0,0,.49.37H7.68a.25.25,0,0,0,.24-.31L6.4,10a6.08,6.08,0,0,1,3.37,1.36L11.54,18ZM10.4,6a6.06,6.06,0,0,1,5.39,4.47l.06.24a3,3,0,0,1-.29,2l-2.23,4.17ZM19,18H15l2.23-4.17a3,3,0,0,1,1.34-1.3,5.84,5.84,0,0,1,2-.51Z"]
  };
  
  var theatre = {
    prefix: 'axis',
    iconName: 'theatre',
    icon: [24, 24, [], "f0000", "M18,2H6A2,2,0,0,0,4,4V14a8,8,0,0,0,16,0V4A2,2,0,0,0,18,2Zm-4.89,8.33a2,2,0,0,1,3.78,0,.5.5,0,0,1-.07.46.49.49,0,0,1-.41.21H13.59a.49.49,0,0,1-.41-.21A.5.5,0,0,1,13.11,10.33Zm-6,0a2,2,0,0,1,3.78,0,.5.5,0,0,1-.07.46.49.49,0,0,1-.41.21H7.59a.49.49,0,0,1-.41-.21A.5.5,0,0,1,7.11,10.33ZM12,19a5,5,0,0,1-5-4.44.46.46,0,0,1,.13-.39A.48.48,0,0,1,7.53,14h8.94a.52.52,0,0,1,.38.17.49.49,0,0,1,.12.39A5,5,0,0,1,12,19Z"]
  };
  
  var toilets = {
    prefix: 'axis',
    iconName: 'toilets',
    icon: [24, 24, [], "f0000", "M5.5,4a2,2,0,1,1,2,2A2,2,0,0,1,5.5,4ZM9.64,7.59A2,2,0,0,0,8.22,7H6.78a2,2,0,0,0-1.42.59l-.77.77A2,2,0,0,0,4,9.78V14.5a.5.5,0,0,0,.5.5h1v6.5A.5.5,0,0,0,6,22H9a.5.5,0,0,0,.5-.5V15h1a.5.5,0,0,0,.5-.5V9.78a2,2,0,0,0-.59-1.42ZM16.5,6a2,2,0,1,0-2-2A2,2,0,0,0,16.5,6Zm3.89,9.37L18.27,7.73a1,1,0,0,0-1-.73H15.76a1,1,0,0,0-1,.73l-2.28,7.64A.5.5,0,0,0,13,16h2v5.5a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5V16h1.91A.5.5,0,0,0,20.39,15.37Z"]
  };
  
  var trencin = {
    prefix: 'axis',
    iconName: 'trencin',
    icon: [24, 24, [], "f0000", "M21,18v2H12V18Zm-2-4v2H17V14ZM13,7h2v5H13ZM4,14H15v2H11a1,1,0,0,0-1,1v3H4ZM17,7h.5a.5.5,0,0,0,.5-.5V5.7a1.94,1.94,0,0,0-.46-1.26L15.72,2.27A.76.76,0,0,0,15.14,2H12.86a.76.76,0,0,0-.58.27L10.46,4.44A1.94,1.94,0,0,0,10,5.7v.8a.5.5,0,0,0,.5.5H11v5H3a1,1,0,0,0-1,1v7H1.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5V17a1,1,0,0,0-1-1H21V13.83a2,2,0,0,0-.59-1.42l-1.12-1.12a1,1,0,0,0-.7-.29H17ZM7.5,16h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,7.5,16Z"]
  };
  
  var zoomIn = {
    prefix: 'axis',
    iconName: 'zoomIn',
    icon: [24, 24, [], "f0000", "M20.85,19.44l-4-4a2.44,2.44,0,0,0-.43-.35l-1-.69h0A7,7,0,1,0,10,17a7,7,0,0,0,4.37-1.53h0l.75,1a2.6,2.6,0,0,0,.3.36l4,4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,20.85,19.44ZM10,15a5,5,0,1,1,5-5A5,5,0,0,1,10,15Zm3-4.62V9.62a.5.5,0,0,0-.5-.5H10.88V7.5a.5.5,0,0,0-.5-.5H9.62a.5.5,0,0,0-.5.5V9.12H7.5a.5.5,0,0,0-.5.5v.76a.5.5,0,0,0,.5.5H9.12V12.5a.5.5,0,0,0,.5.5h.76a.5.5,0,0,0,.5-.5V10.88H12.5A.5.5,0,0,0,13,10.38Z"]
  };
  
  var zoomOut = {
    prefix: 'axis',
    iconName: 'zoomOut',
    icon: [24, 24, [], "f0000", "M20.85,19.44l-4-4a2.44,2.44,0,0,0-.43-.35l-1-.69h0A7,7,0,1,0,10,17a7,7,0,0,0,4.37-1.53h0l.75,1a2.6,2.6,0,0,0,.3.36l4,4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,20.85,19.44ZM10,15a5,5,0,1,1,5-5A5,5,0,0,1,10,15ZM7.5,9.12a.5.5,0,0,0-.5.5v.76a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V9.62a.5.5,0,0,0-.5-.5Z"]
  };
  
  var addPhoto = {
    prefix: 'axis',
    iconName: 'addPhoto',
    icon: [24, 24, [], "f0000", "M20,7H18.83a2,2,0,0,1-1.42-.59L15.88,4.88A3,3,0,0,0,13.76,4H10.24a3,3,0,0,0-2.12.88L6.59,6.41A2,2,0,0,1,5.17,7H4A2,2,0,0,0,2,9v9a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V9A2,2,0,0,0,20,7Zm-4,6.5a.5.5,0,0,1-.5.5H13v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V14H8.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V9.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V12h2.5a.5.5,0,0,1,.5.5Z"]
  };
  
  var adjust = {
    prefix: 'axis',
    iconName: 'adjust',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm3-8a3,3,0,1,1-3-3A3,3,0,0,1,15,12Z"]
  };
  
  var alignToBottom = {
    prefix: 'axis',
    iconName: 'alignToBottom',
    icon: [24, 24, [], "f0000", "M21,20.5v-1a.5.5,0,0,0-.5-.5H19V10a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v9H11V4a1,1,0,0,0-1-1H6A1,1,0,0,0,5,4V19H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17A.5.5,0,0,0,21,20.5Z"]
  };
  
  var alignToBottomOutlined = {
    prefix: 'axis',
    iconName: 'alignToBottomOutlined',
    icon: [24, 24, [], "f0000", "M21,20.5v-1a.5.5,0,0,0-.5-.5H19V10a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v9H11V4a1,1,0,0,0-1-1H6A1,1,0,0,0,5,4V19H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17A.5.5,0,0,0,21,20.5ZM15,11h2v8H15ZM7,5H9V19H7Z"]
  };
  
  var alignToBottomVs = {
    prefix: 'axis',
    iconName: 'alignToBottomVs',
    icon: [24, 24, [], "f0000", "M20.5,21a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H16V4a1,1,0,0,0-1-1H9A1,1,0,0,0,8,4V19H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5ZM14,19H10V5h4Z"]
  };
  
  var alignToCenter = {
    prefix: 'axis',
    iconName: 'alignToCenter',
    icon: [24, 24, [], "f0000", "M20,13H13V11h4a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H13V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V5H7A1,1,0,0,0,6,6v4a1,1,0,0,0,1,1h4v2H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h7v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19h7a1,1,0,0,0,1-1V14A1,1,0,0,0,20,13Z"]
  };
  
  var alignToCenterOutlined = {
    prefix: 'axis',
    iconName: 'alignToCenterOutlined',
    icon: [24, 24, [], "f0000", "M20,13H13V11h4a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H13V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V5H7A1,1,0,0,0,6,6v4a1,1,0,0,0,1,1h4v2H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h7v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19h7a1,1,0,0,0,1-1V14A1,1,0,0,0,20,13ZM8,9V7h8V9ZM5,17V15H19v2Z"]
  };
  
  var alignToCenterVs = {
    prefix: 'axis',
    iconName: 'alignToCenterVs',
    icon: [24, 24, [], "f0000", "M11,20.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V16h7a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H13V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V8H4A1,1,0,0,0,3,9v6a1,1,0,0,0,1,1h7ZM19,10v4H5V10Z"]
  };
  
  var alignToLeft = {
    prefix: 'axis',
    iconName: 'alignToLeft',
    icon: [24, 24, [], "f0000", "M20,13H5V11h9a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H5V3.5A.5.5,0,0,0,4.5,3h-1a.5.5,0,0,0-.5.5v17a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19H20a1,1,0,0,0,1-1V14A1,1,0,0,0,20,13Z"]
  };
  
  var alignToLeftOutlined = {
    prefix: 'axis',
    iconName: 'alignToLeftOutlined',
    icon: [24, 24, [], "f0000", "M20,13H5V11h9a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H5V3.5A.5.5,0,0,0,4.5,3h-1a.5.5,0,0,0-.5.5v17a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19H20a1,1,0,0,0,1-1V14A1,1,0,0,0,20,13ZM13,7V9H5V7Zm6,8v2H5V15Z"]
  };
  
  var alignToLeftVs = {
    prefix: 'axis',
    iconName: 'alignToLeftVs',
    icon: [24, 24, [], "f0000", "M3,20.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V16H20a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H5V3.5A.5.5,0,0,0,4.5,3h-1a.5.5,0,0,0-.5.5ZM19,10v4H5V10Z"]
  };
  
  var alignToMiddle = {
    prefix: 'axis',
    iconName: 'alignToMiddle',
    icon: [24, 24, [], "f0000", "M11,20V13h2v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V13h1.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19V7a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v4H11V4a1,1,0,0,0-1-1H6A1,1,0,0,0,5,4v7H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v7a1,1,0,0,0,1,1h4A1,1,0,0,0,11,20Z"]
  };
  
  var alignToMiddleOutlined = {
    prefix: 'axis',
    iconName: 'alignToMiddleOutlined',
    icon: [24, 24, [], "f0000", "M11,20V13h2v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V13h1.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19V7a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v4H11V4a1,1,0,0,0-1-1H6A1,1,0,0,0,5,4v7H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v7a1,1,0,0,0,1,1h4A1,1,0,0,0,11,20ZM15,8h2v8H15ZM7,5H9V19H7Z"]
  };
  
  var alignToMiddleVs = {
    prefix: 'axis',
    iconName: 'alignToMiddleVs',
    icon: [24, 24, [], "f0000", "M3.5,11a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H8v7a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V13h4.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H16V4a1,1,0,0,0-1-1H9A1,1,0,0,0,8,4v7ZM14,19H10V5h4Z"]
  };
  
  var alignToRight = {
    prefix: 'axis',
    iconName: 'alignToRight',
    icon: [24, 24, [], "f0000", "M20.5,3h-1a.5.5,0,0,0-.5.5V5H10A1,1,0,0,0,9,6v4a1,1,0,0,0,1,1h9v2H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H19v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V3.5A.5.5,0,0,0,20.5,3Z"]
  };
  
  var alignToRightOutlined = {
    prefix: 'axis',
    iconName: 'alignToRightOutlined',
    icon: [24, 24, [], "f0000", "M20.5,3h-1a.5.5,0,0,0-.5.5V5H10A1,1,0,0,0,9,6v4a1,1,0,0,0,1,1h9v2H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H19v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V3.5A.5.5,0,0,0,20.5,3ZM11,9V7h8V9ZM5,17V15H19v2Z"]
  };
  
  var alignToRightVs = {
    prefix: 'axis',
    iconName: 'alignToRightVs',
    icon: [24, 24, [], "f0000", "M21,3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V8H4A1,1,0,0,0,3,9v6a1,1,0,0,0,1,1H19v4.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5ZM19,10v4H5V10Z"]
  };
  
  var alignToTop = {
    prefix: 'axis',
    iconName: 'alignToTop',
    icon: [24, 24, [], "f0000", "M20.5,3H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5V20a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V5h2v9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V5h1.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,3Z"]
  };
  
  var alignToTopOutlined = {
    prefix: 'axis',
    iconName: 'alignToTopOutlined',
    icon: [24, 24, [], "f0000", "M20.5,3H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5V20a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V5h2v9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V5h1.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,3ZM15,5h2v8H15ZM7,5H9V19H7Z"]
  };
  
  var alignToTopVs = {
    prefix: 'axis',
    iconName: 'alignToTopVs',
    icon: [24, 24, [], "f0000", "M3.5,3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H8V20a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V5h4.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5ZM14,19H10V5h4Z"]
  };
  
  var artboard = {
    prefix: 'axis',
    iconName: 'artboard',
    icon: [24, 24, [], "f0000", "M7,20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V13.83a2,2,0,0,0-.59-1.42L16.59,7.59A2,2,0,0,0,15.17,7H7.5a.5.5,0,0,0-.5.5Zm9-6a1,1,0,0,1-1-1V8.82L20.18,14ZM5,7H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5ZM8.5,2h-1a.5.5,0,0,0-.5.5V5H9V2.5A.5.5,0,0,0,8.5,2Z"]
  };
  
  var artboardOutlined = {
    prefix: 'axis',
    iconName: 'artboardOutlined',
    icon: [24, 24, [], "f0000", "M7,20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V14.24a3,3,0,0,0-.88-2.12L16.88,7.88A3,3,0,0,0,14.76,7H7.5a.5.5,0,0,0-.5.5Zm13,0H9V9h5v5a1,1,0,0,0,1,1h5ZM5,7H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5ZM8.5,2h-1a.5.5,0,0,0-.5.5V5H9V2.5A.5.5,0,0,0,8.5,2Z"]
  };
  
  var blackWhite = {
    prefix: 'axis',
    iconName: 'blackWhite',
    icon: [24, 24, [], "f0000", "M21,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM12,19H5V5h7Z"]
  };
  
  var blendTool = {
    prefix: 'axis',
    iconName: 'blendTool',
    icon: [24, 24, [], "f0000", "M16,10V9a3,3,0,0,0-3-3V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v7a2,2,0,0,0,2,2H6a3,3,0,0,0,3,3h1a6,6,0,1,0,6-6ZM4,11V4h7V6H9A3,3,0,0,0,6,9v2Zm6.35,3H9a1,1,0,0,1-1-1V9A1,1,0,0,1,9,8h4a1,1,0,0,1,1,1v1.35A6,6,0,0,0,10.35,14ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"]
  };
  
  var bold = {
    prefix: 'axis',
    iconName: 'bold',
    icon: [24, 24, [], "f0000", "M16.5,10.9A4,4,0,0,0,17,9V8a4,4,0,0,0-4-4H7A1,1,0,0,0,6,5V18a1,1,0,0,0,1,1h7a4,4,0,0,0,4-4V14A4,4,0,0,0,16.5,10.9ZM13,7a1,1,0,0,1,1,1V9a1,1,0,0,1-1,1H9V7Zm2,8a1,1,0,0,1-1,1H9V13h5a1,1,0,0,1,1,1Z"]
  };
  
  var brightness1 = {
    prefix: 'axis',
    iconName: 'brightness1',
    icon: [24, 24, [], "f0000", "M17,12a5,5,0,1,1-5-5A5,5,0,0,1,17,12ZM11.5,5h1a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v2A.5.5,0,0,0,11.5,5Zm1,14h-1a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,0,12.5,19Zm9-8h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11ZM5,12.5v-1a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2A.5.5,0,0,0,5,12.5ZM17.3,7.4a.5.5,0,0,0,.71,0L19.42,6a.5.5,0,0,0,0-.71l-.7-.7a.5.5,0,0,0-.71,0L16.6,6a.5.5,0,0,0,0,.71ZM6.7,16.6a.5.5,0,0,0-.71,0L4.58,18a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0L7.4,18a.5.5,0,0,0,0-.71ZM18,16.6a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71L18,19.42a.5.5,0,0,0,.71,0l.7-.7a.5.5,0,0,0,0-.71ZM6,7.4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,7.4,6L6,4.58a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71Z"]
  };
  
  var brightness1Outlined = {
    prefix: 'axis',
    iconName: 'brightness1Outlined',
    icon: [24, 24, [], "f0000", "M12,9a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5,5,5,0,0,0-5-5Zm-.5-2h1a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v2A.5.5,0,0,0,11.5,5Zm1,14h-1a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,0,12.5,19Zm9-8h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11ZM5,12.5v-1a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2A.5.5,0,0,0,5,12.5ZM17.3,7.4a.5.5,0,0,0,.71,0L19.42,6a.5.5,0,0,0,0-.71l-.7-.7a.5.5,0,0,0-.71,0L16.6,6a.5.5,0,0,0,0,.71ZM6.7,16.6a.5.5,0,0,0-.71,0L4.58,18a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0L7.4,18a.5.5,0,0,0,0-.71ZM18,16.6a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71L18,19.42a.5.5,0,0,0,.71,0l.7-.7a.5.5,0,0,0,0-.71ZM6,7.4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,7.4,6L6,4.58a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71Z"]
  };
  
  var brightness2 = {
    prefix: 'axis',
    iconName: 'brightness2',
    icon: [24, 24, [], "f0000", "M17,12a5,5,0,1,1-5-5A5,5,0,0,1,17,12ZM11.5,5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,11.5,5Zm1,14h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,19Zm8-8h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,11Zm-16,0h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,4.5,11ZM18,5.28a.51.51,0,0,0-.71,0L16.6,6a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l.71-.7a.51.51,0,0,0,0-.71ZM6.7,16.6a.5.5,0,0,0-.71,0l-.71.7a.51.51,0,0,0,0,.71l.71.71a.51.51,0,0,0,.71,0L7.4,18a.5.5,0,0,0,0-.71ZM18,16.6a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71l.7.71a.51.51,0,0,0,.71,0l.71-.71a.51.51,0,0,0,0-.71ZM6,7.4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,7.4,6l-.7-.71a.51.51,0,0,0-.71,0L5.28,6a.51.51,0,0,0,0,.71Z"]
  };
  
  var brightness2Outlined = {
    prefix: 'axis',
    iconName: 'brightness2Outlined',
    icon: [24, 24, [], "f0000", "M11,4.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,11,4.5ZM12.5,19h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,19Zm8-8h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,11Zm-16,0h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,4.5,11ZM18,5.28a.51.51,0,0,0-.71,0L16.6,6a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l.71-.7a.51.51,0,0,0,0-.71ZM6.7,16.6a.5.5,0,0,0-.71,0l-.71.7a.51.51,0,0,0,0,.71l.71.71a.51.51,0,0,0,.71,0L7.4,18a.5.5,0,0,0,0-.71ZM18,16.6a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71l.7.71a.51.51,0,0,0,.71,0l.71-.71a.51.51,0,0,0,0-.71ZM6,7.4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,7.4,6l-.7-.71a.51.51,0,0,0-.71,0L5.28,6a.51.51,0,0,0,0,.71ZM12,9a3,3,0,1,0,3,3,3,3,0,0,0-3-3m0-2a5,5,0,1,1-5,5,5,5,0,0,1,5-5Z"]
  };
  
  var brightness3 = {
    prefix: 'axis',
    iconName: 'brightness3',
    icon: [24, 24, [], "f0000", "M12,9v6a3,3,0,0,1,0-6m0-2a5,5,0,1,0,5,5,5,5,0,0,0-5-5Zm-.5-2h1a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v2A.5.5,0,0,0,11.5,5Zm1,14h-1a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,0,12.5,19Zm9-8h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11ZM5,12.5v-1a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2A.5.5,0,0,0,5,12.5ZM17.3,7.4a.5.5,0,0,0,.71,0L19.42,6a.5.5,0,0,0,0-.71l-.7-.7a.5.5,0,0,0-.71,0L16.6,6a.5.5,0,0,0,0,.71ZM6.7,16.6a.5.5,0,0,0-.71,0L4.58,18a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0L7.4,18a.5.5,0,0,0,0-.71ZM18,16.6a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71L18,19.42a.5.5,0,0,0,.71,0l.7-.7a.5.5,0,0,0,0-.71ZM6,7.4a.5.5,0,0,0,.71,0l.7-.7A.5.5,0,0,0,7.4,6L6,4.58a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71Z"]
  };
  
  var bringForward = {
    prefix: 'axis',
    iconName: 'bringForward',
    icon: [24, 24, [], "f0000", "M20,11H18V8a2,2,0,0,0-2-2H13V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v7a2,2,0,0,0,2,2H6v3a2,2,0,0,0,2,2h3v2a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2V13A2,2,0,0,0,20,11ZM4,11V4h7V6H8A2,2,0,0,0,6,8v3Zm16,9H13V18h3a2,2,0,0,0,2-2V13h2Z"]
  };
  
  var bringToFront = {
    prefix: 'axis',
    iconName: 'bringToFront',
    icon: [24, 24, [], "f0000", "M20,8H16V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V14a2,2,0,0,0,2,2H8v4a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V10A2,2,0,0,0,20,8Zm0,12H10V16h4a2,2,0,0,0,2-2V10h4Z"]
  };
  
  var brush = {
    prefix: 'axis',
    iconName: 'brush',
    icon: [24, 24, [], "f0000", "M20.87,5.28l-7.5,8.15a.5.5,0,0,1-.72,0l-2.09-2.09a.5.5,0,0,1,0-.72l8.15-7.5a.5.5,0,0,1,.69,0l1.44,1.44A.5.5,0,0,1,20.87,5.28Zm-9.18,9.66L9.08,12.32A1.09,1.09,0,0,0,8.49,12,3.91,3.91,0,0,0,8,12a4,4,0,0,0-2.83,1.17c-2,2-.47,4.19-2.09,6.6a.5.5,0,0,0,.06.63h0A2.9,2.9,0,0,0,4.92,21a7.76,7.76,0,0,0,5.91-2.16A4,4,0,0,0,12,16c0-.16,0-.33,0-.49A1,1,0,0,0,11.69,14.94Z"]
  };
  
  var cameraEnhance = {
    prefix: 'axis',
    iconName: 'cameraEnhance',
    icon: [24, 24, [], "f0000", "M20,7H18.83a2,2,0,0,1-1.42-.59L15.88,4.88A3,3,0,0,0,13.76,4H10.24a3,3,0,0,0-2.12.88L6.59,6.41A2,2,0,0,1,5.17,7H4A2,2,0,0,0,2,9v9a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V9A2,2,0,0,0,20,7ZM12,17a4,4,0,1,1,4-4A4,4,0,0,1,12,17Zm2.26-4.4a4,4,0,0,1-1.85-1.85.46.46,0,0,0-.82,0A4,4,0,0,1,9.74,12.6.44.44,0,0,0,9.5,13V13a.44.44,0,0,0,.24.37,4,4,0,0,1,1.86,1.86.44.44,0,0,0,.37.24H12a.44.44,0,0,0,.37-.24,4,4,0,0,1,1.86-1.86A.44.44,0,0,0,14.5,13V13A.44.44,0,0,0,14.26,12.6Z"]
  };
  
  var cameraRoll = {
    prefix: 'axis',
    iconName: 'cameraRoll',
    icon: [24, 24, [], "f0000", "M18,8.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H16a2,2,0,0,0-2-2H13V3a1,1,0,0,0-1-1H8A1,1,0,0,0,7,3V4H6A2,2,0,0,0,4,6V20a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2h3.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,0,.5-.5v-5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.5-.5Zm-2,0v1a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h3A.5.5,0,0,1,16,8.5ZM9.5,10h-1A.5.5,0,0,1,8,9.5v-1A.5.5,0,0,1,8.5,8h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,9.5,10Zm.5,6.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,10,16.5ZM15.5,18h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,15.5,18Z"]
  };
  
  var canvas = {
    prefix: 'axis',
    iconName: 'canvas',
    icon: [24, 24, [], "f0000", "M22,16.5a.5.5,0,0,0-.5-.5H21V6a2,2,0,0,0-2-2H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V16H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H7.31L5.14,21.1a.76.76,0,0,0-.14.43v.22a.25.25,0,0,0,.25.25H6.43a1,1,0,0,0,.82-.43L9.75,18h4.5l2.5,3.57a1,1,0,0,0,.82.43h1.18a.25.25,0,0,0,.25-.25v-.22a.76.76,0,0,0-.14-.43L16.69,18H21.5a.5.5,0,0,0,.5-.5ZM19,16H5V6H19Z"]
  };
  
  var canvasGraphics = {
    prefix: 'axis',
    iconName: 'canvasGraphics',
    icon: [24, 24, [], "f0000", "M21.5,16H21V6a2,2,0,0,0-2-2H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V16H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H7.31L5.14,21.1a.76.76,0,0,0-.14.43v.22a.25.25,0,0,0,.25.25H6.43a1,1,0,0,0,.82-.43L9.75,18h4.5l2.5,3.57a1,1,0,0,0,.82.43h1.18a.25.25,0,0,0,.25-.25v-.22a.76.76,0,0,0-.14-.43L16.69,18H21.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,16ZM19,15.36a.64.64,0,0,1-.64.64h0a.67.67,0,0,1-.5-.24l-3.67-4.57a.5.5,0,0,0-.78,0l-2.29,2.88a.5.5,0,0,1-.79,0l-1-1.36a.51.51,0,0,0-.81,0l-2.23,3a.75.75,0,0,1-.6.3A.64.64,0,0,1,5,15.36V6H19ZM9.5,11A1.5,1.5,0,1,0,8,9.5,1.5,1.5,0,0,0,9.5,11Z"]
  };
  
  var canvasText = {
    prefix: 'axis',
    iconName: 'canvasText',
    icon: [24, 24, [], "f0000", "M22,16.5a.5.5,0,0,0-.5-.5H21V6a2,2,0,0,0-2-2H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V16H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H7.31L5.14,21.1a.76.76,0,0,0-.14.43v.22a.25.25,0,0,0,.25.25H6.43a1,1,0,0,0,.82-.43L9.75,18h4.5l2.5,3.57a1,1,0,0,0,.82.43h1.18a.25.25,0,0,0,.25-.25v-.22a.76.76,0,0,0-.14-.43L16.69,18H21.5a.5.5,0,0,0,.5-.5ZM19,16H5V6H19ZM7.5,14h5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,14Zm0-4h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,10Z"]
  };
  
  var color = {
    prefix: 'axis',
    iconName: 'color',
    icon: [24, 24, [], "f0000", "M20,14A8,8,0,0,1,4,14C4,10.19,6.86,6.64,9.5,4l1.82-1.82A.75.75,0,0,1,11.85,2h.3a.75.75,0,0,1,.53.22L14.5,4C17.14,6.64,20,10.19,20,14Z"]
  };
  
  var colorOff = {
    prefix: 'axis',
    iconName: 'colorOff',
    icon: [24, 24, [], "f0000", "M19.49,16.78,8.14,5.43c.45-.5.91-1,1.36-1.43l1.82-1.82A.75.75,0,0,1,11.85,2h.3a.75.75,0,0,1,.53.22L14.5,4C17.14,6.64,20,10.19,20,14A7.79,7.79,0,0,1,19.49,16.78Zm1.36,3.84L4.38,4.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L6,8.22A10.78,10.78,0,0,0,4,14a8,8,0,0,0,13.53,5.77l2.09,2.08a.48.48,0,0,0,.7,0l.53-.53A.48.48,0,0,0,20.85,20.62Z"]
  };
  
  var colorOffOutlined = {
    prefix: 'axis',
    iconName: 'colorOffOutlined',
    icon: [24, 24, [], "f0000", "M20.85,20.62,4.38,4.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L6,8.22A10.78,10.78,0,0,0,4,14a8,8,0,0,0,13.53,5.77l2.09,2.08a.48.48,0,0,0,.7,0l.53-.53A.48.48,0,0,0,20.85,20.62ZM12,20a6,6,0,0,1-6-6A8.38,8.38,0,0,1,7.44,9.67l8.67,8.68A6,6,0,0,1,12,20ZM10.91,5.41,12,4.33l1.09,1.08C16.39,8.72,18,11.53,18,14a5.66,5.66,0,0,1-.12,1.17l1.61,1.61A7.79,7.79,0,0,0,20,14c0-3.81-2.86-7.36-5.5-10L12.68,2.18A.75.75,0,0,0,12.15,2h-.3a.75.75,0,0,0-.53.22L9.5,4c-.45.45-.91.93-1.36,1.43L9.56,6.85C10,6.38,10.42,5.91,10.91,5.41Z"]
  };
  
  var colorOutlined = {
    prefix: 'axis',
    iconName: 'colorOutlined',
    icon: [24, 24, [], "f0000", "M12,4.33l1.09,1.08C16.39,8.72,18,11.53,18,14A6,6,0,0,1,6,14c0-2.47,1.61-5.28,4.91-8.59L12,4.33M12.15,2h-.3a.75.75,0,0,0-.53.22L9.5,4C6.86,6.64,4,10.19,4,14a8,8,0,0,0,16,0c0-3.81-2.86-7.36-5.5-10L12.68,2.18A.75.75,0,0,0,12.15,2Z"]
  };
  
  var colorPicker = {
    prefix: 'axis',
    iconName: 'colorPicker',
    icon: [24, 24, [], "f0000", "M20.71,4.25l-1-1a1,1,0,0,0-.7-.29H17.87a1,1,0,0,0-.7.29L13.69,6.77,12.28,5.35a.5.5,0,0,0-.7,0l-.71.71a.5.5,0,0,0,0,.71l.71.7-7.7,7.7a2,2,0,0,0-.48,2.06l.5,1.46-.75.75a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l.75-.75,1.46.5a2.05,2.05,0,0,0,.64.11,2,2,0,0,0,1.42-.59l7.7-7.7.7.71a.5.5,0,0,0,.71,0l.71-.71a.5.5,0,0,0,0-.7l-1.42-1.41,3.48-3.48a1,1,0,0,0,.29-.7V5A1,1,0,0,0,20.71,4.25ZM12.12,14H7.88L13,8.91l0,0L15.11,11Z"]
  };
  
  var colorPickerEmpty = {
    prefix: 'axis',
    iconName: 'colorPickerEmpty',
    icon: [24, 24, [], "f0000", "M20.71,4.25l-1-1a1,1,0,0,0-.7-.29H17.87a1,1,0,0,0-.7.29L13.69,6.77,12.28,5.35a.5.5,0,0,0-.7,0l-.71.71a.5.5,0,0,0,0,.71l.71.7-7.7,7.7a2,2,0,0,0-.48,2.06l.5,1.46-.75.75a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l.75-.75,1.46.5a2.05,2.05,0,0,0,.64.11,2,2,0,0,0,1.42-.59l7.7-7.7.7.71a.5.5,0,0,0,.71,0l.71-.71a.5.5,0,0,0,0-.7l-1.42-1.41,3.48-3.48a1,1,0,0,0,.29-.7V5A1,1,0,0,0,20.71,4.25ZM7.53,18.6,5.4,16.47,13,8.91l0,0L15.11,11Z"]
  };
  
  var colorPickerPoint = {
    prefix: 'axis',
    iconName: 'colorPickerPoint',
    icon: [24, 24, [], "f0000", "M20.71,4.25l-1-1a1,1,0,0,0-.7-.29H17.87a1,1,0,0,0-.7.29L13.69,6.77,12.28,5.35a.5.5,0,0,0-.7,0l-.71.71a.5.5,0,0,0,0,.71l.71.7-7.7,7.7a2,2,0,0,0-.48,2.06l.5,1.46-.75.75a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l.75-.75,1.46.5a2.05,2.05,0,0,0,.64.11,2,2,0,0,0,1.42-.59l7.7-7.7.7.71a.5.5,0,0,0,.71,0l.71-.71a.5.5,0,0,0,0-.7l-1.42-1.41,3.48-3.48a1,1,0,0,0,.29-.7V5A1,1,0,0,0,20.71,4.25ZM7.53,18.6,5.4,16.47,13,8.91l0,0L15.11,11ZM4.5,7h2A.5.5,0,0,0,7,6.5v-2A.5.5,0,0,0,6.5,4h-2a.5.5,0,0,0-.5.5v2A.5.5,0,0,0,4.5,7Z"]
  };
  
  var copy = {
    prefix: 'axis',
    iconName: 'copy',
    icon: [24, 24, [], "f0000", "M18,16V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V16a2,2,0,0,0,2,2H16A2,2,0,0,0,18,16ZM4,4H16V16H4ZM20,6V18a2,2,0,0,1-2,2H6a2,2,0,0,0,2,2H18a4,4,0,0,0,4-4V8A2,2,0,0,0,20,6Z"]
  };
  
  var crop = {
    prefix: 'axis',
    iconName: 'crop',
    icon: [24, 24, [], "f0000", "M2.5,7A.5.5,0,0,1,2,6.5v-1A.5.5,0,0,1,2.5,5H5V2.5A.5.5,0,0,1,5.5,2h1a.5.5,0,0,1,.5.5V5H17a2,2,0,0,1,2,2v8H17V7Zm19,10H7V9H5v8a2,2,0,0,0,2,2H17v2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19h2.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,17Z"]
  };
  
  var cut = {
    prefix: 'axis',
    iconName: 'cut',
    icon: [24, 24, [], "f0000", "M8.83,13.17a4,4,0,1,0,1,1.83h1a1,1,0,0,0,.7-.29l.47-.47.47.47a1,1,0,0,0,.7.29h1a4,4,0,1,0,1-1.83l-1.05-1.05,5-5A3,3,0,0,0,20,5V3.5a.5.5,0,0,0-.5-.5h-.29a.49.49,0,0,0-.36.15Zm10.58,1.42A2,2,0,1,1,18,14,2,2,0,0,1,19.41,14.59ZM4.59,17.41a2,2,0,1,1,2.82-2.82,2,2,0,1,1-2.82,2.82ZM5.15,3.15A.49.49,0,0,0,4.79,3H4.5a.5.5,0,0,0-.5.5V5a3,3,0,0,0,.88,2.12l3.76,3.77,2.12-2.12Z"]
  };
  
  var cutInHalf = {
    prefix: 'axis',
    iconName: 'cutInHalf',
    icon: [24, 24, [], "f0000", "M8.83,8.83A4,4,0,1,0,7,9.86v1a1,1,0,0,0,.29.7l.47.47-.47.47a1,1,0,0,0-.29.7v1a4,4,0,1,0,1.83,1l1.05-1.05,6,6A3,3,0,0,0,18,21h1.5a.5.5,0,0,0,.5-.5v-.29a.49.49,0,0,0-.15-.36ZM7.41,19.41A2,2,0,1,1,8,18,2,2,0,0,1,7.41,19.41Zm0-12A2,2,0,1,1,4.59,4.59,2,2,0,1,1,7.41,7.41ZM19.5,3H18a3,3,0,0,0-2.12.88L11.11,8.64l2.12,2.12,6.62-6.61A.49.49,0,0,0,20,3.79V3.5A.5.5,0,0,0,19.5,3Zm0,8h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,19.5,11ZM16,12.5v-1a.5.5,0,0,0-.5-.5h-2l2,2h0A.5.5,0,0,0,16,12.5Z"]
  };
  
  var difference = {
    prefix: 'axis',
    iconName: 'difference',
    icon: [24, 24, [], "f0000", "M2,10V20a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V16h4a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H10A2,2,0,0,0,8,4V8H4A2,2,0,0,0,2,10Zm12,0v4H10V10Z"]
  };
  
  var eraser = {
    prefix: 'axis',
    iconName: 'eraser',
    icon: [24, 24, [], "f0000", "M20.5,19H16.31l-2,2H20.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,19Z"]
  };
  
  var exposure = {
    prefix: 'axis',
    iconName: 'exposure',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM18,16.38a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-.76a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5ZM5,19V5H19ZM6.5,9.88H8.12V11.5a.5.5,0,0,0,.5.5h.76a.5.5,0,0,0,.5-.5V9.88H11.5a.5.5,0,0,0,.5-.5V8.62a.5.5,0,0,0-.5-.5H9.88V6.5a.5.5,0,0,0-.5-.5H8.62a.5.5,0,0,0-.5.5V8.12H6.5a.5.5,0,0,0-.5.5v.76A.5.5,0,0,0,6.5,9.88Z"]
  };
  
  var flare = {
    prefix: 'axis',
    iconName: 'flare',
    icon: [24, 24, [], "f0000", "M16.27,8.37l-.64-.64a.5.5,0,0,1,0-.74L17.19,5.7a.51.51,0,0,1,.68,0l.41.41a.51.51,0,0,1,0,.68L17,8.34A.5.5,0,0,1,16.27,8.37ZM7,15.66,5.7,17.19a.51.51,0,0,0,0,.68l.41.41a.51.51,0,0,0,.68,0L8.34,17a.5.5,0,0,0,0-.74l-.64-.64A.5.5,0,0,0,7,15.66ZM15.66,17l1.53,1.29a.51.51,0,0,0,.68,0l.41-.41a.51.51,0,0,0,0-.68L17,15.66a.5.5,0,0,0-.74,0l-.64.64A.5.5,0,0,0,15.66,17ZM8.34,7,6.81,5.7a.51.51,0,0,0-.68,0l-.41.41a.51.51,0,0,0,0,.68L7,8.34a.5.5,0,0,0,.74,0l.64-.64A.5.5,0,0,0,8.34,7ZM19.55,11.2l-4.91-.54a1,1,0,0,1-.61-.29l-.38-.4a1,1,0,0,1-.28-.61l-.58-6.9a.5.5,0,0,0-.5-.46h-.58a.5.5,0,0,0-.5.46l-.58,6.9a1,1,0,0,1-.28.61l-.38.4a1,1,0,0,1-.61.29l-4.91.54a.5.5,0,0,0-.45.5v.6a.5.5,0,0,0,.45.5l4.91.54a1,1,0,0,1,.61.29l.38.4a1,1,0,0,1,.28.61l.58,6.9a.5.5,0,0,0,.5.46h.58a.5.5,0,0,0,.5-.46l.58-6.9a1,1,0,0,1,.28-.61l.38-.4a1,1,0,0,1,.61-.29l4.91-.54a.5.5,0,0,0,.45-.5v-.6A.5.5,0,0,0,19.55,11.2Z"]
  };
  
  var flash = {
    prefix: 'axis',
    iconName: 'flash',
    icon: [24, 24, [], "f0000", "M18.09,10.22l-7,11.42a.76.76,0,0,1-.64.36h-.2a.51.51,0,0,1-.37-.16.49.49,0,0,1-.13-.38L10.31,15H6.74a.76.76,0,0,1-.65-.38l-.19-.33a.49.49,0,0,1,0-.51l7-11.42A.76.76,0,0,1,13.56,2h.2a.51.51,0,0,1,.37.16.49.49,0,0,1,.13.38L13.69,9h3.57a.76.76,0,0,1,.65.38l.19.33A.49.49,0,0,1,18.09,10.22Z"]
  };
  
  var flashOff = {
    prefix: 'axis',
    iconName: 'flashOff',
    icon: [24, 24, [], "f0000", "M19.85,19.32l-.53.53a.48.48,0,0,1-.7,0l-4-4-3.55,5.78a.76.76,0,0,1-.64.36h-.2a.51.51,0,0,1-.37-.16.49.49,0,0,1-.13-.38L10.31,15H6.74a.76.76,0,0,1-.65-.38L6,14.42a.78.78,0,0,1,0-.77l2.45-4L4.15,5.38a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L19.85,18.62A.48.48,0,0,1,19.85,19.32Zm-1.83-9a.78.78,0,0,0,0-.77l-.12-.2A.76.76,0,0,0,17.26,9H13.69l.57-6.46a.49.49,0,0,0-.13-.38A.51.51,0,0,0,13.76,2h-.2a.76.76,0,0,0-.64.36L10.32,6.6l6.19,6.2Z"]
  };
  
  var focus = {
    prefix: 'axis',
    iconName: 'focus',
    icon: [24, 24, [], "f0000", "M15.5,13H13v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V13H8.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V8.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V11h2.5a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,15.5,13ZM3.5,9h1A.5.5,0,0,0,5,8.5V5H8.5A.5.5,0,0,0,9,4.5v-1A.5.5,0,0,0,8.5,3H5A2,2,0,0,0,3,5V8.5A.5.5,0,0,0,3.5,9Zm5,10H5V15.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V19a2,2,0,0,0,2,2H8.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,8.5,19ZM19,3H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V5A2,2,0,0,0,19,3Zm1.5,12h-1a.5.5,0,0,0-.5.5V19H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19a2,2,0,0,0,2-2V15.5A.5.5,0,0,0,20.5,15Z"]
  };
  
  var format169 = {
    prefix: 'axis',
    iconName: 'format169',
    icon: [24, 24, [], "f0000", "M21,8v8H3V8H21m0-2H3A2,2,0,0,0,1,8v8a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"]
  };
  
  var format11 = {
    prefix: 'axis',
    iconName: 'format11',
    icon: [24, 24, [], "f0000", "M19,5V19H5V5H19m0-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Z"]
  };
  
  var format43 = {
    prefix: 'axis',
    iconName: 'format43',
    icon: [24, 24, [], "f0000", "M20,6V18H4V6H20m0-2H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"]
  };
  
  var formats = {
    prefix: 'axis',
    iconName: 'formats',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4ZM14,18H10V12h4Zm6,0H16V11a1,1,0,0,0-1-1H4V6H20Z"]
  };
  
  var freeTransform = {
    prefix: 'axis',
    iconName: 'freeTransform',
    icon: [24, 24, [], "f0000", "M21,14H19.42l-.8-4H19a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1V6H10V5A1,1,0,0,0,9,4H5A1,1,0,0,0,4,5V9a1,1,0,0,0,1,1h.38l-.8,4H3a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18h8v1a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V15A1,1,0,0,0,21,14ZM16,6h2V8H16ZM6,6H8V8H6ZM6,18H4V16H6Zm10-3v1H8V15a1,1,0,0,0-1-1H6.62l.8-4H9a1,1,0,0,0,1-1V8h4V9a1,1,0,0,0,1,1h1.58l.8,4H17A1,1,0,0,0,16,15Zm4,3H18V16h2Z"]
  };
  
  var fullscreen169 = {
    prefix: 'axis',
    iconName: 'fullscreen169',
    icon: [24, 24, [], "f0000", "M23,8v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V8H18.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H21A2,2,0,0,1,23,8ZM5.5,6H3A2,2,0,0,0,1,8v2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V8H5.5A.5.5,0,0,0,6,7.5v-1A.5.5,0,0,0,5.5,6Zm17,7h-1a.5.5,0,0,0-.5.5V16H18.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H21a2,2,0,0,0,2-2V13.5A.5.5,0,0,0,22.5,13Zm-17,3H3V13.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V16a2,2,0,0,0,2,2H5.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,5.5,16Z"]
  };
  
  var fullscreen11 = {
    prefix: 'axis',
    iconName: 'fullscreen11',
    icon: [24, 24, [], "f0000", "M19,3H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V5A2,2,0,0,0,19,3ZM3,5V8.5a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,5,8.5V5H8.5A.5.5,0,0,0,9,4.5v-1A.5.5,0,0,0,8.5,3H5A2,2,0,0,0,3,5ZM19,15.5V19H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19a2,2,0,0,0,2-2V15.5a.5.5,0,0,0-.5-.5h-1A.5.5,0,0,0,19,15.5ZM4.5,15h-1a.5.5,0,0,0-.5.5V19a2,2,0,0,0,2,2H8.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H5V15.5A.5.5,0,0,0,4.5,15Z"]
  };
  
  var fullscreen43 = {
    prefix: 'axis',
    iconName: 'fullscreen43',
    icon: [24, 24, [], "f0000", "M22,6V8.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V6H17.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H20A2,2,0,0,1,22,6ZM7,4.5A.5.5,0,0,0,6.5,4H4A2,2,0,0,0,2,6V8.5a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,4,8.5V6H6.5A.5.5,0,0,0,7,5.5ZM21.5,15h-1a.5.5,0,0,0-.5.5V18H17.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H20a2,2,0,0,0,2-2V15.5A.5.5,0,0,0,21.5,15ZM7,18.5a.5.5,0,0,0-.5-.5H4V15.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V18a2,2,0,0,0,2,2H6.5a.5.5,0,0,0,.5-.5Z"]
  };
  
  var gesture = {
    prefix: 'axis',
    iconName: 'gesture',
    icon: [24, 24, [], "f0000", "M20.5,13H19V12a4,4,0,0,0-4-4c-2.64,0-4,2-5,3.55S8.24,14,7,14a2,2,0,0,1-2-2c0-1.25.89-1.75,2.77-2.52,1.52-.63,3.41-1.4,3.41-3.47a3,3,0,0,0-3-3A5.08,5.08,0,0,0,5.05,4.08a3.39,3.39,0,0,1-1.61.73A.5.5,0,0,0,3,5.3v1a.52.52,0,0,0,.16.37.56.56,0,0,0,.39.13A5.36,5.36,0,0,0,6.18,5.74a3.07,3.07,0,0,1,2-.74,1,1,0,0,1,1,1c0,.66-.7,1-2.17,1.61C5.32,8.32,3,9.26,3,12a4,4,0,0,0,4,4c2.36,0,3.56-1.77,4.62-3.33S13.53,10,15,10a2,2,0,0,1,2,2v1H15.16A4.11,4.11,0,0,0,11,17a4,4,0,0,0,4,4,4.11,4.11,0,0,0,4-4.16V15h1.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,13ZM17,16.84c0,.43-.36,2.16-2,2.16a2,2,0,0,1-2-2,2.12,2.12,0,0,1,2.16-2H17Z"]
  };
  
  var gradient = {
    prefix: 'axis',
    iconName: 'gradient',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,2v7H17v2H15V12H13v2H11V12H9v2H7V12H5V5Zm-2.25,5h-1.5a.25.25,0,0,0-.25.25V12h2V10.25A.25.25,0,0,0,16.75,10Zm-4,0h-1.5a.25.25,0,0,0-.25.25V12h2V10.25A.25.25,0,0,0,12.75,10Zm-4,0H7.25a.25.25,0,0,0-.25.25V12H9V10.25A.25.25,0,0,0,8.75,10Z"]
  };
  
  var grid = {
    prefix: 'axis',
    iconName: 'grid',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2ZM16,9V6h4V9ZM9.75,9V6h4.5V9ZM4,9V6H8V9Zm12,4.25v-2.5h4v2.5Zm-6.25,0v-2.5h4.5v2.5ZM4,13.25v-2.5H8v2.5ZM16,18V15h4v3ZM9.75,18V15h4.5v3ZM4,18V15H8v3Z"]
  };
  
  var image = {
    prefix: 'axis',
    iconName: 'image',
    icon: [24, 24, [], "f0000", "M6,7A2,2,0,1,1,8,9,2,2,0,0,1,6,7Zm15.8,9.73-6-8a.76.76,0,0,0-1.2,0l-4,5.17a.5.5,0,0,1-.78,0L7.63,11.24a.75.75,0,0,0-1.17,0L2.21,16.73a1,1,0,0,0-.21.61v.91a.76.76,0,0,0,.75.75h18.5a.76.76,0,0,0,.75-.75v-.92A1,1,0,0,0,21.8,16.73Z"]
  };
  
  var imageRotateLeft = {
    prefix: 'axis',
    iconName: 'imageRotateLeft',
    icon: [24, 24, [], "f0000", "M18,10H6a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V12A2,2,0,0,0,18,10Zm0,10H6V12H18ZM6,7.5V3.62a.49.49,0,0,1,.85-.35l1,1a7,7,0,0,1,12,3.13.53.53,0,0,1-.1.42.49.49,0,0,1-.39.19h-1a.5.5,0,0,1-.48-.36,5,5,0,0,0-8.53-2l1.46,1.47a.5.5,0,0,1-.35.85H6.5A.52.52,0,0,1,6,7.5Z"]
  };
  
  var imageRotateRight = {
    prefix: 'axis',
    iconName: 'imageRotateRight',
    icon: [24, 24, [], "f0000", "M18,10H6a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V12A2,2,0,0,0,18,10Zm0,10H6V12H18ZM4.29,7.81a.53.53,0,0,1-.1-.42,7,7,0,0,1,12-3.13l1-1a.49.49,0,0,1,.85.35V7.5a.52.52,0,0,1-.5.5H13.61a.5.5,0,0,1-.35-.85l1.46-1.47a5,5,0,0,0-8.53,2A.5.5,0,0,1,5.71,8h-1A.49.49,0,0,1,4.29,7.81Z"]
  };
  
  var intersect = {
    prefix: 'axis',
    iconName: 'intersect',
    icon: [24, 24, [], "f0000", "M2,10V20a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V16h4a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H10A2,2,0,0,0,8,4V8H4A2,2,0,0,0,2,10Zm14,4V10a2,2,0,0,0-2-2H10V4H20V14ZM4,10H8v4a2,2,0,0,0,2,2h4v4H4Z"]
  };
  
  var invert = {
    prefix: 'axis',
    iconName: 'invert',
    icon: [24, 24, [], "f0000", "M21,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM12,17v2H5V5h7V7a5,5,0,0,1,0,10ZM7,12a5,5,0,0,0,5,5V7A5,5,0,0,0,7,12Z"]
  };
  
  var invertColors = {
    prefix: 'axis',
    iconName: 'invertColors',
    icon: [24, 24, [], "f0000", "M12,20a6,6,0,0,1-6-6c0-2.47,1.61-5.28,4.91-8.59L12,4.33Zm.15-18h-.3a.75.75,0,0,0-.53.22L9.5,4C6.86,6.64,4,10.19,4,14a8,8,0,0,0,16,0c0-3.81-2.86-7.36-5.5-10L12.68,2.18A.75.75,0,0,0,12.15,2Z"]
  };
  
  var invertColorsOff = {
    prefix: 'axis',
    iconName: 'invertColorsOff',
    icon: [24, 24, [], "f0000", "M20.85,20.62,4.38,4.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L6,8.22A10.78,10.78,0,0,0,4,14a8,8,0,0,0,13.53,5.77l2.09,2.08a.48.48,0,0,0,.7,0l.53-.53A.48.48,0,0,0,20.85,20.62ZM12,20a6,6,0,0,1-6-6A8.38,8.38,0,0,1,7.44,9.67L12,14.24ZM10.91,5.41,12,4.33v5l7.49,7.49A7.79,7.79,0,0,0,20,14c0-3.81-2.86-7.36-5.5-10L12.68,2.18A.75.75,0,0,0,12.15,2h-.3a.75.75,0,0,0-.53.22L9.5,4c-.45.45-.91.93-1.36,1.43L9.56,6.85C10,6.38,10.42,5.91,10.91,5.41Z"]
  };
  
  var italic = {
    prefix: 'axis',
    iconName: 'italic',
    icon: [24, 24, [], "f0000", "M16.5,6h-.83a1,1,0,0,0-.95.67L11.4,16.34a.5.5,0,0,0,.47.66h.63a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h.83a1,1,0,0,0,.95-.67L12.6,6.66A.5.5,0,0,0,12.12,6H11.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,16.5,6Z"]
  };
  
  var keyframeBezierIn = {
    prefix: 'axis',
    iconName: 'keyframeBezierIn',
    icon: [24, 24, [], "f0000", "M10.67,3a2,2,0,0,1,1.42.59l7.62,7.62a1,1,0,0,1,.29.7v.18a1,1,0,0,1-.29.7l-7.62,7.62a2,2,0,0,1-1.42.59H4a1,1,0,0,1-1-1V18.51a1,1,0,0,1,.42-.81l3.32-2.37A3,3,0,0,0,8,12.88V11.12A3,3,0,0,0,6.74,8.67L3.42,6.3A1,1,0,0,1,3,5.49V4A1,1,0,0,1,4,3Z"]
  };
  
  var keyframeBezierOut = {
    prefix: 'axis',
    iconName: 'keyframeBezierOut',
    icon: [24, 24, [], "f0000", "M19,3a1,1,0,0,1,1,1V5.49a1,1,0,0,1-.42.81L16.26,8.67A3,3,0,0,0,15,11.12v1.76a3,3,0,0,0,1.26,2.45l3.32,2.37a1,1,0,0,1,.42.81V20a1,1,0,0,1-1,1H12.33a2,2,0,0,1-1.42-.59L3.29,12.79a1,1,0,0,1-.29-.7v-.18a1,1,0,0,1,.29-.7l7.62-7.62A2,2,0,0,1,12.33,3Z"]
  };
  
  var keyframeContBezier = {
    prefix: 'axis',
    iconName: 'keyframeContBezier',
    icon: [24, 24, [], "f0000", "M19.58,6.3,16.26,8.67A3,3,0,0,0,15,11.12v1.76a3,3,0,0,0,1.26,2.45l3.32,2.37a1,1,0,0,1,.42.81V20a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V18.51a1,1,0,0,1,.42-.81l3.32-2.37A3,3,0,0,0,9,12.88V11.12A3,3,0,0,0,7.74,8.67L4.42,6.3A1,1,0,0,1,4,5.49V4A1,1,0,0,1,5,3H19a1,1,0,0,1,1,1V5.49A1,1,0,0,1,19.58,6.3Z"]
  };
  
  var keyframeLinear = {
    prefix: 'axis',
    iconName: 'keyframeLinear',
    icon: [24, 24, [], "f0000", "M21,11.91v.18a1,1,0,0,1-.29.7l-7.92,7.92a1,1,0,0,1-.7.29h-.18a1,1,0,0,1-.7-.29L3.29,12.79a1,1,0,0,1-.29-.7v-.18a1,1,0,0,1,.29-.7l7.92-7.92a1,1,0,0,1,.7-.29h.18a1,1,0,0,1,.7.29l7.92,7.92A1,1,0,0,1,21,11.91Z"]
  };
  
  var keyframeLinearIn = {
    prefix: 'axis',
    iconName: 'keyframeLinearIn',
    icon: [24, 24, [], "f0000", "M21,4V20a1,1,0,0,1-1,1H12.33a2,2,0,0,1-1.42-.59L3.29,12.79a1,1,0,0,1-.29-.7v-.18a1,1,0,0,1,.29-.7l7.62-7.62A2,2,0,0,1,12.33,3H20A1,1,0,0,1,21,4Z"]
  };
  
  var keyframeLinearOut = {
    prefix: 'axis',
    iconName: 'keyframeLinearOut',
    icon: [24, 24, [], "f0000", "M4,3h7.67a2,2,0,0,1,1.42.59l7.62,7.62a1,1,0,0,1,.29.7v.18a1,1,0,0,1-.29.7l-7.62,7.62a2,2,0,0,1-1.42.59H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3Z"]
  };
  
  var knife = {
    prefix: 'axis',
    iconName: 'knife',
    icon: [24, 24, [], "f0000", "M4.61,14.15A5.5,5.5,0,0,0,3,18V20.5a.5.5,0,0,0,.5.5H9.74a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,0,.5-.5V13.41a1,1,0,0,1,.29-.7l1.26-1.26a.5.5,0,0,0,0-.7l-.86-.86L20.85,6a.48.48,0,0,0,0-.7l-2-2A1,1,0,0,0,18.17,3h-2a1,1,0,0,0-.7.29Zm9.92-2.27a1,1,0,0,0-.29.71V13h-1a1,1,0,0,0-1,1v.5a.5.5,0,0,1-.5.5h-.5a1,1,0,0,0-1,1v.5a.5.5,0,0,1-.5.5h-.5a1,1,0,0,0-1,1v.5a.5.5,0,0,1-.5.5H5V18a3.5,3.5,0,0,1,1-2.48L12.9,8.69l2.41,2.41Zm3.32-5.32-.7.71a.51.51,0,0,1-.71,0l-.71-.71a.51.51,0,0,1,0-.71l.71-.7a.5.5,0,0,1,.71,0l.7.7A.5.5,0,0,1,17.85,6.56Z"]
  };
  
  var lasso = {
    prefix: 'axis',
    iconName: 'lasso',
    icon: [24, 24, [], "f0000", "M12,2C6.49,2,2,6,2,11a8.73,8.73,0,0,0,4,7.17A2,2,0,0,1,4,20H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H4a4,4,0,0,0,3.42-2A3.94,3.94,0,0,0,12.65,20c5.21-.31,9.35-4.21,9.35-9C22,6,17.51,2,12,2Zm-.28,16H11a1,1,0,0,0-1,1,2,2,0,1,1,1.72-1Zm2.2-.22a4,4,0,0,0-7.72-2A6.54,6.54,0,0,1,4,11c0-3.86,3.59-7,8-7s8,3.14,8,7C20,14.28,17.41,17,13.92,17.78Z"]
  };
  
  var layers = {
    prefix: 'axis',
    iconName: 'layers',
    icon: [24, 24, [], "f0000", "M21,8.92v.16a.49.49,0,0,1-.22.41l-7.67,5.25a1.49,1.49,0,0,1-.84.26h-.54a1.49,1.49,0,0,1-.84-.26L3.22,9.49A.49.49,0,0,1,3,9.08V8.92a.49.49,0,0,1,.22-.41l7.67-5.25A1.49,1.49,0,0,1,11.73,3h.54a1.49,1.49,0,0,1,.84.26l7.67,5.25A.49.49,0,0,1,21,8.92Zm-2.33,4.14L16.9,14.27,18,15l-5.85,4h-.22L6,15l1.06-.73L5.33,13.06,3.22,14.51a.49.49,0,0,0-.22.41v.16a.49.49,0,0,0,.22.41l7.67,5.25a1.49,1.49,0,0,0,.84.26h.54a1.49,1.49,0,0,0,.84-.26l7.67-5.25a.49.49,0,0,0,.22-.41v-.16a.49.49,0,0,0-.22-.41Z"]
  };
  
  var layersOff = {
    prefix: 'axis',
    iconName: 'layersOff',
    icon: [24, 24, [], "f0000", "M21,8.92v.16a.49.49,0,0,1-.22.41l-4.5,3.08L8.56,4.85l2.33-1.59A1.49,1.49,0,0,1,11.73,3h.54a1.49,1.49,0,0,1,.84.26l7.67,5.25A.49.49,0,0,1,21,8.92Zm-2.33,4.14-1.13.77,2.3,2.3.94-.64a.49.49,0,0,0,.22-.41v-.16a.49.49,0,0,0-.22-.41ZM4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L5.63,6.87,3.22,8.51A.49.49,0,0,0,3,8.92v.16a.49.49,0,0,0,.22.41l7.67,5.25a1.49,1.49,0,0,0,.84.26h.54a1.49,1.49,0,0,0,.84-.26l.23-.16,2.13,2.13L12.11,19h-.22L6,15l1.06-.73L5.33,13.06,3.22,14.51a.49.49,0,0,0-.22.41v.16a.49.49,0,0,0,.22.41l7.67,5.25a1.49,1.49,0,0,0,.84.26h.54a1.49,1.49,0,0,0,.84-.26l3.8-2.59,2.71,2.7a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7Z"]
  };
  
  var layersOutlined = {
    prefix: 'axis',
    iconName: 'layersOutlined',
    icon: [24, 24, [], "f0000", "M20.78,8.51,13.11,3.26A1.49,1.49,0,0,0,12.27,3h-.54a1.49,1.49,0,0,0-.84.26L3.22,8.51A.49.49,0,0,0,3,8.92v.16a.49.49,0,0,0,.22.41l7.67,5.25a1.49,1.49,0,0,0,.84.26h.54a1.49,1.49,0,0,0,.84-.26l7.67-5.25A.49.49,0,0,0,21,9.08V8.92A.49.49,0,0,0,20.78,8.51ZM12.11,13h-.22L6,9l5.85-4h.22L18,9Zm8.67,1.51-2.11-1.45L16.9,14.27,18,15l-5.85,4h-.22L6,15l1.06-.73L5.33,13.06,3.22,14.51a.49.49,0,0,0-.22.41v.16a.49.49,0,0,0,.22.41l7.67,5.25a1.49,1.49,0,0,0,.84.26h.54a1.49,1.49,0,0,0,.84-.26l7.67-5.25a.49.49,0,0,0,.22-.41v-.16A.49.49,0,0,0,20.78,14.51Z"]
  };
  
  var ligature = {
    prefix: 'axis',
    iconName: 'ligature',
    icon: [24, 24, [], "f0000", "M17,11a1,1,0,0,0-1-1H11V8a2,2,0,0,1,2-2,6.17,6.17,0,0,1,2.65.73.5.5,0,0,0,.67-.22l.45-.89a.5.5,0,0,0,0-.38A.48.48,0,0,0,16.55,5,8.24,8.24,0,0,0,13,4,4,4,0,0,0,9,8v2H7.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H9v6.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V12h4v6.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5Z"]
  };
  
  var macro = {
    prefix: 'axis',
    iconName: 'macro',
    icon: [24, 24, [], "f0000", "M19.73,14h.77a.5.5,0,0,1,.5.5V16a6,6,0,0,1-6,6H9a6,6,0,0,1-6-6V14.5a.5.5,0,0,1,.5-.5h.77a2,2,0,0,1,1.29.47L10.91,19H11V13A6,6,0,0,1,5,7V3.5A.5.5,0,0,1,5.5,3h.38a1.5,1.5,0,0,1,1.06.44L8.5,5l2.78-2.78A.75.75,0,0,1,11.81,2h.38a.75.75,0,0,1,.53.22L15.5,5l1.56-1.56A1.5,1.5,0,0,1,18.12,3h.38a.5.5,0,0,1,.5.5V7a6,6,0,0,1-6,6v6h.09l5.35-4.53A2,2,0,0,1,19.73,14Z"]
  };
  
  var macroOutlined = {
    prefix: 'axis',
    iconName: 'macroOutlined',
    icon: [24, 24, [], "f0000", "M21,14.5a.5.5,0,0,0-.5-.5h-.77a2,2,0,0,0-1.29.47L13.09,19H13V13a6,6,0,0,0,6-6V3.5a.5.5,0,0,0-.5-.5h-.38a1.5,1.5,0,0,0-1.06.44L15.5,5,12.72,2.22A.75.75,0,0,0,12.19,2h-.38a.75.75,0,0,0-.53.22L8.5,5,6.94,3.44A1.5,1.5,0,0,0,5.88,3H5.5a.5.5,0,0,0-.5.5V7a6,6,0,0,0,6,6v6h-.09L5.56,14.47A2,2,0,0,0,4.27,14H3.5a.5.5,0,0,0-.5.5V16a6,6,0,0,0,6,6h6a6,6,0,0,0,6-6ZM17,6.34h0V7a4,4,0,0,1-4,4h-.67ZM9.72,10.78A4,4,0,0,1,7,7V6.33H7l3.58,3.57Zm.19-4.37h0L12,4.33l2.09,2.08h0L12,8.5Z"]
  };
  
  var magicWand = {
    prefix: 'axis',
    iconName: 'magicWand',
    icon: [24, 24, [], "f0000", "M16.85,9.27,5.27,20.85a.5.5,0,0,1-.71,0L3.15,19.44a.5.5,0,0,1,0-.71L14.73,7.15a.5.5,0,0,1,.71,0l1.41,1.41A.5.5,0,0,1,16.85,9.27ZM8.24,5.9A4,4,0,0,1,10.1,7.76a.44.44,0,0,0,.37.24h.06a.44.44,0,0,0,.37-.24A4,4,0,0,1,12.76,5.9.44.44,0,0,0,13,5.53V5.47a.44.44,0,0,0-.24-.37,4,4,0,0,1-1.85-1.85.46.46,0,0,0-.82,0A4,4,0,0,1,8.24,5.1.44.44,0,0,0,8,5.47v.06A.44.44,0,0,0,8.24,5.9ZM20.82,4.68A3.19,3.19,0,0,1,19.33,3.2.38.38,0,0,0,19,3h0a.38.38,0,0,0-.33.2,3.17,3.17,0,0,1-1.48,1.48h0A.3.3,0,0,0,17,5V5a.3.3,0,0,0,.19.29h0a3.21,3.21,0,0,1,1.49,1.49A.34.34,0,0,0,19,7H19a.34.34,0,0,0,.3-.18,3.17,3.17,0,0,1,1.49-1.49A.34.34,0,0,0,21,5V5A.34.34,0,0,0,20.82,4.68ZM16.24,13.9a4,4,0,0,1,1.86,1.86.44.44,0,0,0,.37.24h.06a.44.44,0,0,0,.37-.24,4,4,0,0,1,1.86-1.86.44.44,0,0,0,.24-.37v-.06a.44.44,0,0,0-.24-.37,4,4,0,0,1-1.85-1.85.46.46,0,0,0-.82,0,4,4,0,0,1-1.85,1.85.44.44,0,0,0-.24.37v.06A.44.44,0,0,0,16.24,13.9Z"]
  };
  
  var marker = {
    prefix: 'axis',
    iconName: 'marker',
    icon: [24, 24, [], "f0000", "M20.76,7.58l-6.69,7.94a.49.49,0,0,1-.73,0L8.45,10.66a.49.49,0,0,1,0-.73l7.94-6.69a1,1,0,0,1,1.36,0l2.93,2.93A1,1,0,0,1,20.76,7.58ZM7.18,11.86a.5.5,0,0,0-.7,0L4.41,13.93a1,1,0,0,0-.29.7v1.42a1,1,0,0,0,.29.7l.57.57L2.15,20.15A.5.5,0,0,0,2.5,21H5.12a1.05,1.05,0,0,0,.71-.29L7.1,19.44l.27.27a1,1,0,0,0,.7.29H9.25a1,1,0,0,0,.7-.29l2.19-2.19a.5.5,0,0,0,0-.7Z"]
  };
  
  var markerOutlined = {
    prefix: 'axis',
    iconName: 'markerOutlined',
    icon: [24, 24, [], "f0000", "M17,5.36,18.64,7l-5,6L11,10.4l6-5M17.07,3a1,1,0,0,0-.65.24L8.48,9.93a.49.49,0,0,0,0,.73l4.89,4.89a.49.49,0,0,0,.35.15.49.49,0,0,0,.38-.18l6.69-7.94a1,1,0,0,0-.05-1.36L17.78,3.29A1,1,0,0,0,17.07,3ZM7.18,11.86a.5.5,0,0,0-.7,0L4.41,13.93a1,1,0,0,0-.29.7v1.42a1,1,0,0,0,.29.7l.57.57L2.15,20.15A.5.5,0,0,0,2.5,21H5.12a1.05,1.05,0,0,0,.71-.29L7.1,19.44l.27.27a1,1,0,0,0,.7.29H9.25a1,1,0,0,0,.7-.29l2.19-2.19a.5.5,0,0,0,0-.7Z"]
  };
  
  var mask = {
    prefix: 'axis',
    iconName: 'mask',
    icon: [24, 24, [], "f0000", "M18.65,9a6.69,6.69,0,0,0-2-.84h0c-.21,0-.43-.08-.64-.11V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V14a2,2,0,0,0,2,2H8.08c0,.21.06.43.11.64h0a6.69,6.69,0,0,0,.84,2,.5.5,0,0,0,.79.11l.73-.73a.51.51,0,0,0,.07-.61,5.6,5.6,0,0,1-.44-1h0c0-.12,0-.25-.08-.37H14a2,2,0,0,0,2-2V10.11l.37.08h0a5.6,5.6,0,0,1,1,.44.51.51,0,0,0,.61-.07l.73-.73A.5.5,0,0,0,18.65,9ZM4,4H14V8.08a6.91,6.91,0,0,0-2.65,1h0A7.08,7.08,0,0,0,9,11.35H9a6.91,6.91,0,0,0-1,2.65H4ZM21.32,16h-1a.5.5,0,0,0-.48.38,5.6,5.6,0,0,1-.44,1,.51.51,0,0,0,.07.61l.73.73a.5.5,0,0,0,.79-.11,6.69,6.69,0,0,0,.84-2A.5.5,0,0,0,21.32,16Zm-7.7,3.81a5.6,5.6,0,0,1-1-.44.51.51,0,0,0-.61.07l-.73.73a.5.5,0,0,0,.11.79,6.69,6.69,0,0,0,2,.84.5.5,0,0,0,.63-.48v-1A.5.5,0,0,0,13.62,19.81Zm6.19-6.19a.5.5,0,0,0,.48.38h1a.5.5,0,0,0,.48-.63,6.69,6.69,0,0,0-.84-2,.5.5,0,0,0-.79-.11l-.73.73a.51.51,0,0,0-.07.61A5.6,5.6,0,0,1,19.81,13.62ZM18,19.44a.51.51,0,0,0-.61-.07,5.6,5.6,0,0,1-1,.44.5.5,0,0,0-.38.48v1a.5.5,0,0,0,.63.48,6.69,6.69,0,0,0,2-.84.5.5,0,0,0,.11-.79Z"]
  };
  
  var maskVs = {
    prefix: 'axis',
    iconName: 'maskVs',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM12,17a5,5,0,1,1,5-5A5,5,0,0,1,12,17Z"]
  };
  
  var material = {
    prefix: 'axis',
    iconName: 'material',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM4,12h8V4a8,8,0,0,1,8,8H12v8A8,8,0,0,1,4,12Z"]
  };
  
  var mediaPhoto = {
    prefix: 'axis',
    iconName: 'mediaPhoto',
    icon: [24, 24, [], "f0000", "M17,18a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H12.41a1,1,0,0,1-.7-.29L10.29,3.29A1,1,0,0,0,9.59,3H3A2,2,0,0,0,1,5V16a2,2,0,0,0,2,2ZM7.5,6A1.5,1.5,0,1,1,6,7.5,1.5,1.5,0,0,1,7.5,6ZM17,15.5a.5.5,0,0,1-.5.5H3.5a.5.5,0,0,1-.5-.5v-.34a.46.46,0,0,1,.11-.3L6,11.19A.52.52,0,0,1,6.35,11a.5.5,0,0,1,.39.18l1.45,1.75a.49.49,0,0,0,.38.18.51.51,0,0,0,.4-.2l2.88-3.72a.51.51,0,0,1,.8,0l4.25,5.67a.51.51,0,0,1,.1.3ZM21,9v9a2,2,0,0,1-2,2H5a2,2,0,0,0,2,2H19a4,4,0,0,0,4-4V11A2,2,0,0,0,21,9Z"]
  };
  
  var meshGrid = {
    prefix: 'axis',
    iconName: 'meshGrid',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,5.35a13.42,13.42,0,0,1-2.46.37A18,18,0,0,0,16.71,6H20ZM4,10.83A9,9,0,0,1,8,10a11.13,11.13,0,0,1,1.82.14A18,18,0,0,1,9.92,12s0,0,0,.06A9.07,9.07,0,0,0,9,12a14.24,14.24,0,0,0-5,.9Zm7.61-.28,1,.35a12.94,12.94,0,0,0,3.27.8c0,.1,0,.2,0,.3a18,18,0,0,1-.2,2.65,10.89,10.89,0,0,0-4.08-2.26c0-.13,0-.26,0-.39C11.67,11.5,11.64,11,11.61,10.55ZM11.33,8.4A18.06,18.06,0,0,0,10.71,6h4.14a15.63,15.63,0,0,1,.91,3.68A11.68,11.68,0,0,1,13.31,9C12.71,8.81,12.06,8.58,11.33,8.4Zm3.88,8.54c-.12.38-.24.74-.36,1.06H9.78a11.41,11.41,0,0,0,1.59-3.6A10,10,0,0,1,15.21,16.94ZM8.85,6a14.94,14.94,0,0,1,.63,2.08A13.49,13.49,0,0,0,8,8a11.59,11.59,0,0,0-4,.66V6ZM4,15.05A12.47,12.47,0,0,1,9,14c.23,0,.44,0,.66,0a10.23,10.23,0,0,1-2,4H4ZM18.57,18a15.07,15.07,0,0,0-1.35-1.84A19.4,19.4,0,0,0,17.67,12c0-.1,0-.19,0-.29A15.15,15.15,0,0,0,20,11.4V18Z"]
  };
  
  var mouseCursor = {
    prefix: 'axis',
    iconName: 'mouseCursor',
    icon: [24, 24, [], "f0000", "M18.75,9.22,6.27,2.1A.75.75,0,0,0,5.89,2a.69.69,0,0,0-.37.1l-.12.07a.77.77,0,0,0-.4.65V17.16a.5.5,0,0,0,.33.47h0a.5.5,0,0,0,.54-.13l3.06-3.38,4.28,7.41a.77.77,0,0,0,.46.35L14,22l.19,0a.75.75,0,0,0,.38-.1l3.43-2a.75.75,0,0,0,.35-.45l.1-.37a.75.75,0,0,0-.07-.57l-4.28-7.41,4.46-1a.49.49,0,0,0,.39-.4h0A.49.49,0,0,0,18.75,9.22Z"]
  };
  
  var mouseCursorOutlined = {
    prefix: 'axis',
    iconName: 'mouseCursorOutlined',
    icon: [24, 24, [], "f0000", "M18.75,9.22,6.27,2.1A.75.75,0,0,0,5.89,2a.69.69,0,0,0-.37.1l-.12.07a.77.77,0,0,0-.4.65V17.16a.5.5,0,0,0,.33.47h0a.5.5,0,0,0,.54-.13l3.06-3.38,4.28,7.41a.77.77,0,0,0,.46.35L14,22l.19,0a.75.75,0,0,0,.38-.1l3.43-2a.75.75,0,0,0,.35-.45l.1-.37a.75.75,0,0,0-.07-.57l-4.28-7.41,4.46-1a.49.49,0,0,0,.39-.4h0A.49.49,0,0,0,18.75,9.22Zm-7,.38a.5.5,0,0,0-.33.74l4.81,8.34-1.73,1L9.65,11.34a.51.51,0,0,0-.81-.08L7,13.28V4.83L14.37,9Z"]
  };
  
  var opacity = {
    prefix: 'axis',
    iconName: 'opacity',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM5,19V16.14L7.86,19Zm5.33,0L5,13.67V11.19L12.81,19Zm4.95,0L5,8.71V6.24L17.76,19ZM19,17.76,6.24,5H8.71L19,15.29Zm0-5L11.19,5h2.47L19,10.34Zm0-4.95L16.14,5H19Z"]
  };
  
  var paint = {
    prefix: 'axis',
    iconName: 'paint',
    icon: [24, 24, [], "f0000", "M20,5.5v4A1.5,1.5,0,0,1,18.5,11H12v2h.5a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-8a.5.5,0,0,1,.5-.5H10V11a1.5,1.5,0,0,1,1.5-1.5h7v-4H17V7a1,1,0,0,1-1,1H5A1,1,0,0,1,4,7V3A1,1,0,0,1,5,2H16a1,1,0,0,1,1,1V4h1.5A1.5,1.5,0,0,1,20,5.5Z"]
  };
  
  var paintBucket = {
    prefix: 'axis',
    iconName: 'paintBucket',
    icon: [24, 24, [], "f0000", "M2,12.55v1.76a1.5,1.5,0,0,0,.44,1.06l6.19,6.19A1.5,1.5,0,0,0,9.69,22h.76a1.5,1.5,0,0,0,1.06-.44l8.33-8.33a1,1,0,0,0,0-1.41L10.19,2.15A.51.51,0,0,0,9.83,2a.5.5,0,0,0-.35.15l-.71.7a.51.51,0,0,0,0,.71l.8.8L2.44,11.49A1.5,1.5,0,0,0,2,12.55Zm9-6.77L17.19,12H4.76ZM19.48,16h.06a.33.33,0,0,1,.23.1c.75.84,2.23,2.42,2.23,3.4a2.5,2.5,0,0,1-5,0c0-1,1.46-2.55,2.22-3.38A.32.32,0,0,1,19.48,16Z"]
  };
  
  var paintOutlined = {
    prefix: 'axis',
    iconName: 'paintOutlined',
    icon: [24, 24, [], "f0000", "M18.5,4H17V3a1,1,0,0,0-1-1H5A1,1,0,0,0,4,3V7A1,1,0,0,0,5,8H16a1,1,0,0,0,1-1V5.5h1.5v4h-7A1.5,1.5,0,0,0,10,11v2H9.5a.5.5,0,0,0-.5.5v8a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-8a.5.5,0,0,0-.5-.5H12V11h6.5A1.5,1.5,0,0,0,20,9.5v-4A1.5,1.5,0,0,0,18.5,4ZM15,6H6V4h9Z"]
  };
  
  var palette = {
    prefix: 'axis',
    iconName: 'palette',
    icon: [24, 24, [], "f0000", "M19.36,5.36,17.71,3.71A2.41,2.41,0,0,0,16,3h0a2,2,0,0,0-2,2V6.59a1,1,0,0,1-1.71.7l-.12-.12A4,4,0,0,0,9.34,6H8a6,6,0,0,0-6,6v1a8,8,0,0,0,8,8h4a8,8,0,0,0,8-8V11.73A9,9,0,0,0,19.36,5.36ZM6.5,14A1.5,1.5,0,1,1,8,12.5,1.5,1.5,0,0,1,6.5,14Zm3,4A1.5,1.5,0,1,1,11,16.5,1.5,1.5,0,0,1,9.5,18Zm5,0A1.5,1.5,0,1,1,16,16.5,1.5,1.5,0,0,1,14.5,18Zm3-4A1.5,1.5,0,1,1,19,12.5,1.5,1.5,0,0,1,17.5,14Z"]
  };
  
  var paletteOutlined = {
    prefix: 'axis',
    iconName: 'paletteOutlined',
    icon: [24, 24, [], "f0000", "M16,5c0.1,0,0.2,0,0.3,0.1l1.7,1.7c1.3,1.3,2.1,3.1,2.1,4.9V13c0,3.3-2.7,6-6,6h-4c-3.3,0-6-2.7-6-6v-1c0-1.3,0.6-2.4,1.6-3.2C6.3,8.3,7.1,8,8,8h1.3c0.5,0,1,0.2,1.4,0.6l0.1,0.1c0.6,0.6,1.3,0.9,2.1,0.9c1.7,0,3-1.3,3-3L16,5L16,5M16,3L16,3c-1.1,0-2,0.9-2,2v1.6c0,0.6-0.5,1-1,1c-0.2,0-0.5-0.1-0.7-0.3l-0.1-0.1C11.4,6.4,10.4,6,9.3,6H8C6.7,6,5.4,6.4,4.4,7.2h0C2.9,8.3,2,10.1,2,12v1c0,4.4,3.6,8,8,8h4c4.4,0,8-3.6,8-8v-1.3c0-2.4-0.9-4.7-2.6-6.4l-1.7-1.7C17.3,3.3,16.6,3,16,3L16,3zM7.5,13C6.7,13,6,12.3,6,11.5S6.7,10,7.5,10S9,10.7,9,11.5S8.3,13,7.5,13z M9.5,17C8.7,17,8,16.3,8,15.5S8.7,14,9.5,14s1.5,0.7,1.5,1.5S10.3,17,9.5,17z M14.5,17c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S15.3,17,14.5,17z M16.5,13c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S17.3,13,16.5,13z"]
  };
  
  var panTool = {
    prefix: 'axis',
    iconName: 'panTool',
    icon: [24, 24, [], "f0000", "M22,5.5v9.91a6,6,0,0,1-.79,3L18.58,23a2,2,0,0,1-1.74,1H11.7a2,2,0,0,1-1.25-.44l-3.72-3a5.94,5.94,0,0,1-1.25-1.35l-.91-1.37A2.94,2.94,0,0,0,3,16.68l-1.34-.45h0l-.36-.12A.49.49,0,0,1,1,15.63v-.14A1.49,1.49,0,0,1,2.5,14h.84a3.94,3.94,0,0,1,1.28.2L7,15V2.5a1.5,1.5,0,0,1,3,0v8a.5.5,0,0,0,1,0v-9a1.5,1.5,0,0,1,3,0v9a.5.5,0,0,0,1,0v-8a1.5,1.5,0,0,1,3,0v8a.5.5,0,0,0,1,0v-5a1.5,1.5,0,0,1,3,0Z"]
  };
  
  var panorama = {
    prefix: 'axis',
    iconName: 'panorama',
    icon: [24, 24, [], "f0000", "M22,5h-.56a3.69,3.69,0,0,0-.87.1l-2.5.55A28.22,28.22,0,0,1,12,6.32a28.22,28.22,0,0,1-6.07-.67L3.43,5.1A3.69,3.69,0,0,0,2.56,5H2A1,1,0,0,0,1,6V18a1,1,0,0,0,1,1h.56a3.69,3.69,0,0,0,.87-.1l2.5-.55a27.88,27.88,0,0,1,12.15,0l2.49.55a3.69,3.69,0,0,0,.87.1H22a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1Z"]
  };
  
  var panoramaImage = {
    prefix: 'axis',
    iconName: 'panoramaImage',
    icon: [24, 24, [], "f0000", "M22,5h-.56a3.69,3.69,0,0,0-.87.1l-2.5.55A28.22,28.22,0,0,1,12,6.32a28.22,28.22,0,0,1-6.07-.67L3.43,5.1A3.69,3.69,0,0,0,2.56,5H2A1,1,0,0,0,1,6V18a1,1,0,0,0,1,1h.56a3.69,3.69,0,0,0,.87-.1l2.5-.55a27.88,27.88,0,0,1,12.15,0l2.49.55a3.69,3.69,0,0,0,.87.1H22a1,1,0,0,0,1-1V6A1,1,0,0,0,22,5ZM21,16a.74.74,0,0,1-.28.58.76.76,0,0,1-.63.15l-.46-.1a2,2,0,0,1-1.17-.76L16.07,12.7a.5.5,0,0,0-.8,0l-1,1.36a.5.5,0,0,1-.79,0l-2.31-2.88a.5.5,0,0,0-.78,0L8.09,14.07a.51.51,0,0,1-.8,0l-1-1.36a.51.51,0,0,0-.81,0L3.89,14.81A.48.48,0,0,1,3.5,15a.49.49,0,0,1-.5-.5V7.05l2.49.55A29.72,29.72,0,0,0,12,8.32a29.72,29.72,0,0,0,6.51-.72L21,7.05Zm-4.5-5.27A1.25,1.25,0,1,0,17.75,9.5,1.25,1.25,0,0,0,16.5,10.75Z"]
  };
  
  var panoramaOutlined = {
    prefix: 'axis',
    iconName: 'panoramaOutlined',
    icon: [24, 24, [], "f0000", "M21,7.05V17l-2.49-.55a29.79,29.79,0,0,0-13,0L3,17V7.05l2.49.55A29.72,29.72,0,0,0,12,8.32a29.72,29.72,0,0,0,6.51-.72L21,7.05m1-2h-.56a3.69,3.69,0,0,0-.87.1l-2.5.55A28.22,28.22,0,0,1,12,6.32a28.22,28.22,0,0,1-6.07-.67L3.43,5.1A3.69,3.69,0,0,0,2.56,5H2A1,1,0,0,0,1,6V18a1,1,0,0,0,1,1h.56a3.69,3.69,0,0,0,.87-.1l2.5-.55a27.88,27.88,0,0,1,12.15,0l2.49.55a3.69,3.69,0,0,0,.87.1H22a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1Z"]
  };
  
  var panoramaVs = {
    prefix: 'axis',
    iconName: 'panoramaVs',
    icon: [24, 24, [], "f0000", "M7,6.69V17.31a1,1,0,0,1-.8,1l-.27.06-2.5.55a3.69,3.69,0,0,1-.87.1H2a1,1,0,0,1-1-1V6A1,1,0,0,1,2,5h.56a3.69,3.69,0,0,1,.87.1l2.5.55.27.06A1,1,0,0,1,7,6.69ZM22,5h-.56a3.69,3.69,0,0,0-.87.1l-2.5.55-.27.06a1,1,0,0,0-.8,1V17.31a1,1,0,0,0,.8,1l.28.06,2.49.55a3.69,3.69,0,0,0,.87.1H22a1,1,0,0,0,1-1V6A1,1,0,0,0,22,5ZM13.93,6.25c-.64,0-1.29.07-1.93.07s-1.29,0-1.93-.07a1,1,0,0,0-.75.27A1,1,0,0,0,9,7.25v9.5a1,1,0,0,0,.32.73,1,1,0,0,0,.75.27c.64,0,1.29-.07,1.93-.07s1.29,0,1.93.07a1,1,0,0,0,.75-.27,1,1,0,0,0,.32-.73V7.25a1,1,0,0,0-.32-.73A1,1,0,0,0,13.93,6.25Z"]
  };
  
  var panoramaVsOutlined = {
    prefix: 'axis',
    iconName: 'panoramaVsOutlined',
    icon: [24, 24, [], "f0000", "M22,5h-.56a3.69,3.69,0,0,0-.87.1l-2.5.55A28.22,28.22,0,0,1,12,6.32a28.22,28.22,0,0,1-6.07-.67L3.43,5.1A3.69,3.69,0,0,0,2.56,5H2A1,1,0,0,0,1,6V18a1,1,0,0,0,1,1h.56a3.69,3.69,0,0,0,.87-.1l2.5-.55a27.88,27.88,0,0,1,12.15,0l2.49.55a3.69,3.69,0,0,0,.87.1H22a1,1,0,0,0,1-1V6A1,1,0,0,0,22,5ZM5.49,16.4,3,17V7.05l2.49.55c.5.11,1,.21,1.51.29v8.22C6.5,16.19,6,16.29,5.49,16.4ZM9,15.84V8.16c1,.1,2,.16,3,.16s2-.06,3-.16v7.68c-1-.1-2-.16-3-.16S10,15.74,9,15.84ZM21,17l-2.49-.55c-.5-.11-1-.21-1.51-.29V7.89c.51-.08,1-.18,1.51-.29L21,7.05Z"]
  };
  
  var paste = {
    prefix: 'axis',
    iconName: 'paste',
    icon: [24, 24, [], "f0000", "M16,2H4A2,2,0,0,0,2,4V16a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V4A2,2,0,0,0,16,2Zm0,14H4V4H16ZM8.5,20H6a2,2,0,0,0,2,2h.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,8.5,20Zm4,0h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,20Zm4,0h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,16.5,20Zm5-1H20a.47.47,0,0,0-.39.2,2.52,2.52,0,0,1-.4.4A.47.47,0,0,0,19,20v1.54a.26.26,0,0,0,.11.21.25.25,0,0,0,.22,0,4,4,0,0,0,2.44-2.44.25.25,0,0,0,0-.22A.26.26,0,0,0,21.53,19ZM20,6V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V8A2,2,0,0,0,20,6Zm1.5,5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11Zm0,4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,15Z"]
  };
  
  var pattern = {
    prefix: 'axis',
    iconName: 'pattern',
    icon: [24, 24, [], "f0000", "M21,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2Zm-4.3,7L19,9.7v4.6L16.7,12l-2.35,2.35L16.7,16.7,19,14.4V19l-2.3-2.3L14.4,19h-.1L12,16.7,9.7,19H9.6L7.3,16.7,5,19V14.4l2.3,2.3,2.35-2.35L7.3,12,5,14.3V9.7L7.3,12,9.65,9.65,7.3,7.3,5,9.6V5L7.3,7.3,9.6,5h.1L12,7.3,14.3,5h.1l2.3,2.3L19,5V9.6L16.7,7.3,14.35,9.65Zm-7-2.35L12,12l2.35-2.35L12,7.3Zm0,4.7L12,16.7l2.35-2.35L12,12Z"]
  };
  
  var pen = {
    prefix: 'axis',
    iconName: 'pen',
    icon: [24, 24, [], "f0000", "M20.85,9.51,14.49,3.15a.5.5,0,0,0-.71,0l-2.7,2.7a.5.5,0,0,0,0,.71l.59.6L6.24,9.33A2,2,0,0,0,5,10.7L3,18.76a1,1,0,0,0,.26.95l1,1A1,1,0,0,0,5,21a1,1,0,0,0,.24,0l8.06-2a2,2,0,0,0,1.37-1.2l2.17-5.43.6.59a.5.5,0,0,0,.71,0l2.7-2.7A.5.5,0,0,0,20.85,9.51Zm-8,7.51L6.69,18.55l2.86-2.86A.64.64,0,0,1,10,15.5,1.5,1.5,0,1,0,8.5,14a.64.64,0,0,1-.19.45L5.45,17.31,7,11.18l6.23-2.49,2.1,2.1Z"]
  };
  
  var photoAlbum = {
    prefix: 'axis',
    iconName: 'photoAlbum',
    icon: [24, 24, [], "f0000", "M18,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V4A2,2,0,0,0,18,2ZM6,4.5A.5.5,0,0,1,6.5,4h5a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.78.42L9.28,8.62a.52.52,0,0,0-.56,0L6.78,9.92A.5.5,0,0,1,6,9.5Zm12,15a.5.5,0,0,1-.5.5H6.5a.5.5,0,0,1-.5-.5v-.33a.51.51,0,0,1,.11-.31l2.74-3.53a.5.5,0,0,1,.78,0l1.09,1.31a.5.5,0,0,0,.78,0l2-2.57a.5.5,0,0,1,.79,0l3.61,4.81a.51.51,0,0,1,.1.3Z"]
  };
  
  var photoFilter = {
    prefix: 'axis',
    iconName: 'photoFilter',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V5H19ZM7.29,14.48a4.82,4.82,0,0,1,2.23,2.23A.51.51,0,0,0,10,17H10a.51.51,0,0,0,.44-.29,4.82,4.82,0,0,1,2.23-2.23A.51.51,0,0,0,13,14V14a.51.51,0,0,0-.29-.44,4.8,4.8,0,0,1-2.22-2.21.54.54,0,0,0-1,0,4.8,4.8,0,0,1-2.22,2.21A.51.51,0,0,0,7,14V14A.51.51,0,0,0,7.29,14.48Zm5.9-5.16h0a3.21,3.21,0,0,1,1.49,1.49A.34.34,0,0,0,15,11h0a.34.34,0,0,0,.3-.18,3.17,3.17,0,0,1,1.49-1.49A.34.34,0,0,0,17,9V9a.34.34,0,0,0-.18-.3A3.19,3.19,0,0,1,15.33,7.2.38.38,0,0,0,15,7h0a.38.38,0,0,0-.33.2,3.17,3.17,0,0,1-1.48,1.48h0A.3.3,0,0,0,13,9V9A.3.3,0,0,0,13.19,9.32Z"]
  };
  
  var photoGallery = {
    prefix: 'axis',
    iconName: 'photoGallery',
    icon: [24, 24, [], "f0000", "M19,17V3a2,2,0,0,0-2-2H3A2,2,0,0,0,1,3V17a2,2,0,0,0,2,2H17A2,2,0,0,0,19,17ZM7.5,6A1.5,1.5,0,1,1,6,7.5,1.5,1.5,0,0,1,7.5,6ZM16,15.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5v-.33a.51.51,0,0,1,.1-.3L6.47,11.7a.51.51,0,0,1,.81,0l1,1.36a.5.5,0,0,0,.79,0l2.29-2.88a.5.5,0,0,1,.78,0l3.74,4.67a.52.52,0,0,1,.11.32ZM21,5V19a2,2,0,0,1-2,2H5a2,2,0,0,0,2,2H19a4,4,0,0,0,4-4V7A2,2,0,0,0,21,5Z"]
  };
  
  var photoGalleryOutlined = {
    prefix: 'axis',
    iconName: 'photoGalleryOutlined',
    icon: [24, 24, [], "f0000", "M7.5,6A1.5,1.5,0,1,0,9,7.5,1.5,1.5,0,0,0,7.5,6ZM17,1H3A2,2,0,0,0,1,3V17a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V3A2,2,0,0,0,17,1Zm0,13.82a.5.5,0,0,1-.5.51.49.49,0,0,1-.39-.19l-4-5a.49.49,0,0,0-.39-.19.48.48,0,0,0-.39.19L9.08,13.07a.48.48,0,0,1-.39.19.51.51,0,0,1-.4-.2l-1-1.36a.54.54,0,0,0-.41-.2.51.51,0,0,0-.4.2L3.9,15.13a.48.48,0,0,1-.4.2.49.49,0,0,1-.5-.5V3H17ZM7.5,9A1.5,1.5,0,1,0,6,7.5,1.5,1.5,0,0,0,7.5,9Zm0-3A1.5,1.5,0,1,0,9,7.5,1.5,1.5,0,0,0,7.5,6ZM21,5V19a2,2,0,0,1-2,2H5a2,2,0,0,0,2,2H19a4,4,0,0,0,4-4V7A2,2,0,0,0,21,5Z"]
  };
  
  var photoLandscape = {
    prefix: 'axis',
    iconName: 'photoLandscape',
    icon: [24, 24, [], "f0000", "M22,6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2ZM9.5,7A1.5,1.5,0,1,1,8,8.5,1.5,1.5,0,0,1,9.5,7ZM19,16.5a.5.5,0,0,1-.5.5H5.5a.5.5,0,0,1-.5-.5v-.34a.46.46,0,0,1,.11-.3L8,12.19A.52.52,0,0,1,8.35,12a.5.5,0,0,1,.39.18l1.45,1.75a.49.49,0,0,0,.38.18.51.51,0,0,0,.4-.2l2.88-3.72a.51.51,0,0,1,.8,0l4.25,5.67a.51.51,0,0,1,.1.3Z"]
  };
  
  var photoLandscapeOutlined = {
    prefix: 'axis',
    iconName: 'photoLandscapeOutlined',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,12.83a.49.49,0,0,1-.5.5.48.48,0,0,1-.4-.2L14.65,11.2a.51.51,0,0,0-.8,0L11,14.91a.51.51,0,0,1-.4.2.49.49,0,0,1-.38-.18L8.74,13.18A.5.5,0,0,0,8.35,13a.52.52,0,0,0-.39.19L4.89,17.13a.48.48,0,0,1-.39.19.49.49,0,0,1-.5-.5V6H20ZM8,9.5A1.5,1.5,0,1,1,9.5,11,1.5,1.5,0,0,1,8,9.5Z"]
  };
  
  var photoSquare = {
    prefix: 'axis',
    iconName: 'photoSquare',
    icon: [24, 24, [], "f0000", "M21,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM9.5,8A1.5,1.5,0,1,1,8,9.5,1.5,1.5,0,0,1,9.5,8ZM18,17.5a.5.5,0,0,1-.5.5H6.5a.5.5,0,0,1-.5-.5v-.33a.51.51,0,0,1,.1-.3L8.47,13.7a.51.51,0,0,1,.81,0l1,1.36a.5.5,0,0,0,.79,0l2.29-2.88a.5.5,0,0,1,.78,0l3.74,4.67a.52.52,0,0,1,.11.32Z"]
  };
  
  var photoSquareOutlined = {
    prefix: 'axis',
    iconName: 'photoSquareOutlined',
    icon: [24, 24, [], "f0000", "M21,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM19,16.82a.5.5,0,0,1-.5.51.49.49,0,0,1-.39-.19l-4-5a.49.49,0,0,0-.39-.19.48.48,0,0,0-.39.19l-2.29,2.88a.48.48,0,0,1-.39.19.51.51,0,0,1-.4-.2l-1-1.36a.54.54,0,0,0-.41-.2.51.51,0,0,0-.4.2L5.9,17.13a.48.48,0,0,1-.4.2.49.49,0,0,1-.5-.5V5H19ZM9.5,11A1.5,1.5,0,1,0,8,9.5,1.5,1.5,0,0,0,9.5,11Z"]
  };
  
  var podcast = {
    prefix: 'axis',
    iconName: 'podcast',
    icon: [24, 24, [], "f0000", "M12,14h0M12,4A10,10,0,0,0,2,14v.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14a8,8,0,0,1,16,0v.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14A10,10,0,0,0,12,4Zm0,4a6,6,0,0,0-6,6v.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14a4,4,0,0,1,8,0v.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14a6,6,0,0,0-6-6Zm0,4a2,2,0,1,0,2,2,2,2,0,0,0-2-2Zm1.88,5H10.12a1.5,1.5,0,0,0-1.34.83l-.73,1.45A.5.5,0,0,0,8.5,20h7a.5.5,0,0,0,.45-.72l-.73-1.45A1.5,1.5,0,0,0,13.88,17Z"]
  };
  
  var print = {
    prefix: 'axis',
    iconName: 'print',
    icon: [24, 24, [], "f0000", "M19,7V5a2,2,0,0,0-2-2H7A2,2,0,0,0,5,5V7A2,2,0,0,0,3,9v5.5a.5.5,0,0,0,.5.5H5v4a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V15h1.5a.5.5,0,0,0,.5-.5V9A2,2,0,0,0,19,7ZM7,5H17V7H7ZM17,19H7V13H17Zm2-8.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Z"]
  };
  
  var printDisabled = {
    prefix: 'axis',
    iconName: 'printDisabled',
    icon: [24, 24, [], "f0000", "M4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L5,6.24V7A2,2,0,0,0,3,9v5.5a.5.5,0,0,0,.5.5H5v4a2,2,0,0,0,2,2H17a2,2,0,0,0,1.74-1l.88.88a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM17,19H7V13h4.76L17,18.24ZM19,7V5a2,2,0,0,0-2-2H7a2.3,2.3,0,0,0-.26,0l2,2H17V7H10.71l8,8H20.5a.5.5,0,0,0,.5-.5V9A2,2,0,0,0,19,7Zm0,3.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Z"]
  };
  
  var redo = {
    prefix: 'axis',
    iconName: 'redo',
    icon: [24, 24, [], "f0000", "M11.48,8a10.37,10.37,0,0,1,7,2.57l2.42-2.42A.49.49,0,0,1,21.21,8h.29a.5.5,0,0,1,.5.5v7a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-.29a.49.49,0,0,1,.15-.36l2.52-2.52a7.9,7.9,0,0,0-5.19-1.83c-3.67,0-6.69,2.23-7,5.05A.49.49,0,0,1,4,16H2.5a.5.5,0,0,1-.5-.54C2.33,11.29,6.45,8,11.48,8Z"]
  };
  
  var reflectHorizontal = {
    prefix: 'axis',
    iconName: 'reflectHorizontal',
    icon: [24, 24, [], "f0000", "M3.29,5.9a.67.67,0,0,0-.43-.14.69.69,0,0,0-.37.1l-.11.06A.74.74,0,0,0,2,6.57V17.42a.74.74,0,0,0,.38.65l.11.06a.69.69,0,0,0,.37.1.73.73,0,0,0,.43-.13l7.39-5.18a.75.75,0,0,0,.32-.61v-.62a.75.75,0,0,0-.32-.61ZM4,15.16V8.83L8.51,12ZM21.62,5.92l-.11-.06a.73.73,0,0,0-.8,0l-7.39,5.18a.75.75,0,0,0-.32.61v.62a.75.75,0,0,0,.32.61l7.39,5.18a.75.75,0,0,0,.8,0l.11-.06a.74.74,0,0,0,.38-.65V6.57A.74.74,0,0,0,21.62,5.92ZM12.5,3h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,3Zm0,4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,7Zm0,8h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,15Zm0,4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,19Z"]
  };
  
  var reflectVertical = {
    prefix: 'axis',
    iconName: 'reflectVertical',
    icon: [24, 24, [], "f0000", "M18.1,3.29a.67.67,0,0,0,.14-.43.69.69,0,0,0-.1-.37l-.06-.11A.74.74,0,0,0,17.43,2H6.58a.74.74,0,0,0-.65.38l-.06.11a.69.69,0,0,0-.1.37.73.73,0,0,0,.13.43l5.18,7.39a.75.75,0,0,0,.61.32h.62a.75.75,0,0,0,.61-.32ZM8.84,4h6.33L12,8.51Zm8.59,18H6.58a.74.74,0,0,1-.65-.38l-.06-.11a.75.75,0,0,1,0-.8l5.18-7.39a.75.75,0,0,1,.61-.32h.62a.75.75,0,0,1,.61.32l5.18,7.39a.73.73,0,0,1,0,.8l-.06.11A.74.74,0,0,1,17.43,22Zm3.07-9h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,20.5,13Zm-4,0h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,16.5,13Zm-8,0h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,8.5,13Zm-4,0h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,4.5,13Z"]
  };
  
  var roundedCorner = {
    prefix: 'axis',
    iconName: 'roundedCorner',
    icon: [24, 24, [], "f0000", "M11,4.52v-1a.5.5,0,0,1,.16-.36A.55.55,0,0,1,11.53,3,10,10,0,0,1,21,12.47a.55.55,0,0,1-.14.37.5.5,0,0,1-.36.16h-1a.49.49,0,0,1-.49-.47A8,8,0,0,0,11.47,5,.49.49,0,0,1,11,4.52ZM20.5,15h-1a.5.5,0,0,0-.5.5V19H5V5H8.5A.5.5,0,0,0,9,4.5v-1A.5.5,0,0,0,8.5,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V15.5A.5.5,0,0,0,20.5,15Zm-9-1A1.5,1.5,0,1,0,10,12.5,1.5,1.5,0,0,0,11.5,14Z"]
  };
  
  var ruler = {
    prefix: 'axis',
    iconName: 'ruler',
    icon: [24, 24, [], "f0000", "M21.71,5.81,18.19,2.29a1,1,0,0,0-.7-.29h-.73a1,1,0,0,0-.71.29L2.29,16.05a1,1,0,0,0-.29.71v.73a1,1,0,0,0,.29.7l3.52,3.52a1,1,0,0,0,.7.29h.73A1,1,0,0,0,8,21.71L21.71,8A1,1,0,0,0,22,7.24V6.51A1,1,0,0,0,21.71,5.81ZM6.88,20,4.05,17.12l1-.95,1.06,1.06a.5.5,0,0,0,.7,0l.54-.54a.5.5,0,0,0,0-.7L6.25,14.93l1.24-1.24.56.56a.5.5,0,0,0,.7,0l.54-.54a.5.5,0,0,0,0-.7l-.56-.56L10,11.21,11,12.27a.5.5,0,0,0,.7,0l.54-.54a.5.5,0,0,0,0-.7L11.21,10l1.24-1.24.56.56a.5.5,0,0,0,.7,0l.54-.54a.5.5,0,0,0,0-.7l-.56-.56,1.24-1.24L16,7.31a.5.5,0,0,0,.7,0l.54-.54a.5.5,0,0,0,0-.7L16.17,5l.95-1L20,6.88Z"]
  };
  
  var save = {
    prefix: 'axis',
    iconName: 'save',
    icon: [24, 24, [], "f0000", "M20.41,6.41,17.59,3.59A2,2,0,0,0,16.17,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V7.83A2,2,0,0,0,20.41,6.41ZM9,6.5V5h6V6.5a.5.5,0,0,1-.5.5h-5A.5.5,0,0,1,9,6.5ZM17,19H7V11.5a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5Zm-2.5-4h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,14.5,15Z"]
  };
  
  var saveOutlined = {
    prefix: 'axis',
    iconName: 'saveOutlined',
    icon: [24, 24, [], "f0000", "M20.41,6.41,17.59,3.59A2,2,0,0,0,16.17,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V7.83A2,2,0,0,0,20.41,6.41ZM9,16.5v-1a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-5A.5.5,0,0,1,9,16.5ZM19,19H17V11.5a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5V19H5V5H9V6.5a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5V5h1.17L19,7.83Z"]
  };
  
  var scanDocument = {
    prefix: 'axis',
    iconName: 'scanDocument',
    icon: [24, 24, [], "f0000", "M4,20a2,2,0,0,0,2,2h7.17a2,2,0,0,0,1.42-.59l4.82-4.82A2,2,0,0,0,20,15.17V13H4Zm9-4a1,1,0,0,1,1-1h4.18L13,20.18Zm8.5-7H20V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V9H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h19a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,9Z"]
  };
  
  var scanDocumentIcon = {
    prefix: 'axis',
    iconName: 'scanDocumentIcon',
    icon: [24, 24, [], "f0000", "M21.5,8H20V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h19a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,8ZM6,4H18V8H6ZM18,14H13a1,1,0,0,0-1,1v5H6V12H4v8a2,2,0,0,0,2,2h6.76a3,3,0,0,0,2.12-.88l4.24-4.24A3,3,0,0,0,20,14.76V12H18Z"]
  };
  
  var selection = {
    prefix: 'axis',
    iconName: 'selection',
    icon: [24, 24, [], "f0000", "M9,19.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,9,19.5Zm3.5-.5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,19ZM13,3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5ZM8.5,3h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,9,4.5v-1A.5.5,0,0,0,8.5,3ZM4.71,3A2,2,0,0,0,3,4.71a.23.23,0,0,0,.06.2A.25.25,0,0,0,3.27,5H4.5A.5.5,0,0,0,5,4.5V3.27a.25.25,0,0,0-.09-.19A.23.23,0,0,0,4.71,3ZM4.5,7h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,5,8.5v-1A.5.5,0,0,0,4.5,7Zm0,4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,4.5,11Zm0,4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,4.5,15Zm0,4H3.27a.25.25,0,0,0-.19.09.23.23,0,0,0-.06.2A2,2,0,0,0,4.71,21a.23.23,0,0,0,.2-.06A.25.25,0,0,0,5,20.73V19.5A.5.5,0,0,0,4.5,19Zm16.23,0H19.5a.5.5,0,0,0-.5.5v1.23a.25.25,0,0,0,.09.19.23.23,0,0,0,.2.06A2,2,0,0,0,21,19.29a.23.23,0,0,0-.06-.2A.25.25,0,0,0,20.73,19ZM19,4.5a.5.5,0,0,0,.5.5h1.23a.25.25,0,0,0,.19-.09.23.23,0,0,0,.06-.2A2,2,0,0,0,19.29,3a.23.23,0,0,0-.2.06.25.25,0,0,0-.09.19ZM20.5,7h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,7Zm0,4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,11Zm0,4h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,15ZM17,3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5ZM16.5,19h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,16.5,19Z"]
  };
  
  var sendBackward = {
    prefix: 'axis',
    iconName: 'sendBackward',
    icon: [24, 24, [], "f0000", "M20,11H18V8a2,2,0,0,0-2-2H13V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v7a2,2,0,0,0,2,2H6v3a2,2,0,0,0,2,2h3v2a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2V13A2,2,0,0,0,20,11ZM4,4h7v7H4ZM20,20H13V13h7Z"]
  };
  
  var sendToBack = {
    prefix: 'axis',
    iconName: 'sendToBack',
    icon: [24, 24, [], "f0000", "M4,16H8v4a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V14A2,2,0,0,0,4,16ZM4,4H14V14H4Z"]
  };
  
  var sharpness = {
    prefix: 'axis',
    iconName: 'sharpness',
    icon: [24, 24, [], "f0000", "M22.9,3.37a.79.79,0,0,0,0-.76l-.14-.23A.73.73,0,0,0,22.11,2H1.89a.73.73,0,0,0-.65.38l-.14.23a.79.79,0,0,0,0,.76L11.21,20.63a.76.76,0,0,0,.65.37h.3a.76.76,0,0,0,.65-.37ZM12,18,3.79,4H12Z"]
  };
  
  var shear = {
    prefix: 'axis',
    iconName: 'shear',
    icon: [24, 24, [], "f0000", "M21.5,5h-9a2,2,0,0,0-1.63.84L10,7.06V6A1,1,0,0,0,9,5H3A1,1,0,0,0,2,6V18a1.42,1.42,0,0,0,0,.2H2A1,1,0,0,0,3,19h8.44a2,2,0,0,0,1.63-.84L21.91,5.79A.5.5,0,0,0,21.5,5ZM4,7H8V9.86l-4,5.6Z"]
  };
  
  var shutter = {
    prefix: 'axis',
    iconName: 'shutter',
    icon: [24, 24, [], "f0000", "M9,9.75,6,4.58a.52.52,0,0,1,.13-.66A10,10,0,0,1,12,2a10.17,10.17,0,0,1,1.47.11.5.5,0,0,1,.35.74l-4,6.9A.5.5,0,0,1,9,9.75ZM12.87,9h8a.5.5,0,0,0,.47-.67,10,10,0,0,0-5.25-5.46.49.49,0,0,0-.63.21l-3,5.17A.5.5,0,0,0,12.87,9ZM5,5.86a.49.49,0,0,0-.81-.07A9.91,9.91,0,0,0,2,12a9.28,9.28,0,0,0,.07,1.06.49.49,0,0,0,.5.44h6A.5.5,0,0,0,9,12.75ZM11.13,15h-8a.5.5,0,0,0-.47.67A10,10,0,0,0,8,21.13a.49.49,0,0,0,.63-.21l3-5.17A.5.5,0,0,0,11.13,15ZM19,18.14a.49.49,0,0,0,.81.07A9.91,9.91,0,0,0,22,12a9.28,9.28,0,0,0-.07-1.06.49.49,0,0,0-.5-.44h-6a.5.5,0,0,0-.43.75Zm-4.84-3.89-4,6.9a.5.5,0,0,0,.35.74A10.17,10.17,0,0,0,12,22a10,10,0,0,0,5.89-1.92.52.52,0,0,0,.13-.66l-3-5.17A.5.5,0,0,0,14.17,14.25Z"]
  };
  
  var shutterOutlined = {
    prefix: 'axis',
    iconName: 'shutterOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3,2.61a8,8,0,0,1,4,3.64.51.51,0,0,1-.44.75H12.87a.52.52,0,0,1-.44-.25.5.5,0,0,1,0-.5l2-3.42A.49.49,0,0,1,15,4.61ZM7.11,5.68A8,8,0,0,1,12,4h.31a.48.48,0,0,1,.41.26.5.5,0,0,1,0,.49l-2.89,5a.5.5,0,0,1-.86,0L7,6.33A.52.52,0,0,1,7.11,5.68Zm-3,7.4A7.62,7.62,0,0,1,4,12,7.88,7.88,0,0,1,5.23,7.76a.5.5,0,0,1,.86,0L8.54,12l.43.75a.5.5,0,0,1,0,.5.52.52,0,0,1-.43.25h-4A.5.5,0,0,1,4.08,13.08ZM9,19.39a8,8,0,0,1-4-3.64A.51.51,0,0,1,5.38,15h5.75a.52.52,0,0,1,.44.25.5.5,0,0,1,0,.5l-2,3.42A.49.49,0,0,1,9,19.39Zm7.92-1.07A8,8,0,0,1,12,20h-.31a.48.48,0,0,1-.41-.26.5.5,0,0,1,0-.49l2.89-5a.5.5,0,0,1,.86,0l2,3.42A.51.51,0,0,1,16.89,18.32Zm1.88-2.08a.5.5,0,0,1-.86,0l-2.88-5a.5.5,0,0,1,.43-.75h4a.5.5,0,0,1,.49.42A7.62,7.62,0,0,1,20,12,7.88,7.88,0,0,1,18.77,16.24Z"]
  };
  
  var slideshow = {
    prefix: 'axis',
    iconName: 'slideshow',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm-3.94,9.62-3.89,2.6A.75.75,0,0,1,10,14.6V9.4a.75.75,0,0,1,1.17-.62l3.89,2.6A.74.74,0,0,1,15.06,12.62Z"]
  };
  
  var slideshowOutlined = {
    prefix: 'axis',
    iconName: 'slideshowOutlined',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V5H19Zm-7.83-3.78,3.89-2.6a.74.74,0,0,0,0-1.24l-3.89-2.6A.75.75,0,0,0,10,9.4v5.2A.75.75,0,0,0,11.17,15.22Z"]
  };
  
  var smallCaps = {
    prefix: 'axis',
    iconName: 'smallCaps',
    icon: [24, 24, [], "f0000", "M9,18.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V6H2.5A.5.5,0,0,1,2,5.5v-1A.5.5,0,0,1,2.5,4h11a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H9ZM18,10h3.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H16v8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5Z"]
  };
  
  var snapTo = {
    prefix: 'axis',
    iconName: 'snapTo',
    icon: [24, 24, [], "f0000", "M18.65,9.06h-.48a1,1,0,0,0-.7.29l-6,6a2.09,2.09,0,0,1-2.65.3,1.38,1.38,0,0,1-.26-.22,2,2,0,0,1,0-2.83l6.1-6a1,1,0,0,0,.3-.71V5.34a1,1,0,0,0-.29-.7L12.29,2.29a1,1,0,0,0-.7-.29h-.51a1,1,0,0,0-.7.29L4.48,8.15a8.18,8.18,0,0,0-.56,11.12l.36.39a8,8,0,0,0,11.32,0l6.1-6.06a1,1,0,0,0,.3-.71v-.48a1,1,0,0,0-.29-.7L19.35,9.35A1,1,0,0,0,18.65,9.06Zm-4.47,9.18a6,6,0,0,1-8.48,0A3.83,3.83,0,0,1,5.42,18a6.17,6.17,0,0,1,.47-8.39l2.8-2.73L10.1,8.24l-3,2.93a4,4,0,0,0,0,5.66,3.6,3.6,0,0,0,.52.43,4.1,4.1,0,0,0,5.22-.52l2.91-2.84,1.41,1.41Z"]
  };
  
  var spiral = {
    prefix: 'axis',
    iconName: 'spiral',
    icon: [24, 24, [], "f0000", "M21,16.35a.54.54,0,0,1-.11.37A12.8,12.8,0,0,1,12,21h0A9,9,0,0,1,12,3a7,7,0,0,1,0,14A5,5,0,0,1,12,7a3,3,0,0,1,.6,5.94.53.53,0,0,1-.42-.1.53.53,0,0,1-.18-.39v-1a.5.5,0,0,1,.33-.47A1,1,0,0,0,12,9a3,3,0,0,0,0,6A5,5,0,0,0,12,5a7,7,0,0,0,0,14h0a10.78,10.78,0,0,0,7.32-3.53.5.5,0,0,1,.7-.08l.79.62A.58.58,0,0,1,21,16.35Z"]
  };
  
  var stamp = {
    prefix: 'axis',
    iconName: 'stamp',
    icon: [24, 24, [], "f0000", "M6,20H18v1.5a.5.5,0,0,1-.5.5H6.5a.5.5,0,0,1-.5-.5Zm12.55-6.41-3.82-1.1a1,1,0,0,1-.73-1V10a1,1,0,0,1,.4-.8,4,4,0,1,0-4.8,0,1,1,0,0,1,.4.8v1.55a1,1,0,0,1-.73,1l-3.82,1.1A2,2,0,0,0,4,15.51v2a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-2A2,2,0,0,0,18.55,13.59Z"]
  };
  
  var strikethrough = {
    prefix: 'axis',
    iconName: 'strikethrough',
    icon: [24, 24, [], "f0000", "M20,10.5v1a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V6H6.5A.5.5,0,0,1,6,5.5v-1A.5.5,0,0,1,6.5,4h11a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H13v4h6.5A.5.5,0,0,1,20,10.5Zm-9,8a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14H11Z"]
  };
  
  var strokeWeight = {
    prefix: 'axis',
    iconName: 'strokeWeight',
    icon: [24, 24, [], "f0000", "M4,21.5v-1a.5.5,0,0,1,.5-.5h15a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H4.5A.5.5,0,0,1,4,21.5ZM4.5,18h15a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5H4.5a.5.5,0,0,0-.5.5v2A.5.5,0,0,0,4.5,18Zm0-5h15a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5H4.5a.5.5,0,0,0-.5.5v3A.5.5,0,0,0,4.5,13Zm0-6h15a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,0-.5-.5H4.5a.5.5,0,0,0-.5.5v4A.5.5,0,0,0,4.5,7Z"]
  };
  
  var substract = {
    prefix: 'axis',
    iconName: 'substract',
    icon: [24, 24, [], "f0000", "M2,10V20a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V16h4a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H10A2,2,0,0,0,8,4V8H4A2,2,0,0,0,2,10Zm2,0H14V20H4Z"]
  };
  
  var switchCamera = {
    prefix: 'axis',
    iconName: 'switchCamera',
    icon: [24, 24, [], "f0000", "M20,7H18.83a2,2,0,0,1-1.42-.59L15.88,4.88A3,3,0,0,0,13.76,4H10.24a3,3,0,0,0-2.12.88L6.59,6.41A2,2,0,0,1,5.17,7H4A2,2,0,0,0,2,9v9a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V9A2,2,0,0,0,20,7Zm-8.41,3.5a2.25,2.25,0,0,0-1.84,2.21h.81a.25.25,0,0,1,.21.39L9.23,15.4a.24.24,0,0,1-.41,0L7.28,13.1a.25.25,0,0,1,.21-.39h.76A3.75,3.75,0,0,1,11.41,9,.5.5,0,0,1,12,9.5V10A.5.5,0,0,1,11.59,10.5Zm4.92,2.79h-.76A3.75,3.75,0,0,1,12.59,17,.5.5,0,0,1,12,16.5V16a.5.5,0,0,1,.41-.49,2.25,2.25,0,0,0,1.84-2.21h-.81a.25.25,0,0,1-.21-.39l1.54-2.3a.24.24,0,0,1,.41,0l1.54,2.3A.25.25,0,0,1,16.51,13.29Z"]
  };
  
  var switchVideo = {
    prefix: 'axis',
    iconName: 'switchVideo',
    icon: [24, 24, [], "f0000", "M20.5,7h-.09a1,1,0,0,0-.7.29L17,10V8a2,2,0,0,0-2-2H5A2,2,0,0,0,3,8v8a2,2,0,0,0,2,2H15a2,2,0,0,0,2-2V14l2.71,2.71a1,1,0,0,0,.7.29h.09a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,20.5,7ZM9.59,9.5a2.25,2.25,0,0,0-1.84,2.21h.81a.25.25,0,0,1,.21.39L7.23,14.4a.24.24,0,0,1-.41,0L5.28,12.1a.25.25,0,0,1,.21-.39h.76A3.75,3.75,0,0,1,9.41,8,.5.5,0,0,1,10,8.5V9A.5.5,0,0,1,9.59,9.5Zm4.92,2.79h-.76A3.75,3.75,0,0,1,10.59,16,.5.5,0,0,1,10,15.5V15a.5.5,0,0,1,.41-.49,2.25,2.25,0,0,0,1.84-2.21h-.81a.25.25,0,0,1-.21-.39l1.54-2.3a.24.24,0,0,1,.41,0l1.54,2.3A.25.25,0,0,1,14.51,12.29Z"]
  };
  
  var text = {
    prefix: 'axis',
    iconName: 'text',
    icon: [24, 24, [], "f0000", "M13,18.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V6H6.5A.5.5,0,0,1,6,5.5v-1A.5.5,0,0,1,6.5,4h11a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H13Z"]
  };
  
  var textCenter = {
    prefix: 'axis',
    iconName: 'textCenter',
    icon: [24, 24, [], "f0000", "M21,11.5v1a.5.5,0,0,1-.5.5H3.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h17A.5.5,0,0,1,21,11.5ZM7.5,9h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,9Zm13-6H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,3Zm0,16H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,19Zm-13-2h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,7.5,17Z"]
  };
  
  var textLeft = {
    prefix: 'axis',
    iconName: 'textLeft',
    icon: [24, 24, [], "f0000", "M21,11.5v1a.5.5,0,0,1-.5.5H3.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h17A.5.5,0,0,1,21,11.5ZM3.5,9h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,3.5,9Zm17-6H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,3Zm0,16H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,19Zm-17-2h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,3.5,17Z"]
  };
  
  var textRight = {
    prefix: 'axis',
    iconName: 'textRight',
    icon: [24, 24, [], "f0000", "M21,11.5v1a.5.5,0,0,1-.5.5H3.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h17A.5.5,0,0,1,21,11.5ZM11.5,9h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,11.5,9Zm9-6H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,3Zm0,16H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,19Zm-9-2h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,11.5,17Z"]
  };
  
  var texture = {
    prefix: 'axis',
    iconName: 'texture',
    icon: [24, 24, [], "f0000", "M3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5ZM5,8H8V5h4V8h4V5h3V8H16v4h3v4H16v3H12V16H8v3H5V16H8V12H5Zm11,4v4H12V12ZM8,12V8h4v4Z"]
  };
  
  var tools = {
    prefix: 'axis',
    iconName: 'tools',
    icon: [24, 24, [], "f0000", "M3.3,18.6C3.1,18.8,3,19,3,19.3v0.2c0,0.3,0.1,0.5,0.3,0.7l0.5,0.5C4,20.9,4.3,21,4.5,21h0.2c0.3,0,0.5-0.1,0.7-0.3l5.7-5.7L9,12.9L3.3,18.6z M17,11c2.2,0,4-1.8,4-4V6.7c0-0.1-0.1-0.3-0.1-0.4l-0.2-0.2C20.5,6,20.2,6,20,6.1c0,0,0,0,0,0l-1.6,1.6c-0.2,0.2-0.5,0.2-0.7,0l-1.4-1.4c-0.2-0.2-0.2-0.5,0-0.7L17.9,4c0.2-0.2,0.2-0.5,0-0.7c0,0,0,0,0,0l-0.2-0.2C17.6,3,17.5,3,17.3,3H17c-2.2,0-4,1.8-4,4c0,0.5,0.1,1.1,0.3,1.6l-1.7,1.7L8.2,6.8L7.3,5.2C7.2,4.9,7,4.6,6.7,4.4L4.6,3.1C4.4,3,4.2,3,4,3.1L3.2,4C3,4.2,3,4.4,3.1,4.6l1.4,2C4.6,7,4.9,7.2,5.2,7.3l1.6,0.9l0,0l6.8,6.8l-0.5,0.5c-0.2,0.2-0.2,0.5,0,0.7l4.5,4.5c0.2,0.2,0.4,0.3,0.7,0.3h1.2c0.3,0,0.5-0.1,0.7-0.3l0.5-0.5c0.2-0.2,0.3-0.4,0.3-0.7v-1.2c0-0.3-0.1-0.5-0.3-0.7l-4.5-4.5c-0.2-0.2-0.5-0.2-0.7,0L15,13.6l-1.2-1.2l1.7-1.7C15.9,10.9,16.5,11,17,11z"]
  };
  
  var transform = {
    prefix: 'axis',
    iconName: 'transform',
    icon: [24, 24, [], "f0000", "M20,9a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H16a1,1,0,0,0-1,1V5H9V4A1,1,0,0,0,8,3H4A1,1,0,0,0,3,4V8A1,1,0,0,0,4,9H5v6H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H8a1,1,0,0,0,1-1V19h6v1a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V16a1,1,0,0,0-1-1H19V9ZM17,5h2V7H17ZM5,5H7V7H5ZM7,19H5V17H7Zm12,0H17V17h2Zm-2-4H16a1,1,0,0,0-1,1v1H9V16a1,1,0,0,0-1-1H7V9H8A1,1,0,0,0,9,8V7h6V8a1,1,0,0,0,1,1h1Z"]
  };
  
  var transformArtboard = {
    prefix: 'axis',
    iconName: 'transformArtboard',
    icon: [24, 24, [], "f0000", "M5,9H2.5A.5.5,0,0,1,2,8.5v-1A.5.5,0,0,1,2.5,7H5ZM8.5,2h-1a.5.5,0,0,0-.5.5V5H9V2.5A.5.5,0,0,0,8.5,2ZM17,5V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V5Zm5,3.5v-1a.5.5,0,0,0-.5-.5H19V9h2.5A.5.5,0,0,0,22,8.5ZM19,17h2.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19Zm-3.5,5h1a.5.5,0,0,0,.5-.5V19H15v2.5A.5.5,0,0,0,15.5,22ZM7,19v2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19ZM2,15.5v1a.5.5,0,0,0,.5.5H5V15H2.5A.5.5,0,0,0,2,15.5ZM15,9H9v6h6V9m1.5-2a.5.5,0,0,1,.5.5v9a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5v-9A.5.5,0,0,1,7.5,7Z"]
  };
  
  var underline = {
    prefix: 'axis',
    iconName: 'underline',
    icon: [24, 24, [], "f0000", "M19,17.5v1a.5.5,0,0,1-.5.5H5.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13A.5.5,0,0,1,19,17.5ZM16.5,4h-1a.5.5,0,0,0-.5.5V10a3,3,0,0,1-6,0V4.5A.5.5,0,0,0,8.5,4h-1a.5.5,0,0,0-.5.5V10a5,5,0,0,0,10,0V4.5A.5.5,0,0,0,16.5,4Z"]
  };
  
  var undo = {
    prefix: 'axis',
    iconName: 'undo',
    icon: [24, 24, [], "f0000", "M22,15.46a.5.5,0,0,1-.5.54H20a.49.49,0,0,1-.49-.45c-.29-2.82-3.31-5.05-7-5.05a7.9,7.9,0,0,0-5.19,1.83l2.52,2.52a.49.49,0,0,1,.15.36v.29a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-7A.5.5,0,0,1,2.5,8h.29a.49.49,0,0,1,.36.15l2.42,2.42a10.37,10.37,0,0,1,7-2.57C17.55,8,21.67,11.29,22,15.46Z"]
  };
  
  var union = {
    prefix: 'axis',
    iconName: 'union',
    icon: [24, 24, [], "f0000", "M2,10V20a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V16h4a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H10A2,2,0,0,0,8,4V8H4A2,2,0,0,0,2,10Z"]
  };
  
  var vector = {
    prefix: 'axis',
    iconName: 'vector',
    icon: [24, 24, [], "f0000", "M22,13H20.1a11.86,11.86,0,0,0-4-4.25h3.73A1.75,1.75,0,1,0,19.67,7H15V6a1,1,0,0,0-1-1H10A1,1,0,0,0,9,6V7H4.33a1.75,1.75,0,1,0-.15,1.75H7.91A11.86,11.86,0,0,0,3.9,13H2a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H5.93A11.08,11.08,0,0,1,9,10.12.49.49,0,0,1,9,10a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1,.49.49,0,0,1,0,.12A11.08,11.08,0,0,1,18.07,13H18a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13ZM5,17H3V15H5Zm8-8H11V7h2Zm8,8H19V15h2Z"]
  };
  
  var verticalAlignBottom = {
    prefix: 'axis',
    iconName: 'verticalAlignBottom',
    icon: [24, 24, [], "f0000", "M8.64,13.85A.5.5,0,0,1,9,13h2V3.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V13h2a.5.5,0,0,1,.35.85l-3,3a.51.51,0,0,1-.71,0ZM3.5,21h17a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,3.5,21Z"]
  };
  
  var verticalAlignMiddle = {
    prefix: 'axis',
    iconName: 'verticalAlignMiddle',
    icon: [24, 24, [], "f0000", "M15.36,18.15A.5.5,0,0,1,15,19H13v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V19H9a.5.5,0,0,1-.35-.85l3-3a.51.51,0,0,1,.71,0ZM20.5,11H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,11ZM11.65,8.86a.51.51,0,0,0,.71,0l3-3A.5.5,0,0,0,15,5H13V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V5H9a.5.5,0,0,0-.35.85Z"]
  };
  
  var verticalAlignTop = {
    prefix: 'axis',
    iconName: 'verticalAlignTop',
    icon: [24, 24, [], "f0000", "M15.36,10.15A.5.5,0,0,1,15,11H13v9.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V11H9a.5.5,0,0,1-.35-.85l3-3a.51.51,0,0,1,.71,0ZM20.5,3H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,3Z"]
  };
  
  var videoAdd = {
    prefix: 'axis',
    iconName: 'videoAdd',
    icon: [24, 24, [], "f0000", "M21.5,7h-.09a1,1,0,0,0-.7.29L18,10V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V17a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V14l2.71,2.71a1,1,0,0,0,.7.29h.09a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,21.5,7ZM14,12.5a.5.5,0,0,1-.5.5H11v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V13H6.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H9V8.5A.5.5,0,0,1,9.5,8h1a.5.5,0,0,1,.5.5V11h2.5a.5.5,0,0,1,.5.5Z"]
  };
  
  var videoGallery = {
    prefix: 'axis',
    iconName: 'videoGallery',
    icon: [24, 24, [], "f0000", "M17,1H3A2,2,0,0,0,1,3V17a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V3A2,2,0,0,0,17,1Zm-3.94,9.62-3.89,2.6A.75.75,0,0,1,8,12.6V7.4a.75.75,0,0,1,1.17-.62l3.89,2.6A.74.74,0,0,1,13.06,10.62ZM21,5V19a2,2,0,0,1-2,2H5a2,2,0,0,0,2,2H19a4,4,0,0,0,4-4V7A2,2,0,0,0,21,5Z"]
  };
  
  var videoGalleryOutlined = {
    prefix: 'axis',
    iconName: 'videoGalleryOutlined',
    icon: [24, 24, [], "f0000", "M17,3V17H3V3H17m0-2H3A2,2,0,0,0,1,3V17a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2Zm4,4V19a2,2,0,0,1-2,2H5a2,2,0,0,0,2,2H19a4,4,0,0,0,4-4V7A2,2,0,0,0,21,5ZM9.17,13.22l3.89-2.6a.74.74,0,0,0,0-1.24L9.17,6.78A.75.75,0,0,0,8,7.4v5.2A.75.75,0,0,0,9.17,13.22Z"]
  };
  
  var videoHorizontal = {
    prefix: 'axis',
    iconName: 'videoHorizontal',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm-4.94,8.62-3.89,2.6A.75.75,0,0,1,10,14.6V9.4a.75.75,0,0,1,1.17-.62l3.89,2.6A.74.74,0,0,1,15.06,12.62Z"]
  };
  
  var videoHorizontalOutlined = {
    prefix: 'axis',
    iconName: 'videoHorizontalOutlined',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,14H4V6H20Zm-8.83-2.78,3.89-2.6a.74.74,0,0,0,0-1.24l-3.89-2.6A.75.75,0,0,0,10,9.4v5.2A.75.75,0,0,0,11.17,15.22Z"]
  };
  
  var videoVertical = {
    prefix: 'axis',
    iconName: 'videoVertical',
    icon: [24, 24, [], "f0000", "M20,20V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18A2,2,0,0,0,20,20Zm-4.94-7.38-3.89,2.6A.75.75,0,0,1,10,14.6V9.4a.75.75,0,0,1,1.17-.62l3.89,2.6A.74.74,0,0,1,15.06,12.62Z"]
  };
  
  var videoVerticalOutlined = {
    prefix: 'axis',
    iconName: 'videoVerticalOutlined',
    icon: [24, 24, [], "f0000", "M20,20V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18A2,2,0,0,0,20,20ZM6,20V4H18V20Zm4-5.4V9.4a.75.75,0,0,1,1.17-.62l3.89,2.6a.74.74,0,0,1,0,1.24l-3.89,2.6A.75.75,0,0,1,10,14.6Z"]
  };
  
  var americanFootball = {
    prefix: 'axis',
    iconName: 'americanFootball',
    icon: [24, 24, [], "f0000", "M18.14,5h0l.86.86V6c0,1.82,0,5.21-1.61,8-1.93,3.33-5.79,5-11.48,5h0L5,18.1V18c0-1.81,0-5.19,1.62-8,1.93-3.33,5.81-5,11.52-5m0-2C2.85,3,3,14.22,3,18.1a2,2,0,0,0,.59,1.42l.89.89A2,2,0,0,0,5.9,21C21.17,21,21,9.73,21,5.86a2,2,0,0,0-.59-1.42l-.85-.85A2,2,0,0,0,18.14,3Z"]
  };
  
  var anchor = {
    prefix: 'axis',
    iconName: 'anchor',
    icon: [24, 24, [], "f0000", "M19.5,11h-.43a1,1,0,0,0-.71.29l-1.29,1.28a.26.26,0,0,0-.05.28.25.25,0,0,0,.23.15h.36a.25.25,0,0,1,.19.09.23.23,0,0,1,.05.21,6,6,0,0,1-4.55,4.55.23.23,0,0,1-.21-.05.25.25,0,0,1-.09-.19V10.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H13.1a.09.09,0,0,1-.1-.1h0a.13.13,0,0,1,.06-.1,3,3,0,1,0-2.12,0,.13.13,0,0,1,.06.1h0a.09.09,0,0,1-.1.1H9.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,1,.5.5v7.11a.25.25,0,0,1-.09.19.23.23,0,0,1-.21.05A6,6,0,0,1,6.15,13.3a.23.23,0,0,1,0-.21A.25.25,0,0,1,6.39,13h.36A.25.25,0,0,0,7,12.85a.26.26,0,0,0-.05-.28L5.64,11.29A1,1,0,0,0,4.93,11H4.5a.5.5,0,0,0-.5.5v.73H4a8,8,0,0,0,6.3,7.58,1,1,0,0,1,.78.86l.11.89a.5.5,0,0,0,.49.44h.62a.5.5,0,0,0,.49-.44l.11-.89a1,1,0,0,1,.78-.86A8,8,0,0,0,20,12.23h0V11.5A.5.5,0,0,0,19.5,11ZM12,6a1,1,0,1,1,1-1A1,1,0,0,1,12,6Z"]
  };
  
  var armchair = {
    prefix: 'axis',
    iconName: 'armchair',
    icon: [24, 24, [], "f0000", "M22,10v3a1,1,0,0,1-1,1H20v6.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5V18H7v2.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5V14H3a1,1,0,0,1-1-1V10A1,1,0,0,1,3,9H6a1,1,0,0,1,1,1v4H17V10a1,1,0,0,1,1-1h3A1,1,0,0,1,22,10ZM6,7.25A2.75,2.75,0,0,1,8.75,10v2h6.5V10A2.75,2.75,0,0,1,18,7.25h1V5a2,2,0,0,0-2-2H7A2,2,0,0,0,5,5V7.25Z"]
  };
  
  var baseball = {
    prefix: 'axis',
    iconName: 'baseball',
    icon: [24, 24, [], "f0000", "M15,14.21a8.09,8.09,0,0,1-3.13,1.94l-1.11.37A6,6,0,0,0,8.45,18L6.33,20.09l.35.35a.5.5,0,0,1,0,.71l-.71.7a.48.48,0,0,1-.7,0L3.15,19.73a.48.48,0,0,1,0-.7l.7-.71a.5.5,0,0,1,.71,0l.35.35L7,16.55a6,6,0,0,0,1.45-2.34l.37-1.11A8.09,8.09,0,0,1,10.79,10l6.38-6.38a2,2,0,0,1,2.83,0L21.41,5a2,2,0,0,1,0,2.83ZM5.5,2A3.5,3.5,0,1,0,9,5.5,3.49,3.49,0,0,0,5.5,2Zm0,5.25A1.75,1.75,0,1,1,7.25,5.5,1.75,1.75,0,0,1,5.5,7.25Z"]
  };
  
  var basketball = {
    prefix: 'axis',
    iconName: 'basketball',
    icon: [24, 24, [], "f0000", "M2,12A10,10,0,1,0,12,2,10,10,0,0,0,2,12Zm2.06,1H7a5.08,5.08,0,0,1-1.91,3.07A8,8,0,0,1,4.06,13ZM5.11,7.93A5.08,5.08,0,0,1,7,11H4.07A8.16,8.16,0,0,1,5.11,7.93ZM11,4.06V11H8.8A6.82,6.82,0,0,0,6.16,6.53,8.07,8.07,0,0,1,11,4.06Zm6.84,2.48A6.86,6.86,0,0,0,15.21,11H13V4.07A8,8,0,0,1,17.84,6.54ZM19.94,11H17a5.12,5.12,0,0,1,1.91-3.06A8,8,0,0,1,19.94,11Zm-1.05,5.07A5.08,5.08,0,0,1,17,13h2.95A8.16,8.16,0,0,1,18.89,16.07ZM13,19.94V13h2.2a6.82,6.82,0,0,0,2.64,4.47A8.07,8.07,0,0,1,13,19.94ZM6.16,17.47A6.82,6.82,0,0,0,8.8,13H11v6.93A8,8,0,0,1,6.16,17.47Z"]
  };
  
  var birthday = {
    prefix: 'axis',
    iconName: 'birthday',
    icon: [24, 24, [], "f0000", "M19,9H13V6.72A2,2,0,0,0,14,5a6.65,6.65,0,0,0-1.46-2.8.48.48,0,0,0-.4-.2h-.28a.48.48,0,0,0-.4.2A6.65,6.65,0,0,0,10,5a2,2,0,0,0,1,1.72V9H5a2,2,0,0,0-2,2v6a1,1,0,0,0,1,1v3a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V18a1,1,0,0,0,1-1V11A2,2,0,0,0,19,9ZM18,20H6V17.87a4,4,0,0,0,2.26-1.59,4.93,4.93,0,0,0,7.48,0A4,4,0,0,0,18,17.87Z"]
  };
  
  var birthdayOutlined = {
    prefix: 'axis',
    iconName: 'birthdayOutlined',
    icon: [24, 24, [], "f0000", "M19,9H13V6.72A2,2,0,0,0,14,5a6.65,6.65,0,0,0-1.46-2.8.48.48,0,0,0-.4-.2h-.28a.48.48,0,0,0-.4.2A6.65,6.65,0,0,0,10,5a2,2,0,0,0,1,1.72V9H5a2,2,0,0,0-2,2v6a1,1,0,0,0,1,1v3a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V18a1,1,0,0,0,1-1V11A2,2,0,0,0,19,9ZM5,11H19v5a2,2,0,0,1-1.62-.86l-.65-.93a.51.51,0,0,0-.41-.21h-1a.5.5,0,0,0-.38.17l-.69.79a2.93,2.93,0,0,1-4.48,0l-.69-.79A.5.5,0,0,0,8.69,14h-1a.51.51,0,0,0-.41.21l-.65.93A2,2,0,0,1,5,16Zm1,9V17.87a4,4,0,0,0,2.26-1.59,4.93,4.93,0,0,0,7.48,0A4,4,0,0,0,18,17.87V20Z"]
  };
  
  var block = {
    prefix: 'axis',
    iconName: 'block',
    icon: [24, 24, [], "f0000", "M20.73,6.94l-.14-.25A2.13,2.13,0,0,0,19.86,6L15.14,3.27a2,2,0,0,0-1-.27h-.28a1.92,1.92,0,0,0-1,.27L4.14,8.32a2,2,0,0,0-.73.73l-.14.25a2,2,0,0,0-.27,1v5.76a2,2,0,0,0,.27,1l.14.25a2.13,2.13,0,0,0,.73.73l4.72,2.69a2,2,0,0,0,1,.27h.28a1.92,1.92,0,0,0,1-.27l8.72-5.05a2,2,0,0,0,.73-.73l.14-.25a2,2,0,0,0,.27-1V7.94A2,2,0,0,0,20.73,6.94ZM13.86,5h.28L18,7.2l-8,4.63L6,9.55Zm5,9L11,18.5V13.57l8-4.64V13.7Z"]
  };
  
  var book = {
    prefix: 'axis',
    iconName: 'book',
    icon: [24, 24, [], "f0000", "M19,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H19.5a.5.5,0,0,0,.5-.5V3A1,1,0,0,0,19,2ZM7,6.5A.5.5,0,0,1,7.5,6h9a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-9A.5.5,0,0,1,7,7.5Zm0,4a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5ZM6,19a1,1,0,0,1,1-1H18v2H7A1,1,0,0,1,6,19Z"]
  };
  
  var bookBookmarked = {
    prefix: 'axis',
    iconName: 'bookBookmarked',
    icon: [24, 24, [], "f0000", "M19,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H19.5a.5.5,0,0,0,.5-.5V3A1,1,0,0,0,19,2ZM6,19a1,1,0,0,1,1-1H18v2H7A1,1,0,0,1,6,19Zm6-7.5a.5.5,0,0,1-.78.42l-1.94-1.3a.52.52,0,0,0-.56,0l-1.94,1.3A.5.5,0,0,1,6,11.5v-7A.5.5,0,0,1,6.5,4h5a.5.5,0,0,1,.5.5Z"]
  };
  
  var bookOpened = {
    prefix: 'axis',
    iconName: 'bookOpened',
    icon: [24, 24, [], "f0000", "M21,4H15a4,4,0,0,0-3,1.37A4,4,0,0,0,9,4H3A1,1,0,0,0,2,5V18a1,1,0,0,0,1,1H8.59a1,1,0,0,1,.7.29l.42.42a1,1,0,0,0,.7.29h3.18a1,1,0,0,0,.7-.29l.42-.42a1,1,0,0,1,.7-.29H21a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4ZM11,16.54A4,4,0,0,0,9,16H4V6H9a2,2,0,0,1,2,2ZM20,16H15a4,4,0,0,0-2,.54V8a2,2,0,0,1,2-2h5Z"]
  };
  
  var bookOutlined = {
    prefix: 'axis',
    iconName: 'bookOutlined',
    icon: [24, 24, [], "f0000", "M19,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H19.5a.5.5,0,0,0,.5-.5V3A1,1,0,0,0,19,2ZM6,5A1,1,0,0,1,7,4H18V16H7a3,3,0,0,0-1,.17ZM6,19a1,1,0,0,1,1-1H18v2H7A1,1,0,0,1,6,19ZM8.5,8h7a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-7a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,8.5,8Zm0,4h3a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,8.5,12Z"]
  };
  
  var brain = {
    prefix: 'axis',
    iconName: 'brain',
    icon: [24, 24, [], "f0000", "M11,19a2,2,0,0,1-3.87.7.47.47,0,0,0-.33-.3A2.5,2.5,0,0,1,5,17a2.36,2.36,0,0,1,.14-.8.49.49,0,0,0-.25-.6,3.49,3.49,0,0,1,0-6.2.49.49,0,0,0,.25-.6A2.36,2.36,0,0,1,5,8,2.49,2.49,0,0,1,6.67,5.65.52.52,0,0,0,7,5.13.53.53,0,0,1,7,5a2,2,0,0,1,4,0Zm2,0a2,2,0,0,0,3.87.7.47.47,0,0,1,.33-.3A2.5,2.5,0,0,0,19,17a2.36,2.36,0,0,0-.14-.8.49.49,0,0,1,.25-.6,3.49,3.49,0,0,0,0-6.2.49.49,0,0,1-.25-.6A2.36,2.36,0,0,0,19,8a2.49,2.49,0,0,0-1.67-2.35A.52.52,0,0,1,17,5.13.53.53,0,0,0,17,5a2,2,0,0,0-4,0Z"]
  };
  
  var brickWall = {
    prefix: 'axis',
    iconName: 'brickWall',
    icon: [24, 24, [], "f0000", "M2,7.5v-3A.5.5,0,0,1,2.5,4h8a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-8A.5.5,0,0,1,2,7.5ZM21.5,4h-8a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h8a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,21.5,4ZM2.5,14h2a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v3A.5.5,0,0,0,2.5,14ZM7,10.5v3a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-9A.5.5,0,0,0,7,10.5ZM21.5,10h-2a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,21.5,10Zm-11,6h-8a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h8a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,10.5,16Zm11,0h-8a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h8a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,21.5,16Z"]
  };
  
  var briefcase = {
    prefix: 'axis',
    iconName: 'briefcase',
    icon: [24, 24, [], "f0000", "M20,7H17V5a2,2,0,0,0-2-2H9A2,2,0,0,0,7,5V7H4A2,2,0,0,0,2,9V19a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V9A2,2,0,0,0,20,7Zm-6,7a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1v-.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Zm1-7H9V5h6Z"]
  };
  
  var briefcaseNotAccessible = {
    prefix: 'axis',
    iconName: 'briefcaseNotAccessible',
    icon: [24, 24, [], "f0000", "M3.38,2.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L4.76,6H4A2,2,0,0,0,2,8V18a2,2,0,0,0,2,2H18.76l1.86,1.85a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM11,14a1,1,0,0,1-1-1v-.5a.5.5,0,0,1,.5-.5h.26l2,2Zm9-8H17V4a2,2,0,0,0-2-2H9A2,2,0,0,0,7.1,3.39L9,5.29V4h6V6H9.71L22,18.29V8A2,2,0,0,0,20,6Z"]
  };
  
  var briefcaseOutlined = {
    prefix: 'axis',
    iconName: 'briefcaseOutlined',
    icon: [24, 24, [], "f0000", "M10,14v-.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5V14a1,1,0,0,1-1,1H11A1,1,0,0,1,10,14ZM22,9V19a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V9A2,2,0,0,1,4,7H7V5A2,2,0,0,1,9,3h6a2,2,0,0,1,2,2V7h3A2,2,0,0,1,22,9ZM9,7h6V5H9ZM20,9H4V19H20Z"]
  };
  
  var chair = {
    prefix: 'axis',
    iconName: 'chair',
    icon: [24, 24, [], "f0000", "M18,14a1,1,0,0,1,1,1v6.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V18H7v3.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V15a1,1,0,0,1,1-1Zm1.78-9.63a14,14,0,0,0-15.56,0A.49.49,0,0,0,4,4.78v.14a.69.69,0,0,0,.1.37L5,6.78A.56.56,0,0,0,5.31,7,.54.54,0,0,0,5.74,7c.34-.23.69-.44,1-.64L7.5,12h2L8.69,5.51A10.4,10.4,0,0,1,11,5.05v7h2V5.05a10.6,10.6,0,0,1,2.32.46L14.5,12h2l.71-5.68a11.06,11.06,0,0,1,1,.63.54.54,0,0,0,.43.09.6.6,0,0,0,.36-.26l.85-1.49a.69.69,0,0,0,.1-.37V4.78A.49.49,0,0,0,19.78,4.37Z"]
  };
  
  var circle = {
    prefix: 'axis',
    iconName: 'circle',
    icon: [24, 24, [], "f0000", "M22,12A10,10,0,1,1,12,2,10,10,0,0,1,22,12Z"]
  };
  
  var circleOutlined = {
    prefix: 'axis',
    iconName: 'circleOutlined',
    icon: [24, 24, [], "f0000", "M12,4a8,8,0,1,1-8,8,8,8,0,0,1,8-8m0-2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Z"]
  };
  
  var cricket = {
    prefix: 'axis',
    iconName: 'cricket',
    icon: [24, 24, [], "f0000", "M18.5,22A3.5,3.5,0,1,0,15,18.5,3.49,3.49,0,0,0,18.5,22Zm0-5.25a1.75,1.75,0,1,1-1.75,1.75A1.75,1.75,0,0,1,18.5,16.75Zm-12,4a1,1,0,0,1-1.42,0L2.29,17.88a1,1,0,0,1,0-1.42l9.9-9.89a1,1,0,0,1,1.19-.17l.84.46a.52.52,0,0,0,.6-.09l2.85-2.86-.35-.35a.5.5,0,0,1,0-.71l.71-.7a.48.48,0,0,1,.7,0l2.12,2.12a.48.48,0,0,1,0,.7l-.7.71a.5.5,0,0,1-.71,0l-.35-.35L16.23,8.18a.52.52,0,0,0-.09.6l.46.84a1,1,0,0,1-.17,1.19Z"]
  };
  
  var crossfit = {
    prefix: 'axis',
    iconName: 'crossfit',
    icon: [24, 24, [], "f0000", "M19,7c0-3.87-3.13-5-7-5S5,3.13,5,7a7,7,0,0,0,1.64,4.5A7,7,0,0,0,7.81,21.6,2,2,0,0,0,9,22h6a2,2,0,0,0,1.19-.4,7,7,0,0,0,1.17-10.1A7,7,0,0,0,19,7ZM12,4c5,0,5,2,5,3a5,5,0,0,1-1.13,3.16,7,7,0,0,0-7.74,0A5,5,0,0,1,7,7C7,6,7,4,12,4Zm0,15a3,3,0,1,1,3-3A3,3,0,0,1,12,19Z"]
  };
  
  var cube = {
    prefix: 'axis',
    iconName: 'cube',
    icon: [24, 24, [], "f0000", "M20.73,7.12l-.14-.25a2.07,2.07,0,0,0-.74-.73L13.14,2.27a2,2,0,0,0-1-.27h-.29a2,2,0,0,0-1,.27L4.14,6.15a2,2,0,0,0-.73.73l-.14.25a2,2,0,0,0-.27,1v7.75a2,2,0,0,0,.27,1l.14.25a2.13,2.13,0,0,0,.73.73l6.72,3.87a1.92,1.92,0,0,0,1,.27h.28a2,2,0,0,0,1-.27l6.71-3.88a1.9,1.9,0,0,0,.73-.73l.15-.25a2.05,2.05,0,0,0,.27-1V8.12A2,2,0,0,0,20.73,7.12ZM11.85,4h.29L18,7.38l-6,3.46L6,7.38Zm7,12.12L13,19.5V12.58l6-3.47v6.76Z"]
  };
  
  var diningTable = {
    prefix: 'axis',
    iconName: 'diningTable',
    icon: [24, 24, [], "f0000", "M15,18.5v1a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V15.26l.08-.09a1.23,1.23,0,0,1,.92-.42,1.26,1.26,0,0,1,.84.33l.16.13V18h1.5A.5.5,0,0,1,15,18.5Zm7-5.05L21.14,4.9a1,1,0,0,0-1-.9H3.85a1,1,0,0,0-1,.9L2,13.45a.5.5,0,0,0,.5.55H3.82a.77.77,0,0,0,.55-.24,2.7,2.7,0,0,1,3.79,0,.78.78,0,0,0,.52.21h.79a.74.74,0,0,0,.51-.2,3,3,0,0,1,4,0,.74.74,0,0,0,.51.2h.79a.78.78,0,0,0,.52-.21,2.7,2.7,0,0,1,3.79,0,.77.77,0,0,0,.55.24H21.5A.5.5,0,0,0,22,13.45Z"]
  };
  
  var diningTableOutlined = {
    prefix: 'axis',
    iconName: 'diningTableOutlined',
    icon: [24, 24, [], "f0000", "M15,18.5v1a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V15.26l.08-.09a1.23,1.23,0,0,1,.92-.42,1.26,1.26,0,0,1,.84.33l.16.13V18h1.5A.5.5,0,0,1,15,18.5ZM19.24,6l.55,5.47a4.68,4.68,0,0,0-4.87.48,5,5,0,0,0-5.84,0,4.68,4.68,0,0,0-4.87-.48L4.76,6H19.24m.91-2H3.85a1,1,0,0,0-1,.9L2,13.45a.5.5,0,0,0,.5.55H3.82a.77.77,0,0,0,.55-.24,2.7,2.7,0,0,1,3.79,0,.78.78,0,0,0,.52.21h.79a.74.74,0,0,0,.51-.2,3,3,0,0,1,4,0,.74.74,0,0,0,.51.2h.79a.78.78,0,0,0,.52-.21,2.7,2.7,0,0,1,3.79,0,.77.77,0,0,0,.55.24H21.5a.5.5,0,0,0,.5-.55L21.14,4.9a1,1,0,0,0-1-.9Z"]
  };
  
  var diving = {
    prefix: 'axis',
    iconName: 'diving',
    icon: [24, 24, [], "f0000", "M19.5,2h-1a.5.5,0,0,0-.5.5V6.55A4,4,0,0,0,16,6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4h8a4,4,0,0,0,2-.55V18a2,2,0,0,1-2,2H14a1,1,0,0,1-1-1h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H11a3,3,0,0,0,3,3h2a4,4,0,0,0,4-4V2.5A.5.5,0,0,0,19.5,2ZM16,13H15a2,2,0,0,1-1.94-1.52l0-.1a.49.49,0,0,0-.48-.38H11.44a.49.49,0,0,0-.48.38l0,.1A2,2,0,0,1,9,13H8a2,2,0,0,1-2-2V10A2,2,0,0,1,8,8h8a2,2,0,0,1,2,2v1A2,2,0,0,1,16,13Z"]
  };
  
  var door = {
    prefix: 'axis',
    iconName: 'door',
    icon: [24, 24, [], "f0000", "M20.5,19H18V4a1,1,0,0,0-1-1H7A1,1,0,0,0,6,4V19H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,19ZM14,14.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,14,14.5ZM8,5h8V9H8Z"]
  };
  
  var flag = {
    prefix: 'axis',
    iconName: 'flag',
    icon: [24, 24, [], "f0000", "M20,6.5v9a.5.5,0,0,1-.5.5H14a2,2,0,0,1-2-2H6v7.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2h1a.5.5,0,0,1,.5.5V4h6a2,2,0,0,1,2,2h5.5A.5.5,0,0,1,20,6.5Z"]
  };
  
  var flagCross1 = {
    prefix: 'axis',
    iconName: 'flagCross1',
    icon: [24, 24, [], "f0000", "M19.5,6H13a2,2,0,0,0-2-2H6V2.5A.5.5,0,0,0,5.5,2h-1a.5.5,0,0,0-.5.5v19a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h5a2,2,0,0,0,2,2h6.5a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,19.5,6ZM18,8v2H13V8ZM11,6V8H6V6ZM6,12V10h5v2Zm7,2V12h5v2Z"]
  };
  
  var flagCross2 = {
    prefix: 'axis',
    iconName: 'flagCross2',
    icon: [24, 24, [], "f0000", "M19.5,6H13a2,2,0,0,0-2-2H6V2.5A.5.5,0,0,0,5.5,2h-1a.5.5,0,0,0-.5.5v19a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h5a2,2,0,0,0,2,2h6.5a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,19.5,6ZM11,10H6V8h5Zm7,2H13V10h5Z"]
  };
  
  var flagHalf1 = {
    prefix: 'axis',
    iconName: 'flagHalf1',
    icon: [24, 24, [], "f0000", "M19.5,6H13a2,2,0,0,0-2-2H6V2.5A.5.5,0,0,0,5.5,2h-1a.5.5,0,0,0-.5.5v19a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h5a2,2,0,0,0,2,2h6.5a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,19.5,6ZM13,8h5v6H13Z"]
  };
  
  var flagHalf2 = {
    prefix: 'axis',
    iconName: 'flagHalf2',
    icon: [24, 24, [], "f0000", "M19.5,6H13a2,2,0,0,0-2-2H6V2.5A.5.5,0,0,0,5.5,2h-1a.5.5,0,0,0-.5.5v19a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h5a2,2,0,0,0,2,2h6.5a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,19.5,6ZM11,12H6V6h5Z"]
  };
  
  var flagOutlined = {
    prefix: 'axis',
    iconName: 'flagOutlined',
    icon: [24, 24, [], "f0000", "M13,6a2,2,0,0,0-2-2H6V2.5A.5.5,0,0,0,5.5,2h-1a.5.5,0,0,0-.5.5v19a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h5a2,2,0,0,0,2,2h6.5a.5.5,0,0,0,.5-.5v-9a.5.5,0,0,0-.5-.5ZM6,12V6h5V7.5a.5.5,0,0,0,.5.5H18v6H13V12.5a.5.5,0,0,0-.5-.5Z"]
  };
  
  var flagQuarter1 = {
    prefix: 'axis',
    iconName: 'flagQuarter1',
    icon: [24, 24, [], "f0000", "M19.5,6H13a2,2,0,0,0-2-2H6V2.5A.5.5,0,0,0,5.5,2h-1a.5.5,0,0,0-.5.5v19a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h5a2,2,0,0,0,2,2h6.5a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,19.5,6ZM11,12H6V9h5Zm2-4h5v3H13Z"]
  };
  
  var flagQuarter2 = {
    prefix: 'axis',
    iconName: 'flagQuarter2',
    icon: [24, 24, [], "f0000", "M19.5,6H13a2,2,0,0,0-2-2H6V2.5A.5.5,0,0,0,5.5,2h-1a.5.5,0,0,0-.5.5v19a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h5a2,2,0,0,0,2,2h6.5a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,19.5,6ZM11,9H6V6h5Zm2,2h5v3H13Z"]
  };
  
  var flask = {
    prefix: 'axis',
    iconName: 'flask',
    icon: [24, 24, [], "f0000", "M13,7.52a4,4,0,0,0,1.78,3.33A5,5,0,0,1,17,15H7a5,5,0,0,1,2.22-4.15A4,4,0,0,0,11,7.52V4h2ZM15.5,2h-7a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H9V7.52a2,2,0,0,1-.89,1.67,7,7,0,1,0,7.78,0A2,2,0,0,1,15,7.52V4h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5Z"]
  };
  
  var flower = {
    prefix: 'axis',
    iconName: 'flower',
    icon: [24, 24, [], "f0000", "M20.18,12.33a.49.49,0,0,1,0-.66,4,4,0,0,0-3.8-6.58.51.51,0,0,1-.58-.34,4,4,0,0,0-7.6,0,.51.51,0,0,1-.58.34,4,4,0,0,0-3.8,6.58.49.49,0,0,1,0,.66,4,4,0,0,0,3.8,6.58.51.51,0,0,1,.58.34,4,4,0,0,0,7.6,0,.51.51,0,0,1,.58-.34,4,4,0,0,0,3.8-6.58ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"]
  };
  
  var footPrint = {
    prefix: 'axis',
    iconName: 'footPrint',
    icon: [24, 24, [], "f0000", "M12,3a1,1,0,1,1,1,1A1,1,0,0,1,12,3Zm3,3a1,1,0,1,0-1-1A1,1,0,0,0,15,6Zm2,0a1,1,0,1,0,1,1A1,1,0,0,0,17,6ZM9,5a2,2,0,0,0,2-2V2A2,2,0,0,0,7,2V3A2,2,0,0,0,9,5Zm4.71,2.17A4,4,0,0,0,10.88,6H9.5a2.5,2.5,0,0,0,0,5H11a2,2,0,0,1,2,2c0,2.81-4,4.5-4,8a3,3,0,0,0,6,0c0-3.72,2-7.55,2-9.5a2.5,2.5,0,0,0-.73-1.77Z"]
  };
  
  var gift = {
    prefix: 'axis',
    iconName: 'gift',
    icon: [24, 24, [], "f0000", "M19,8h-.54A4,4,0,0,0,19,6a3,3,0,0,0-3-3,5.67,5.67,0,0,0-4,2.44A5.67,5.67,0,0,0,8,3,3,3,0,0,0,5,6a4,4,0,0,0,.54,2H5a2,2,0,0,0-2,2v3a1,1,0,0,0,1,1H5v5a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V14h1a1,1,0,0,0,1-1V10A2,2,0,0,0,19,8ZM16,5a1,1,0,0,1,1,1,2,2,0,0,1-.88,1.66A2,2,0,0,1,15,8H13C13,6.91,14.91,5,16,5ZM7,6A1,1,0,0,1,8,5c1.09,0,3,1.91,3,3H9A2,2,0,0,1,7,6ZM5,10h6v2H5Zm2,4h4v5H7Zm10,5H13V14h4Zm2-7H13V10h6Z"]
  };
  
  var glasses = {
    prefix: 'axis',
    iconName: 'glasses',
    icon: [24, 24, [], "f0000", "M22.51,12.87l0,0-3.6-7.74A2,2,0,0,0,17.11,4H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1.61L19,10.11a4.94,4.94,0,0,0-5.35,2.42A3,3,0,0,0,12,12a2.94,2.94,0,0,0-1.67.54A4.95,4.95,0,0,0,5,10.11L6.89,6H8.5A.5.5,0,0,0,9,5.5v-1A.5.5,0,0,0,8.5,4H6.89A2,2,0,0,0,5.07,5.15l-3.6,7.74,0,0A4.93,4.93,0,0,0,1,15a5,5,0,0,0,10,0,1,1,0,0,1,2,0,5,5,0,0,0,10,0A4.93,4.93,0,0,0,22.51,12.87ZM6,18a2.93,2.93,0,0,1-1.55-.45l4.1-4.1A2.93,2.93,0,0,1,9,15,3,3,0,0,1,6,18Zm12,0a2.93,2.93,0,0,1-1.55-.45l4.1-4.1A2.93,2.93,0,0,1,21,15,3,3,0,0,1,18,18Z"]
  };
  
  var glassesOutlined = {
    prefix: 'axis',
    iconName: 'glassesOutlined',
    icon: [24, 24, [], "f0000", "M22.51,12.87l0,0-3.6-7.74A2,2,0,0,0,17.11,4H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1.61L19,10.11a4.94,4.94,0,0,0-5.35,2.42A3,3,0,0,0,12,12a2.94,2.94,0,0,0-1.67.54A4.95,4.95,0,0,0,5,10.11L6.89,6H8.5A.5.5,0,0,0,9,5.5v-1A.5.5,0,0,0,8.5,4H6.89A2,2,0,0,0,5.07,5.15l-3.6,7.74,0,0A4.93,4.93,0,0,0,1,15a5,5,0,0,0,10,0,1,1,0,0,1,2,0,5,5,0,0,0,10,0A4.93,4.93,0,0,0,22.51,12.87ZM6,18a3,3,0,1,1,3-3A3,3,0,0,1,6,18Zm12,0a3,3,0,1,1,3-3A3,3,0,0,1,18,18Z"]
  };
  
  var hourglass = {
    prefix: 'axis',
    iconName: 'hourglass',
    icon: [24, 24, [], "f0000", "M18,7V4h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H6V7A3,3,0,0,0,7.13,9.38L10.4,12,7.13,14.62A3,3,0,0,0,6,17v3H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H18V17a3,3,0,0,0-1.13-2.34L13.6,12l3.27-2.62A3,3,0,0,0,18,7Z"]
  };
  
  var hourglassHalf = {
    prefix: 'axis',
    iconName: 'hourglassHalf',
    icon: [24, 24, [], "f0000", "M18,7V4h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H6V7A3,3,0,0,0,7.13,9.38L10.4,12,7.13,14.62A3,3,0,0,0,6,17v3H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H18V17a3,3,0,0,0-1.13-2.34L13.6,12l3.27-2.62A3,3,0,0,0,18,7ZM16,4V7H8V4Zm-.38,12.18A1,1,0,0,1,16,17v1H8V17a1,1,0,0,1,.38-.78L12,13.28Z"]
  };
  
  var hourglassOutlined = {
    prefix: 'axis',
    iconName: 'hourglassOutlined',
    icon: [24, 24, [], "f0000", "M18,7V4h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H6V7A3,3,0,0,0,7.13,9.38L10.4,12,7.13,14.62A3,3,0,0,0,6,17v3H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H18V17a3,3,0,0,0-1.13-2.34L13.6,12l3.27-2.62A3,3,0,0,0,18,7Zm-2.38,9.14A1,1,0,0,1,16,17v3H8V17a1,1,0,0,1,.38-.78L12,13.28Zm0-8.36L12,10.72,8.38,7.82A1,1,0,0,1,8,7V4h8V7A1,1,0,0,1,15.62,7.82Z"]
  };
  
  var hourglassQuarter = {
    prefix: 'axis',
    iconName: 'hourglassQuarter',
    icon: [24, 24, [], "f0000", "M18,7V4h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H6V7A3,3,0,0,0,7.13,9.38L10.4,12,7.13,14.62A3,3,0,0,0,6,17v3H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H18V17a3,3,0,0,0-1.13-2.34L13.6,12l3.27-2.62A3,3,0,0,0,18,7Zm-2.38,9.14A1,1,0,0,1,16,17v0H8v0a1,1,0,0,1,.38-.78L12,13.28ZM16,7a1,1,0,0,1-.38.78L14.15,9H9.85L8.38,7.82A1,1,0,0,1,8,7V4h8Z"]
  };
  
  var iceHockey = {
    prefix: 'axis',
    iconName: 'iceHockey',
    icon: [24, 24, [], "f0000", "M4,13a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h9.26A4,4,0,0,0,17,17.45L22,4.68A.5.5,0,0,0,21.5,4H20.43a.5.5,0,0,0-.46.32l-3.13,8a1,1,0,0,1-.93.64Zm9.26,5H12V15h3.8l-.67,1.73A2,2,0,0,1,13.26,18ZM4,15H6v3H4Zm7-4H5a1,1,0,0,1-1-1V8A1,1,0,0,1,5,7h6a1,1,0,0,1,1,1v2A1,1,0,0,1,11,11Z"]
  };
  
  var infinity = {
    prefix: 'axis',
    iconName: 'infinity',
    icon: [24, 24, [], "f0000", "M18,7a6.86,6.86,0,0,0-4.79,2.24c.29.32.58.63.86.95s.32.35.48.53A5.1,5.1,0,0,1,18,9a3,3,0,0,1,0,6c-1.8,0-3.23-1.38-4.67-3h0l-.58-.66L12,10.49h0C10.35,8.66,8.56,7,6,7A5,5,0,0,0,6,17c2.56,0,4.35-1.66,6-3.49C13.65,15.34,15.44,17,18,17A5,5,0,0,0,18,7ZM6,15A3,3,0,0,1,6,9c1.8,0,3.23,1.38,4.67,3C9.23,13.62,7.8,15,6,15Z"]
  };
  
  var justice = {
    prefix: 'axis',
    iconName: 'justice',
    icon: [24, 24, [], "f0000", "M22,6.5v-1a.5.5,0,0,0-.5-.5H18.35A5.6,5.6,0,0,0,15,4a6,6,0,0,0-2.08.35l-.12-.91A.5.5,0,0,0,12.31,3h-.62a.5.5,0,0,0-.49.44l-.12.91A6,6,0,0,0,9,4,5.6,5.6,0,0,0,5.65,5H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1L2.07,12.71a2,2,0,0,0,0,.74,3.5,3.5,0,0,0,6.94,0,2,2,0,0,0,0-.74L7.33,6.33A4.09,4.09,0,0,1,9,6a3.85,3.85,0,0,1,2,.5V19H9.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H13V6.5A3.85,3.85,0,0,1,15,6a4.09,4.09,0,0,1,1.67.33l-1.6,6.38a2,2,0,0,0,0,.74,3.5,3.5,0,0,0,6.94,0,2,2,0,0,0,0-.74L20.5,7h1A.5.5,0,0,0,22,6.5ZM3.8,13,5.26,7.19A.24.24,0,0,1,5.5,7h0a.24.24,0,0,1,.24.19L7.2,13Zm13,0,1.46-5.81A.24.24,0,0,1,18.5,7h0a.24.24,0,0,1,.24.19L20.2,13Z"]
  };
  
  var lab = {
    prefix: 'axis',
    iconName: 'lab',
    icon: [24, 24, [], "f0000", "M19.76,19.11,15.32,12.2A2,2,0,0,1,15,11.12V4h.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-7a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H9v7.13a2,2,0,0,1-.32,1.08L4.24,19.12a1.51,1.51,0,0,0,0,1.56l.32.57a1.52,1.52,0,0,0,1.3.75H18.17a1.52,1.52,0,0,0,1.3-.75l.33-.58A1.49,1.49,0,0,0,19.76,19.11Zm-9.39-5.82A4.06,4.06,0,0,0,11,11.13V4h2v7.12a3.93,3.93,0,0,0,.64,2.16L15.38,16H8.62Z"]
  };
  
  var leaf = {
    prefix: 'axis',
    iconName: 'leaf',
    icon: [24, 24, [], "f0000", "M19,12.33c0-4.57-4.15-8.52-6.06-10.1A1,1,0,0,0,12.3,2h-.6a1,1,0,0,0-.64.23C9.15,3.81,5,7.76,5,12.33a7,7,0,0,0,6,6.92V21.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19.25A7,7,0,0,0,19,12.33Zm-6,4.9V10.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v6.73a5,5,0,0,1-4-4.9C7,9.06,10,5.78,12,4c2,1.74,5,5,5,8.29A5,5,0,0,1,13,17.23Z"]
  };
  
  var leafDiagonal = {
    prefix: 'axis',
    iconName: 'leafDiagonal',
    icon: [24, 24, [], "f0000", "M20.89,4.44a1,1,0,0,0-.29-.61l-.43-.44a1,1,0,0,0-.61-.28A22.38,22.38,0,0,0,17.3,3c-2.68,0-6.72.46-9.24,3a7,7,0,0,0-.65,9.2L3.15,19.44a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l4.27-4.26A7,7,0,0,0,18,15.94C21.27,12.69,21.13,6.92,20.89,4.44ZM16.6,14.52a5,5,0,0,1-6.35.64l3.6-3.6a.5.5,0,0,0,0-.71l-.7-.7a.5.5,0,0,0-.71,0l-3.6,3.6A5,5,0,0,1,9.48,7.4C11.56,5.31,15.27,5,17.3,5c.55,0,1.1,0,1.64.06C19.08,7.07,19.14,12,16.6,14.52Z"]
  };
  
  var lightOn = {
    prefix: 'axis',
    iconName: 'lightOn',
    icon: [24, 24, [], "f0000", "M12,6A6,6,0,0,0,8.8,17.07a1.5,1.5,0,0,1,.7,1.27v.16a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5v-.16a1.48,1.48,0,0,1,.7-1.27A6,6,0,0,0,12,6Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,16Zm-2,5.59a1,1,0,0,0,.29.7l.42.42a1,1,0,0,0,.7.29h1.18a1,1,0,0,0,.7-.29l.42-.42a1,1,0,0,0,.29-.7V21H10ZM11.5,4h1a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v2A.5.5,0,0,0,11.5,4Zm8.63.58-.71-.71a.48.48,0,0,0-.7,0L17.3,5.28a.51.51,0,0,0,0,.71L18,6.7a.51.51,0,0,0,.71,0l1.41-1.42A.48.48,0,0,0,20.13,4.58ZM6.7,5.28,5.28,3.87a.48.48,0,0,0-.7,0l-.71.71a.48.48,0,0,0,0,.7L5.28,6.7A.51.51,0,0,0,6,6.7L6.7,6A.51.51,0,0,0,6.7,5.28ZM22.5,11h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,11Zm-19,0h-2a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,3.5,11Z"]
  };
  
  var lightbulb = {
    prefix: 'axis',
    iconName: 'lightbulb',
    icon: [24, 24, [], "f0000", "M19,9a7,7,0,0,0-7-7h-.12A7.1,7.1,0,0,0,5,8.74a7,7,0,0,0,3.08,6A2,2,0,0,1,9,16.48V17a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-.52a2,2,0,0,1,.91-1.68A7,7,0,0,0,19,9Zm-4.21,4.14A4,4,0,0,0,13.29,15H10.71A4.08,4.08,0,0,0,9.2,13.14,5,5,0,0,1,7,8.81,5.12,5.12,0,0,1,11.91,4H12a5,5,0,0,1,2.79,9.14ZM10,20.59a1,1,0,0,0,.29.7l.42.42a1,1,0,0,0,.7.29h1.18a1,1,0,0,0,.7-.29l.42-.42a1,1,0,0,0,.29-.7V20H10Z"]
  };
  
  var medicaments = {
    prefix: 'axis',
    iconName: 'medicaments',
    icon: [24, 24, [], "f0000", "M18.11,9.41,16.45,8.3a1.75,1.75,0,0,0-1-.3H8.54a1.75,1.75,0,0,0-1,.3L5.89,9.41A2,2,0,0,0,5,11.07V20a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V11.07A2,2,0,0,0,18.11,9.41ZM17,17.5a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5ZM7,5.5v-3A.5.5,0,0,1,7.5,2h9a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-9A.5.5,0,0,1,7,5.5Z"]
  };
  
  var mma = {
    prefix: 'axis',
    iconName: 'mma',
    icon: [24, 24, [], "f0000", "M19.5,6A1.5,1.5,0,0,0,18,7.5a.5.5,0,0,1-1,0v-3a1.5,1.5,0,0,0-3,0v3a.5.5,0,0,1-1,0v-4a1.5,1.5,0,0,0-3,0v4a.5.5,0,0,1-1,0v-3a1.5,1.5,0,0,0-3,0v9l-.31-.31A2,2,0,0,1,5,11.65V10a2,2,0,0,0-2,2v1.7a5,5,0,0,0,1.75,3.8l3.62,3.62a3,3,0,0,0,2.12.88h4.14a2,2,0,0,0,1.73-1H17a3,3,0,0,0,2.61-1.51l.63-1.12a5.91,5.91,0,0,0,.79-3V7.5A1.5,1.5,0,0,0,19.5,6ZM19,15.41a4,4,0,0,1-.52,2l-.64,1.12A1,1,0,0,1,17,19H9.84A1.84,1.84,0,0,1,8,17.16V11a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1ZM16.5,12a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-6a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5Z"]
  };
  
  var moon = {
    prefix: 'axis',
    iconName: 'moon',
    icon: [24, 24, [], "f0000", "M4,12A10,10,0,0,1,18.74,3.19a.51.51,0,0,1,.26.44v.13a.51.51,0,0,1-.19.4,10,10,0,0,0,0,15.68.51.51,0,0,1,.19.4v.13a.51.51,0,0,1-.26.44A10,10,0,0,1,4,12Z"]
  };
  
  var moonOutlined = {
    prefix: 'axis',
    iconName: 'moonOutlined',
    icon: [24, 24, [], "f0000", "M14,4a7.7,7.7,0,0,1,1.86.22,12,12,0,0,0,0,15.56A7.7,7.7,0,0,1,14,20,8,8,0,0,1,14,4m0-2a10,10,0,1,0,4.74,18.81.51.51,0,0,0,.26-.44v-.13a.51.51,0,0,0-.19-.4,10,10,0,0,1,0-15.68.51.51,0,0,0,.19-.4V3.63a.51.51,0,0,0-.26-.44A10,10,0,0,0,14,2Z"]
  };
  
  var moonVs = {
    prefix: 'axis',
    iconName: 'moonVs',
    icon: [24, 24, [], "f0000", "M22,14.73A10.21,10.21,0,1,1,9.27,2h0a.54.54,0,0,1,.51.13l.09.09a.55.55,0,0,1,.15.42A10.18,10.18,0,0,0,21.34,14a.55.55,0,0,1,.42.15l.09.09a.54.54,0,0,1,.13.51Z"]
  };
  
  var moonVsOutlined = {
    prefix: 'axis',
    iconName: 'moonVsOutlined',
    icon: [24, 24, [], "f0000", "M8,4.77a12.13,12.13,0,0,0,3.54,7.72A12.1,12.1,0,0,0,19.23,16,8.2,8.2,0,1,1,8,4.77M9.41,2,9.27,2h0A10.21,10.21,0,1,0,22,14.73h0a.54.54,0,0,0-.13-.51l-.09-.09A.51.51,0,0,0,21.4,14h-.06a10,10,0,0,1-1.22.08A10.19,10.19,0,0,1,10,2.66a.55.55,0,0,0-.15-.42l-.09-.09A.51.51,0,0,0,9.41,2Z"]
  };
  
  var movie = {
    prefix: 'axis',
    iconName: 'movie',
    icon: [24, 24, [], "f0000", "M20.5,3h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,5,4.5v-1A.5.5,0,0,0,4.5,3h-1a.5.5,0,0,0-.5.5v17a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V3.5A.5.5,0,0,0,20.5,3ZM7,16.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm0-6a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,5.5,7h1a.5.5,0,0,1,.5.5Zm12,6a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm0-6a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Z"]
  };
  
  var node = {
    prefix: 'axis',
    iconName: 'node',
    icon: [24, 24, [], "f0000", "M19,14a3,3,0,0,0-2.82,2H15a2,2,0,0,1-2-2V10A4,4,0,0,0,9,6H7.82a3,3,0,1,0,0,2H9a2,2,0,0,1,2,2v4a4,4,0,0,0,4,4h1.18A3,3,0,1,0,19,14Z"]
  };
  
  var nodeMultiple = {
    prefix: 'axis',
    iconName: 'nodeMultiple',
    icon: [24, 24, [], "f0000", "M22,17a3,3,0,0,0-5.82-1H15a2,2,0,0,1-2-2,3,3,0,0,0-.78-2h0A3,3,0,0,0,10,11H7.82a3,3,0,1,0,0,2H10a1,1,0,0,1,1,1,4,4,0,0,0,4,4h1.18A3,3,0,0,0,22,17Zm-9-6.68c0-.11,0-.21,0-.32a2,2,0,0,1,2-2h1.18a3,3,0,1,0,0-2H15a4,4,0,0,0-3.94,3.37A4.77,4.77,0,0,1,13,10.32Z"]
  };
  
  var nodeMultipleOutlined = {
    prefix: 'axis',
    iconName: 'nodeMultipleOutlined',
    icon: [24, 24, [], "f0000", "M22,17a3,3,0,0,0-5.82-1H15a2,2,0,0,1-2-2,3,3,0,0,0-.78-2h0A3,3,0,0,0,10,11H7.82a3,3,0,1,0,0,2H10a1,1,0,0,1,1,1,4,4,0,0,0,4,4h1.18A3,3,0,0,0,22,17ZM5,13a1,1,0,1,1,1-1A1,1,0,0,1,5,13Zm14,5a1,1,0,1,1,1-1A1,1,0,0,1,19,18Zm-6-7.68c0-.11,0-.21,0-.32a2,2,0,0,1,2-2h1.18a3,3,0,1,0,0-2H15a4,4,0,0,0-3.94,3.37A4.77,4.77,0,0,1,13,10.32ZM19,6a1,1,0,1,1-1,1A1,1,0,0,1,19,6Z"]
  };
  
  var nodeOutlined = {
    prefix: 'axis',
    iconName: 'nodeOutlined',
    icon: [24, 24, [], "f0000", "M19,14a3,3,0,0,0-2.82,2H15a2,2,0,0,1-2-2V10A4,4,0,0,0,9,6H7.82a3,3,0,1,0,0,2H9a2,2,0,0,1,2,2v4a4,4,0,0,0,4,4h1.18A3,3,0,1,0,19,14ZM5,8A1,1,0,1,1,6,7,1,1,0,0,1,5,8ZM19,18a1,1,0,1,1,1-1A1,1,0,0,1,19,18Z"]
  };
  
  var pet = {
    prefix: 'axis',
    iconName: 'pet',
    icon: [24, 24, [], "f0000", "M7,7V5a2,2,0,0,1,4,0V7A2,2,0,0,1,7,7Zm8,2a2,2,0,0,0,2-2V5a2,2,0,0,0-4,0V7A2,2,0,0,0,15,9ZM7,12V11a2,2,0,0,0-4,0v1a2,2,0,0,0,4,0ZM19,9a2,2,0,0,0-2,2v1a2,2,0,0,0,4,0V11A2,2,0,0,0,19,9Zm-2.2,6.8A7,7,0,0,1,15.49,14l-.94-1.87A2,2,0,0,0,12.76,11H11.24a2,2,0,0,0-1.79,1.11L8.51,14A7,7,0,0,1,7.2,15.8L5.59,17.41A2,2,0,0,0,5,18.83V19a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2v-.17a2,2,0,0,0-.59-1.42Z"]
  };
  
  var pill = {
    prefix: 'axis',
    iconName: 'pill',
    icon: [24, 24, [], "f0000", "M4.46,19.54a5,5,0,0,0,7.08,0l8-8a5,5,0,0,0-7.08-7.08l-8,8A5,5,0,0,0,4.46,19.54Zm1.42-5.66,4-4,4.24,4.24-4,4a3,3,0,1,1-4.24-4.24Z"]
  };
  
  var puzzle = {
    prefix: 'axis',
    iconName: 'puzzle',
    icon: [24, 24, [], "f0000", "M21,15H20a1,1,0,0,0-1,1v3a2,2,0,0,1-2,2H14a1,1,0,0,1-1-1V19a2,2,0,0,0-4,0v1a1,1,0,0,1-1,1H5a2,2,0,0,1-2-2V16a1,1,0,0,1,1-1H5a2,2,0,0,0,0-4H4a1,1,0,0,1-1-1V7A2,2,0,0,1,5,5H8A1,1,0,0,0,9,4V3a2,2,0,0,1,4,0V4a1,1,0,0,0,1,1h3a2,2,0,0,1,2,2v3a1,1,0,0,0,1,1h1a2,2,0,0,1,0,4Z"]
  };
  
  var quotes = {
    prefix: 'axis',
    iconName: 'quotes',
    icon: [24, 24, [], "f0000", "M11,7v7a5,5,0,0,1-4.44,5,.49.49,0,0,1-.39-.12A.52.52,0,0,1,6,18.47v-2A.5.5,0,0,1,6.39,16,2,2,0,0,0,8,14V13H5a2,2,0,0,1-2-2V7A2,2,0,0,1,5,5H9A2,2,0,0,1,11,7Zm8-2H15a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v1a2,2,0,0,1-1.61,2,.5.5,0,0,0-.39.49v2a.52.52,0,0,0,.17.38.49.49,0,0,0,.39.12A5,5,0,0,0,21,14V7A2,2,0,0,0,19,5Z"]
  };
  
  var recycling = {
    prefix: 'axis',
    iconName: 'recycling',
    icon: [24, 24, [], "f0000", "M12,6.08l-1.15,2a.51.51,0,0,1-.69.18l-1.73-1a.5.5,0,0,1-.18-.68L9.75,4a2,2,0,0,1,1.73-1h1a2,2,0,0,1,1.73,1L16,6.89l1.2-.71a.51.51,0,0,1,.38,0l.24.06A.28.28,0,0,1,18,6.5l-1.1,4.22a.51.51,0,0,1-.62.36L12,10a.28.28,0,0,1-.18-.32l.07-.23a.47.47,0,0,1,.22-.31l1.21-.71Zm8.72,9L19.24,12.5a.5.5,0,0,0-.68-.18l-1.73,1a.49.49,0,0,0-.18.68l1.16,2H15V14.6a.48.48,0,0,0-.16-.35l-.17-.18a.27.27,0,0,0-.36,0l-3.08,3.08a.48.48,0,0,0,0,.7l3.08,3.08a.27.27,0,0,0,.36,0l.17-.18A.48.48,0,0,0,15,20.4V19h3.48a2,2,0,0,0,1.72-1l.53-.94A2,2,0,0,0,20.72,15ZM8.47,9.85a.5.5,0,0,0-.61-.36L3.64,10.6a.26.26,0,0,0-.18.31l.07.23a.46.46,0,0,0,.23.31L5,12.16l-1.7,2.9a2,2,0,0,0,0,2l.52.91a2,2,0,0,0,1.75,1h3a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5H6.2l1.36-2.32,1.21.7a.46.46,0,0,0,.38,0l.24-.06a.27.27,0,0,0,.18-.31Z"]
  };
  
  var rugby = {
    prefix: 'axis',
    iconName: 'rugby',
    icon: [24, 24, [], "f0000", "M21,5.86a2,2,0,0,0-.59-1.42l-.85-.85A2,2,0,0,0,18.14,3C2.85,3,3,14.22,3,18.1a2,2,0,0,0,.59,1.42l.89.89A2,2,0,0,0,5.9,21C21.17,21,21,9.73,21,5.86ZM17.39,14c-1.89,3.26-5.64,4.93-11.14,5L9.5,15.74l.53.53a.51.51,0,0,0,.7,0l.53-.54a.48.48,0,0,0,0-.7L9,12.74a.47.47,0,0,0-.35-.15.51.51,0,0,0-.36.15l-.53.53a.5.5,0,0,0,0,.7l.53.53L5,17.76c0-1.85.06-5.07,1.62-7.75,1.89-3.25,5.64-4.92,11.13-5L14.5,8.26,14,7.74a.47.47,0,0,0-.35-.15.51.51,0,0,0-.36.15l-.53.53a.5.5,0,0,0,0,.7l2.3,2.3a.51.51,0,0,0,.7,0l.53-.54a.48.48,0,0,0,0-.7l-.52-.53L19,6.24C19,8.1,18.94,11.31,17.39,14Zm-3.63-1.45a.48.48,0,0,1,0,.7l-.53.54a.51.51,0,0,1-.7,0l-2.3-2.3a.5.5,0,0,1,0-.7l.53-.53a.51.51,0,0,1,.36-.15.47.47,0,0,1,.35.15Z"]
  };
  
  var seat = {
    prefix: 'axis',
    iconName: 'seat',
    icon: [24, 24, [], "f0000", "M20,9.19l-2.3,12a1,1,0,0,1-1,.81H7A2,2,0,0,1,5,20.53L4,16.89a1,1,0,0,1,.25-1l.47-.46a1,1,0,0,1,.85-.29l8,1.14-.12-.75a4,4,0,0,1,.62-2.88l2.82-4.23A1,1,0,0,1,17.74,8H19A1,1,0,0,1,20,9.19ZM19,2H17a1,1,0,0,0-1,1.24l.5,2a1,1,0,0,0,1,.76H19a1,1,0,0,0,1-1V3A1,1,0,0,0,19,2Z"]
  };
  
  var seatOutlined = {
    prefix: 'axis',
    iconName: 'seatOutlined',
    icon: [24, 24, [], "f0000", "M19,8H16.74a1,1,0,0,0-.83.45l-2.82,4.23a4,4,0,0,0-.65,2.46l-6.83-1H5.48a1,1,0,0,0-.72.3l-.47.46a1,1,0,0,0-.25,1L5.3,20.53A2,2,0,0,0,7.23,22h9.46a1,1,0,0,0,1-.81l2.3-12A1,1,0,0,0,19,8ZM15.87,20H7.23l-1-3.72,6.42.91a1,1,0,0,0,.83-.27l.69-.66a1,1,0,0,0,.31-.78l0-.46a2,2,0,0,1,.31-1.23L17.28,10h.51ZM19,2H17a1,1,0,0,0-1,1.24l.5,2a1,1,0,0,0,1,.76H19a1,1,0,0,0,1-1V3A1,1,0,0,0,19,2Z"]
  };
  
  var shoePrint = {
    prefix: 'axis',
    iconName: 'shoePrint',
    icon: [24, 24, [], "f0000", "M17,8a18.17,18.17,0,0,1-.75,5.3,1,1,0,0,1-.95.7H9.05a1,1,0,0,1-.88-.54A12.35,12.35,0,0,1,7,8c0-3,1-8,5-8S17,5,17,8Zm-2.43,9.49-4.92-.87a1,1,0,0,0-1.16.81l-.44,2.46h0A4.07,4.07,0,0,0,8,20.5a3.5,3.5,0,0,0,6.94.61h0l.43-2.46A1,1,0,0,0,14.57,17.49Z"]
  };
  
  var shoePrintOutlined = {
    prefix: 'axis',
    iconName: 'shoePrintOutlined',
    icon: [24, 24, [], "f0000", "M12,2c.65,0,1.49.2,2.19,1.72A10.85,10.85,0,0,1,15,8a17.42,17.42,0,0,1-.46,4H9.69A11.12,11.12,0,0,1,9,8a10.85,10.85,0,0,1,.81-4.28C10.51,2.2,11.35,2,12,2m0-2C8,0,7,5,7,8a12.35,12.35,0,0,0,1.17,5.46,1,1,0,0,0,.88.54H15.3a1,1,0,0,0,.95-.7A18.17,18.17,0,0,0,17,8c0-3-1-8-5-8ZM10.28,18.76l3,.52L13,20.76a1.5,1.5,0,0,1-3-.26,1.56,1.56,0,0,1,0-.26l.25-1.48M9.47,16.6a1,1,0,0,0-1,.83l-.44,2.46h0A4.07,4.07,0,0,0,8,20.5a3.5,3.5,0,0,0,6.94.61h0l.43-2.46a1,1,0,0,0-.81-1.16l-4.92-.87-.18,0Z"]
  };
  
  var shower = {
    prefix: 'axis',
    iconName: 'shower',
    icon: [24, 24, [], "f0000", "M9,19a2,2,0,0,1-4,0,6.09,6.09,0,0,1,2-3H7A6.22,6.22,0,0,1,9,19ZM15,3A6,6,0,0,0,9.09,8H7.83a2,2,0,0,0-1.42.59L3.59,11.41A2,2,0,0,0,3,12.83v.67a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-.67a2,2,0,0,0-.59-1.42L13.59,8.59A2,2,0,0,0,12.17,8h-1A4,4,0,0,1,15,5a4.11,4.11,0,0,1,4,4.18V20.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V9.21C21,8.1,20.12,3,15,3ZM13,16h0a6.09,6.09,0,0,0-2,3,2,2,0,0,0,4,0A6.27,6.27,0,0,0,13,16Z"]
  };
  
  var signMan = {
    prefix: 'axis',
    iconName: 'signMan',
    icon: [24, 24, [], "f0000", "M20.85,3.6l-.45-.45A.49.49,0,0,0,20,3H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h2.08l-3.4,3.39A7.05,7.05,0,1,0,15.59,9.8L19,6.41V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V4A.49.49,0,0,0,20.85,3.6ZM10,19a5,5,0,1,1,5-5A5,5,0,0,1,10,19Z"]
  };
  
  var signWoman = {
    prefix: 'axis',
    iconName: 'signWoman',
    icon: [24, 24, [], "f0000", "M19,9a7,7,0,1,0-8,6.92V18H9.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H11v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V20h1.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H13V15.92A7,7,0,0,0,19,9ZM7,9a5,5,0,1,1,5,5A5,5,0,0,1,7,9Z"]
  };
  
  var skull = {
    prefix: 'axis',
    iconName: 'skull',
    icon: [24, 24, [], "f0000", "M12,2a8,8,0,0,0-8,8v5.17a2,2,0,0,0,.59,1.42l1.12,1.12a1,1,0,0,1,.29.7v1.68a1,1,0,0,0,.29.7l1.06,1.06a.49.49,0,0,0,.36.15h.58a.49.49,0,0,0,.36-.15l1-1a.5.5,0,0,1,.7,0l1,1a.49.49,0,0,0,.36.15h.58a.49.49,0,0,0,.36-.15l1-1a.5.5,0,0,1,.7,0l1,1a.49.49,0,0,0,.36.15h.58a.49.49,0,0,0,.36-.15l1.06-1.06a1,1,0,0,0,.29-.7V18.41a1,1,0,0,1,.29-.7l1.12-1.12A2,2,0,0,0,20,15.17V10A8,8,0,0,0,12,2ZM9.35,15.63a1,1,0,0,1-.78.37H7a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v.24a1,1,0,0,1-.22.63Zm4.23,2.17a.35.35,0,0,1-.31.2H10.73a.35.35,0,0,1-.27-.57l1-1.24a.49.49,0,0,1,.39-.19h.28a.49.49,0,0,1,.39.19l1,1.24A.35.35,0,0,1,13.58,17.8ZM18,15a1,1,0,0,1-1,1H15.43a1,1,0,0,1-.78-.37l-1.43-1.76a1,1,0,0,1-.22-.63V13a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1Z"]
  };
  
  var smokeFree = {
    prefix: 'axis',
    iconName: 'smokeFree',
    icon: [24, 24, [], "f0000", "M22,12.5v2a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,22,12.5ZM15.71,12l3,3A.49.49,0,0,0,19,14.5v-2a.5.5,0,0,0-.5-.5Zm.73-5A4,4,0,0,1,20,10.56a.49.49,0,0,0,.49.44h1a.52.52,0,0,0,.37-.16.56.56,0,0,0,.13-.39,6,6,0,0,0-3.08-4.7A4,4,0,0,0,20,3.57a.49.49,0,0,0-.12-.4A.49.49,0,0,0,19.46,3h-1a.5.5,0,0,0-.49.4A2,2,0,0,1,16.4,5a.5.5,0,0,0-.4.49V6.53A.49.49,0,0,0,16.44,7Zm1,4a.51.51,0,0,0,.37-.13.52.52,0,0,0,.16-.37v-1a.5.5,0,0,0-.46-.5A6,6,0,0,1,12,3.46a.5.5,0,0,0-.5-.46h-1a.52.52,0,0,0-.37.16.51.51,0,0,0-.13.37A8,8,0,0,0,17.47,11ZM4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L10.76,12H2.5a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5H13.76l5.86,5.85a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7Z"]
  };
  
  var smoking = {
    prefix: 'axis',
    iconName: 'smoking',
    icon: [24, 24, [], "f0000", "M22,14.5v2a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,22,14.5ZM18.5,14H2.5a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h16a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,0,18.5,14Zm2-1h1a.52.52,0,0,0,.37-.16.56.56,0,0,0,.13-.39,6,6,0,0,0-3.08-4.7A4,4,0,0,0,20,5.57a.49.49,0,0,0-.12-.4A.49.49,0,0,0,19.46,5h-1a.5.5,0,0,0-.49.4A2,2,0,0,1,16.4,7a.5.5,0,0,0-.4.49V8.53a.49.49,0,0,0,.44.49A4,4,0,0,1,20,12.56.49.49,0,0,0,20.47,13Zm-3,0a.51.51,0,0,0,.37-.13.52.52,0,0,0,.16-.37v-1a.5.5,0,0,0-.46-.5A6,6,0,0,1,12,5.46a.5.5,0,0,0-.5-.46h-1a.52.52,0,0,0-.37.16.51.51,0,0,0-.13.37A8,8,0,0,0,17.47,13Z"]
  };
  
  var snowflake = {
    prefix: 'axis',
    iconName: 'snowflake',
    icon: [24, 24, [], "f0000", "M21,11.69v.5a.5.5,0,0,1-.5.5H16.42l2.43,2.43a.48.48,0,0,1,0,.7l-.35.36a.51.51,0,0,1-.71,0L14.3,12.69H12.69v1.49l3.49,3.49a.5.5,0,0,1,0,.7l-.36.36a.5.5,0,0,1-.7,0L12.69,16.3v4.23a.47.47,0,0,1-.47.47h-.57a.47.47,0,0,1-.46-.47v-4l-2.31,2.3a.48.48,0,0,1-.7,0l-.36-.35a.51.51,0,0,1,0-.71l3.37-3.36V12.69H9.82L6.33,16.18a.5.5,0,0,1-.7,0l-.36-.36a.5.5,0,0,1,0-.7L7.7,12.69H3.47A.47.47,0,0,1,3,12.22v-.57a.47.47,0,0,1,.47-.46h4L5.15,8.88a.48.48,0,0,1,0-.7l.35-.36a.51.51,0,0,1,.71,0l3.36,3.37h1.62V9.7L7.82,6.33a.5.5,0,0,1,0-.7l.36-.36a.5.5,0,0,1,.7,0l2.31,2.3V3.5a.5.5,0,0,1,.5-.5h.5a.5.5,0,0,1,.5.5V7.58l2.43-2.43a.48.48,0,0,1,.7,0l.36.35a.51.51,0,0,1,0,.71L12.69,9.7v1.49H14.3l3.37-3.37a.5.5,0,0,1,.7,0l.36.36a.5.5,0,0,1,0,.7l-2.3,2.31H20.5A.5.5,0,0,1,21,11.69Z"]
  };
  
  var sport = {
    prefix: 'axis',
    iconName: 'sport',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm6.46,14.7-2.32,0a1,1,0,0,0-1,.72l-.67,2.22a7.89,7.89,0,0,1-5,0l-.67-2.22a1,1,0,0,0-1-.72l-2.32,0A8,8,0,0,1,4,12H4l1.91-1.34A1,1,0,0,0,6.29,9.5L5.53,7.32a8,8,0,0,1,4-2.93L11.39,5.8a1,1,0,0,0,1.22,0l1.85-1.41a8,8,0,0,1,4,2.93L17.71,9.5a1,1,0,0,0,.38,1.16L20,12h0A8,8,0,0,1,18.46,16.7ZM15.1,10.44a.88.88,0,0,1,.35,1l-1,2.89a1,1,0,0,1-1,.65h-3a1,1,0,0,1-1-.65l-1-2.89a.88.88,0,0,1,.35-1l2.49-1.75a1.09,1.09,0,0,1,1.22,0Z"]
  };
  
  var square = {
    prefix: 'axis',
    iconName: 'square',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Z"]
  };
  
  var squareOutlined = {
    prefix: 'axis',
    iconName: 'squareOutlined',
    icon: [24, 24, [], "f0000", "M19,5m0,0V19H5V5Zm0-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Z"]
  };
  
  var stairsDown = {
    prefix: 'axis',
    iconName: 'stairsDown',
    icon: [24, 24, [], "f0000", "M22,6.5v1a.5.5,0,0,1-.5.5H19v3a1,1,0,0,1-1,1H15v3a1,1,0,0,1-1,1H11v3a1,1,0,0,1-1,1H2.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H9V15a1,1,0,0,1,1-1h3V11a1,1,0,0,1,1-1h3V7a1,1,0,0,1,1-1h3.5A.5.5,0,0,1,22,6.5ZM2.5,13H6.75a.5.5,0,0,0,.35-.85L5.68,10.72l5.17-5.16a.5.5,0,0,0,0-.71l-.7-.7a.5.5,0,0,0-.71,0L4.27,9.31,2.85,7.89A.5.5,0,0,0,2,8.25V12.5A.52.52,0,0,0,2.5,13Z"]
  };
  
  var stairsUp = {
    prefix: 'axis',
    iconName: 'stairsUp',
    icon: [24, 24, [], "f0000", "M22,6.5v1a.5.5,0,0,1-.5.5H19v3a1,1,0,0,1-1,1H15v3a1,1,0,0,1-1,1H11v3a1,1,0,0,1-1,1H2.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H9V15a1,1,0,0,1,1-1h3V11a1,1,0,0,1,1-1h3V7a1,1,0,0,1,1-1h3.5A.5.5,0,0,1,22,6.5ZM2.85,12.86a.51.51,0,0,0,.71,0L8.73,7.69l1.42,1.42A.5.5,0,0,0,11,8.75V4.5a.52.52,0,0,0-.5-.5H6.25a.5.5,0,0,0-.35.85L7.32,6.28,2.15,11.44a.5.5,0,0,0,0,.71Z"]
  };
  
  var survey = {
    prefix: 'axis',
    iconName: 'survey',
    icon: [24, 24, [], "f0000", "M20,5a2,2,0,0,0-2-2H14a2,2,0,0,0-4,0H6A2,2,0,0,0,4,5V21a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2ZM18,21H6V5H8V6.5a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5V5h2ZM8.5,11h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,9.5,9h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,8.5,11Zm0,4h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,8.5,15Zm0,4h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,8.5,19Z"]
  };
  
  var tShirt = {
    prefix: 'axis',
    iconName: 'tShirt',
    icon: [24, 24, [], "f0000", "M7,8.59l-2,2a.48.48,0,0,1-.7,0L2.15,8.49a.48.48,0,0,1,0-.7L5.86,4.07a2,2,0,0,1,.9-.52L8.81,3a.25.25,0,0,1,.29.15A3.79,3.79,0,0,0,12,5a3.79,3.79,0,0,0,2.9-1.84A.25.25,0,0,1,15.19,3l2,.54a2,2,0,0,1,.9.52l3.71,3.72a.48.48,0,0,1,0,.7l-2.12,2.12a.48.48,0,0,1-.7,0l-2-2V20a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1Z"]
  };
  
  var tableTennis = {
    prefix: 'axis',
    iconName: 'tableTennis',
    icon: [24, 24, [], "f0000", "M19.1,4.9A6.67,6.67,0,0,0,14.34,3,8.69,8.69,0,0,0,8.25,5.63,6.71,6.71,0,0,0,6.89,14a1,1,0,0,1-.17,1.2L3.15,18.73a.5.5,0,0,0,0,.71l1.41,1.41a.5.5,0,0,0,.35.15.51.51,0,0,0,.36-.15l3.57-3.57a1,1,0,0,1,.71-.3,1.05,1.05,0,0,1,.49.13,6.73,6.73,0,0,0,3.3.89,7.08,7.08,0,0,0,5-2.25C21.57,12.56,21.89,7.7,19.1,4.9ZM17,14.34a5.69,5.69,0,0,1-2.22,1.4l-6.5-6.5A6,6,0,0,1,9.66,7a6.71,6.71,0,0,1,4.68-2,4.66,4.66,0,0,1,3.34,1.32C19.7,8.33,19.37,11.93,17,14.34Z"]
  };
  
  var temperature = {
    prefix: 'axis',
    iconName: 'temperature',
    icon: [24, 24, [], "f0000", "M13,12.13V5A3,3,0,0,0,7,5v7.13a2,2,0,0,1-.57,1.4A4.91,4.91,0,0,0,5,17a5,5,0,0,0,10,0,4.91,4.91,0,0,0-1.43-3.47A2,2,0,0,1,13,12.13ZM9,5a1,1,0,0,1,2,0V8H9Zm1,14a2,2,0,1,1,2-2A2,2,0,0,1,10,19Z"]
  };
  
  var tennis = {
    prefix: 'axis',
    iconName: 'tennis',
    icon: [24, 24, [], "f0000", "M18.5,15A3.5,3.5,0,1,0,22,18.5,3.49,3.49,0,0,0,18.5,15Zm0,5.25a1.75,1.75,0,1,1,1.75-1.75A1.75,1.75,0,0,1,18.5,20.25ZM14.87,2a6.8,6.8,0,0,0-4.68,2.19C6.25,8.13,9.07,11.66,6.26,14.5l0,0-.89.89a.5.5,0,0,0,0,.7l.54.54a.5.5,0,0,0,.7,0l.89-.89c2.8-2.8,6.42,0,10.33-3.95a9.36,9.36,0,0,0,1.12-1.38A6.08,6.08,0,0,0,20,7.13,5.31,5.31,0,0,0,14.87,2ZM13.14,12.25A3.56,3.56,0,0,1,9.75,8.86c0-2.47,2.9-5.11,5.11-5.11a3.56,3.56,0,0,1,3.39,3.4C18.25,9.61,15.36,12.25,13.14,12.25Zm-11,6.37A.47.47,0,0,0,2,19a.49.49,0,0,0,.15.35l.53.53a.48.48,0,0,0,.7,0l1.26-1.26a.49.49,0,0,0,0-.7l-.54-.54a.49.49,0,0,0-.7,0Z"]
  };
  
  var testTube = {
    prefix: 'axis',
    iconName: 'testTube',
    icon: [24, 24, [], "f0000", "M17,2.5a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H8V18a4,4,0,0,0,8,0V4h.5a.5.5,0,0,0,.5-.5ZM14,4v6H10V4Z"]
  };
  
  var ticket = {
    prefix: 'axis',
    iconName: 'ticket',
    icon: [24, 24, [], "f0000", "M21.71,8.2l-.63-.63A1,1,0,0,0,20,7.31a2.57,2.57,0,0,1-1,.19A2.5,2.5,0,0,1,16.5,5a2.57,2.57,0,0,1,.19-1,1,1,0,0,0-.26-1.12l-.63-.63A1,1,0,0,0,15.1,2H13.92a1,1,0,0,0-.7.29L2.29,13.22a1,1,0,0,0-.29.7V15.1a1,1,0,0,0,.29.7l.63.63A1,1,0,0,0,4,16.69a2.57,2.57,0,0,1,1-.19A2.5,2.5,0,0,1,7.5,19a2.57,2.57,0,0,1-.19,1,1,1,0,0,0,.26,1.12l.63.63a1,1,0,0,0,.7.29h1.18a1,1,0,0,0,.7-.29L21.71,10.78a1,1,0,0,0,.29-.7V8.9A1,1,0,0,0,21.71,8.2ZM12,14a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"]
  };
  
  var triangle = {
    prefix: 'axis',
    iconName: 'triangle',
    icon: [24, 24, [], "f0000", "M22.9,19.63,12.81,2.37A.76.76,0,0,0,12.16,2h-.3a.76.76,0,0,0-.65.37L1.1,19.63a.79.79,0,0,0,0,.76l.14.23a.73.73,0,0,0,.65.38H22.11a.73.73,0,0,0,.65-.38l.14-.23A.79.79,0,0,0,22.9,19.63Z"]
  };
  
  var triangleOutlined = {
    prefix: 'axis',
    iconName: 'triangleOutlined',
    icon: [24, 24, [], "f0000", "M22.9,19.63,12.81,2.37A.76.76,0,0,0,12.16,2h-.3a.76.76,0,0,0-.65.37L1.1,19.63a.79.79,0,0,0,0,.76l.14.23a.73.73,0,0,0,.65.38H22.11a.73.73,0,0,0,.65-.38l.14-.23A.79.79,0,0,0,22.9,19.63ZM3.79,19,12,5l8.2,14Z"]
  };
  
  var umbrella = {
    prefix: 'axis',
    iconName: 'umbrella',
    icon: [24, 24, [], "f0000", "M17,18.5V19a3,3,0,0,1-6,0V15.26l.08-.09a1.23,1.23,0,0,1,.92-.42,1.26,1.26,0,0,1,.84.33l.16.13V19a1,1,0,0,0,2,0v-.5a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,17,18.5ZM13,4.06V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4.06A9,9,0,0,0,3,13v.5a.5.5,0,0,0,.5.5h.32a.78.78,0,0,0,.52-.21,2.7,2.7,0,0,1,3.82,0,.78.78,0,0,0,.52.21h.79a.74.74,0,0,0,.51-.2,3,3,0,0,1,4,0,.74.74,0,0,0,.51.2h.79a.78.78,0,0,0,.52-.21,2.7,2.7,0,0,1,3.82,0,.78.78,0,0,0,.52.21h.32a.5.5,0,0,0,.5-.5V13A9,9,0,0,0,13,4.06Z"]
  };
  
  var umbrellaOutlined = {
    prefix: 'axis',
    iconName: 'umbrellaOutlined',
    icon: [24, 24, [], "f0000", "M16.5,18h-1a.5.5,0,0,0-.5.5V19a1,1,0,0,1-2,0V15.21l-.16-.13a1.26,1.26,0,0,0-.84-.33,1.23,1.23,0,0,0-.92.42l-.08.09V19a3,3,0,0,0,6,0v-.5A.5.5,0,0,0,16.5,18ZM13,4.06V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4.06A9,9,0,0,0,3,13v.5a.5.5,0,0,0,.5.5h.32a.78.78,0,0,0,.52-.21,2.7,2.7,0,0,1,3.82,0,.78.78,0,0,0,.52.21h.79a.74.74,0,0,0,.51-.2,3,3,0,0,1,4,0,.74.74,0,0,0,.51.2h.79a.78.78,0,0,0,.52-.21,2.7,2.7,0,0,1,3.82,0,.78.78,0,0,0,.52.21h.32a.5.5,0,0,0,.5-.5V13A9,9,0,0,0,13,4.06ZM17.75,11a4.64,4.64,0,0,0-2.83.95,5,5,0,0,0-5.84,0A4.64,4.64,0,0,0,6.25,11a5.36,5.36,0,0,0-1,.1,7,7,0,0,1,13.48,0A5.36,5.36,0,0,0,17.75,11Z"]
  };
  
  var volleyball = {
    prefix: 'axis',
    iconName: 'volleyball',
    icon: [24, 24, [], "f0000", "M12,2A9.93,9.93,0,0,0,6,4H6a10,10,0,1,0,6-2ZM8,5.08a8.17,8.17,0,0,1,2-.82v8.89L8,14.31Zm4,2.3L20,12a8,8,0,0,1-.3,2.14L12,9.69Zm7.58,2.07L12,5.07V4A8,8,0,0,1,19.58,9.45ZM6,6.72v8.74L5.08,16A8,8,0,0,1,6,6.72ZM6.29,17.6,14,13.15l2,1.16L8,18.92A7.87,7.87,0,0,1,6.29,17.6ZM12,20a8.22,8.22,0,0,1-1.58-.16L18,15.46l.92.54A8,8,0,0,1,12,20Z"]
  };
  
  var weight = {
    prefix: 'axis',
    iconName: 'weight',
    icon: [24, 24, [], "f0000", "M20.43,10.7a2,2,0,0,0-2-1.7H14.62A4,4,0,1,0,9.38,9H5.55a2,2,0,0,0-2,1.7L2,20.85A1,1,0,0,0,3,22H21a1,1,0,0,0,1-1.15ZM12,17a2,2,0,1,1,2-2A2,2,0,0,1,12,17Zm0-9a2,2,0,1,1,2-2A2,2,0,0,1,12,8Z"]
  };
  
  var weightOutlined = {
    prefix: 'axis',
    iconName: 'weightOutlined',
    icon: [24, 24, [], "f0000", "M20.43,10.7a2,2,0,0,0-2-1.7H14.62A4,4,0,1,0,9.38,9H5.55a2,2,0,0,0-2,1.7L2,20.85A1,1,0,0,0,3,22H21a1,1,0,0,0,1-1.15ZM12,4a2,2,0,1,1-2,2A2,2,0,0,1,12,4ZM4.17,20l1.38-9h12.9l1.38,9ZM14,15a2,2,0,1,1-2-2A2,2,0,0,1,14,15Z"]
  };
  
  var wishlist = {
    prefix: 'axis',
    iconName: 'wishlist',
    icon: [24, 24, [], "f0000", "M21,4a2,2,0,0,0-2-2H7A2,2,0,0,0,5,4H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM14.2,15.08l-.78.75a.6.6,0,0,1-.84,0l-.78-.75C10.9,14.2,9,12.5,9,11.14A2.17,2.17,0,0,1,11.2,9a2.59,2.59,0,0,1,1.8.8A2.59,2.59,0,0,1,14.8,9,2.17,2.17,0,0,1,17,11.14C17,12.5,15.1,14.2,14.2,15.08Z"]
  };
  
  var wishlistOutlined = {
    prefix: 'axis',
    iconName: 'wishlistOutlined',
    icon: [24, 24, [], "f0000", "M7,4H19V20H7ZM19,2H7A2,2,0,0,0,5,4H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2ZM14.2,15.08l-.78.75a.6.6,0,0,1-.84,0l-.78-.75C10.9,14.2,9,12.5,9,11.14A2.17,2.17,0,0,1,11.2,9a2.59,2.59,0,0,1,1.8.8A2.59,2.59,0,0,1,14.8,9,2.17,2.17,0,0,1,17,11.14C17,12.5,15.1,14.2,14.2,15.08Z"]
  };
  
  var wrench = {
    prefix: 'axis',
    iconName: 'wrench',
    icon: [24, 24, [], "f0000", "M21,6.68V7a4,4,0,0,1-4,4,3.89,3.89,0,0,1-1.56-.32l-10,10a1,1,0,0,1-.7.29H4.53a1,1,0,0,1-.7-.29l-.54-.54a1,1,0,0,1-.29-.7v-.18a1,1,0,0,1,.29-.7l10-10A3.89,3.89,0,0,1,13,7a4,4,0,0,1,4-4h.32a.51.51,0,0,1,.36.15l.17.17a.5.5,0,0,1,0,.71L16.29,5.59a.5.5,0,0,0,0,.7l1.42,1.42a.51.51,0,0,0,.7,0L20,6.15a.5.5,0,0,1,.71,0l.17.17A.51.51,0,0,1,21,6.68Z"]
  };
  
  var americanExpress = {
    prefix: 'axis',
    iconName: 'americanExpress',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4ZM4,10.5v-2A.5.5,0,0,1,4.5,8h11a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5H4.5A.5.5,0,0,1,4,10.5Zm16,5a.5.5,0,0,1-.5.5H8.5a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h11a.5.5,0,0,1,.5.5Z"]
  };
  
  var atm = {
    prefix: 'axis',
    iconName: 'atm',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V8.5A1.5,1.5,0,0,0,3.5,10,.5.5,0,0,0,4,9.5V6H6V18a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6h2V9.5a.5.5,0,0,0,.5.5A1.5,1.5,0,0,0,22,8.5V6A2,2,0,0,0,20,4ZM14,17.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5V6.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5Z"]
  };
  
  var atmOutlined = {
    prefix: 'axis',
    iconName: 'atmOutlined',
    icon: [24, 24, [], "f0000", "M2,6V8.5A1.5,1.5,0,0,0,3.5,10h0A.5.5,0,0,0,4,9.5V6H6V18a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6h2V9.5a.5.5,0,0,0,.5.5h0A1.5,1.5,0,0,0,22,8.5V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6ZM8,18V6h3V18Zm8,0H14V6h2Z"]
  };
  
  var bitcoin = {
    prefix: 'axis',
    iconName: 'bitcoin',
    icon: [24, 24, [], "f0000", "M10.75,9.75v1.37h3V9.75Zm0,3.13v1.37h3.5V12.88Zm0,0v1.37h3.5V12.88Zm0-3.13v1.37h3V9.75Zm0,0v1.37h3V9.75Zm0,3.13v1.37h3.5V12.88Zm0,0v1.37h3.5V12.88Zm3-3.13h-3v1.37h3ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm4,12a2,2,0,0,1-2,2H13v1.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V16H8.5a.5.5,0,0,1-.5-.5v-.75a.5.5,0,0,1,.5-.5h.25A.25.25,0,0,0,9,14V10a.25.25,0,0,0-.25-.25H8.5a.5.5,0,0,1-.5-.5V8.5A.5.5,0,0,1,8.5,8H11V6.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V8h.5a2,2,0,0,1,2,2v.88a2,2,0,0,1-.16.77A2,2,0,0,1,16,13.12Zm-5.25.25h3.5V12.88h-3.5Zm3-4.5h-3v1.37h3Zm-3,0v1.37h3V9.75Zm0,3.13v1.37h3.5V12.88Zm0,0v1.37h3.5V12.88Zm0-3.13v1.37h3V9.75Z"]
  };
  
  var bitcoinOutlined = {
    prefix: 'axis',
    iconName: 'bitcoinOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm3.5-9.12V10a2,2,0,0,0-2-2H13V6.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V8H8.5a.5.5,0,0,0-.5.5v.75a.5.5,0,0,0,.5.5h.25A.25.25,0,0,1,9,10v4a.25.25,0,0,1-.25.25H8.5a.5.5,0,0,0-.5.5v.75a.5.5,0,0,0,.5.5H11v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V16h1a2,2,0,0,0,2-2v-.88a2,2,0,0,0-.66-1.47A2,2,0,0,0,15.5,10.88ZM10.75,9.75h3v1.37h-3Zm3.5,4.5h-3.5V12.88h3.5Z"]
  };
  
  var coin = {
    prefix: 'axis',
    iconName: 'coin',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM11.47,6A6,6,0,0,0,6,11.45a.56.56,0,0,0,.13.39.52.52,0,0,0,.37.16h1A.49.49,0,0,0,8,11.56,4,4,0,0,1,11.56,8,.49.49,0,0,0,12,7.53v-1A.5.5,0,0,0,11.47,6Z"]
  };
  
  var creditCard = {
    prefix: 'axis',
    iconName: 'creditCard',
    icon: [24, 24, [], "f0000", "M22,6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2ZM10,16.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Zm10-5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5v-2A.5.5,0,0,1,4.5,9h15a.5.5,0,0,1,.5.5Z"]
  };
  
  var creditCardAdd = {
    prefix: 'axis',
    iconName: 'creditCardAdd',
    icon: [24, 24, [], "f0000", "M22,9a5,5,0,0,0-5-5,4.94,4.94,0,0,0-3,1H4A2,2,0,0,0,2,7V18a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V12A4.94,4.94,0,0,0,22,9ZM16.12,6.5a.5.5,0,0,1,.5-.5h.76a.5.5,0,0,1,.5.5V8.12H19.5a.5.5,0,0,1,.5.5v.76a.5.5,0,0,1-.5.5H17.88V11.5a.5.5,0,0,1-.5.5h-.76a.5.5,0,0,1-.5-.5V9.88H14.5a.5.5,0,0,1-.5-.5V8.62a.5.5,0,0,1,.5-.5h1.62ZM4,7h8.42A4.94,4.94,0,0,0,12,9a5.47,5.47,0,0,0,.1,1H4ZM4,18V13H14a4.93,4.93,0,0,0,5,.58V18Z"]
  };
  
  var creditCardOutlined = {
    prefix: 'axis',
    iconName: 'creditCardOutlined',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,2V9H4V6ZM4,18V12H20v6Zm5.5-4h-3a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,9.5,14Z"]
  };
  
  var creditCardRemove = {
    prefix: 'axis',
    iconName: 'creditCardRemove',
    icon: [24, 24, [], "f0000", "M22,9a5,5,0,0,0-5-5,4.94,4.94,0,0,0-3,1H4A2,2,0,0,0,2,7V18a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V12A4.94,4.94,0,0,0,22,9Zm-7.5.88a.5.5,0,0,1-.5-.5V8.62a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v.76a.5.5,0,0,1-.5.5ZM4,7h8.42A4.94,4.94,0,0,0,12,9a5.47,5.47,0,0,0,.1,1H4ZM4,18V13H14a4.93,4.93,0,0,0,5,.58V18Z"]
  };
  
  var creditCards = {
    prefix: 'axis',
    iconName: 'creditCards',
    icon: [24, 24, [], "f0000", "M17,3H3A2,2,0,0,0,1,5V16a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V5A2,2,0,0,0,17,3Zm0,2V8H3V5ZM3,16V11H17v5ZM21,7V18a2,2,0,0,1-2,2H5a2,2,0,0,0,2,2H19a4,4,0,0,0,4-4V9A2,2,0,0,0,21,7Z"]
  };
  
  var discover = {
    prefix: 'axis',
    iconName: 'discover',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4ZM4,18V6H20v6c0,3.31-6,6-12,6Zm8-9a3,3,0,1,0,3,3A3,3,0,0,0,12,9Z"]
  };
  
  var dollar = {
    prefix: 'axis',
    iconName: 'dollar',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3,7.75a.5.5,0,0,1-.5.5h-.75a.5.5,0,0,1-.5-.5v-1h-2.5v.88a.22.22,0,0,0,.09.19l3.43,2.83A2,2,0,0,1,15,14.19V15a2,2,0,0,1-2,2v.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V17a2,2,0,0,1-2-2v-.75a.5.5,0,0,1,.5-.5h.75a.5.5,0,0,1,.5.5v1h2.5v-.88a.22.22,0,0,0-.09-.19L9.73,11.35A2,2,0,0,1,9,9.81V9a2,2,0,0,1,2-2V6.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V7a2,2,0,0,1,2,2Z"]
  };
  
  var dollarOutlined = {
    prefix: 'axis',
    iconName: 'dollarOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM13,7V6.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V7A2,2,0,0,0,9,9v.81a2,2,0,0,0,.73,1.54l3.43,2.83a.22.22,0,0,1,.09.19v.88h-2.5v-1a.5.5,0,0,0-.5-.5H9.5a.5.5,0,0,0-.5.5V15a2,2,0,0,0,2,2v.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V17a2,2,0,0,0,2-2v-.81a2,2,0,0,0-.73-1.54L10.84,9.82a.22.22,0,0,1-.09-.19V8.75h2.5v1a.5.5,0,0,0,.5.5h.75a.5.5,0,0,0,.5-.5V9A2,2,0,0,0,13,7Z"]
  };
  
  var ethereum = {
    prefix: 'axis',
    iconName: 'ethereum',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3.64,12.13-3.18,3.7a.5.5,0,0,1-.38.17h-.16a.5.5,0,0,1-.38-.17l-3.18-3.7a.11.11,0,0,1,0-.13.09.09,0,0,1,.13,0l3.27,1.76a.51.51,0,0,0,.48,0L15.51,14a.09.09,0,0,1,.13,0A.11.11,0,0,1,15.64,14.13Zm.12-2L12.24,14a.51.51,0,0,1-.48,0L8.24,12.15a.26.26,0,0,1-.09-.36l3.39-5.55A.51.51,0,0,1,12,6H12a.51.51,0,0,1,.43.24l3.39,5.55A.26.26,0,0,1,15.76,12.15Z"]
  };
  
  var ethereumOutlined = {
    prefix: 'axis',
    iconName: 'ethereumOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.46-13.76A.51.51,0,0,0,12,6H12a.51.51,0,0,0-.43.24L8.15,11.79a.26.26,0,0,0,.09.36L11.76,14a.51.51,0,0,0,.48,0l3.52-1.89a.26.26,0,0,0,.09-.36Zm-.22,9.5a.51.51,0,0,1-.48,0L8.49,14a.09.09,0,0,0-.13,0,.11.11,0,0,0,0,.13l3.18,3.7a.5.5,0,0,0,.38.17h.16a.5.5,0,0,0,.38-.17l3.18-3.7a.11.11,0,0,0,0-.13.09.09,0,0,0-.13,0Z"]
  };
  
  var euro = {
    prefix: 'axis',
    iconName: 'euro',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1.6,9a.25.25,0,0,1,.21.12.25.25,0,0,1,0,.24l-.61,1.23a.76.76,0,0,1-.67.41H8.92A3.26,3.26,0,0,0,12,15.25a3.21,3.21,0,0,0,2-.67.5.5,0,0,1,.66.05l.53.54a.46.46,0,0,1,.15.38.52.52,0,0,1-.19.36A5,5,0,0,1,7.1,13H6.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h.6a5,5,0,0,1,8-2.91.52.52,0,0,1,.19.36.46.46,0,0,1-.15.38l-.53.54a.5.5,0,0,1-.66.05,3.21,3.21,0,0,0-2-.67A3.26,3.26,0,0,0,8.92,11Z"]
  };
  
  var euroOutlined = {
    prefix: 'axis',
    iconName: 'euroOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM12,8.75a3.21,3.21,0,0,1,2,.67.5.5,0,0,0,.66-.05l.53-.54a.46.46,0,0,0,.15-.38.52.52,0,0,0-.19-.36A5,5,0,0,0,7.1,11H6.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h.6a5,5,0,0,0,8,2.91.52.52,0,0,0,.19-.36.46.46,0,0,0-.15-.38l-.53-.54a.5.5,0,0,0-.66-.05,3.21,3.21,0,0,1-2,.67A3.26,3.26,0,0,1,8.92,13h3.62a.76.76,0,0,0,.67-.41l.61-1.23a.25.25,0,0,0,0-.24A.25.25,0,0,0,13.6,11H8.92A3.26,3.26,0,0,1,12,8.75Z"]
  };
  
  var insurance = {
    prefix: 'axis',
    iconName: 'insurance',
    icon: [24, 24, [], "f0000", "M24,7v7.53a2.47,2.47,0,0,1-.94,1.95l-3.69,3a1,1,0,0,0-.37.77V21a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V18.05a3,3,0,0,1,1.46-2.57l5.3-3.18a1.4,1.4,0,0,1,.75-.21,1.36,1.36,0,0,1,.49.08,1.46,1.46,0,0,1,.81.64,1.5,1.5,0,0,1-.51,2.06L17.7,17a.56.56,0,0,0-.23.31.5.5,0,0,0,.75.55l3.59-2.16A2.47,2.47,0,0,0,23,14.19,2.48,2.48,0,0,0,22,11.58V7a1,1,0,0,1,1-1h0A1,1,0,0,1,24,7ZM9.54,15.48,4.24,12.3a1.4,1.4,0,0,0-.75-.21,1.36,1.36,0,0,0-.49.08,1.46,1.46,0,0,0-.81.64,1.5,1.5,0,0,0,.51,2.06L6.3,17a.56.56,0,0,1,.23.31.5.5,0,0,1-.75.55L2.19,15.73a2.47,2.47,0,0,1-1.14-1.54,2.41,2.41,0,0,1,.28-1.89A2.34,2.34,0,0,1,2,11.57V7A1,1,0,0,0,1,6H1A1,1,0,0,0,0,7v7.54a2.47,2.47,0,0,0,.94,1.95l3.69,3A1,1,0,0,1,5,20.2V21a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18.05A3,3,0,0,0,9.54,15.48ZM12,4a3,3,0,1,0,3,3,3,3,0,0,0-3-3m0-2A5,5,0,1,1,7,7a5,5,0,0,1,5-5Zm8.64,9.1.37,0V7.75l-.15-.26a1,1,0,0,0-1.35-.36h0a1,1,0,0,0-.36,1.35ZM4.88,8.49a1,1,0,0,0-.36-1.35h0a1,1,0,0,0-1.35.36L3,7.75v3.39l.37,0Z"]
  };
  
  var litecoin = {
    prefix: 'axis',
    iconName: 'litecoin',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3.73,14.6a.5.5,0,0,1-.49.4H9.3a.25.25,0,0,1-.24-.3l.64-3.18-1.38.39A.26.26,0,0,1,8,13.67v-1a.5.5,0,0,1,.36-.48l1.71-.49.85-4.26a.5.5,0,0,1,.49-.4H13.7a.25.25,0,0,1,.24.3l-.69,3.45,1.43-.41a.26.26,0,0,1,.32.24v1a.5.5,0,0,1-.36.48l-1.76.51-.53,2.64H15.7a.25.25,0,0,1,.24.3Z"]
  };
  
  var litecoinOutlined = {
    prefix: 'axis',
    iconName: 'litecoinOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm3.7-4.75H12.35l.53-2.64,1.76-.51a.5.5,0,0,0,.36-.48v-1a.26.26,0,0,0-.32-.24l-1.43.41.69-3.45A.25.25,0,0,0,13.7,7H11.41a.5.5,0,0,0-.49.4l-.85,4.26-1.71.49a.5.5,0,0,0-.36.48v1a.26.26,0,0,0,.32.24l1.38-.39L9.06,16.7a.25.25,0,0,0,.24.3h5.94a.5.5,0,0,0,.49-.4l.21-1.05A.25.25,0,0,0,15.7,15.25Z"]
  };
  
  var maestro = {
    prefix: 'axis',
    iconName: 'maestro',
    icon: [24, 24, [], "f0000", "M17,5a7,7,0,0,0-5,2.11,7,7,0,1,0,0,9.78A7,7,0,1,0,17,5Zm0,12a5,5,0,0,1-3.79-1.78,7,7,0,0,0,0-6.44A5,5,0,1,1,17,17Z"]
  };
  
  var money = {
    prefix: 'axis',
    iconName: 'money',
    icon: [24, 24, [], "f0000", "M21,4H3A1,1,0,0,0,2,5V19a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4ZM8,18a4,4,0,0,0-4-4V10A4,4,0,0,0,8,6h8a4,4,0,0,0,4,4v4a4,4,0,0,0-4,4Zm4-9a3,3,0,1,0,3,3A3,3,0,0,0,12,9Z"]
  };
  
  var moneyVs = {
    prefix: 'axis',
    iconName: 'moneyVs',
    icon: [24, 24, [], "f0000", "M21,4H15.89a9.08,9.08,0,0,0-4,1l-.62.31A6.93,6.93,0,0,1,8.11,6H3A1,1,0,0,0,2,7V19a1,1,0,0,0,1,1H8.11a9.08,9.08,0,0,0,4-.95l.62-.31A6.93,6.93,0,0,1,15.89,18H21a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4Zm-1,9a3,3,0,0,0-3,3H15.89a9.11,9.11,0,0,0-4,.95l-.62.31A7.06,7.06,0,0,1,8.11,18H7a3,3,0,0,0-3-3V11A3,3,0,0,0,7,8H8.11a9.11,9.11,0,0,0,4-1l.62-.31A7.06,7.06,0,0,1,15.89,6H17a3,3,0,0,0,3,3Zm-5-1a3,3,0,1,1-3-3A3,3,0,0,1,15,12Z"]
  };
  
  var paypal = {
    prefix: 'axis',
    iconName: 'paypal',
    icon: [24, 24, [], "f0000", "M20,10.05l-.14.89A6,6,0,0,1,13.89,16H12.75a.75.75,0,0,0-.74.63l-.75,4.74a.76.76,0,0,1-.75.63H8.7a.49.49,0,0,1-.49-.58l1.13-7.16a.75.75,0,0,1,.7-.51h1.7a7.75,7.75,0,0,0,7.6-6.26A3.45,3.45,0,0,1,20,10.05ZM11.74,12a6,6,0,0,0,5.93-5.06l.14-.89a3.5,3.5,0,0,0-3.46-4h-7a1,1,0,0,0-1,.84L4,17.42A.49.49,0,0,0,4.5,18H6.31a.74.74,0,0,0,.74-.63l.76-4.74A.74.74,0,0,1,8.55,12Z"]
  };
  
  var pound = {
    prefix: 'axis',
    iconName: 'pound',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm4,13a2,2,0,0,1-2,2H9.68a.52.52,0,0,1-.37-.16l-.26-.29A.51.51,0,0,1,9,16a8.31,8.31,0,0,0,.79-2.51,2.2,2.2,0,0,0-.06-.5H8.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h.64A4.38,4.38,0,0,1,9,10a3,3,0,0,1,5.94-.6.53.53,0,0,1-.1.42.53.53,0,0,1-.39.18h-.77a.5.5,0,0,1-.48-.36,1.25,1.25,0,0,0-2.45.36,4.08,4.08,0,0,0,.2,1H12.5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a4.07,4.07,0,0,1,0,.5,6,6,0,0,1-.36,1.75H14a.25.25,0,0,0,.25-.25v-.25a.5.5,0,0,1,.5-.5h.75a.5.5,0,0,1,.5.5Z"]
  };
  
  var poundOutlined = {
    prefix: 'axis',
    iconName: 'poundOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm3.5-5.75h-.75a.5.5,0,0,0-.5.5V15a.25.25,0,0,1-.25.25H11.14a6,6,0,0,0,.36-1.75,4.07,4.07,0,0,0,0-.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H11a4.08,4.08,0,0,1-.2-1,1.25,1.25,0,0,1,2.45-.36.5.5,0,0,0,.48.36h.77a.53.53,0,0,0,.39-.18.53.53,0,0,0,.1-.42A3,3,0,0,0,9,10a4.38,4.38,0,0,0,.14,1H8.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H9.69a2.2,2.2,0,0,1,.06.5A8.31,8.31,0,0,1,9,16a.51.51,0,0,0,.09.54l.26.29a.52.52,0,0,0,.37.16H14a2,2,0,0,0,2-2v-.25A.5.5,0,0,0,15.5,14.25Z"]
  };
  
  var receipt = {
    prefix: 'axis',
    iconName: 'receipt',
    icon: [24, 24, [], "f0000", "M6.18,21.85a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L9,20a.51.51,0,0,1,.71,0l1.81,1.81a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L14.32,20A.51.51,0,0,1,15,20l1.81,1.81a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L19.71,20a1,1,0,0,0,.29-.7V3a1,1,0,0,0-1-1H5A1,1,0,0,0,4,3V19.26a1.05,1.05,0,0,0,.29.71ZM13,13.5a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5Zm3-4a.5.5,0,0,1-.5.5h-7A.5.5,0,0,1,8,9.5v-1A.5.5,0,0,1,8.5,8h7a.5.5,0,0,1,.5.5Z"]
  };
  
  var receiptOutlined = {
    prefix: 'axis',
    iconName: 'receiptOutlined',
    icon: [24, 24, [], "f0000", "M13,13.5a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5Zm3-4a.5.5,0,0,1-.5.5h-7A.5.5,0,0,1,8,9.5v-1A.5.5,0,0,1,8.5,8h7a.5.5,0,0,1,.5.5ZM19,2H5A1,1,0,0,0,4,3V19.26a1.05,1.05,0,0,0,.29.71l1.89,1.88a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L9,20a.5.5,0,0,1,.35-.15A.51.51,0,0,1,9.7,20l1.81,1.81a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L14.32,20a.5.5,0,0,1,.35-.15A.51.51,0,0,1,15,20l1.81,1.81a.47.47,0,0,0,.35.15h.29a.47.47,0,0,0,.35-.15L19.71,20a1,1,0,0,0,.29-.7V3A1,1,0,0,0,19,2ZM18,18.86l-.66.66h0l-.74-.73-.16-.16h0l-.34-.34a1,1,0,0,0-.7-.29H14a1,1,0,0,0-.71.29L12,19.53l-1.24-1.24a1,1,0,0,0-.7-.29H8.61a1,1,0,0,0-.7.29L6.68,19.52h0L6,18.84V4H18Z"]
  };
  
  var saving = {
    prefix: 'axis',
    iconName: 'saving',
    icon: [24, 24, [], "f0000", "M21,10a2,2,0,0,0-2-2H15.45A4,4,0,0,0,16,6h3a2,2,0,0,0-2-2H15.45a4,4,0,0,0-6.9,0H6A3,3,0,0,0,3,7V20a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM12,4a2,2,0,1,1-2,2A2,2,0,0,1,12,4ZM5,7A1,1,0,0,1,6,6H8a4,4,0,0,0,.55,2H6A1,1,0,0,1,5,7ZM19,18H12a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1h7Zm-6-2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5Z"]
  };
  
  var savingOutlined = {
    prefix: 'axis',
    iconName: 'savingOutlined',
    icon: [24, 24, [], "f0000", "M19,8H15.45A4,4,0,0,0,16,6h3a2,2,0,0,0-2-2H15.45a4,4,0,0,0-6.9,0H6A3,3,0,0,0,3,7V20a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V10A2,2,0,0,0,19,8ZM12,4a2,2,0,1,1-2,2A2,2,0,0,1,12,4ZM6,6H8a4,4,0,0,0,.55,2H6A1,1,0,0,1,6,6Zm13,6H12a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h7v2H5V10H19Zm-4,2.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,15,14.5Z"]
  };
  
  var savings = {
    prefix: 'axis',
    iconName: 'savings',
    icon: [24, 24, [], "f0000", "M9,10A4,4,0,1,0,5,6,4,4,0,0,0,9,10ZM9,4A2,2,0,1,1,7,6,2,2,0,0,1,9,4Zm6.75,10.42L17,13.17V10a1,1,0,0,0-2,0v3.5A2.48,2.48,0,0,1,15.75,14.42Zm5-2.13a1,1,0,0,0-1.42,0L16,15.59h0A2.5,2.5,0,0,1,13.5,18h-4a.5.5,0,0,1,0-1h4l.23,0h0A1.49,1.49,0,0,0,15,15.35,1.57,1.57,0,0,0,13.4,14H8.71a3.32,3.32,0,0,0-2.59.91L3.29,17.82a1,1,0,0,0,0,1.41l2.48,2.48a1,1,0,0,0,1.41,0L8.6,20.29A1,1,0,0,1,9.3,20h4.08a2.51,2.51,0,0,0,1.77-.73l5.56-5.56A1,1,0,0,0,20.71,12.29Z"]
  };
  
  var visa = {
    prefix: 'axis',
    iconName: 'visa',
    icon: [24, 24, [], "f0000", "M21,4.7,14.38,19.41a1,1,0,0,1-.92.59H10.09a1,1,0,0,1-1-.73L5.78,7.36a3,3,0,0,0-1.6-1.91,20,20,0,0,0-2-.79A.26.26,0,0,1,2,4.42V4.25A.25.25,0,0,1,2.25,4H7.92c1,0,1.77.27,2,1.33l1.59,7.51.44,2.3L16.24,4.62A1,1,0,0,1,17.17,4H20.5A.5.5,0,0,1,21,4.7Z"]
  };
  
  var wallet = {
    prefix: 'axis',
    iconName: 'wallet',
    icon: [24, 24, [], "f0000", "M19,7H6A1,1,0,0,1,6,5H19a2,2,0,0,0-2-2H6A3,3,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V9A2,2,0,0,0,19,7Zm0,10H12a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h7Zm-5.5-2h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,13.5,15Z"]
  };
  
  var walletOutlined = {
    prefix: 'axis',
    iconName: 'walletOutlined',
    icon: [24, 24, [], "f0000", "M19,7H6A1,1,0,0,1,6,5H19a2,2,0,0,0-2-2H6A3,3,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V9A2,2,0,0,0,19,7ZM5,19V9H19v2H12a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h7v2Zm10-5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,15,13.5Z"]
  };
  
  var accessibility = {
    prefix: 'axis',
    iconName: 'accessibility',
    icon: [24, 24, [], "f0000", "M21,6.5v1a.5.5,0,0,1-.5.5H15V22.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V15H11v7.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V8H3.5A.5.5,0,0,1,3,7.5v-1A.5.5,0,0,1,3.5,6h17A.5.5,0,0,1,21,6.5ZM12,5a2,2,0,1,0-2-2A2,2,0,0,0,12,5Z"]
  };
  
  var accessibilityVs = {
    prefix: 'axis',
    iconName: 'accessibilityVs',
    icon: [24, 24, [], "f0000", "M10,3a2,2,0,1,1,2,2A2,2,0,0,1,10,3ZM21.16,5.47l-.32-.94a.49.49,0,0,0-.63-.32L15.92,5.64A7,7,0,0,1,13.7,6H10.29a7,7,0,0,1-2.21-.36L3.79,4.21a.49.49,0,0,0-.63.32l-.32.94a.51.51,0,0,0,.32.64L7.45,7.54A8.49,8.49,0,0,0,9,7.9V22.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V15h2v7.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V7.9a9.4,9.4,0,0,0,1.55-.36l4.29-1.43A.51.51,0,0,0,21.16,5.47Z"]
  };
  
  var accessible = {
    prefix: 'axis',
    iconName: 'accessible',
    icon: [24, 24, [], "f0000", "M9,4c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S9,5.1,9,4z M20,21.4l-1.5-5.2C18.1,14.9,17,14,15.6,14H13v-3c0.7,0.6,1.6,1,2.6,1h1.9c0.3,0,0.5-0.2,0.5-0.5v-1c0-0.3-0.2-0.5-0.5-0.5h-1.9c-0.7,0-1.3-0.3-1.7-0.9l-0.8-1.2c-0.4-0.6-1-0.9-1.7-0.9H11C9.9,7,9,7.9,9,9v5.5c0,0.8,0.7,1.5,1.5,1.5l0,0h4.7c0.7,0,1.3,0.4,1.5,1.1l1.3,4.5c0.1,0.2,0.3,0.4,0.5,0.4h1c0.3,0,0.5-0.2,0.5-0.5C20,21.5,20,21.4,20,21.4z M12,17c0,1.7-1.3,3-3,3s-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8v-2.1c-2.7,0.6-4.5,3.2-3.9,5.9s3.2,4.5,5.9,3.9c2.3-0.5,4-2.5,4-4.9H12z"]
  };
  
  var accessibleForward = {
    prefix: 'axis',
    iconName: 'accessibleForward',
    icon: [24, 24, [], "f0000", "M15,4.5a2,2,0,1,1,2,2A2,2,0,0,1,15,4.5Zm1.12,5.34A2,2,0,0,0,14.3,7H10.53A3,3,0,0,0,7.81,8.73l-.73,1.56a.5.5,0,0,0,.46.71h1.1a.48.48,0,0,0,.45-.29l.53-1.13A1,1,0,0,1,10.53,9H12.1l-1.94,4.15A2,2,0,0,0,12,16H16.5a.5.5,0,0,1,.5.5v5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V16a2,2,0,0,0-2-2H14.18ZM10,20a3,3,0,0,1-1-5.82V12.1A5,5,0,1,0,15,17H13A3,3,0,0,1,10,20Z"]
  };
  
  var hiking = {
    prefix: 'axis',
    iconName: 'hiking',
    icon: [24, 24, [], "f0000", "M7.7,15.18l1.75,1.17-.24.84a3.06,3.06,0,0,1-.49,1l-2,2.62a.5.5,0,0,1-.7.1l-.79-.61a.51.51,0,0,1-.1-.7l2-2.62a1,1,0,0,0,.16-.33ZM11,5A2,2,0,1,0,9,3,2,2,0,0,0,11,5ZM5.83,5H4.12a1,1,0,0,0-1,.72L2,9.7a1,1,0,0,0,.46,1.14l1.45.84a.5.5,0,0,0,.73-.3L6.31,5.64A.5.5,0,0,0,5.83,5ZM18.49,4h-1a.5.5,0,0,0-.5.51L17.07,9h-.84a2.06,2.06,0,0,1-1.1-.34L11.92,6.51A3,3,0,0,0,10.25,6H9.8A2,2,0,0,0,7.87,7.45L6.69,11.57a1,1,0,0,0,.41,1.11l4.57,3a.78.78,0,0,1,.33.63V22.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V16a2,2,0,0,0-.89-1.67l-2.55-1.7h0L11.65,8.8l2.22,1.44a4.46,4.46,0,0,0,2.34.76h.88l.15,11.51a.51.51,0,0,0,.5.49h.52a.51.51,0,0,0,.5-.49l.23-18A.5.5,0,0,0,18.49,4Z"]
  };
  
  var man = {
    prefix: 'axis',
    iconName: 'man',
    icon: [24, 24, [], "f0000", "M10,3a2,2,0,1,1,2,2A2,2,0,0,1,10,3Zm5.41,4.36-.77-.77A2,2,0,0,0,13.22,6H10.78a2,2,0,0,0-1.42.59l-.77.77A2,2,0,0,0,8,8.78V13.5a.5.5,0,0,0,.5.5H9v8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V15h2v7.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h.5a.5.5,0,0,0,.5-.5V8.78A2,2,0,0,0,15.41,7.36Z"]
  };
  
  var pregnancy = {
    prefix: 'axis',
    iconName: 'pregnancy',
    icon: [24, 24, [], "f0000", "M8,10a3,3,0,0,1,3-3,3,3,0,0,1,3,3.11v.07A3,3,0,0,1,16,13v3.5a.5.5,0,0,1-.5.5H13v5.5a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5V17H8.5a.5.5,0,0,1-.5-.5ZM9.5,5h3a.5.5,0,0,0,.5-.5V3A2,2,0,0,0,9,3V4.5A.5.5,0,0,0,9.5,5Z"]
  };
  
  var running = {
    prefix: 'axis',
    iconName: 'running',
    icon: [24, 24, [], "f0000", "M15,4a2,2,0,1,1,2,2A2,2,0,0,1,15,4Zm5.6,6.75-1.93-.39A1,1,0,0,1,18.1,10L15.88,7.41A4,4,0,0,0,12.83,6H9.77a2,2,0,0,0-1.61.82L6.48,9.13a.5.5,0,0,0,.12.7l.8.58a.49.49,0,0,0,.7-.11l1.45-2A.77.77,0,0,1,10.16,8h1.55L9.29,11.21l-.16.22a1,1,0,0,0,.24,1.43l4.3,2.86a.78.78,0,0,1,.33.63V21.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V16a2,2,0,0,0-.89-1.67L13,12.89l2.3-3.05,1.25,1.48a3,3,0,0,0,1.7,1l2.12.42a.5.5,0,0,0,.6-.49v-1A.5.5,0,0,0,20.6,10.75ZM8.37,15.7a.74.74,0,0,1-.6.3H4.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H8.15a2,2,0,0,0,1.6-.8l1-1.33L9.06,14.76Z"]
  };
  
  var standing = {
    prefix: 'axis',
    iconName: 'standing',
    icon: [24, 24, [], "f0000", "M10,3a2,2,0,1,1,2,2A2,2,0,0,1,10,3Zm9.45,9L15.67,7.44A4,4,0,0,0,12.59,6H11.41A4,4,0,0,0,8.33,7.44L4.55,12a.5.5,0,0,0,.07.7l.76.64a.51.51,0,0,0,.71-.06L9,9.76V22.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V15h2v7.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V9.76l2.91,3.5a.51.51,0,0,0,.71.06l.76-.64A.5.5,0,0,0,19.45,12Z"]
  };
  
  var swimming = {
    prefix: 'axis',
    iconName: 'swimming',
    icon: [24, 24, [], "f0000", "M15,6.5A2.5,2.5,0,1,1,17.5,9,2.51,2.51,0,0,1,15,6.5ZM21.46,15c-2.15.12-2.49,1-4.46,1-2.16,0-2.35-1-5-1s-2.87,1-5,1-2.31-.86-4.46-1a.5.5,0,0,0-.54.5v1a.5.5,0,0,0,.45.5c1.74.12,2.09,1,4.55,1,2.71,0,2.77-1,5-1s2.36,1,5,1c2.45,0,2.83-.86,4.55-1a.5.5,0,0,0,.45-.5v-1A.5.5,0,0,0,21.46,15Zm0,4c-2.15.12-2.49,1-4.46,1-2.16,0-2.35-1-5-1s-2.87,1-5,1-2.31-.86-4.46-1a.5.5,0,0,0-.54.5v1a.5.5,0,0,0,.45.5c1.74.12,2.09,1,4.55,1,2.71,0,2.77-1,5-1s2.36,1,5,1c2.45,0,2.83-.86,4.55-1a.5.5,0,0,0,.45-.5v-1A.5.5,0,0,0,21.46,19ZM5.5,7.5H8.61A2,2,0,0,1,10,8.09L11,9,6.11,13.89A3.22,3.22,0,0,0,7,14c1.4,0,2.11-1,5-1s3.56,1,5,1a5,5,0,0,0,2-.51l-7-7A5,5,0,0,0,8.41,5H5.5a.5.5,0,0,0-.5.5V7A.5.5,0,0,0,5.5,7.5Z"]
  };
  
  var walking = {
    prefix: 'axis',
    iconName: 'walking',
    icon: [24, 24, [], "f0000", "M19,10.23v1a.5.5,0,0,1-.6.49l-2.14-.43a3.07,3.07,0,0,1-1.69-1l-1-1.12-.81,4.69,1.45,1.38a2.07,2.07,0,0,1,.58,1l1.27,6.09a.49.49,0,0,1-.49.6h-1a.49.49,0,0,1-.49-.4L12.94,17a1,1,0,0,0-.3-.54L9.31,13.32a1,1,0,0,1-.3-.9l.64-3.71-1.26.84a1,1,0,0,0-.41.56l-.72,2.53a.5.5,0,0,1-.48.36h-1a.5.5,0,0,1-.48-.64L6.16,9.2A2,2,0,0,1,7,8.08L8.87,6.83A5,5,0,0,1,11.63,6h.51a3,3,0,0,1,2.29,1.06L16.1,9a1,1,0,0,0,.57.34l1.93.38A.5.5,0,0,1,19,10.23ZM9.42,15.84l0,.11a1,1,0,0,1-.23.49L6.46,19.51a.5.5,0,0,0,0,.7l.76.67a.49.49,0,0,0,.7-.05l2.89-3.28a1.56,1.56,0,0,0,.16-.2ZM13,5a2,2,0,1,0-2-2A2,2,0,0,0,13,5Z"]
  };
  
  var woman = {
    prefix: 'axis',
    iconName: 'woman',
    icon: [24, 24, [], "f0000", "M15,17v5.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V17H11v5.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V17H7.5A.5.5,0,0,1,7,16.36L9.61,7.71a1,1,0,0,1,1-.71h2.86a1,1,0,0,1,1,.71L17,16.36a.5.5,0,0,1-.48.64ZM10.5,5h3a.5.5,0,0,0,.5-.5V3a2,2,0,0,0-4,0V4.5A.5.5,0,0,0,10.5,5Z"]
  };
  
  var award = {
    prefix: 'axis',
    iconName: 'award',
    icon: [24, 24, [], "f0000", "M20,4H17V3a1,1,0,0,0-1-1H8A1,1,0,0,0,7,3V4H4A1,1,0,0,0,3,5V9a4,4,0,0,0,4,4h.14A4,4,0,0,0,11,16v4H8.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H13V16a4,4,0,0,0,3.86-3H17a4,4,0,0,0,4-4V5A1,1,0,0,0,20,4ZM5,9V6H7v5A2,2,0,0,1,5,9ZM19,9a2,2,0,0,1-2,2V6h2Z"]
  };
  
  var awardOutlined = {
    prefix: 'axis',
    iconName: 'awardOutlined',
    icon: [24, 24, [], "f0000", "M20,4H17V3a1,1,0,0,0-1-1H8A1,1,0,0,0,7,3V4H4A1,1,0,0,0,3,5V9a4,4,0,0,0,4,4h.14A4,4,0,0,0,11,16v4H8.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H13V16a4,4,0,0,0,3.86-3H17a4,4,0,0,0,4-4V5A1,1,0,0,0,20,4ZM5,9V6H7v5A2,2,0,0,1,5,9Zm10,3a2,2,0,0,1-2,2H11a2,2,0,0,1-2-2V4h6Zm4-3a2,2,0,0,1-2,2V6h2Z"]
  };
  
  var boost = {
    prefix: 'axis',
    iconName: 'boost',
    icon: [24, 24, [], "f0000", "M22.9,20.39a.79.79,0,0,0,0-.76L12.81,2.37A.76.76,0,0,0,12.16,2h-.3a.76.76,0,0,0-.65.37L1.1,19.63a.79.79,0,0,0,0,.76l.14.23a.73.73,0,0,0,.65.38H22.11a.73.73,0,0,0,.65-.38ZM15,12.68a.59.59,0,0,1-.07.26l-3,4.84a.44.44,0,0,1-.39.22H11.5a.48.48,0,0,1-.35-.16.47.47,0,0,1-.1-.36l.34-2.41H9.5a.5.5,0,0,1-.5-.5v-.16a.59.59,0,0,1,.07-.26l3-4.91A.51.51,0,0,1,12.52,9a.48.48,0,0,1,.35.16.47.47,0,0,1,.1.36L12.61,12H14.5a.5.5,0,0,1,.5.5Z"]
  };
  
  var crown = {
    prefix: 'axis',
    iconName: 'crown',
    icon: [24, 24, [], "f0000", "M21.5,5h-.38a1.5,1.5,0,0,0-1.06.44L17,8.5,12.72,4.22A.75.75,0,0,0,12.19,4h-.38a.75.75,0,0,0-.53.22L7,8.5,3.94,5.44A1.5,1.5,0,0,0,2.88,5H2.5a.5.5,0,0,0-.5.5v10a.5.5,0,0,0,.5.5h19a.5.5,0,0,0,.5-.5V5.5A.5.5,0,0,0,21.5,5ZM12,13a2,2,0,1,1,2-2A2,2,0,0,1,12,13Zm9.5,5H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h19a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,18Z"]
  };
  
  var crownOutlined = {
    prefix: 'axis',
    iconName: 'crownOutlined',
    icon: [24, 24, [], "f0000", "M22,18.5v1a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h19A.5.5,0,0,1,22,18.5Zm0-13v10a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,2.5,5h.38a1.5,1.5,0,0,1,1.06.44L7,8.5l4.28-4.28A.75.75,0,0,1,11.81,4h.38a.75.75,0,0,1,.53.22L17,8.5l3.06-3.06A1.5,1.5,0,0,1,21.12,5h.38A.5.5,0,0,1,22,5.5ZM20,8.33l-2,2a.49.49,0,0,1-.36.15H16.38a.49.49,0,0,1-.36-.15l-4-4-4,4a.49.49,0,0,1-.36.15H6.38A.49.49,0,0,1,6,10.35l-2-2V14H20Z"]
  };
  
  var diamond = {
    prefix: 'axis',
    iconName: 'diamond',
    icon: [24, 24, [], "f0000", "M21.74,8.16,17.59,3.65A2,2,0,0,0,16.12,3H7.88a2,2,0,0,0-1.47.65L2.26,8.16A1,1,0,0,0,2,8.84v.3a1,1,0,0,0,.23.64l9,10.86A1,1,0,0,0,12,21H12a1,1,0,0,0,.77-.36l9-10.86A1,1,0,0,0,22,9.14v-.3A1,1,0,0,0,21.74,8.16ZM11.18,17.47l-6.65-8A.25.25,0,0,1,4.72,9H8.27a1,1,0,0,1,1,.69l2.39,7.55A.25.25,0,0,1,11.18,17.47ZM19.24,9H13.07a.25.25,0,0,1-.19-.42L15.94,5.2a.25.25,0,0,1,.37,0l3.11,3.38A.25.25,0,0,1,19.24,9Z"]
  };
  
  var diamondOutlined = {
    prefix: 'axis',
    iconName: 'diamondOutlined',
    icon: [24, 24, [], "f0000", "M21.74,8.16,17.59,3.65A2,2,0,0,0,16.12,3H7.88a2,2,0,0,0-1.47.65L2.26,8.16A1,1,0,0,0,2,8.84v.3a1,1,0,0,0,.23.64l9,10.86A1,1,0,0,0,12,21H12a1,1,0,0,0,.77-.36l9-10.86A1,1,0,0,0,22,9.14v-.3A1,1,0,0,0,21.74,8.16ZM12,18.46,9.22,9.7a1,1,0,0,0-1-.7H4.21L7.88,5h8.24l0,0L13.26,8.16a.5.5,0,0,0,.37.84h6.16l0,0Z"]
  };
  
  var dnaSpiral = {
    prefix: 'axis',
    iconName: 'dnaSpiral',
    icon: [24, 24, [], "f0000", "M16,9.46a7,7,0,0,0,2.05-5v-2a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v2A3.87,3.87,0,0,1,16,5H8.05A3.87,3.87,0,0,1,8,4.51v-2A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5v2a7,7,0,0,0,2.05,5L10.59,12,8.05,14.54A7,7,0,0,0,6,19.49v2a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-2A3.87,3.87,0,0,1,8.05,19H16a3.87,3.87,0,0,1,.05.49v2a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-2A7,7,0,0,0,16,14.54l-1.3-1.3-1.41,1.41,1.3,1.3A5,5,0,0,1,15.32,17H8.69A4.65,4.65,0,0,1,9.46,16ZM9.46,8.05A5,5,0,0,1,8.68,7h6.63a4.65,4.65,0,0,1-.77,1.05L12,10.59Z"]
  };
  
  var luck = {
    prefix: 'axis',
    iconName: 'luck',
    icon: [24, 24, [], "f0000", "M20,12.12a2.27,2.27,0,0,1-2.13,2.25h0a.25.25,0,0,0-.24.25v.13a2.25,2.25,0,0,1-4.44.49h0L13,14.57a.11.11,0,0,0-.11-.08.11.11,0,0,0-.09.1l0,1.47,0,1.48v.77a5.51,5.51,0,0,1-.1.9,5,5,0,0,1-1.48,2.65.51.51,0,0,1-.77-.07L10,21a.5.5,0,0,1,.06-.65A3.08,3.08,0,0,0,11,18.81a2.1,2.1,0,0,0,.08-.56l0-.71,0-1.48,0-1.47a.11.11,0,0,0-.09-.1.11.11,0,0,0-.11.08l-.15.67h0a2.25,2.25,0,0,1-4.44-.49v-.12h0a.25.25,0,0,0-.24-.25A2.25,2.25,0,0,1,6,9.89H6c.17-.05.61,0,.61-.29s-.43-.26-.73-.37h0a2.39,2.39,0,0,1,.52-4.72h.15a.24.24,0,0,0,.25-.25,2.39,2.39,0,0,1,4.76-.15h0l.2,1.71a.25.25,0,0,0,.5,0l.2-1.71h0a2.39,2.39,0,0,1,4.76.16.25.25,0,0,0,.25.24h.15a2.39,2.39,0,0,1,.52,4.72h0c-.31.11-.73,0-.73.37s.45.25.61.29h0A2.25,2.25,0,0,1,20,12.12Z"]
  };
  
  var medal = {
    prefix: 'axis',
    iconName: 'medal',
    icon: [24, 24, [], "f0000", "M19.81,9.05a2.43,2.43,0,0,0-.49-.75L19.07,8a2.39,2.39,0,0,1-.49-.74,2.44,2.44,0,0,1-.19-.88V6a2.35,2.35,0,0,0-.19-.88A2.46,2.46,0,0,0,16,3.62h-.37A2.5,2.5,0,0,1,14,2.93l-.27-.26a2.48,2.48,0,0,0-3.4,0L10,2.93a2.45,2.45,0,0,1-1.62.68H8A2.48,2.48,0,0,0,5.62,6v.37A2.5,2.5,0,0,1,4.93,8l-.26.27A2.5,2.5,0,0,0,4.19,11a2.43,2.43,0,0,0,.49.75l.25.28a2.32,2.32,0,0,1,.49.75,2.34,2.34,0,0,1,.19.87V14a2.35,2.35,0,0,0,.19.88A2.48,2.48,0,0,0,8,16.38V21.5a.5.5,0,0,0,.5.5h.26a1,1,0,0,0,.45-.11l2.57-1.28a.49.49,0,0,1,.44,0l2.57,1.28a1,1,0,0,0,.45.11h.26a.5.5,0,0,0,.5-.5V16.38A2.48,2.48,0,0,0,18.38,14v-.37A2.5,2.5,0,0,1,19.07,12l.26-.27A2.5,2.5,0,0,0,19.81,9.05Zm-1.93,1.27-.27.28a4.55,4.55,0,0,0-1.22,3v.37a.48.48,0,0,1-.49.46l-.34,0a4.39,4.39,0,0,0-2.93,1.2l-.29.27A.48.48,0,0,1,12,16a.45.45,0,0,1-.32-.12l-.28-.27a4.55,4.55,0,0,0-3-1.22H8.08a.45.45,0,0,1-.42-.29.37.37,0,0,1,0-.2l0-.34A4.35,4.35,0,0,0,7.27,12a4.25,4.25,0,0,0-.87-1.34l-.27-.29A.6.6,0,0,1,6,10.18a.46.46,0,0,1,.08-.5l.27-.28A4.55,4.55,0,0,0,7.61,6.45V6.08a.48.48,0,0,1,.49-.46h.34A4.45,4.45,0,0,0,11.38,4.4l.29-.27A.48.48,0,0,1,12,4a.45.45,0,0,1,.32.12l.28.27a4.55,4.55,0,0,0,3,1.22h.37a.45.45,0,0,1,.42.29.37.37,0,0,1,0,.2l0,.34A4.35,4.35,0,0,0,16.73,8a4.25,4.25,0,0,0,.87,1.34l.27.29a.6.6,0,0,1,.09.15A.46.46,0,0,1,17.88,10.32Z"]
  };
  
  var planet = {
    prefix: 'axis',
    iconName: 'planet',
    icon: [24, 24, [], "f0000", "M22.88,7.57C22.53,6.62,21.52,6,19.57,6a16,16,0,0,0-3.34.43A7,7,0,0,0,5.17,10.48c-3.58,1.92-4.55,3.59-4,4.95.63,1.71,3.09,1.79,5.76,1.32A7,7,0,0,0,19,12.45C22.43,10.56,23.37,8.91,22.88,7.57ZM5.05,12.81a4.93,4.93,0,0,0,.11.67,18.22,18.22,0,0,0,2-.34A5.38,5.38,0,0,1,7,12a5,5,0,0,1,9.92-.75c-1.24.6-2.72,1.23-4.34,1.82A43.23,43.23,0,0,1,7.7,14.55h0a18.84,18.84,0,0,1-2.06.38h0C2.85,15.3,2.07,14.58,5.05,12.81ZM12,17a4.94,4.94,0,0,1-2.69-.8c1.52-.41,2.95-.9,3.95-1.26,1.31-.48,2.46-.94,3.47-1.39A5,5,0,0,1,12,17Zm6.78-6.73a7.34,7.34,0,0,0-.94-2.14C22,7.43,21.57,8.63,18.78,10.27Z"]
  };
  
  var premium = {
    prefix: 'axis',
    iconName: 'premium',
    icon: [24, 24, [], "f0000", "M22,8.84v.3a1,1,0,0,1-.23.64l-9,10.86A1,1,0,0,1,12,21H12a1,1,0,0,1-.77-.36l-9-10.86A1,1,0,0,1,2,9.14v-.3a1,1,0,0,1,.26-.68L6.41,3.65A2,2,0,0,1,7.88,3h8.24a2,2,0,0,1,1.47.65l4.15,4.51A1,1,0,0,1,22,8.84Z"]
  };
  
  var premiumOutlined = {
    prefix: 'axis',
    iconName: 'premiumOutlined',
    icon: [24, 24, [], "f0000", "M16.12,5h0l3.69,4L12,18.46,4.19,9,7.88,5h8.24m0-2H7.88a2,2,0,0,0-1.47.65L2.26,8.16A1,1,0,0,0,2,8.84v.3a1,1,0,0,0,.23.64l9,10.86A1,1,0,0,0,12,21H12a1,1,0,0,0,.77-.36l9-10.86A1,1,0,0,0,22,9.14v-.3a1,1,0,0,0-.26-.68L17.59,3.65A2,2,0,0,0,16.12,3Z"]
  };
  
  var robot = {
    prefix: 'axis',
    iconName: 'robot',
    icon: [24, 24, [], "f0000", "M6,11A2,2,0,0,1,8,9h8a2,2,0,0,1,2,2v7a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2Zm6-9a2,2,0,0,0-2,2,2,2,0,0,0,1,1.72V7H8a4,4,0,0,0-4,4v2a2,2,0,0,0,0,4v1a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4V17a2,2,0,0,0,0-4V11a4,4,0,0,0-4-4H13V5.72a2,2,0,0,0-.57-3.67A1.58,1.58,0,0,0,12,2ZM11,12.5a1.5,1.5,0,0,0-3,0,.5.5,0,0,0,.5.5h2A.5.5,0,0,0,11,12.5ZM14.5,11A1.5,1.5,0,0,0,13,12.5a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5A1.5,1.5,0,0,0,14.5,11ZM14,15H10a1,1,0,0,0-1,1H9a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2h0A1,1,0,0,0,14,15Z"]
  };
  
  var sticker = {
    prefix: 'axis',
    iconName: 'sticker',
    icon: [24, 24, [], "f0000", "M12,2C6.5,2,2,6.5,2,12c0,5.2,4,9.5,9,10c0.1,0,0.1,0,0.2,0c0.5,0,1-0.2,1.4-0.6l8.8-8.8c0.4-0.4,0.6-1,0.6-1.6C21.5,6,17.2,2,12,2z M12,19.2V18c0-3.3,2.7-6,6-6h1.3L12,19.2z"]
  };
  
  var stickerOutlined = {
    prefix: 'axis',
    iconName: 'stickerOutlined',
    icon: [24, 24, [], "f0000", "M12,2C6.5,2,2,6.5,2,12c0,5.2,4,9.5,9,10c0.1,0,0.1,0,0.2,0c0.5,0,1-0.2,1.4-0.6l8.8-8.8c0.4-0.4,0.6-1,0.6-1.6C21.5,6,17.2,2,12,2z M4,12c0-4.4,3.6-8,8-8c3.7,0,6.8,2.5,7.8,6H18c-4.4,0-8,3.6-8,8v1.8C6.5,18.9,4,15.7,4,12z M12,19.2V18c0-3.3,2.7-6,6-6h1.3L12,19.2z"]
  };
  
  var topSecurity = {
    prefix: 'axis',
    iconName: 'topSecurity',
    icon: [24, 24, [], "f0000", "M20.12,5.12,16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09V7.24A3,3,0,0,0,20.12,5.12Zm-3.75,5-2,1.7L15,14.38a.5.5,0,0,1-.74.55L12,13.56,9.75,14.93A.5.5,0,0,1,9,14.38l.61-2.54-2-1.7a.51.51,0,0,1,.29-.88l2.6-.2,1-2.43a.5.5,0,0,1,.92,0l1,2.43,2.6.2A.51.51,0,0,1,16.37,10.14Z"]
  };
  
  var topSecurityOutlined = {
    prefix: 'axis',
    iconName: 'topSecurityOutlined',
    icon: [24, 24, [], "f0000", "M20.12,5.12,16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09V7.24A3,3,0,0,0,20.12,5.12Zm-1.12,8a5.93,5.93,0,0,1-2.32,4.73L12.6,21H11.4L7.32,17.82A5.93,5.93,0,0,1,5,13.09V7.24a1,1,0,0,1,.29-.7L8.83,3h6.34l3.54,3.54a1,1,0,0,1,.29.7ZM16.08,9.26l-2.6-.2-1-2.43a.5.5,0,0,0-.92,0l-1,2.43-2.6.2a.51.51,0,0,0-.29.88l2,1.7L9,14.38a.5.5,0,0,0,.74.55L12,13.56l2.25,1.37a.5.5,0,0,0,.74-.55l-.61-2.54,2-1.7A.51.51,0,0,0,16.08,9.26Z"]
  };
  
  var verified = {
    prefix: 'axis',
    iconName: 'verified',
    icon: [24, 24, [], "f0000", "M21.61,13.16a3.2,3.2,0,0,1,0-2.32l.17-.46a3.27,3.27,0,0,0-1.71-4.15L19.62,6A3.31,3.31,0,0,1,18,4.38l-.2-.45a3.27,3.27,0,0,0-4.15-1.71l-.46.17a3.2,3.2,0,0,1-2.32,0l-.46-.17A3.27,3.27,0,0,0,6.23,3.93L6,4.38A3.31,3.31,0,0,1,4.38,6l-.45.2a3.27,3.27,0,0,0-1.71,4.15l.17.46a3.2,3.2,0,0,1,0,2.32l-.17.46a3.27,3.27,0,0,0,1.71,4.15l.45.2A3.31,3.31,0,0,1,6,19.62l.2.45a3.27,3.27,0,0,0,4.15,1.71l.46-.17a3.2,3.2,0,0,1,2.32,0l.46.17a3.27,3.27,0,0,0,4.15-1.71l.2-.45A3.31,3.31,0,0,1,19.62,18l.45-.2a3.27,3.27,0,0,0,1.71-4.15ZM16.35,9.73l-5.62,5.62a.48.48,0,0,1-.7,0L7.65,13a.5.5,0,0,1,0-.71l.53-.53a.48.48,0,0,1,.7,0l1.5,1.49,4.74-4.74a.5.5,0,0,1,.7,0l.53.53A.5.5,0,0,1,16.35,9.73Z"]
  };
  
  var verifiedOutlined = {
    prefix: 'axis',
    iconName: 'verifiedOutlined',
    icon: [24, 24, [], "f0000", "M14.79,4a1.25,1.25,0,0,1,1.15.74l.21.46a5.3,5.3,0,0,0,2.66,2.66l.44.19a1.29,1.29,0,0,1,.66,1.64l-.16.43a5.16,5.16,0,0,0,0,3.73l.17.49a1.25,1.25,0,0,1-.65,1.6l-.46.21a5.3,5.3,0,0,0-2.66,2.66l-.19.44a1.27,1.27,0,0,1-1.16.75,1.45,1.45,0,0,1-.48-.09l-.43-.16A5.06,5.06,0,0,0,12,19.4a5,5,0,0,0-1.85.34l-.49.17a1.17,1.17,0,0,1-.45.09,1.25,1.25,0,0,1-1.15-.74l-.21-.46a5.3,5.3,0,0,0-2.66-2.66L4.75,16a1.29,1.29,0,0,1-.66-1.64l.16-.43a5.16,5.16,0,0,0,0-3.73l-.17-.49a1.25,1.25,0,0,1,.65-1.6l.46-.21A5.3,5.3,0,0,0,7.86,5.19l.19-.44A1.27,1.27,0,0,1,9.21,4a1.45,1.45,0,0,1,.48.09l.43.16A5.06,5.06,0,0,0,12,4.6a5,5,0,0,0,1.85-.34l.49-.17A1.17,1.17,0,0,1,14.79,4m0-2a3.23,3.23,0,0,0-1.17.22l-.46.17A3.3,3.3,0,0,1,12,2.6a3.3,3.3,0,0,1-1.16-.21l-.46-.17A3.26,3.26,0,0,0,6.23,3.93L6,4.38A3.31,3.31,0,0,1,4.38,6l-.45.2a3.27,3.27,0,0,0-1.71,4.15l.17.46a3.2,3.2,0,0,1,0,2.32l-.17.46a3.27,3.27,0,0,0,1.71,4.15l.45.2A3.31,3.31,0,0,1,6,19.62l.2.45a3.26,3.26,0,0,0,4.15,1.71l.46-.17a3.31,3.31,0,0,1,2.32,0l.46.17a3.26,3.26,0,0,0,4.15-1.71l.2-.45A3.31,3.31,0,0,1,19.62,18l.45-.2a3.27,3.27,0,0,0,1.71-4.15l-.17-.46a3.2,3.2,0,0,1,0-2.32l.17-.46a3.27,3.27,0,0,0-1.71-4.15L19.62,6A3.31,3.31,0,0,1,18,4.38l-.2-.45a3.26,3.26,0,0,0-3-1.93Zm.68,6.35a.5.5,0,0,0-.35.14l-4.74,4.74-1.5-1.49a.48.48,0,0,0-.7,0l-.53.53a.5.5,0,0,0,0,.71L10,15.35a.47.47,0,0,0,.35.15.49.49,0,0,0,.35-.15l5.62-5.62a.5.5,0,0,0,0-.71l-.53-.53a.5.5,0,0,0-.35-.14Z"]
  };
  
  var appstore = {
    prefix: 'axis',
    iconName: 'appstore',
    icon: [24, 24, [], "f0000", "M4.2,19l-0.1,0.1c-0.4,0.6-0.2,1.4,0.4,1.7s1.4,0.2,1.7-0.4c0,0,0.1-0.1,0.1-0.1l1.2-2.1h-2C5,18.2,4.5,18.5,4.2,19zM11.7,14.5h-2l5.6-9.6c0.4-0.6,0.2-1.4-0.4-1.7s-1.4-0.2-1.7,0.4c0,0-0.1,0.1-0.1,0.1L12,5.6l-1.1-1.9C10.6,3,9.8,2.8,9.2,3.1S8.3,4.1,8.7,4.8c0,0,0,0.1,0.1,0.1l1.8,3.2l-3.7,6.4H3.2c-0.7,0-1.2,0.6-1.2,1.2C2,16.4,2.6,17,3.2,17h11l-0.9-1.5C13,14.9,12.4,14.5,11.7,14.5z M20.8,14.5h-3.6l-3-5.2l-0.6,1c-0.5,0.9-0.5,2.1,0,3l4.1,7.1c0.3,0.6,1.1,0.9,1.7,0.6c0.6-0.3,0.9-1.1,0.6-1.7c0,0,0-0.1-0.1-0.1L18.6,17h2.1c0.7,0,1.2-0.6,1.2-1.2C22,15.1,21.4,14.5,20.8,14.5z"]
  };
  
  var behance = {
    prefix: 'axis',
    iconName: 'behance',
    icon: [24, 24, [], "f0000", "M10.28,11.32a2.94,2.94,0,0,0,1-.71,2.78,2.78,0,0,0,.57-1.83,3.17,3.17,0,0,0-.57-1.9A3.8,3.8,0,0,0,8,5.56H2.75A.75.75,0,0,0,2,6.31V17.25a.76.76,0,0,0,.75.75H7.6a8.76,8.76,0,0,0,1.76-.17,3.48,3.48,0,0,0,1.41-.62,3.6,3.6,0,0,0,.88-1,3.66,3.66,0,0,0,.55-2,3.24,3.24,0,0,0-.49-1.82A2.76,2.76,0,0,0,10.28,11.32ZM4.87,7.72H7.19a4.73,4.73,0,0,1,1.47.19,1.12,1.12,0,0,1,.66,1.15,1.16,1.16,0,0,1-.5,1.09,2.48,2.48,0,0,1-1.32.31H4.87Zm3.89,8.05A2.73,2.73,0,0,1,7.5,16H4.87V12.5H7.54a3.18,3.18,0,0,1,1.25.22,1.44,1.44,0,0,1,.79,1.41A1.69,1.69,0,0,1,8.76,15.77ZM15.5,7.5h4A.5.5,0,0,0,20,7V6.5a.5.5,0,0,0-.5-.5h-4a.5.5,0,0,0-.5.5V7A.5.5,0,0,0,15.5,7.5Zm6.36,6.24a.5.5,0,0,0,.14-.35,8.44,8.44,0,0,0-.08-1.27,4.32,4.32,0,0,0-.71-1.84A3.62,3.62,0,0,0,19.67,9a5,5,0,0,0-2.09-.42,4.28,4.28,0,0,0-3.19,1.24,4.82,4.82,0,0,0-1.23,3.55,4.31,4.31,0,0,0,1.36,3.57A4.87,4.87,0,0,0,17.66,18,4.31,4.31,0,0,0,21,16.7a3.28,3.28,0,0,0,.8-1.29.24.24,0,0,0,0-.22.23.23,0,0,0-.2-.1H19.78a.51.51,0,0,0-.42.22,1.64,1.64,0,0,1-.34.39,2,2,0,0,1-1.3.41,2.29,2.29,0,0,1-1.28-.34,2.09,2.09,0,0,1-.93-1.88h6A.51.51,0,0,0,21.86,13.74Zm-6.3-1.24a2.39,2.39,0,0,1,.62-1.38,1.87,1.87,0,0,1,1.4-.52,2,2,0,0,1,1.38.49,1.94,1.94,0,0,1,.62,1.41Z"]
  };
  
  var dribbble = {
    prefix: 'axis',
    iconName: 'dribbble',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm8,10v0a12.31,12.31,0,0,0-3.53-.52,12.49,12.49,0,0,0-2.12.21c-.25-.61-.51-1.2-.79-1.79A16.92,16.92,0,0,0,18,6.69,7.94,7.94,0,0,1,20,12ZM16.87,5.67a15.15,15.15,0,0,1-4,2.91,32.65,32.65,0,0,0-2.79-4.34A8.06,8.06,0,0,1,12,4,8,8,0,0,1,16.87,5.67ZM8.62,4.76A32.16,32.16,0,0,1,11.51,9.2,15.33,15.33,0,0,1,6,10.25a17.34,17.34,0,0,1-1.77-.11A8,8,0,0,1,8.62,4.76ZM4,12c0-.13,0-.25,0-.38a16.32,16.32,0,0,0,2,.13,16.68,16.68,0,0,0,6.19-1.21c.24.5.48,1,.69,1.52a12.22,12.22,0,0,0-6.82,5.28A8,8,0,0,1,4,12Zm3.18,6.37a10.71,10.71,0,0,1,6.23-4.91,29.83,29.83,0,0,1,1.49,6,7.93,7.93,0,0,1-7.72-1.08Zm9.13.36a32.7,32.7,0,0,0-1.42-5.61A11.88,11.88,0,0,1,16.47,13a10.73,10.73,0,0,1,3.38.55A8,8,0,0,1,16.31,18.73Z"]
  };
  
  var dropbox = {
    prefix: 'axis',
    iconName: 'dropbox',
    icon: [24, 24, [], "f0000", "M18.39,8.49l2.53,3.1a.37.37,0,0,1,.08.22V12a.34.34,0,0,1-.16.29l-5.21,3.48a.5.5,0,0,1-.67-.1l-3-3.76,5.32-3.44L12,5l2.85-2.85A.49.49,0,0,1,15.21,2h.28a.5.5,0,0,1,.27.08l5.08,3.29a.34.34,0,0,1,.16.29v.07a.36.36,0,0,1-.1.25ZM15,18H15a.52.52,0,0,1-.39-.18L12,14.65,9.43,17.82A.52.52,0,0,1,9,18H9a.5.5,0,0,1-.27-.08L6,16.19v1.89a1,1,0,0,0,.46.84L11,21.84a1,1,0,0,0,.54.16h1a1,1,0,0,0,.54-.16l4.52-2.92a1,1,0,0,0,.46-.84V16.19l-2.69,1.73A.5.5,0,0,1,15,18ZM12,5,9.15,2.15A.49.49,0,0,0,8.79,2H8.51a.5.5,0,0,0-.27.08L3.16,5.37A.34.34,0,0,0,3,5.66v.07A.36.36,0,0,0,3.1,6L5.61,8.49l-2.53,3.1a.37.37,0,0,0-.08.22V12a.34.34,0,0,0,.16.29l5.21,3.38A.51.51,0,0,0,9,15.53l3-3.65L6.68,8.44Z"]
  };
  
  var facebook = {
    prefix: 'axis',
    iconName: 'facebook',
    icon: [24, 24, [], "f0000", "M16.5,6h-3a1,1,0,0,0-1,1v3h4a.35.35,0,0,1,.34.46l-.74,2.2a.5.5,0,0,1-.47.34H12.5v7.5a.5.5,0,0,1-.5.5H9.5a.5.5,0,0,1-.5-.5V13H7.5a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5H9V7a4,4,0,0,1,4-4h3.5a.5.5,0,0,1,.5.5v2A.5.5,0,0,1,16.5,6Z"]
  };
  
  var facebookSquare = {
    prefix: 'axis',
    iconName: 'facebookSquare',
    icon: [24, 24, [], "f0000", "M21,5V19a2,2,0,0,1-2,2H15.25a.5.5,0,0,1-.5-.5v-6h2.34a.5.5,0,0,0,.49-.4l.36-1.8a.25.25,0,0,0-.24-.3H14.75V8.75A.25.25,0,0,1,15,8.5h2.5A.5.5,0,0,0,18,8V6.5a.5.5,0,0,0-.5-.5H15a3,3,0,0,0-3,3v3H10.77a.5.5,0,0,0-.5.5V14a.5.5,0,0,0,.5.5H12v6a.5.5,0,0,1-.5.5H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H19A2,2,0,0,1,21,5Z"]
  };
  
  var github = {
    prefix: 'axis',
    iconName: 'github',
    icon: [24, 24, [], "f0000", "M22,12a10,10,0,0,1-6.84,9.48.52.52,0,0,1-.45-.07A.51.51,0,0,1,14.5,21V18.33A4,4,0,0,0,14,16.27.25.25,0,0,1,14,16a.27.27,0,0,1,.2-.14C16.64,15.61,18,14.64,18,12a4.71,4.71,0,0,0-1.19-3.36A4.3,4.3,0,0,0,17,7.44a4.33,4.33,0,0,0-.15-1.08A.49.49,0,0,0,16.32,6a4.45,4.45,0,0,0-2.44,1.18,9.91,9.91,0,0,0-3.76,0A4.45,4.45,0,0,0,7.68,6a.49.49,0,0,0-.53.36A4.33,4.33,0,0,0,7,7.44a4.3,4.3,0,0,0,.19,1.2A4.71,4.71,0,0,0,6,12c0,2.78,1.51,3.71,4.28,3.94a3.71,3.71,0,0,0-.69,1.53v0s0,.07,0,.12a.68.68,0,0,0,0,.14.59.59,0,0,1-.64.51h0a1,1,0,0,1-.43-.12A5.34,5.34,0,0,1,7.1,16.86a10.09,10.09,0,0,0-.8-.81,2.74,2.74,0,0,0-.59-.39.49.49,0,0,0-.48,0,.5.5,0,0,0-.23.42v.06a.5.5,0,0,0,.23.42,4.54,4.54,0,0,1,.92,1.05,6.61,6.61,0,0,0,1.59,1.72,2.48,2.48,0,0,0,1.4.42l.36,0V21a.51.51,0,0,1-.21.41.52.52,0,0,1-.45.07A10,10,0,1,1,22,12Z"]
  };
  
  var gmail = {
    prefix: 'axis',
    iconName: 'gmail',
    icon: [24, 24, [], "f0000", "M22,6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2ZM19.5,18h-1a.5.5,0,0,1-.5-.5V8.37l-5.58,4.47A.81.81,0,0,1,12,13h-.18a.81.81,0,0,1-.47-.16L6,8.59V17.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V6.5A.5.5,0,0,1,4.5,6H5.61a1,1,0,0,1,.62.22l5.63,4.5,5.64-4.5A1,1,0,0,1,18.12,6H19.5a.5.5,0,0,1,.5.5v11A.5.5,0,0,1,19.5,18Z"]
  };
  
  var gmailOutlined = {
    prefix: 'axis',
    iconName: 'gmailOutlined',
    icon: [24, 24, [], "f0000", "M22,6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2ZM17.1,6,12,10.08,6.9,6ZM19,18H5V8.32l6.21,5a1,1,0,0,0,.62.22h.35a1,1,0,0,0,.62-.22l6.2-5Z"]
  };
  
  var google = {
    prefix: 'axis',
    iconName: 'google',
    icon: [24, 24, [], "f0000", "M21,11.79C21,15.94,18.79,21,12.13,21A9.07,9.07,0,0,1,3,12a9.07,9.07,0,0,1,9.13-9,9.22,9.22,0,0,1,5.7,2,.52.52,0,0,1,.19.37.55.55,0,0,1-.16.39A26.4,26.4,0,0,0,16,7.64a.49.49,0,0,1-.66.06,5.11,5.11,0,0,0-3.2-1,5.35,5.35,0,0,0,0,10.7c3,0,4.27-1.28,4.93-3.55H12.5a.5.5,0,0,1-.5-.5V10.7a.5.5,0,0,1,.5-.5h8a.45.45,0,0,1,.45.4A11.56,11.56,0,0,1,21,11.79Z"]
  };
  
  var googleDrive = {
    prefix: 'axis',
    iconName: 'googleDrive',
    icon: [24, 24, [], "f0000", "M21.77,15.75,19.34,20a2,2,0,0,1-1.74,1H8.4A.5.5,0,0,1,8,20.25L10.37,16a2,2,0,0,1,1.74-1h9.23A.5.5,0,0,1,21.77,15.75Zm-11.54-5.7L7.77,5.78a.49.49,0,0,0-.86,0L2.2,14a1.53,1.53,0,0,0-.2.75v.22a1.53,1.53,0,0,0,.2.75l2.53,4.42a.51.51,0,0,0,.87,0L10.23,12A2,2,0,0,0,10.23,10.05ZM13.75,12a2,2,0,0,0,1.73,1h4.89a.5.5,0,0,0,.44-.75L16.1,4a2,2,0,0,0-1.74-1H9.47A.5.5,0,0,0,9,3.75Z"]
  };
  
  var googlePlay = {
    prefix: 'axis',
    iconName: 'googlePlay',
    icon: [24, 24, [], "f0000", "M16.6,15.7l5-2.9c0.2-0.1,0.4-0.4,0.4-0.6v-0.3c0-0.3-0.1-0.5-0.4-0.6l-5-2.9L13.3,12L16.6,15.7z M12.5,11.1l3-3.4L4.4,1.1C4.2,1,4,1,3.8,1.1L12.5,11.1z M12.5,13L3.8,23c0.2,0.1,0.4,0.1,0.6,0l11.1-6.5L12.5,13z M3,2.1v19.8l8.7-9.9L3,2.1z"]
  };
  
  var hangouts = {
    prefix: 'axis',
    iconName: 'hangouts',
    icon: [24, 24, [], "f0000", "M11.5,2C6.8,2,3,5.8,3,10.5c0,4.5,3.5,8.2,8,8.5v2.5c0,0.3,0.3,0.6,0.7,0.5c4.8-1.7,8.3-5.4,8.3-11.5C20,5.8,16.2,2,11.5,2z M10.8,11.8c0,1.5-1,2.7-2.4,2.9c-0.1,0-0.3,0-0.4-0.1s-0.2-0.2-0.2-0.4v-0.5c0-0.2,0.2-0.4,0.4-0.5c0.6-0.2,1.1-0.8,1.1-1.5H7.5c-0.3,0-0.5-0.2-0.5-0.5V8.5C7,8.2,7.2,8,7.5,8h2.8c0.3,0,0.5,0.2,0.5,0.5V11.8z M16,11.8c0,1.5-1,2.7-2.4,2.9c-0.1,0-0.3,0-0.4-0.1S13,14.4,13,14.2v-0.5c0-0.2,0.2-0.4,0.4-0.5c0.6-0.2,1.1-0.8,1.1-1.5h-1.8c-0.3,0-0.5-0.2-0.5-0.5V8.5c0-0.3,0.2-0.5,0.5-0.5h2.8C15.8,8,16,8.2,16,8.5V11.8z"]
  };
  
  var hangoutsOutlined = {
    prefix: 'axis',
    iconName: 'hangoutsOutlined',
    icon: [24, 24, [], "f0000", "M11.5,2C6.8,2,3,5.8,3,10.5c0,4.5,3.5,8.2,8,8.5v2.5c0,0.3,0.2,0.5,0.5,0.5c0.1,0,0.1,0,0.2,0c4.8-1.7,8.3-5.4,8.3-11.5C20,5.8,16.2,2,11.5,2z M13,19.2V19v-1.4c0-0.3-0.2-0.5-0.5-0.5L11.1,17C7.7,16.8,5,13.9,5,10.5C5,6.9,7.9,4,11.5,4S18,6.9,18,10.5C18,15.2,15.6,17.8,13,19.2z M10.2,8H7.5C7.2,8,7,8.2,7,8.5v2.8c0,0.3,0.2,0.5,0.5,0.5h1.8c0,0.7-0.5,1.3-1.1,1.5c-0.2,0.1-0.4,0.3-0.4,0.5v0.5c0,0.2,0.1,0.3,0.2,0.4s0.3,0.1,0.4,0.1c1.4-0.3,2.4-1.5,2.4-2.9V8.5C10.8,8.2,10.5,8,10.2,8z M15.5,8h-2.8c-0.3,0-0.5,0.2-0.5,0.5v2.8c0,0.3,0.2,0.5,0.5,0.5h1.8c0,0.7-0.5,1.3-1.1,1.5c-0.2,0.1-0.4,0.3-0.4,0.5v0.5c0,0.2,0.1,0.3,0.2,0.4s0.3,0.1,0.4,0.1c1.4-0.3,2.4-1.5,2.4-2.9V8.5C16,8.2,15.8,8,15.5,8z"]
  };
  
  var instagram = {
    prefix: 'axis',
    iconName: 'instagram',
    icon: [24, 24, [], "f0000", "M16,3H8A5,5,0,0,0,3,8v8a5,5,0,0,0,5,5h8a5,5,0,0,0,5-5V8A5,5,0,0,0,16,3Zm3.25,13A3.26,3.26,0,0,1,16,19.25H8A3.26,3.26,0,0,1,4.75,16V8A3.26,3.26,0,0,1,8,4.75h8A3.26,3.26,0,0,1,19.25,8Zm-1.5-8.75a1,1,0,1,1-1-1A1,1,0,0,1,17.75,7.25ZM12,7.5A4.5,4.5,0,1,0,16.5,12,4.49,4.49,0,0,0,12,7.5Zm0,7.25A2.75,2.75,0,1,1,14.75,12,2.75,2.75,0,0,1,12,14.75Z"]
  };
  
  var linkedin = {
    prefix: 'axis',
    iconName: 'linkedin',
    icon: [24, 24, [], "f0000", "M7.5,9.5v10A.5.5,0,0,1,7,20H4.5a.5.5,0,0,1-.5-.5V9.5A.5.5,0,0,1,4.5,9H7A.5.5,0,0,1,7.5,9.5ZM21,13.41a4.61,4.61,0,0,0-3.55-4.56A4.46,4.46,0,0,0,13.5,9.92V9.5A.5.5,0,0,0,13,9H10.5a.5.5,0,0,0-.5.5v10a.5.5,0,0,0,.5.5H13a.5.5,0,0,0,.5-.5V13.86a2.07,2.07,0,0,1,1.66-2.08,2,2,0,0,1,2.34,2V19.5a.5.5,0,0,0,.5.5h2.5a.5.5,0,0,0,.5-.5ZM5.5,3a2,2,0,1,0,2,2A2,2,0,0,0,5.5,3Z"]
  };
  
  var linkedinSquare = {
    prefix: 'axis',
    iconName: 'linkedinSquare',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM8.5,17.5A.5.5,0,0,1,8,18H6.5a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5H8a.5.5,0,0,1,.5.5ZM7.25,9a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,7.25,9ZM18,17.5a.5.5,0,0,1-.5.5H16a.5.5,0,0,1-.5-.5V13.75a1.5,1.5,0,0,0-3,0V17.5a.5.5,0,0,1-.5.5H10.5a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5H12a.5.5,0,0,1,.5.5v.6a3,3,0,0,1,2.78-1.34A3.1,3.1,0,0,1,18,12.9Z"]
  };
  
  var medium = {
    prefix: 'axis',
    iconName: 'medium',
    icon: [24, 24, [], "f0000", "M21.85,19.15a.5.5,0,0,1-.35.85h-7a.5.5,0,0,1-.35-.85l1.56-1.57a1,1,0,0,0,.29-.7V8.81a.11.11,0,0,0-.08-.1.11.11,0,0,0-.11.06l-4.56,11a.35.35,0,0,1-.32.22h-.18a.35.35,0,0,1-.33-.22L5.69,8.15a.1.1,0,0,0-.11-.06.1.1,0,0,0-.08.1v8.19a1,1,0,0,0,.29.7l2.06,2.07A.5.5,0,0,1,7.5,20h-5a.5.5,0,0,1-.35-.85l2.06-2.07a1,1,0,0,0,.29-.7V7.62a1,1,0,0,0-.29-.7L2.15,4.85A.5.5,0,0,1,2.5,4H7.66a.5.5,0,0,1,.47.31l4.18,10.28L16.57,4.31A.5.5,0,0,1,17,4H21.5a.5.5,0,0,1,.35.85L20.29,6.42a1,1,0,0,0-.29.7v9.76a1,1,0,0,0,.29.7Z"]
  };
  
  var mediumSquare = {
    prefix: 'axis',
    iconName: 'mediumSquare',
    icon: [24, 24, [], "f0000", "M21,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM16.94,15.57a.49.49,0,0,0,.15.36l.67.64a.25.25,0,0,1,0,.27.24.24,0,0,1-.23.16h-3.9a.25.25,0,0,1-.23-.16.25.25,0,0,1,.06-.27l.68-.66a.49.49,0,0,0,.15-.36V10.66a.1.1,0,0,0-.08-.1.09.09,0,0,0-.11.06l-2.47,6.26a.16.16,0,0,1-.14.1h-.16a.14.14,0,0,1-.14-.09L8.33,10.55a.1.1,0,0,0-.11-.06.1.1,0,0,0-.08.1v4.28a.51.51,0,0,0,.11.31l1.14,1.39a.25.25,0,0,1,0,.27A.26.26,0,0,1,9.2,17H6.36a.27.27,0,0,1-.23-.14.27.27,0,0,1,0-.27l1.14-1.38a.49.49,0,0,0,.11-.31V9.38a.47.47,0,0,0-.12-.32l-1-1.18a.26.26,0,0,1,0-.27.26.26,0,0,1,.22-.14h2.8a.49.49,0,0,1,.45.29l2.56,5.61,2.23-5.59A.5.5,0,0,1,15,7.47h2.57a.25.25,0,0,1,.23.16.25.25,0,0,1-.06.27l-.66.63a.52.52,0,0,0-.16.36Z"]
  };
  
  var messenger = {
    prefix: 'axis',
    iconName: 'messenger',
    icon: [24, 24, [], "f0000", "M12,2A9.76,9.76,0,0,0,2,11.5,9.22,9.22,0,0,0,4.71,18a1,1,0,0,1,.29.7V21a1,1,0,0,0,.45.84h0a1,1,0,0,0,.94.09L9.1,20.79a1,1,0,0,1,.61-.05A10.18,10.18,0,0,0,12,21a9.76,9.76,0,0,0,10-9.5A9.76,9.76,0,0,0,12,2Zm5.5,7.21-2.62,4a1.49,1.49,0,0,1-1.25.68H13.2a1.49,1.49,0,0,1-.91-.31L10.1,11.89l-3,2.25a.43.43,0,0,1-.56,0,.5.5,0,0,1-.07-.63L9.1,9.54a1.51,1.51,0,0,1,1.26-.67h.21a1.48,1.48,0,0,1,.91.3l2.3,1.76,3.06-2.34a.43.43,0,0,1,.56,0l0,0A.43.43,0,0,1,17.5,9.21Z"]
  };
  
  var messengerOutlined = {
    prefix: 'axis',
    iconName: 'messengerOutlined',
    icon: [24, 24, [], "f0000", "M12,2A9.76,9.76,0,0,0,2,11.5,9.22,9.22,0,0,0,4.71,18a1,1,0,0,1,.29.7V21a1,1,0,0,0,.45.84h0A1,1,0,0,0,6,22a1,1,0,0,0,.38-.08L9.1,20.79a1.09,1.09,0,0,1,.39-.08.83.83,0,0,1,.22,0A10.18,10.18,0,0,0,12,21a9.76,9.76,0,0,0,10-9.5A9.76,9.76,0,0,0,12,2Zm0,17a8.47,8.47,0,0,1-1.85-.21,3,3,0,0,0-.66-.08A2.9,2.9,0,0,0,8.33,19L7,19.51V18.7a3,3,0,0,0-.87-2.11A7.24,7.24,0,0,1,4,11.5,7.77,7.77,0,0,1,12,4a7.77,7.77,0,0,1,8,7.5A7.77,7.77,0,0,1,12,19ZM17.4,8.62a.43.43,0,0,0-.56,0l-3.06,2.34-2.3-1.76a1.48,1.48,0,0,0-.91-.3h-.21a1.51,1.51,0,0,0-1.26.67L6.51,13.48a.5.5,0,0,0,.07.63.43.43,0,0,0,.56,0l3-2.25,2.19,1.67a1.49,1.49,0,0,0,.91.31h.43a1.49,1.49,0,0,0,1.25-.68l2.62-4a.43.43,0,0,0-.06-.55Z"]
  };
  
  var pinterest = {
    prefix: 'axis',
    iconName: 'pinterest',
    icon: [24, 24, [], "f0000", "M20,9c0,4.19-2.41,7-6,7a4.56,4.56,0,0,1-3.42-1.27l-.66,3.11A8.24,8.24,0,0,1,9.09,20l-1,1.78a.35.35,0,0,1-.31.18.27.27,0,0,1-.2-.09.3.3,0,0,1-.08-.2l.08-2a8.87,8.87,0,0,1,.17-1.36L9.18,11.7A13.06,13.06,0,0,1,9,9.43C9,8.86,9.09,6,10.79,6a1.24,1.24,0,0,1,1,.44A2.07,2.07,0,0,1,12,8.18l-.76,3.55A2.52,2.52,0,0,0,14,14c2.95,0,4-2.58,4-5,0-2.9-2.52-5-6-5C8.69,4,6,6.24,6,9a4.26,4.26,0,0,0,1.15,2.85.5.5,0,0,1,.12.44L7,13.46a.49.49,0,0,1-.34.38.49.49,0,0,1-.49-.12A6.48,6.48,0,0,1,4,9c0-3.86,3.59-7,8-7S20,5,20,9Z"]
  };
  
  var pinterestCircle = {
    prefix: 'axis',
    iconName: 'pinterestCircle',
    icon: [24, 24, [], "f0000", "M22,12A10,10,0,0,1,12,22a9.82,9.82,0,0,1-2.25-.26.48.48,0,0,1-.34-.28.49.49,0,0,1,0-.44l.15-.29a5.91,5.91,0,0,0,.56-1.54l.66-3.1a3.94,3.94,0,0,0,2.92,1.07c3.09,0,5.17-2.42,5.17-6,0-3.43-3-6-6.88-6s-6.88,2.7-6.88,6a5.48,5.48,0,0,0,1.78,4,.49.49,0,0,0,.49.12.47.47,0,0,0,.34-.37l.2-.9a.52.52,0,0,0-.11-.43,3.61,3.61,0,0,1-.94-2.38c0-2.35,2.29-4.26,5.12-4.26s5.12,1.79,5.12,4.26c0,2.07-.89,4.27-3.41,4.27a2.14,2.14,0,0,1-2.36-1.93l.65-3a1.8,1.8,0,0,0-.21-1.51A1.06,1.06,0,0,0,11,8.55c-1.47,0-1.55,2.47-1.55,3a10.42,10.42,0,0,0,.16,1.94L8.33,19.26a5.74,5.74,0,0,0-.13,1.49.34.34,0,0,1-.14.28.31.31,0,0,1-.31,0A10,10,0,1,1,22,12Z"]
  };
  
  var reddit = {
    prefix: 'axis',
    iconName: 'reddit',
    icon: [24, 24, [], "f0000", "M22,11.5A2.5,2.5,0,0,0,19.5,9,2.46,2.46,0,0,0,18,9.53,11.4,11.4,0,0,0,12.93,8l.62-3.55a.24.24,0,0,1,.24-.21h.07L17,5.2a2,2,0,1,0,.42-1.44l-3.16-.92a2,2,0,0,0-.49-.07,1.75,1.75,0,0,0-1.72,1.45L11.41,8A11.52,11.52,0,0,0,6,9.53,2.46,2.46,0,0,0,4.5,9,2.49,2.49,0,0,0,3,13.52,3.88,3.88,0,0,0,3,14c0,3.31,4,6,9,6s9-2.69,9-6a3.88,3.88,0,0,0,0-.48A2.5,2.5,0,0,0,22,11.5Zm-15,1A1.5,1.5,0,1,1,8.5,14,1.5,1.5,0,0,1,7,12.5Zm8.21,4.44a.51.51,0,0,1-.25.32,6.29,6.29,0,0,1-5.92,0,.51.51,0,0,1-.25-.32.52.52,0,0,1,.08-.4l.29-.41A.49.49,0,0,1,9.8,16a5.07,5.07,0,0,0,4.4,0,.49.49,0,0,1,.64.16l.29.41A.52.52,0,0,1,15.21,16.94ZM15.5,14A1.5,1.5,0,1,1,17,12.5,1.5,1.5,0,0,1,15.5,14Z"]
  };
  
  var rss = {
    prefix: 'axis',
    iconName: 'rss',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM7.75,18A1.75,1.75,0,1,1,9.5,16.25,1.75,1.75,0,0,1,7.75,18Zm6.1-.16a.52.52,0,0,1-.37.16h-1a.5.5,0,0,1-.5-.46A6,6,0,0,0,6.46,12a.5.5,0,0,1-.46-.5v-1a.52.52,0,0,1,.16-.37A.51.51,0,0,1,6.53,10,8,8,0,0,1,14,17.47.51.51,0,0,1,13.85,17.84Zm4,0a.51.51,0,0,1-.36.15h-1a.5.5,0,0,1-.5-.48A10,10,0,0,0,6.48,8,.5.5,0,0,1,6,7.51v-1a.51.51,0,0,1,.15-.36A.57.57,0,0,1,6.52,6,12,12,0,0,1,18,17.48.57.57,0,0,1,17.85,17.85Z"]
  };
  
  var skype = {
    prefix: 'axis',
    iconName: 'skype',
    icon: [24, 24, [], "f0000", "M20.91,13.22A9.73,9.73,0,0,0,21,12a9,9,0,0,0-9-9,9.73,9.73,0,0,0-1.22.09,5.5,5.5,0,0,0-7.69,7.69A9.73,9.73,0,0,0,3,12a9,9,0,0,0,9,9,9.73,9.73,0,0,0,1.22-.09,5.5,5.5,0,0,0,7.69-7.69Zm-4.51,3a3.8,3.8,0,0,1-1.73,1.32A6.77,6.77,0,0,1,12,18,6.44,6.44,0,0,1,9,17.35a3.86,3.86,0,0,1-1.4-1.26A2.72,2.72,0,0,1,7,14.53a1.07,1.07,0,0,1,.36-.81,1.21,1.21,0,0,1,.89-.34,1.11,1.11,0,0,1,.75.27,2,2,0,0,1,.5.74,3.91,3.91,0,0,0,.49.87,1.76,1.76,0,0,0,.71.56,2.89,2.89,0,0,0,1.24.23,3,3,0,0,0,1.72-.46,1.24,1.24,0,0,0,.63-1.07A1.08,1.08,0,0,0,14,13.7a2.35,2.35,0,0,0-.91-.51q-.59-.18-1.56-.39a12,12,0,0,1-2.24-.68A3.7,3.7,0,0,1,7.79,11a2.72,2.72,0,0,1-.56-1.73,2.87,2.87,0,0,1,.58-1.75A3.63,3.63,0,0,1,9.47,6.4,7.05,7.05,0,0,1,12,6a6.56,6.56,0,0,1,2,.27A4.15,4.15,0,0,1,15.37,7a2.87,2.87,0,0,1,.83.94,2,2,0,0,1,.27,1,1.25,1.25,0,0,1-1.23,1.21,1,1,0,0,1-.73-.24A2.59,2.59,0,0,1,14,9.19a2.91,2.91,0,0,0-.77-1,2.37,2.37,0,0,0-1.42-.33,2.62,2.62,0,0,0-1.48.37,1,1,0,0,0-.53.82A.8.8,0,0,0,10,9.6a1.5,1.5,0,0,0,.51.39,4.12,4.12,0,0,0,.69.27l1.18.29a18,18,0,0,1,1.88.5,6,6,0,0,1,1.46.67,3,3,0,0,1,1,1A3.13,3.13,0,0,1,17,14.27,3.29,3.29,0,0,1,16.4,16.2Z"]
  };
  
  var slack = {
    prefix: 'axis',
    iconName: 'slack',
    icon: [24, 24, [], "f0000", "M12.75,9.38V4.12a1.87,1.87,0,0,1,1.87-1.87h0A1.87,1.87,0,0,1,16.5,4.12V9.38a1.87,1.87,0,0,1-1.87,1.87h0A1.87,1.87,0,0,1,12.75,9.38Zm7.13,3.37H14.62a1.87,1.87,0,0,0-1.87,1.87h0a1.87,1.87,0,0,0,1.87,1.87h5.26a1.87,1.87,0,0,0,1.87-1.87h0A1.87,1.87,0,0,0,19.88,12.75Zm-10.5,0h0A1.87,1.87,0,0,0,7.5,14.62v5.26a1.87,1.87,0,0,0,1.87,1.87h0a1.87,1.87,0,0,0,1.87-1.87V14.62A1.87,1.87,0,0,0,9.38,12.75Zm0-5.25H4.12A1.87,1.87,0,0,0,2.25,9.37h0a1.87,1.87,0,0,0,1.87,1.87H9.38a1.87,1.87,0,0,0,1.87-1.87h0A1.87,1.87,0,0,0,9.38,7.5Zm0-5.25h0A1.87,1.87,0,0,0,7.5,4.12h0A1.87,1.87,0,0,0,9.37,6h1.38a.5.5,0,0,0,.5-.5V4.12A1.87,1.87,0,0,0,9.38,2.25ZM19.88,7.5h0A1.87,1.87,0,0,0,18,9.37v1.38a.5.5,0,0,0,.5.5h1.38a1.87,1.87,0,0,0,1.87-1.87h0A1.87,1.87,0,0,0,19.88,7.5ZM14.63,18H13.25a.5.5,0,0,0-.5.5v1.38a1.87,1.87,0,0,0,1.87,1.87h0a1.87,1.87,0,0,0,1.87-1.87h0A1.87,1.87,0,0,0,14.63,18ZM5.5,12.75H4.12a1.87,1.87,0,0,0-1.87,1.87h0A1.87,1.87,0,0,0,4.12,16.5h0A1.87,1.87,0,0,0,6,14.63V13.25A.5.5,0,0,0,5.5,12.75Z"]
  };
  
  var snapchat = {
    prefix: 'axis',
    iconName: 'snapchat',
    icon: [24, 24, [], "f0000", "M22,17a1,1,0,0,1-1,1c-1.3,0-2,.41-2,1a1,1,0,0,1-1,1c-.83,0-1-.47-1.77-.47a1.28,1.28,0,0,0-.65.28,6.54,6.54,0,0,1-.84.52,5,5,0,0,1-2,.62,5.35,5.35,0,0,1-1.46,0,5,5,0,0,1-2-.62,6.54,6.54,0,0,1-.84-.52,1.28,1.28,0,0,0-.65-.28C7,19.53,6.83,20,6,20a1,1,0,0,1-1-1c0-.59-.7-1-2-1a1,1,0,0,1,0-2,3.34,3.34,0,0,0,3-2.71.49.49,0,0,0-.27-.59,14.89,14.89,0,0,1-2.13-1.2A1.36,1.36,0,1,1,5.13,9.24l.5.32a.24.24,0,0,0,.26,0A.25.25,0,0,0,6,9.33C6,9.22,6,9.11,6,9A6,6,0,0,1,18,9c0,.11,0,.22,0,.33a.25.25,0,0,0,.12.23.24.24,0,0,0,.26,0l.5-.32a1.36,1.36,0,0,1,1.52,2.26,14.89,14.89,0,0,1-2.13,1.2.49.49,0,0,0-.27.59A3.34,3.34,0,0,0,21,16,1,1,0,0,1,22,17Z"]
  };
  
  var snapchatOutlined = {
    prefix: 'axis',
    iconName: 'snapchatOutlined',
    icon: [24, 24, [], "f0000", "M21,16c-2.33,0-3-2.7-3-2.85,0-.85,3-1.09,3-2.78A1.36,1.36,0,0,0,19.63,9c-.73,0-1.11.58-1.39.58A.25.25,0,0,1,18,9.34S18,9.2,18,9A6,6,0,0,0,6,9c0,.2,0,.31,0,.34a.25.25,0,0,1-.25.25C5.5,9.59,5.08,9,4.37,9A1.36,1.36,0,0,0,3,10.37c0,1.69,3,2,3,2.78C6,13.27,5.33,16,3,16a1,1,0,0,0,0,2c1.3,0,2,.41,2,1a1,1,0,0,0,1,1c.83,0,1-.47,1.77-.47a1.28,1.28,0,0,1,.65.28,6.54,6.54,0,0,0,.84.52,5,5,0,0,0,2,.62,5.35,5.35,0,0,0,1.46,0,5,5,0,0,0,2-.62,6.54,6.54,0,0,0,.84-.52,1.28,1.28,0,0,1,.65-.28c.73,0,.94.47,1.77.47a1,1,0,0,0,1-1c0-.59.7-1,2-1a1,1,0,0,0,0-2Zm-3.36.77,0,.05a.21.21,0,0,1-.18.12C14.93,17.19,14.23,19,12,19s-2.93-1.81-5.44-2.06a.21.21,0,0,1-.18-.12l0-.05a.23.23,0,0,1,0-.25A5.76,5.76,0,0,0,8,13.16V9a4,4,0,0,1,8,0v4.16a5.63,5.63,0,0,0,1.6,3.36A.23.23,0,0,1,17.64,16.77Z"]
  };
  
  var steam = {
    prefix: 'axis',
    iconName: 'steam',
    icon: [24, 24, [], "f0000", "M22,12c0-5.5-4.5-10-10.1-9.9c-4.9,0-9,3.6-9.8,8.4c0,0.2,0.1,0.4,0.3,0.5l4.4,2c0.5-0.6,1.2-0.9,1.9-1c0.2,0,0.3-0.1,0.4-0.2l0.8-1.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.2c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4h-0.2c-0.1,0-0.2,0-0.3,0.1l-1.2,0.8C12.1,15,12,15.1,12,15.3c-0.1,1.7-1.6,2.9-3.2,2.7C7.2,17.9,6,16.6,6,15c0-0.1,0-0.1,0-0.2l-3.5-1.6c-0.1-0.1-0.3,0-0.3,0.1c0,0,0,0.1,0,0.1c0.8,5.5,5.9,9.2,11.4,8.4C18.4,21.1,22,16.9,22,12z M9,14c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S8.4,14,9,14z M14,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S12.9,8,14,8z"]
  };
  
  var telegram = {
    prefix: 'axis',
    iconName: 'telegram',
    icon: [24, 24, [], "f0000", "M21.38,3.61l0,0A2,2,0,0,0,20,3a2,2,0,0,0-.78.16L2.62,10.35a1,1,0,0,0-.62,1V12a1,1,0,0,0,.69,1L7,14.44,8.3,18.83a1.78,1.78,0,0,0,1.32,1.25,1.47,1.47,0,0,0,.36,0,1.73,1.73,0,0,0,1.19-.48l1.59-1.5,3.08,2.43a2,2,0,0,0,2.11.22l.33-.17a2.07,2.07,0,0,0,1.09-1.47L22,5.51A2.11,2.11,0,0,0,21.38,3.61ZM17.9,18.87a.59.59,0,0,1-.3.41l-.33.17a.46.46,0,0,1-.21.05.46.46,0,0,1-.29-.11l-3.76-3a.49.49,0,0,0-.65,0l-2.22,2.09a.26.26,0,0,1-.14.05V15a.51.51,0,0,1,.16-.37c3.19-3,5.1-4.68,6.24-5.64a.37.37,0,0,0,.12-.26.32.32,0,0,0-.1-.26h0A.35.35,0,0,0,16,8.37L8.44,13.14a.5.5,0,0,1-.43,0L3.5,11.6,19.77,4.54a.39.39,0,0,1,.18,0,.52.52,0,0,1,.38.18.63.63,0,0,1,.16.55Z"]
  };
  
  var tikTok = {
    prefix: 'axis',
    iconName: 'tikTok',
    icon: [24, 24, [], "f0000", "M21,7.48v2a.52.52,0,0,1-.16.37.51.51,0,0,1-.37.13A7.91,7.91,0,0,1,16,8.24V16a6,6,0,1,1-6-6,5.07,5.07,0,0,1,.55,0,.49.49,0,0,1,.45.49v2a.48.48,0,0,1-.17.37.49.49,0,0,1-.4.12A3.11,3.11,0,0,0,10,13a3,3,0,1,0,3,3V2.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.45A5,5,0,0,0,20.55,7,.5.5,0,0,1,21,7.48Z"]
  };
  
  var twitch = {
    prefix: 'axis',
    iconName: 'twitch',
    icon: [24, 24, [], "f0000", "M10.59,20.41,12,19h3.17a2,2,0,0,0,1.42-.59l3.82-3.82A2,2,0,0,0,21,13.17V4a1,1,0,0,0-1-1H5.19a1,1,0,0,0-.93.65l-1,2.67A4.23,4.23,0,0,0,3,7.73V18a1,1,0,0,0,1,1H7v1a1,1,0,0,0,1,1H9.17A2,2,0,0,0,10.59,20.41ZM6,16V5H19v8.17L16.17,16h-4l-2,2H9V16Zm4.5-3h1a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v4A.5.5,0,0,0,10.5,13Zm5,0h1a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v4A.5.5,0,0,0,15.5,13Z"]
  };
  
  var twitter = {
    prefix: 'axis',
    iconName: 'twitter',
    icon: [24, 24, [], "f0000", "M22,6.45a8,8,0,0,1-1.85,1.78c0,.18,0,.36,0,.55A12.2,12.2,0,0,1,7.78,21a12.24,12.24,0,0,1-5.45-1.26.25.25,0,0,1-.15-.23V19.4a.26.26,0,0,1,.26-.26A8.86,8.86,0,0,0,7.56,17.3a4.37,4.37,0,0,1-3.89-2.56.26.26,0,0,1,.26-.36,4,4,0,0,0,1.52-.14A4.36,4.36,0,0,1,2,10.43a.26.26,0,0,1,.36-.26,4,4,0,0,0,1.58.34A4.28,4.28,0,0,1,2.23,5.57a.54.54,0,0,1,.91-.18,12.36,12.36,0,0,0,8.41,3.88,4,4,0,0,1-.12-1,4.36,4.36,0,0,1,7.51-2.94,8.69,8.69,0,0,0,2.39-.83.17.17,0,0,1,.18,0,.17.17,0,0,1,0,.18,4.37,4.37,0,0,1-1.76,2,8.58,8.58,0,0,0,2-.48.16.16,0,0,1,.18,0A.17.17,0,0,1,22,6.45Z"]
  };
  
  var viber = {
    prefix: 'axis',
    iconName: 'viber',
    icon: [24, 24, [], "f0000", "M12,2C5.37,2,3,4.24,3,10.5c0,4.31,1.13,6.72,4,7.8v3.2a.5.5,0,0,0,.5.5h.31a.51.51,0,0,0,.33-.13L11.34,19H12c6.63,0,9-2.24,9-8.5S18.63,2,12,2Zm-.25,6.56a.48.48,0,0,1,.19-.39.46.46,0,0,1,.42-.1,2.74,2.74,0,0,1,2.07,2.07.46.46,0,0,1-.1.42.48.48,0,0,1-.39.19h-.51a.5.5,0,0,1-.48-.36,1.26,1.26,0,0,0-.84-.84.5.5,0,0,1-.36-.48Zm3.68,6a2.11,2.11,0,0,1-1,.83,1.15,1.15,0,0,1-.91,0,11.38,11.38,0,0,1-5.78-5.14,15.26,15.26,0,0,1-.67-1.56A2.14,2.14,0,0,1,7,8.34,1.55,1.55,0,0,1,8.32,6.87l.19,0A.78.78,0,0,1,9,7.08a5.74,5.74,0,0,1,1.23,1.7.58.58,0,0,1-.15.73l-.15.13a.86.86,0,0,0-.32,1.28A4.15,4.15,0,0,0,11.86,13a.62.62,0,0,0,.73-.16l.07-.09c.4-.67,1-.6,1.52-.22l1,.77C15.75,13.7,15.75,14.06,15.43,14.59Zm1.42-4a.5.5,0,0,1-.38.17H16a.51.51,0,0,1-.5-.44A3.74,3.74,0,0,0,12.19,7a.51.51,0,0,1-.44-.5V6a.5.5,0,0,1,.17-.38.47.47,0,0,1,.38-.12A5.26,5.26,0,0,1,17,10.2.47.47,0,0,1,16.85,10.58Z"]
  };
  
  var viberOutlined = {
    prefix: 'axis',
    iconName: 'viberOutlined',
    icon: [24, 24, [], "f0000", "M12,2C5.37,2,3,4.24,3,10.5c0,4.31,1.13,6.72,4,7.8v3.2a.5.5,0,0,0,.5.5h.31a.51.51,0,0,0,.33-.13L11.34,19H12c6.63,0,9-2.24,9-8.5S18.63,2,12,2Zm0,15h-.61l-.6,0a.51.51,0,0,0-.35.13l-.44.4-1,.9V17.26a.5.5,0,0,0-.32-.47l-1-.37C6.4,15.93,5,15,5,10.5,5,5.34,6.44,4,12,4s7,1.34,7,6.5S17.56,17,12,17Zm3.22-3.69-1-.77c-.54-.38-1.12-.45-1.52.22l-.07.09a.62.62,0,0,1-.73.16,4.15,4.15,0,0,1-2.27-2.09.86.86,0,0,1,.32-1.28l.15-.13a.58.58,0,0,0,.15-.73A5.74,5.74,0,0,0,9,7.08a.78.78,0,0,0-.47-.23l-.19,0A1.55,1.55,0,0,0,7,8.34a2.14,2.14,0,0,0,.06.35,15.26,15.26,0,0,0,.67,1.56,11.38,11.38,0,0,0,5.78,5.14,1.15,1.15,0,0,0,.91,0,2.11,2.11,0,0,0,1-.83C15.75,14.06,15.75,13.7,15.22,13.31ZM12.3,5.53a.47.47,0,0,0-.38.12.5.5,0,0,0-.17.38v.5a.51.51,0,0,0,.44.5,3.74,3.74,0,0,1,3.28,3.28.51.51,0,0,0,.5.44h.5a.5.5,0,0,0,.38-.17A.47.47,0,0,0,17,10.2,5.26,5.26,0,0,0,12.3,5.53Zm-.19,4a1.26,1.26,0,0,1,.84.84.5.5,0,0,0,.48.36h.51a.48.48,0,0,0,.39-.19.46.46,0,0,0,.1-.42,2.74,2.74,0,0,0-2.07-2.07.46.46,0,0,0-.42.1.48.48,0,0,0-.19.39v.51A.5.5,0,0,0,12.11,9.55Z"]
  };
  
  var arrowLongLeftDiagonal = {
    prefix: 'axis',
    iconName: 'arrowLongLeftDiagonal',
    icon: [24, 24, [], "f0000", "M17.08,16.09Q13.17,21,10.46,21c-1.12,0-2.07-1-2.84-3L6.07,12.53c-.57-2-1.18-3-1.85-3a4.2,4.2,0,0,0-1.14.63.47.47,0,0,1-.63-.1l-.34-.42A.45.45,0,0,1,2.16,9C3,8.31,3.82,7.6,4.62,6.9A6.32,6.32,0,0,1,7.47,5.24Q9.69,5,10.22,8.19c.37,2.27.63,3.68.78,4.24q.63,2.82,1.41,2.82c.41,0,1-.61,1.82-1.84a7.2,7.2,0,0,0,1.29-2.78C15.63,9.58,15.19,9,14.23,9a3.73,3.73,0,0,0-.8.1A.3.3,0,0,1,13.1,9,.33.33,0,0,1,13,8.7c1-2.54,2.72-3.76,5.18-3.7,2,.06,2.9,1.3,2.78,3.71C20.91,10.51,19.6,13,17.08,16.09Z"]
  };
  
  var vimeoSquare = {
    prefix: 'axis',
    iconName: 'vimeoSquare',
    icon: [24, 24, [], "f0000", "M19.2,3H4.8A1.81,1.81,0,0,0,3,4.8V19.2A1.81,1.81,0,0,0,4.8,21H19.2A1.81,1.81,0,0,0,21,19.2V4.8A1.81,1.81,0,0,0,19.2,3ZM16.11,14.32Q13.23,18,11.23,18c-.82,0-1.52-.75-2.09-2.24L8,11.65c-.42-1.49-.87-2.24-1.36-2.24a3.14,3.14,0,0,0-.84.47.34.34,0,0,1-.47-.07l-.25-.32a.34.34,0,0,1,0-.48C5.73,8.48,6.34,8,6.93,7.42A4.62,4.62,0,0,1,9,6.18c1.09-.11,1.77.63,2,2.21s.46,2.76.57,3.18c.31,1.41.66,2.12,1,2.12s.74-.46,1.34-1.38a5.44,5.44,0,0,0,1-2.09C15,9.43,14.72,9,14,9a3.06,3.06,0,0,0-.59.07A.22.22,0,0,1,13.18,9a.25.25,0,0,1,0-.26A3.75,3.75,0,0,1,16.94,6c1.45,0,2.14,1,2,2.78Q18.9,10.81,16.11,14.32Z"]
  };
  
  var vkontakte = {
    prefix: 'axis',
    iconName: 'vkontakte',
    icon: [24, 24, [], "f0000", "M22,17.43a.45.45,0,0,1-.07.39.44.44,0,0,1-.35.18h-3a1,1,0,0,1-.89-.54,8.93,8.93,0,0,0-1.5-2.13A1.05,1.05,0,0,0,15.4,15H15a.94.94,0,0,0-.71.29A1,1,0,0,0,14,16v1a1,1,0,0,1-1,1H11.94C6.73,18,2.42,8.84,2,7.61a0,0,0,0,0,0,0A.44.44,0,0,1,2.44,7h3a1,1,0,0,1,.89.55,27.92,27.92,0,0,0,2.32,3.64A.75.75,0,0,0,10,10.74V8.47a1.51,1.51,0,0,0-.86-1.33.26.26,0,0,1-.06-.4A3.1,3.1,0,0,1,11.28,6H12.5A1.5,1.5,0,0,1,14,7.5V10a1,1,0,0,0,1,1,1,1,0,0,0,.83-.42,22.75,22.75,0,0,0,1.84-3,1,1,0,0,1,.9-.55h3a.41.41,0,0,1,.39.53s0,0,0,0a21.38,21.38,0,0,1-2.45,4.71.75.75,0,0,0,.06.9A13.76,13.76,0,0,1,22,17.36Z"]
  };
  
  var whatsapp = {
    prefix: 'axis',
    iconName: 'whatsapp',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,0,0,3.9,17.86L3,20.6a.49.49,0,0,0,.12.51l0,0a.51.51,0,0,0,.51.13l2.85-.92A10,10,0,1,0,12,2Zm5.82,14.12a2.81,2.81,0,0,1-2,1.41c-.52.11-1.21.2-3.5-.75a12.43,12.43,0,0,1-5-4.4,5.69,5.69,0,0,1-1.19-3,3.21,3.21,0,0,1,1-2.44,1.49,1.49,0,0,1,1-.36l.33,0c.29,0,.44,0,.64.49s.82,2,.89,2.16a.57.57,0,0,1,.05.54,1.85,1.85,0,0,1-.33.46c-.14.17-.29.3-.43.48a.47.47,0,0,0-.12.63,8.94,8.94,0,0,0,1.62,2,7.34,7.34,0,0,0,2.35,1.45.62.62,0,0,0,.7-.11,10,10,0,0,0,.78-1,.56.56,0,0,1,.72-.21c.27.09,1.7.8,2,.94s.49.22.56.34A2.5,2.5,0,0,1,17.82,16.12Z"]
  };
  
  var whatsappOutlined = {
    prefix: 'axis',
    iconName: 'whatsappOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,0,0,3.9,17.86L3,20.6a.49.49,0,0,0,.12.51l0,0a.51.51,0,0,0,.36.15l.15,0,2.85-.92A10,10,0,1,0,12,2Zm8,10a8,8,0,1,1-8-8A8,8,0,0,1,20,12Zm-3.07,3.49a2.33,2.33,0,0,1-1.65,1.19c-.44.1-1,.17-3-.63a10.41,10.41,0,0,1-4.2-3.72,4.77,4.77,0,0,1-1-2.54A2.74,2.74,0,0,1,8,7.73a1.26,1.26,0,0,1,.87-.3h.28c.25,0,.37,0,.54.42s.69,1.7.75,1.82a.47.47,0,0,1,0,.46,1.7,1.7,0,0,1-.27.39c-.12.14-.25.25-.37.4a.4.4,0,0,0-.1.53,7.54,7.54,0,0,0,1.37,1.7,6.33,6.33,0,0,0,2,1.23.55.55,0,0,0,.6-.1,7.76,7.76,0,0,0,.65-.88.48.48,0,0,1,.61-.17c.23.07,1.44.67,1.68.79s.42.19.48.29A2,2,0,0,1,16.93,15.49Z"]
  };
  
  var youtube = {
    prefix: 'axis',
    iconName: 'youtube',
    icon: [24, 24, [], "f0000", "M20,4.49l-1.46-.15a64.12,64.12,0,0,0-13.14,0L4,4.49A3.38,3.38,0,0,0,1,7.9v8.2a3.38,3.38,0,0,0,3,3.41l1.46.15a64.12,64.12,0,0,0,13.14,0L20,19.51a3.38,3.38,0,0,0,3-3.41V7.9A3.38,3.38,0,0,0,20,4.49Zm-5,8.13-3.89,2.6A.75.75,0,0,1,10,14.6V9.4a.75.75,0,0,1,1.17-.62l3.89,2.6A.74.74,0,0,1,15.06,12.62Z"]
  };
  
  var youtubeOutlined = {
    prefix: 'axis',
    iconName: 'youtubeOutlined',
    icon: [24, 24, [], "f0000", "M20,4.49l-1.46-.15a63.65,63.65,0,0,0-13.14,0L4,4.49A3.38,3.38,0,0,0,1,7.9v8.2a3.38,3.38,0,0,0,3,3.41l1.46.15A62.85,62.85,0,0,0,12,20a62.85,62.85,0,0,0,6.57-.34L20,19.51a3.38,3.38,0,0,0,3-3.41V7.9A3.38,3.38,0,0,0,20,4.49ZM21,16.1a1.38,1.38,0,0,1-1.18,1.42l-1.46.15A61.29,61.29,0,0,1,12,18a61.29,61.29,0,0,1-6.36-.33l-1.46-.15A1.38,1.38,0,0,1,3,16.1V7.9A1.38,1.38,0,0,1,4.18,6.48l1.46-.15a61.45,61.45,0,0,1,12.72,0l1.46.15A1.38,1.38,0,0,1,21,7.9ZM11.17,8.78A.75.75,0,0,0,10,9.4v5.2a.75.75,0,0,0,1.17.62l3.89-2.6a.74.74,0,0,0,0-1.24Z"]
  };
  
  var airdrop = {
    prefix: 'axis',
    iconName: 'airdrop',
    icon: [24, 24, [], "f0000", "M22,13a10,10,0,0,1-2.57,6.69.51.51,0,0,1-.72,0l-.36-.36a.51.51,0,0,1,0-.68,8.5,8.5,0,1,0-12.66,0,.51.51,0,0,1,0,.68l-.36.36a.51.51,0,0,1-.72,0A10,10,0,1,1,22,13ZM12,6A7,7,0,0,0,6.68,17.56a.56.56,0,0,0,.36.17.54.54,0,0,0,.38-.15l.35-.35a.5.5,0,0,0,0-.68,5.5,5.5,0,1,1,8.4,0,.5.5,0,0,0,0,.68l.35.35a.54.54,0,0,0,.38.15.56.56,0,0,0,.36-.17A7,7,0,0,0,12,6Zm2,8.45a.5.5,0,0,0,.05.64l.36.36a.5.5,0,0,0,.39.14.47.47,0,0,0,.36-.2,4,4,0,1,0-6.4,0,.47.47,0,0,0,.36.2.5.5,0,0,0,.39-.14l.36-.36a.5.5,0,0,0,.05-.64,2.5,2.5,0,1,1,4.08,0ZM11,13a1,1,0,1,0,1-1A1,1,0,0,0,11,13Zm1.75,3.22a.75.75,0,0,0-.53-.22h-.44a.75.75,0,0,0-.53.22L7.52,19.94a.51.51,0,0,0,0,.71l.21.2a.47.47,0,0,0,.35.15h7.83a.47.47,0,0,0,.35-.15l.21-.2a.5.5,0,0,0,0-.71Z"]
  };
  
  var airplay = {
    prefix: 'axis',
    iconName: 'airplay',
    icon: [24, 24, [], "f0000", "M18.48,19.94a.51.51,0,0,1,0,.71l-.21.2a.47.47,0,0,1-.35.15H6.08a.47.47,0,0,1-.35-.15l-.21-.2a.5.5,0,0,1,0-.71l5.73-5.72a.75.75,0,0,1,.53-.22h.44a.75.75,0,0,1,.53.22ZM23,3H1A1,1,0,0,0,0,4V18a1,1,0,0,0,1,1H4l2-2H2V5H22V17H18l2,2h3a1,1,0,0,0,1-1V4A1,1,0,0,0,23,3Z"]
  };
  
  var android = {
    prefix: 'axis',
    iconName: 'android',
    icon: [24, 24, [], "f0000", "M20,9c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1s1-0.4,1-1v-5C21,9.4,20.6,9,20,9z M17.5,8h-11C6.2,8,6,8.2,6,8.5V16c0,0.6,0.4,1,1,1h1v4c0,0.6,0.4,1,1,1s1-0.4,1-1v-4h4v4c0,0.6,0.4,1,1,1s1-0.4,1-1v-4h1c0.6,0,1-0.4,1-1V8.5C18,8.2,17.8,8,17.5,8zM6.7,7h10.6c0.3,0,0.5-0.2,0.5-0.5c0,0,0-0.1,0-0.1c-0.3-0.9-0.8-1.8-1.5-2.5l0.6-1.1c0.1-0.2,0.1-0.5-0.2-0.7S16.2,2,16.1,2.2l0,0l-0.6,0.9c-2.1-1.5-4.9-1.5-7,0L8,2.2C7.8,2,7.5,1.9,7.3,2.1S7,2.5,7.1,2.8l0.6,1.1C7,4.5,6.5,5.4,6.2,6.3C6.2,6.6,6.3,6.9,6.6,7C6.6,7,6.7,7,6.7,7z M13.7,4c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8S13,5.2,13,4.8C13,4.3,13.3,4,13.7,4C13.7,4,13.7,4,13.7,4L13.7,4z M10.2,4C10.6,4,11,4.3,11,4.8s-0.3,0.8-0.8,0.8S9.5,5.2,9.5,4.8C9.5,4.3,9.8,4,10.2,4C10.2,4,10.2,4,10.2,4L10.2,4z M4,9c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1s1-0.4,1-1v-5C5,9.4,4.6,9,4,9z"]
  };
  
  var apple = {
    prefix: 'axis',
    iconName: 'apple',
    icon: [24, 24, [], "f0000", "M11.76,6.69a.52.52,0,0,1-.59-.52,4.37,4.37,0,0,1,1-2.61A4.82,4.82,0,0,1,14.64,2a.51.51,0,0,1,.63.51,4.66,4.66,0,0,1-1,2.63A4.07,4.07,0,0,1,11.76,6.69Zm5.42,5.82c0-2.72,2-3.33,2-3.92s-1.73-1.91-3.56-1.91-2.54.86-3.78.86-2.25-.86-3.79-.86A5.16,5.16,0,0,0,3.89,9.21,6.64,6.64,0,0,0,3,12.75C3,17.14,6.15,22,8.47,22c1.3,0,1.63-.85,3.42-.85S14,22,15.22,22c2.52,0,4.62-5,4.62-5.07a.51.51,0,0,0-.3-.46A4.44,4.44,0,0,1,17.18,12.51Z"]
  };
  
  var appleOutlined = {
    prefix: 'axis',
    iconName: 'appleOutlined',
    icon: [24, 24, [], "f0000", "M14.76,2a.52.52,0,0,1,.51.53,4.66,4.66,0,0,1-1,2.63,4.07,4.07,0,0,1-2.51,1.53h-.08a.52.52,0,0,1-.51-.53,4.37,4.37,0,0,1,1-2.61A4.82,4.82,0,0,1,14.64,2l.12,0Zm.86,6.68A3.82,3.82,0,0,0,14.09,9a6.14,6.14,0,0,1-2.25.5A6.82,6.82,0,0,1,9.45,9a4.13,4.13,0,0,0-1.4-.34,3.17,3.17,0,0,0-2.47,1.61A4.59,4.59,0,0,0,5,12.75C5,16.36,7.54,19.83,8.5,20c.11,0,.18,0,.56-.19a6.22,6.22,0,0,1,2.83-.66,6,6,0,0,1,2.78.66c.35.16.42.19.55.19.49-.06,1.48-1.33,2.18-2.58a6.45,6.45,0,0,1-2.22-4.91,5.93,5.93,0,0,1,1.17-3.68,2.12,2.12,0,0,0-.73-.15m0-2c1.83,0,3.56,1.46,3.56,1.91s-2,1.2-2,3.92a4.44,4.44,0,0,0,2.36,4,.51.51,0,0,1,.3.46c0,.08-2.1,5.07-4.62,5.07-1.27,0-1.61-.85-3.33-.85S9.77,22,8.47,22C6.15,22,3,17.14,3,12.75a6.64,6.64,0,0,1,.89-3.54A5.16,5.16,0,0,1,8.05,6.68c1.54,0,2.51.86,3.79.86s2-.86,3.78-.86Z"]
  };
  
  var augmentedReality = {
    prefix: 'axis',
    iconName: 'augmentedReality',
    icon: [24, 24, [], "f0000", "M21,15.5V19a2,2,0,0,1-2,2H15.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H19V15.5a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,21,15.5ZM8.5,19H5V15.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V19a2,2,0,0,0,2,2H8.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,8.5,19ZM3.5,9h1A.5.5,0,0,0,5,8.5V5H8.5A.5.5,0,0,0,9,4.5v-1A.5.5,0,0,0,8.5,3H5A2,2,0,0,0,3,5V8.5A.5.5,0,0,0,3.5,9ZM19,3H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V5A2,2,0,0,0,19,3ZM16.76,13.6V10.4a2,2,0,0,0-1-1.73l-2.43-1.4a2,2,0,0,0-1-.27h-.66a2,2,0,0,0-1,.27L8.24,8.67a2,2,0,0,0-1,1.73v3.2a2,2,0,0,0,1,1.73l2.43,1.4a2,2,0,0,0,1,.27h.66a2,2,0,0,0,1-.27l2.43-1.4A2,2,0,0,0,16.76,13.6ZM12.33,15H12V12.58a1,1,0,0,0-.5-.87L9.24,10.4,11.67,9h.66l2.43,1.4v3.2Z"]
  };
  
  var barcode = {
    prefix: 'axis',
    iconName: 'barcode',
    icon: [24, 24, [], "f0000", "M4,18.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,2.5,5h1a.5.5,0,0,1,.5.5ZM21.5,5h-1a.5.5,0,0,0-.5.5v13a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V5.5A.5.5,0,0,0,21.5,5Zm-8,0a.5.5,0,0,0-.5.5v11a.5.5,0,0,0,1,0V5.5A.5.5,0,0,0,13.5,5Zm-7,0a.5.5,0,0,0-.5.5v11a.5.5,0,0,0,1,0V5.5A.5.5,0,0,0,6.5,5Zm11,0h-1a.5.5,0,0,0-.5.5v11a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V5.5A.5.5,0,0,0,17.5,5ZM11,5.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v11a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5Z"]
  };
  
  var bluetooth = {
    prefix: 'axis',
    iconName: 'bluetooth',
    icon: [24, 24, [], "f0000", "M17.65,16.23,13.41,12l4.24-4.23a.51.51,0,0,0,0-.71L12.88,2.29A1,1,0,0,0,12.17,2H11.5a.5.5,0,0,0-.5.5V9.59L7.56,6.15a.5.5,0,0,0-.71,0l-.7.71a.48.48,0,0,0,0,.7L10.58,12,6.15,16.44a.48.48,0,0,0,0,.7l.7.71a.5.5,0,0,0,.71,0L11,14.41V21.5a.5.5,0,0,0,.5.5h.67a1,1,0,0,0,.71-.29l4.77-4.77A.51.51,0,0,0,17.65,16.23ZM13,5.24l2.17,2.17h0L13,9.58Zm0,13.52V14.42l2.17,2.17h0Z"]
  };
  
  var bluetoothConnect = {
    prefix: 'axis',
    iconName: 'bluetoothConnect',
    icon: [24, 24, [], "f0000", "M9.41,12l4.24-4.23a.51.51,0,0,0,0-.71L8.88,2.29A1,1,0,0,0,8.17,2H7.5a.5.5,0,0,0-.5.5V9.59L3.56,6.15a.5.5,0,0,0-.71,0l-.7.71a.48.48,0,0,0,0,.7L6.58,12,2.15,16.44a.48.48,0,0,0,0,.7l.7.71a.5.5,0,0,0,.71,0L7,14.41V21.5a.5.5,0,0,0,.5.5h.67a1,1,0,0,0,.71-.29l4.77-4.77a.51.51,0,0,0,0-.71ZM9,5.24l2.17,2.17h0L9,9.58ZM9,18.76V14.42l2.17,2.17h0ZM13.5,11h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,13.5,11Zm4,0h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,17.5,11Zm4,0h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11Z"]
  };
  
  var bluetoothOff = {
    prefix: 'axis',
    iconName: 'bluetoothOff',
    icon: [24, 24, [], "f0000", "M20.85,20.15a.5.5,0,0,0,0-.71L4.56,3.15a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71L10.6,12h0L6.15,16.44a.48.48,0,0,0,0,.7l.7.71a.5.5,0,0,0,.71,0L11,14.41V21.5a.5.5,0,0,0,.5.5h.67a1,1,0,0,0,.71-.29L16.59,18l2.85,2.85a.5.5,0,0,0,.71,0ZM13,18.76V14.42l2.17,2.17h0ZM13,5.24l2.17,2.17h0L13.24,9.35l1.41,1.41,3-3a.51.51,0,0,0,0-.71L12.88,2.29A1,1,0,0,0,12.17,2H11.5a.5.5,0,0,0-.5.5V7.11l2,2Z"]
  };
  
  var bluetoothSearch = {
    prefix: 'axis',
    iconName: 'bluetoothSearch',
    icon: [24, 24, [], "f0000", "M10.41,12l4.24-4.23a.51.51,0,0,0,0-.71L9.88,2.29A1,1,0,0,0,9.17,2H8.5a.5.5,0,0,0-.5.5V9.59L4.56,6.15a.5.5,0,0,0-.71,0l-.7.71a.48.48,0,0,0,0,.7L7.58,12,3.15,16.44a.48.48,0,0,0,0,.7l.7.71a.5.5,0,0,0,.71,0L8,14.41V21.5a.5.5,0,0,0,.5.5h.67a1,1,0,0,0,.71-.29l4.77-4.77a.51.51,0,0,0,0-.71ZM10,5.24l2.17,2.17h0L10,9.58Zm0,13.52V14.42l2.17,2.17h0Zm9-12a.58.58,0,0,0-.36-.17.5.5,0,0,0-.37.15l-.71.71a.5.5,0,0,0,0,.68,6,6,0,0,1,0,7.8.5.5,0,0,0,0,.68l.71.71a.5.5,0,0,0,.37.15.56.56,0,0,0,.36-.17A8,8,0,0,0,19,6.73ZM15.84,9.4a.53.53,0,0,0-.39.15l-.71.72a.5.5,0,0,0-.07.63,2,2,0,0,1,0,2.2.5.5,0,0,0,.07.63l.71.72a.52.52,0,0,0,.39.14.52.52,0,0,0,.37-.19,4,4,0,0,0,0-4.8A.57.57,0,0,0,15.84,9.4Z"]
  };
  
  var chartBar1 = {
    prefix: 'axis',
    iconName: 'chartBar1',
    icon: [24, 24, [], "f0000", "M7,16H5a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1H7a1,1,0,0,1,1,1v2A1,1,0,0,1,7,16Zm7-1V9a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h2A1,1,0,0,0,14,15Zm8,4.5v-1a.5.5,0,0,0-.5-.5H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h19A.5.5,0,0,0,22,19.5ZM20,15V5a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1V15a1,1,0,0,0,1,1h2A1,1,0,0,0,20,15Z"]
  };
  
  var chartBar2 = {
    prefix: 'axis',
    iconName: 'chartBar2',
    icon: [24, 24, [], "f0000", "M4,15V13a1,1,0,0,1,1-1H7a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H5A1,1,0,0,1,4,15Zm7,1h2a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V15A1,1,0,0,0,11,16Zm6,0h2a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v6A1,1,0,0,0,17,16Zm4.5,2H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h19a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,18Z"]
  };
  
  var chartBar3 = {
    prefix: 'axis',
    iconName: 'chartBar3',
    icon: [24, 24, [], "f0000", "M7,20H5a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1H7a1,1,0,0,1,1,1v6A1,1,0,0,1,7,20Zm7-1V9a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h2A1,1,0,0,0,14,19Zm6,0V5a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h2A1,1,0,0,0,20,19Z"]
  };
  
  var chartBar4 = {
    prefix: 'axis',
    iconName: 'chartBar4',
    icon: [24, 24, [], "f0000", "M8,13v6a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1H7A1,1,0,0,1,8,13Zm5-9H11a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V5A1,1,0,0,0,13,4Zm6,4H17a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V9A1,1,0,0,0,19,8Z"]
  };
  
  var chartBubble = {
    prefix: 'axis',
    iconName: 'chartBubble',
    icon: [24, 24, [], "f0000", "M14,19a2,2,0,1,1-2-2A2,2,0,0,1,14,19Zm3.5-8A3.5,3.5,0,1,0,21,14.5,3.5,3.5,0,0,0,17.5,11ZM14,8.5A5.5,5.5,0,1,0,8.5,14,5.5,5.5,0,0,0,14,8.5Z"]
  };
  
  var chartDonut1 = {
    prefix: 'axis',
    iconName: 'chartDonut1',
    icon: [24, 24, [], "f0000", "M21,10.47a.51.51,0,0,1-.13.37.52.52,0,0,1-.37.16h-1a.5.5,0,0,1-.5-.48A6,6,0,0,0,13.47,5,.5.5,0,0,1,13,4.53v-1a.52.52,0,0,1,.16-.37A.51.51,0,0,1,13.53,3,8,8,0,0,1,21,10.47ZM18.48,13h-1a.5.5,0,0,0-.5.48A6,6,0,1,1,10.54,7a.5.5,0,0,0,.46-.5v-1a.5.5,0,0,0-.52-.5,8,8,0,1,0,8.5,8.5A.5.5,0,0,0,18.48,13Z"]
  };
  
  var chartDonut2 = {
    prefix: 'axis',
    iconName: 'chartDonut2',
    icon: [24, 24, [], "f0000", "M13,4.66v-2a.46.46,0,0,1,.18-.38.48.48,0,0,1,.4-.12,10,10,0,0,1,8.3,8.3.48.48,0,0,1-.12.4.46.46,0,0,1-.38.18h-2a.5.5,0,0,1-.49-.4A7,7,0,0,0,13.4,5.15.5.5,0,0,1,13,4.66ZM16.48,17.9a.49.49,0,0,0-.63-.06A6.9,6.9,0,0,1,12,19,7,7,0,0,1,10.6,5.15a.5.5,0,0,0,.4-.49v-2a.46.46,0,0,0-.18-.38.48.48,0,0,0-.4-.12,10,10,0,1,0,7.45,18,.53.53,0,0,0,.2-.37.5.5,0,0,0-.14-.39Zm4.9-4.9h-2a.5.5,0,0,0-.49.4,6.63,6.63,0,0,1-1,2.45.5.5,0,0,0,.06.63l1.45,1.45a.5.5,0,0,0,.39.14.51.51,0,0,0,.37-.21,10.17,10.17,0,0,0,1.77-4.28.48.48,0,0,0-.12-.4A.46.46,0,0,0,21.38,13Z"]
  };
  
  var chartLineDown = {
    prefix: 'axis',
    iconName: 'chartLineDown',
    icon: [24, 24, [], "f0000", "M2.15,6.56a.5.5,0,0,1,0-.71l.7-.7a.5.5,0,0,1,.71,0l6.94,6.94,2.65-2.65a.48.48,0,0,1,.7,0l8,8a.5.5,0,0,1,0,.71l-.7.7a.5.5,0,0,1-.71,0L13.5,11.91l-2.65,2.65a.48.48,0,0,1-.7,0Z"]
  };
  
  var chartLineUp = {
    prefix: 'axis',
    iconName: 'chartLineUp',
    icon: [24, 24, [], "f0000", "M10.15,9.44a.48.48,0,0,1,.7,0l2.65,2.65,6.94-6.94a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71l-8,8a.48.48,0,0,1-.7,0L10.5,11.91,3.56,18.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71Z"]
  };
  
  var chartPie1 = {
    prefix: 'axis',
    iconName: 'chartPie1',
    icon: [24, 24, [], "f0000", "M21,10.47a.51.51,0,0,1-.13.37.52.52,0,0,1-.37.16H13V3.52a.52.52,0,0,1,.16-.37A.5.5,0,0,1,13.53,3,8,8,0,0,1,21,10.47ZM18.48,13H11V5.52a.5.5,0,0,0-.52-.5,8,8,0,1,0,8.5,8.5A.5.5,0,0,0,18.48,13Z"]
  };
  
  var chartPie2 = {
    prefix: 'axis',
    iconName: 'chartPie2',
    icon: [24, 24, [], "f0000", "M13,10.5V2.62a.46.46,0,0,1,.18-.38.45.45,0,0,1,.4-.11,10,10,0,0,1,8.29,8.29.45.45,0,0,1-.11.4.46.46,0,0,1-.38.18H13.5A.5.5,0,0,1,13,10.5ZM21.38,13H13.5a.5.5,0,0,0-.5.5v7.88a.46.46,0,0,0,.18.38.45.45,0,0,0,.4.11,10,10,0,0,0,8.29-8.29.45.45,0,0,0-.11-.4A.46.46,0,0,0,21.38,13Zm-11-10.87a10,10,0,0,0,0,19.74.45.45,0,0,0,.4-.11.46.46,0,0,0,.18-.38V2.62a.46.46,0,0,0-.18-.38A.45.45,0,0,0,10.42,2.13Z"]
  };
  
  var cloud = {
    prefix: 'axis',
    iconName: 'cloud',
    icon: [24, 24, [], "f0000", "M6,10c0-3.3,2.7-6,6-6c3,0,5.4,2.2,5.9,5c2.8,0.2,5.1,2.6,5.1,5.5c0,3-2.5,5.5-5.5,5.5H6c-2.8,0-5-2.2-5-5S3.2,10,6,10z"]
  };
  
  var cloudDisabled = {
    prefix: 'axis',
    iconName: 'cloudDisabled',
    icon: [24, 24, [], "f0000", "M17.9,9C17.4,6.2,15,4,12,4c-3.3,0-6,2.7-6,6c-2.8,0-5,2.2-5,5s2.2,5,5,5h11.5c3,0,5.5-2.5,5.5-5.5C23,11.6,20.8,9.2,17.9,9z M14.8,14.6c0.2,0.2,0.2,0.5,0,0.7l-0.5,0.5c-0.2,0.2-0.5,0.2-0.7,0L12,14.2l-1.6,1.6c-0.2,0.2-0.5,0.2-0.7,0l-0.5-0.5c-0.2-0.2-0.2-0.5,0-0.7l1.6-1.6l-1.6-1.6c-0.2-0.2-0.2-0.5,0-0.7l0.5-0.5c0.2-0.2,0.5-0.2,0.7,0l1.6,1.6l1.6-1.6c0.2-0.2,0.5-0.2,0.7,0l0.5,0.5c0.2,0.2,0.2,0.5,0,0.7L13.2,13L14.8,14.6z"]
  };
  
  var cloudOff = {
    prefix: 'axis',
    iconName: 'cloudOff',
    icon: [24, 24, [], "f0000", "M23,14.5a5.49,5.49,0,0,1-1.76,4L8.13,5.42A5.92,5.92,0,0,1,12,4a6,6,0,0,1,5.91,5A5.49,5.49,0,0,1,23,14.5ZM4.38,4.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L6.21,8.45A6,6,0,0,0,6,10,5,5,0,0,0,6,20H17.5l.25,0,1.87,1.87a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7Z"]
  };
  
  var cloudOffOutlined = {
    prefix: 'axis',
    iconName: 'cloudOffOutlined',
    icon: [24, 24, [], "f0000", "M4.38,4.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L6.2,8.44A6.18,6.18,0,0,0,6,10,5,5,0,0,0,6,20H17.5l.25,0,1.87,1.87a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM6,18a3,3,0,0,1-2.94-3.6A3.09,3.09,0,0,1,6.13,12H7.5a.5.5,0,0,0,.5-.5V10.24L15.76,18ZM17.91,9A6,6,0,0,0,12,4,5.92,5.92,0,0,0,8.13,5.42L9.55,6.84a4,4,0,0,1,6.39,2.51l.2,1.16a.49.49,0,0,0,.45.42l1.17.09A3.5,3.5,0,0,1,21,14.5a3.45,3.45,0,0,1-1.18,2.61l1.42,1.42A5.49,5.49,0,0,0,17.91,9Z"]
  };
  
  var cloudOn = {
    prefix: 'axis',
    iconName: 'cloudOn',
    icon: [24, 24, [], "f0000", "M17.9,9C17.4,6.2,15,4,12,4c-3.3,0-6,2.7-6,6c-2.8,0-5,2.2-5,5s2.2,5,5,5h11.5c3,0,5.5-2.5,5.5-5.5C23,11.6,20.8,9.2,17.9,9z M15.5,11.6l-4.2,4.2c-0.2,0.2-0.5,0.2-0.7,0l-2.1-2.1c-0.2-0.2-0.2-0.5,0-0.7L9,12.5c0.2-0.2,0.5-0.2,0.7,0l1.2,1.2l3.4-3.4c0.2-0.2,0.5-0.2,0.7,0l0.5,0.5C15.7,11.1,15.7,11.4,15.5,11.6z"]
  };
  
  var cloudOutlined = {
    prefix: 'axis',
    iconName: 'cloudOutlined',
    icon: [24, 24, [], "f0000", "M12,6c2,0,3.6,1.4,3.9,3.3l0.2,1.2c0,0.2,0.2,0.4,0.5,0.4l1.1,0.1c1.6,0.1,3,1.3,3.3,2.9c0.4,2.2-1.3,4.1-3.4,4.1L6.1,18c-1.5,0-2.8-1-3.1-2.4C2.7,13.7,4.2,12,6,12h1.5C7.8,12,8,11.8,8,11.5V10C8,7.8,9.8,6,12,6 M12,4c-3.3,0-6,2.7-6,6c-2.8,0-5,2.2-5,5s2.2,5,5,5h11.5c3,0,5.5-2.5,5.5-5.5c0-2.9-2.2-5.3-5.1-5.5C17.4,6.2,15,4,12,4L12,4z"]
  };
  
  var code = {
    prefix: 'axis',
    iconName: 'code',
    icon: [24, 24, [], "f0000", "M22,11.81v.38a.77.77,0,0,1-.22.53l-4.14,4.13a.5.5,0,0,1-.71,0l-.71-.71a.49.49,0,0,1,0-.7L19.67,12,16.22,8.56a.5.5,0,0,1,0-.71l.71-.7a.5.5,0,0,1,.71,0l4.14,4.13A.75.75,0,0,1,22,11.81ZM4.33,12,7.77,8.56a.49.49,0,0,0,0-.7l-.71-.71a.5.5,0,0,0-.71,0L2.22,11.28a.77.77,0,0,0-.22.53v.38a.75.75,0,0,0,.22.53l4.14,4.13a.5.5,0,0,0,.71,0l.71-.7a.5.5,0,0,0,0-.71Zm11-7.63L14.36,4a.52.52,0,0,0-.65.3L8.4,19a.5.5,0,0,0,.3.64l.94.34a.51.51,0,0,0,.64-.3L15.59,5A.5.5,0,0,0,15.29,4.37Z"]
  };
  
  var dataSharing = {
    prefix: 'axis',
    iconName: 'dataSharing',
    icon: [24, 24, [], "f0000", "M18.91,9.09A5,5,0,0,0,14,5H6a5,5,0,0,0-.91,9.91A5,5,0,0,0,10,19h8a5,5,0,0,0,.91-9.91ZM3,10A3,3,0,0,1,6,7h8a3,3,0,0,1,0,6H7.18A3,3,0,0,1,10,11h4.7a1.19,1.19,0,0,0,.55-1,1.23,1.23,0,0,0-.54-1H10a5,5,0,0,0-4.86,3.86A3,3,0,0,1,3,10Zm15,7H10a3,3,0,0,1-2.82-2H14a5,5,0,0,0,4.86-3.86A3,3,0,0,1,18,17Z"]
  };
  
  var downloadFromCloud = {
    prefix: 'axis',
    iconName: 'downloadFromCloud',
    icon: [24, 24, [], "f0000", "M17.9,9C17.4,6.2,15,4,12,4c-3.3,0-6,2.7-6,6c-2.8,0-5,2.2-5,5s2.2,5,5,5h11.5c3,0,5.5-2.5,5.5-5.5C23,11.6,20.8,9.2,17.9,9z M15.9,13.3l-3.5,3.5c-0.2,0.2-0.5,0.2-0.7,0l-3.5-3.5c-0.2-0.2-0.2-0.5,0-0.7l0.2-0.2c0.1-0.1,0.2-0.1,0.4-0.1H10V8.5C10,8.2,10.2,8,10.5,8h3C13.8,8,14,8.2,14,8.5v3.8h1.3c0.1,0,0.3,0.1,0.4,0.1l0.2,0.2C16.1,12.8,16.1,13.1,15.9,13.3z"]
  };
  
  var faceId = {
    prefix: 'axis',
    iconName: 'faceId',
    icon: [24, 24, [], "f0000", "M21,6V7.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V6a1,1,0,0,0-1-1H16.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H18A3,3,0,0,1,21,6ZM7.5,19H6a1,1,0,0,1-1-1V16.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V18a3,3,0,0,0,3,3H7.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,7.5,19ZM3.5,8h1A.5.5,0,0,0,5,7.5V6A1,1,0,0,1,6,5H7.5A.5.5,0,0,0,8,4.5v-1A.5.5,0,0,0,7.5,3H6A3,3,0,0,0,3,6V7.5A.5.5,0,0,0,3.5,8Zm17,8h-1a.5.5,0,0,0-.5.5V18a1,1,0,0,1-1,1H16.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H18a3,3,0,0,0,3-3V16.5A.5.5,0,0,0,20.5,16ZM9,10.5v-2A.5.5,0,0,0,8.5,8h-1a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,9,10.5Zm8,0v-2a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,17,10.5ZM10.5,14A2.5,2.5,0,0,0,13,11.5v-3a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v3a.5.5,0,0,1-.5.5.5.5,0,0,0-.5.5v1A.5.5,0,0,0,10.5,14Zm4.18,1.57a.51.51,0,0,0-.67-.11,4.11,4.11,0,0,1-4,0,.51.51,0,0,0-.67.11l-.6.81a.49.49,0,0,0,.11.72A6,6,0,0,0,12,18a5.92,5.92,0,0,0,3.16-.9.49.49,0,0,0,.12-.72Z"]
  };
  
  var fingerprint = {
    prefix: 'axis',
    iconName: 'fingerprint',
    icon: [24, 24, [], "f0000", "M5.75,11.75C5.75,16.58,8,19.15,8,19.6A.49.49,0,0,1,7.8,20l-.42.28a.47.47,0,0,1-.28.09c-.38,0-1.08-1.08-1.7-2.68a17.32,17.32,0,0,1-1.15-5.84V10A7.87,7.87,0,0,1,12,2a8.11,8.11,0,0,1,1.21.09.49.49,0,0,1,.35.24.5.5,0,0,1,0,.43l-.18.48a.49.49,0,0,1-.54.33A5.14,5.14,0,0,0,12,3.5c-4.91,0-6.21,4.7-6.21,6.43ZM15.7,3a.51.51,0,0,0-.42,0,.51.51,0,0,0-.29.3l-.18.49a.5.5,0,0,0,.22.6,6.19,6.19,0,0,1,3.15,5.39v1.65a.5.5,0,0,0,.5.5h.5a.51.51,0,0,0,.5-.5V9.71A7.74,7.74,0,0,0,15.7,3ZM12.25,9.75h-.5a.5.5,0,0,0-.5.5v1.5a8.48,8.48,0,0,0,.57,3.06.49.49,0,0,0,.29.29.51.51,0,0,0,.42,0l.43-.24a.49.49,0,0,0,.23-.61,7.06,7.06,0,0,1-.44-2.47v-1.5A.5.5,0,0,0,12.25,9.75Zm4.82,8.64a7.08,7.08,0,0,1-2.73-2.13.5.5,0,0,0-.63-.13l-.45.25a.5.5,0,0,0-.16.74,8.72,8.72,0,0,0,3.42,2.66.5.5,0,0,0,.66-.29l.18-.48A.49.49,0,0,0,17.07,18.39ZM9.25,11.93a.47.47,0,0,0-.5-.43h-.5a.5.5,0,0,0-.5.46v0c.13,6,4.74,9.89,5.53,9.89a.5.5,0,0,0,.43-.24l.27-.42a.48.48,0,0,0,.07-.26C14.05,20.35,9.34,18.14,9.25,11.93Zm9.31,3.28a3.76,3.76,0,0,1-2.31-3.46V9.94A4.37,4.37,0,0,0,12,5.5a4.26,4.26,0,0,0-4.24,4v0a.49.49,0,0,0,.5.48h.51a.5.5,0,0,0,.5-.48,2.74,2.74,0,0,1,5.48.23v2a5.13,5.13,0,0,0,3.51,4.92.5.5,0,0,0,.48-.37l.13-.48a.32.32,0,0,0,0-.13A.53.53,0,0,0,18.56,15.21Z"]
  };
  
  var link = {
    prefix: 'axis',
    iconName: 'link',
    icon: [24, 24, [], "f0000", "M8.65,13.94l5.29-5.29a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71l-5.29,5.29a.5.5,0,0,1-.71,0l-.7-.7A.5.5,0,0,1,8.65,13.94ZM21,7.66V8a4,4,0,0,1-1.18,2.84L17,13.67a1.35,1.35,0,0,1-1.9,0L15,13.56a.5.5,0,0,1,0-.7l3.44-3.44A2,2,0,0,0,19,8V7.66a2,2,0,0,0-.59-1.42l-.65-.65A2,2,0,0,0,16.34,5H16a2,2,0,0,0-1.42.59L11.14,9a.5.5,0,0,1-.7,0l-.11-.11a1.35,1.35,0,0,1,0-1.9l2.83-2.84A4,4,0,0,1,16,3h.34a4,4,0,0,1,2.83,1.17l.66.66A4,4,0,0,1,21,7.66ZM12.86,15a.5.5,0,0,1,.7,0l.11.11a1.35,1.35,0,0,1,0,1.9l-2.85,2.85A4,4,0,0,1,8,21H7.66a4,4,0,0,1-2.83-1.17l-.66-.66A4,4,0,0,1,3,16.35V16a4,4,0,0,1,1.18-2.84L7,10.33a1.35,1.35,0,0,1,1.9,0l.11.11a.5.5,0,0,1,0,.7L5.59,14.58A2,2,0,0,0,5,16v.34a2,2,0,0,0,.59,1.42l.65.65A2,2,0,0,0,7.66,19H8a2,2,0,0,0,1.43-.59Z"]
  };
  
  var linkOff = {
    prefix: 'axis',
    iconName: 'linkOff',
    icon: [24, 24, [], "f0000", "M4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7l4.9,4.91h0L4.18,13.16A4,4,0,0,0,3,16v.34a4,4,0,0,0,1.17,2.83l.66.66A4,4,0,0,0,7.66,21H8a4,4,0,0,0,2.83-1.17l3.89-3.89h0l4.91,4.9a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7Zm5,15.26A2,2,0,0,1,8,19H7.66a2,2,0,0,1-1.42-.59l-.65-.65A2,2,0,0,1,5,16.34V16a2,2,0,0,1,.59-1.42L9.47,10.7l1.21,1.22-2,2a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l2-2,1.21,1.2ZM19.83,4.83l-.66-.66A4,4,0,0,0,16.34,3H16a4,4,0,0,0-2.84,1.18L10.53,6.81,12,8.23l2.63-2.64A2,2,0,0,1,16,5h.34a2,2,0,0,1,1.42.59l.65.65A2,2,0,0,1,19,7.66V8a2,2,0,0,1-.59,1.42l-2.63,2.64,1.41,1.41,2.63-2.63A4,4,0,0,0,21,8V7.66A4,4,0,0,0,19.83,4.83ZM15.35,9.35l-.7-.7a.5.5,0,0,0-.71,0l-.78.79,1.41,1.41.78-.79A.5.5,0,0,0,15.35,9.35Z"]
  };
  
  var memoryChip = {
    prefix: 'axis',
    iconName: 'memoryChip',
    icon: [24, 24, [], "f0000", "M20.5,10a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19V7a2,2,0,0,0-2-2H16V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V5H10V3.5A.5.5,0,0,0,9.5,3h-1a.5.5,0,0,0-.5.5V5H7A2,2,0,0,0,5,7V8H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v4H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H5v1a2,2,0,0,0,2,2H8v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19h4v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V19h1a2,2,0,0,0,2-2V16h1.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H19V10ZM17,17H7V7H17Zm-6.5-3h3a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v3A.5.5,0,0,0,10.5,14Z"]
  };
  
  var mobileData = {
    prefix: 'axis',
    iconName: 'mobileData',
    icon: [24, 24, [], "f0000", "M5.31,16a.5.5,0,0,1,0,.69l-.71.71a.51.51,0,0,1-.72,0,11,11,0,0,1,0-14.8.51.51,0,0,1,.72,0l.71.71a.5.5,0,0,1,0,.69,9,9,0,0,0,0,12ZM20.14,2.6a.51.51,0,0,0-.72,0l-.71.71a.5.5,0,0,0,0,.69,9,9,0,0,1,0,12,.5.5,0,0,0,0,.69l.71.71a.51.51,0,0,0,.72,0,11,11,0,0,0,0-14.8ZM17.32,5.45A.52.52,0,0,0,17,5.27a.54.54,0,0,0-.38.15l-.71.71a.5.5,0,0,0,0,.67,5,5,0,0,1,0,6.4.5.5,0,0,0,0,.67l.71.71a.54.54,0,0,0,.38.15.52.52,0,0,0,.36-.18A7,7,0,0,0,17.32,5.45Zm-9.19.68-.71-.71A.54.54,0,0,0,7,5.27a.52.52,0,0,0-.36.18,7,7,0,0,0,0,9.1.52.52,0,0,0,.36.18.54.54,0,0,0,.38-.15l.71-.71a.5.5,0,0,0,0-.67,5,5,0,0,1,0-6.4A.5.5,0,0,0,8.13,6.13ZM9.88,7.88A3,3,0,0,0,11,12.82V21.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V12.82A3,3,0,1,0,9.88,7.88Z"]
  };
  
  var mobileDataLow = {
    prefix: 'axis',
    iconName: 'mobileDataLow',
    icon: [24, 24, [], "f0000", "M17.32,14.55a.52.52,0,0,1-.36.18.54.54,0,0,1-.38-.15l-.71-.71a.5.5,0,0,1,0-.67,5,5,0,0,0,0-6.4.5.5,0,0,1,0-.67l.71-.71A.54.54,0,0,1,17,5.27a.52.52,0,0,1,.36.18A7,7,0,0,1,17.32,14.55ZM8.13,6.13l-.71-.71A.54.54,0,0,0,7,5.27a.52.52,0,0,0-.36.18,7,7,0,0,0,0,9.1.52.52,0,0,0,.36.18.54.54,0,0,0,.38-.15l.71-.71a.5.5,0,0,0,0-.67,5,5,0,0,1,0-6.4A.5.5,0,0,0,8.13,6.13ZM9.88,7.88A3,3,0,0,0,11,12.82V21.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V12.82A3,3,0,1,0,9.88,7.88Z"]
  };
  
  var online = {
    prefix: 'axis',
    iconName: 'online',
    icon: [24, 24, [], "f0000", "M12,2a10,10,0,0,0,0,20c1.91,0,4.81-.78,4.81-1.53a.48.48,0,0,0-.07-.26l-.5-.87a.51.51,0,0,0-.43-.24A9.93,9.93,0,0,1,12,20a8,8,0,1,1,8-8c0,1-.72,3.27-2.88,3.27a2.58,2.58,0,0,1-.39,0c-.82-.17-1.34-.88-1.11-2.13h0l1-5.51A.5.5,0,0,0,16.13,7h-1a.5.5,0,0,0-.49.41l-.08.45A3.69,3.69,0,0,0,12.13,7a5,5,0,0,0-4.81,4.16l-.25,1.46a3.89,3.89,0,0,0,.16,2,3.57,3.57,0,0,0,3.47,2.32,4.86,4.86,0,0,0,3.35-1.47,3.18,3.18,0,0,0,3.07,1.83C20.45,17.27,22,14.12,22,12A10,10,0,0,0,12,2ZM9,13.39A2,2,0,0,1,9,13l.27-1.46a3.13,3.13,0,0,1,3-2.52c1,0,1.89.71,1.73,1.62h0l-.46,2.5a2.8,2.8,0,0,1-2.22,1.93,3.88,3.88,0,0,1-.48,0A1.71,1.71,0,0,1,9,13.39Z"]
  };
  
  var plugin = {
    prefix: 'axis',
    iconName: 'plugin',
    icon: [24, 24, [], "f0000", "M20,15v6a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1H7V12.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5V14h4V12.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5V14h2A1,1,0,0,1,20,15ZM19,2H5A1,1,0,0,0,4,3V9a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3A1,1,0,0,0,19,2Z"]
  };
  
  var pluginOutlined = {
    prefix: 'axis',
    iconName: 'pluginOutlined',
    icon: [24, 24, [], "f0000", "M19,14H17V12.5a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5V14H10V12.5a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5V14H5a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V15A1,1,0,0,0,19,14Zm-1,6H6V16H18ZM19,2H5A1,1,0,0,0,4,3V9a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3A1,1,0,0,0,19,2ZM18,8H6V4H18Z"]
  };
  
  var poll = {
    prefix: 'axis',
    iconName: 'poll',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM9,17.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm4,0a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V6.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Zm4,0a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5Z"]
  };
  
  var qrCode = {
    prefix: 'axis',
    iconName: 'qrCode',
    icon: [24, 24, [], "f0000", "M4,9H8A1,1,0,0,0,9,8V4A1,1,0,0,0,8,3H4A1,1,0,0,0,3,4V8A1,1,0,0,0,4,9ZM5,5H7V7H5ZM3.5,13h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,3.5,13ZM8,15H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H8a1,1,0,0,0,1-1V16A1,1,0,0,0,8,15ZM7,19H5V17H7Zm10.5,2h3a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V19H17v1.5A.5.5,0,0,0,17.5,21ZM20,3H16a1,1,0,0,0-1,1V8a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,7H17V5h2ZM7.5,11a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H11V11ZM11,14.5a.5.5,0,0,0,.5.5H13v1.5a.5.5,0,0,0,.5.5H15V13H11Zm0,5v1a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V19H11.5A.5.5,0,0,0,11,19.5ZM20.5,11h-5a.5.5,0,0,0-.5.5V13h2v1.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V13h1.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,11ZM17,19V17H15v2ZM11.5,7h1a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v3A.5.5,0,0,0,11.5,7ZM13,10.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V11h1.5A.5.5,0,0,0,13,10.5Z"]
  };
  
  var scan = {
    prefix: 'axis',
    iconName: 'scan',
    icon: [24, 24, [], "f0000", "M3,8.5V5A2,2,0,0,1,5,3H8.5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H5V8.5a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,3,8.5ZM15.5,5H19V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V5a2,2,0,0,0-2-2H15.5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,15.5,5Zm-7,14H5V15.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V19a2,2,0,0,0,2,2H8.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,8.5,19Zm12-4h-1a.5.5,0,0,0-.5.5V19H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19a2,2,0,0,0,2-2V15.5A.5.5,0,0,0,20.5,15Zm1-4H2.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h19a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,21.5,11Z"]
  };
  
  var security = {
    prefix: 'axis',
    iconName: 'security',
    icon: [24, 24, [], "f0000", "M20.12,5.12,16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09V7.24A3,3,0,0,0,20.12,5.12Zm-1.12,8a5.93,5.93,0,0,1-2.32,4.73L12.6,21H12V12H5V7.24a1,1,0,0,1,.29-.7L8.83,3H12v9h7Z"]
  };
  
  var securityOff = {
    prefix: 'axis',
    iconName: 'securityOff',
    icon: [24, 24, [], "f0000", "M21,7.24a3,3,0,0,0-.88-2.12L16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09Zm-5.91,5.62a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L12,12.24l-1.86,1.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7L10.76,11,8.91,9.14a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L12,9.76l1.86-1.85a.48.48,0,0,1,.7,0l.53.53a.48.48,0,0,1,0,.7L13.24,11Z"]
  };
  
  var securityOffOutlined = {
    prefix: 'axis',
    iconName: 'securityOffOutlined',
    icon: [24, 24, [], "f0000", "M20.12,5.12,16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09V7.24A3,3,0,0,0,20.12,5.12Zm-1.12,8a5.93,5.93,0,0,1-2.32,4.73L12.6,21H11.4L7.32,17.82A5.93,5.93,0,0,1,5,13.09V7.24a1,1,0,0,1,.29-.7L8.83,3h6.34l3.54,3.54a1,1,0,0,1,.29.7ZM15.09,8.44l-.53-.53a.48.48,0,0,0-.7,0L12,9.76,10.14,7.91a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L10.76,11,8.91,12.86a.48.48,0,0,0,0,.7l.53.53a.48.48,0,0,0,.7,0L12,12.24l1.86,1.85a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7L13.24,11l1.85-1.86A.48.48,0,0,0,15.09,8.44Z"]
  };
  
  var securityOn = {
    prefix: 'axis',
    iconName: 'securityOn',
    icon: [24, 24, [], "f0000", "M21,7.24a3,3,0,0,0-.88-2.12L16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09Zm-4.65,2-5.62,5.62a.48.48,0,0,1-.7,0L7.65,12.48a.5.5,0,0,1,0-.71l.53-.53a.48.48,0,0,1,.7,0l1.5,1.49L15.12,8a.5.5,0,0,1,.7,0l.53.53A.5.5,0,0,1,16.35,9.23Z"]
  };
  
  var securityOnOutlined = {
    prefix: 'axis',
    iconName: 'securityOnOutlined',
    icon: [24, 24, [], "f0000", "M20.12,5.12,16.59,1.59A2,2,0,0,0,15.17,1H8.83a2,2,0,0,0-1.42.59L3.88,5.12A3,3,0,0,0,3,7.24v5.85A8,8,0,0,0,6.09,19.4l4.08,3.18A2,2,0,0,0,11.4,23h1.2a2,2,0,0,0,1.23-.42l4.08-3.18A8,8,0,0,0,21,13.09V7.24A3,3,0,0,0,20.12,5.12Zm-1.12,8a5.93,5.93,0,0,1-2.32,4.73L12.6,21H11.4L7.32,17.82A5.93,5.93,0,0,1,5,13.09V7.24a1,1,0,0,1,.29-.7L8.83,3h6.34l3.54,3.54a1,1,0,0,1,.29.7ZM15.82,8a.5.5,0,0,0-.7,0l-4.74,4.74-1.5-1.49a.48.48,0,0,0-.7,0l-.53.53a.5.5,0,0,0,0,.71L10,14.85a.48.48,0,0,0,.7,0l5.62-5.62a.5.5,0,0,0,0-.71Z"]
  };
  
  var touchId = {
    prefix: 'axis',
    iconName: 'touchId',
    icon: [24, 24, [], "f0000", "M12,6a5,5,0,0,0-5,5V21.5a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,.5-.5V11A5,5,0,0,0,12,6Zm3,6a3,3,0,0,1-6,0V10a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1ZM11.74,2A9,9,0,0,0,3.63,14.32a.5.5,0,0,0,.68.26l.91-.43a.49.49,0,0,0,.25-.64,6.89,6.89,0,0,1-.45-2A7.1,7.1,0,0,1,11.79,4,7,7,0,0,1,19,11a6.79,6.79,0,0,1-.47,2.51.49.49,0,0,0,.25.64l.91.43a.5.5,0,0,0,.68-.26A9,9,0,0,0,11.74,2Z"]
  };
  
  var trendingDown = {
    prefix: 'axis',
    iconName: 'trendingDown',
    icon: [24, 24, [], "f0000", "M21.5,19h-5a.5.5,0,0,1-.5-.5v-.29a.49.49,0,0,1,.15-.36l1.64-1.64-4.29-4.3-2.65,2.65a.48.48,0,0,1-.7,0l-8-8a.5.5,0,0,1,0-.71l.7-.7a.5.5,0,0,1,.71,0l6.94,6.94,2.65-2.65a.48.48,0,0,1,.7,0l5.36,5.35,1.64-1.64a.49.49,0,0,1,.36-.15h.29a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,21.5,19Z"]
  };
  
  var trendingUp = {
    prefix: 'axis',
    iconName: 'trendingUp',
    icon: [24, 24, [], "f0000", "M22,5.5v5a.5.5,0,0,1-.5.5h-.29a.49.49,0,0,1-.36-.15L19.21,9.21l-5.36,5.35a.48.48,0,0,1-.7,0L10.5,11.91,3.56,18.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71l8-8a.48.48,0,0,1,.7,0l2.65,2.65,4.29-4.3L16.15,6.15A.49.49,0,0,1,16,5.79V5.5a.5.5,0,0,1,.5-.5h5A.5.5,0,0,1,22,5.5Z"]
  };
  
  var uploadOnCloud = {
    prefix: 'axis',
    iconName: 'uploadOnCloud',
    icon: [24, 24, [], "f0000", "M17.9,9C17.4,6.2,15,4,12,4c-3.3,0-6,2.7-6,6c-2.8,0-5,2.2-5,5s2.2,5,5,5h11.5c3,0,5.5-2.5,5.5-5.5C23,11.6,20.8,9.2,17.9,9z M15.9,12.4l-0.2,0.2c-0.1,0.1-0.2,0.1-0.4,0.1H14v3.8c0,0.3-0.2,0.5-0.5,0.5h-3c-0.3,0-0.5-0.2-0.5-0.5v-3.8H8.7c-0.1,0-0.3-0.1-0.4-0.1l-0.2-0.2c-0.2-0.2-0.2-0.5,0-0.7l3.5-3.5c0.2-0.2,0.5-0.2,0.7,0l3.5,3.5C16.1,11.9,16.1,12.2,15.9,12.4z"]
  };
  
  var usb = {
    prefix: 'axis',
    iconName: 'usb',
    icon: [24, 24, [], "f0000", "M18,9.5v3a2,2,0,0,1-.75,1.56L13,17.48v4a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-2l-4.25-3.4A2,2,0,0,1,6,14.52v-3a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v3l3,2.4V6.77H9.82A.74.74,0,0,1,9.2,5.61l2.18-3.28a.75.75,0,0,1,1.24,0L14.8,5.61a.74.74,0,0,1-.62,1.16H13v8.15l3-2.4v-3a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,18,9.5Z"]
  };
  
  var virtualReality = {
    prefix: 'axis',
    iconName: 'virtualReality',
    icon: [24, 24, [], "f0000", "M22.11,8.87,19,5.76A6,6,0,0,0,14.76,4H9.24A6,6,0,0,0,5,5.76L1.89,8.87A3,3,0,0,0,1,11v6a3,3,0,0,0,3,3H8.76a2,2,0,0,0,1.79-1.11l.17-.34a1,1,0,0,1,.9-.55h.76a1,1,0,0,1,.9.55l.17.34A2,2,0,0,0,15.24,20H20a3,3,0,0,0,3-3V11A3,3,0,0,0,22.11,8.87ZM6.42,7.17A4,4,0,0,1,9.24,6h5.52a4,4,0,0,1,2.82,1.17l.83.83H5.59ZM19,13.5a.5.5,0,0,1-.5.5H5.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5Z"]
  };
  
  var virtualRealityOutlined = {
    prefix: 'axis',
    iconName: 'virtualRealityOutlined',
    icon: [24, 24, [], "f0000", "M22.11,8.87,19,5.76A6,6,0,0,0,14.76,4H9.24A6,6,0,0,0,5,5.76L1.89,8.87A3,3,0,0,0,1,11v6a3,3,0,0,0,3,3H8.76a2,2,0,0,0,1.79-1.11l.17-.34a1,1,0,0,1,.9-.55h.76a1,1,0,0,1,.9.55l.17.34A2,2,0,0,0,15.24,20H20a3,3,0,0,0,3-3V11A3,3,0,0,0,22.11,8.87ZM6.42,7.17A4,4,0,0,1,9.24,6h5.52a4,4,0,0,1,2.82,1.17l.83.83H5.59ZM21,17a1,1,0,0,1-1,1H15.24l-.45-.89A2,2,0,0,0,13,16H11a2,2,0,0,0-1.79,1.11L8.76,18H4a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H20a1,1,0,0,1,1,1Zm-2.5-5H5.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,18.5,12Z"]
  };
  
  var website = {
    prefix: 'axis',
    iconName: 'website',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,14H4V8H20ZM6.5,16h4a.5.5,0,0,0,.5-.5v-5a.5.5,0,0,0-.5-.5h-4a.5.5,0,0,0-.5.5v5A.5.5,0,0,0,6.5,16Zm7-4h4a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-4a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,13.5,12Zm0,4h2a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,13.5,16Z"]
  };
  
  var wifi = {
    prefix: 'axis',
    iconName: 'wifi',
    icon: [24, 24, [], "f0000", "M22.78,9.25a.46.46,0,0,1-.13.33l-1.32,1.5a.48.48,0,0,1-.36.16c-.52,0-3.29-3.24-9-3.24s-8.45,3.24-9,3.24a.48.48,0,0,1-.36-.16L1.35,9.58a.46.46,0,0,1-.13-.33C1.22,8.55,6,5,12,5,17.81,5,22.78,8.48,22.78,9.25ZM12,11c-3.61,0-6.81,2.08-6.81,2.74a.55.55,0,0,0,.13.34l1.33,1.5a.48.48,0,0,0,.36.16c.53,0,1.77-1.74,5-1.74s4.5,1.74,5,1.74a.48.48,0,0,0,.36-.16l1.33-1.5a.55.55,0,0,0,.13-.34C18.81,13.09,15.6,11,12,11Zm0,6c-1.09,0-2.82.58-2.82,1.26a.52.52,0,0,0,.12.33l1,1.16a.73.73,0,0,0,.56.25h2.22a.73.73,0,0,0,.56-.25l1-1.16a.52.52,0,0,0,.12-.33C14.82,17.59,13.11,17,12,17Z"]
  };
  
  var wifiOff = {
    prefix: 'axis',
    iconName: 'wifiOff',
    icon: [24, 24, [], "f0000", "M3.4,3.2C3.2,3,2.9,2.9,2.7,3.1c0,0,0,0,0,0L2.2,3.7C2,3.9,1.9,4.2,2.1,4.4c0,0,0,0,0,0l2.4,2.4c-2,1-3.3,2.1-3.3,2.5c0,0.1,0,0.2,0.1,0.3l1.3,1.5c0.1,0.1,0.2,0.2,0.4,0.2c0.3,0,1.5-1.2,3.8-2.2l2.4,2.4c-2.3,0.6-4,1.9-4,2.3c0,0.1,0,0.2,0.1,0.3l1.3,1.5c0.1,0.1,0.2,0.2,0.4,0.2c0.5,0,1.7-1.6,4.8-1.7l6.8,6.8c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l0.5-0.5c0.2-0.2,0.2-0.5,0-0.7c0,0,0,0,0,0L3.4,3.2z M14.8,18.3c0,0.1,0,0.2-0.1,0.3l-1,1.2c-0.1,0.2-0.3,0.3-0.6,0.2h-2.2c-0.2,0-0.4-0.1-0.6-0.2l-1-1.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.7,1.7-1.3,2.8-1.3S14.8,17.6,14.8,18.3z M12,5c-1.3,0-2.6,0.2-3.8,0.5l2.6,2.6C11.2,8,11.6,8,12,8c5.7,0,8.5,3.2,9,3.2c0.1,0,0.3-0.1,0.4-0.2l1.3-1.5c0.1-0.1,0.1-0.2,0.1-0.3C22.8,8.5,17.8,5,12,5z M18.8,13.7c0-0.5-2.1-2-4.9-2.6l3.9,3.9l0.9-1C18.8,14,18.8,13.9,18.8,13.7z"]
  };
  
  var windows = {
    prefix: 'axis',
    iconName: 'windows',
    icon: [24, 24, [], "f0000", "M10,11a.5.5,0,0,1-.5.5h-6A.5.5,0,0,1,3,11V6.33a.5.5,0,0,1,.42-.49l6-1a.5.5,0,0,1,.58.49ZM21,3.5A.5.5,0,0,0,20.42,3l-9,1.5A.5.5,0,0,0,11,5v6a.5.5,0,0,0,.5.5h9A.5.5,0,0,0,21,11ZM10,13a.5.5,0,0,0-.5-.5h-6A.5.5,0,0,0,3,13v4.67a.5.5,0,0,0,.42.49l6,1a.5.5,0,0,0,.58-.49Zm11,0a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.42.49l9,1.5A.5.5,0,0,0,21,20.5Z"]
  };
  
  var arrival = {
    prefix: 'axis',
    iconName: 'arrival',
    icon: [24, 24, [], "f0000", "M22,19.5v1a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h19A.5.5,0,0,1,22,19.5ZM3.44,10l3.12,2.11a6,6,0,0,0,1.31.66L19.1,16.88a2,2,0,0,0,1.53-.07l.08,0a.5.5,0,0,0,.24-.67l-.46-1a3,3,0,0,0-1.69-1.55l-3.74-1.31L11.9,3.85a1,1,0,0,0-.6-.59L10.67,3A.5.5,0,0,0,10,3.5v7L5.71,9,4.9,6.85a1,1,0,0,0-.6-.59L3.67,6A.5.5,0,0,0,3,6.5V9.19A1,1,0,0,0,3.44,10Z"]
  };
  
  var bike = {
    prefix: 'axis',
    iconName: 'bike',
    icon: [24, 24, [], "f0000", "M10.4,16c0.8,0,1.4-0.4,1.8-1.1L15.1,9h0.8l0.6,1.7C15,11.6,14,13.2,14,15c0,2.8,2.2,5,5,5s5-2.2,5-5s-2.2-5-5-5c-0.2,0-0.4,0-0.6,0.1l-1-3.1H19c0.4,0,0.8,0.3,0.9,0.7C20,7.9,20.2,8,20.4,8h1c0.2,0,0.3-0.1,0.4-0.2s0.1-0.3,0.1-0.4C21.7,6,20.4,5,19,5h-2.7c-0.4,0-0.8,0.2-1,0.5c-0.2,0.3-0.3,0.7-0.2,1.1L15.3,7h-7C7.6,7,7,7.6,7,8.2v0.3C7,8.7,7,8.8,6.9,9l-0.6,1.2C5.9,10.1,5.4,10,5,10c-2.8,0-5,2.2-5,5s2.2,5,5,5c2,0,3.8-1.2,4.6-3H7.2c-0.5,0.6-1.3,1-2.2,1c-1.7,0-3-1.3-3-3s1.3-3,3-3c0.1,0,0.2,0,0.4,0l-0.9,1.8c-0.2,0.5-0.2,1,0.1,1.5S5.3,16,5.8,16H10.4z M6.6,14l0.5-1.1c0.3,0.3,0.5,0.7,0.7,1.1H6.6z M10.4,14H9.9c-0.2-1.2-0.9-2.2-1.8-2.9l0.6-1.2C8.8,9.6,8.9,9.3,9,9h3.9L10.4,14z M19,18c-1.7,0-3-1.3-3-3c0-1,0.5-1.8,1.2-2.4l0.7,2.2c0.1,0.3,0.4,0.5,0.7,0.5h1.1c0.2,0,0.4-0.2,0.3-0.5l-1-2.9c1.6,0,2.9,1.4,2.9,3C22,16.7,20.7,18,19,18z M5.5,5h3C8.8,5,9,4.8,9,4.5v-1C9,3.2,8.8,3,8.5,3h-3C5.2,3,5,3.2,5,3.5v1C5,4.8,5.2,5,5.5,5z"]
  };
  
  var boat = {
    prefix: 'axis',
    iconName: 'boat',
    icon: [24, 24, [], "f0000", "M20.64,10.51,19,10V5a2.49,2.49,0,0,0-.73-1.77l-.54-.54A2.49,2.49,0,0,0,16,2H8a2.49,2.49,0,0,0-1.77.73l-.54.54A2.49,2.49,0,0,0,5,5v5l-1.64.49a.5.5,0,0,0-.34.61l1.77,6.56A6.63,6.63,0,0,0,7,18c2.71,0,2.77-1,5-1s2.36,1,5,1a6.63,6.63,0,0,0,2.21-.33L21,11.12h0A.49.49,0,0,0,20.64,10.51ZM17,9.41l-.83-.25-3.6-1.08a2,2,0,0,0-1.14,0L7,9.41V5H17Zm5,10.1v1a.5.5,0,0,1-.45.5c-1.72.12-2.1,1-4.55,1-2.65,0-2.85-1-5-1s-2.28,1-5,1c-2.46,0-2.81-.86-4.55-1a.5.5,0,0,1-.45-.5v-1a.5.5,0,0,1,.54-.5C4.69,19.14,5,20,7,20s2.35-1,5-1,2.85,1,5,1c2,0,2.31-.86,4.46-1A.5.5,0,0,1,22,19.51Z"]
  };
  
  var bus = {
    prefix: 'axis',
    iconName: 'bus',
    icon: [24, 24, [], "f0000", "M19.27,3.27l-.54-.54A2.49,2.49,0,0,0,17,2H7a2.49,2.49,0,0,0-1.77.73l-.54.54A2.49,2.49,0,0,0,4,5V21a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1V20H17v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V5A2.49,2.49,0,0,0,19.27,3.27ZM9,17a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1Zm9,0a1,1,0,0,1-1,1H16a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1Zm0-5H6V6H18Z"]
  };
  
  var car = {
    prefix: 'axis',
    iconName: 'car',
    icon: [24, 24, [], "f0000", "M21,11.56a4.11,4.11,0,0,0-.15-1.1l-1.44-5A2,2,0,0,0,17.49,4h-11A2,2,0,0,0,4.59,5.45l-1.44,5A4.11,4.11,0,0,0,3,11.56V19a1,1,0,0,0,1,1H5a1,1,0,0,0,1-1V18H18v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1ZM6.27,5.93a.25.25,0,0,1,.24-.18h11a.25.25,0,0,1,.24.18L18.89,10H5.11ZM8,14a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1H7a1,1,0,0,1,1,1Zm11,0a1,1,0,0,1-1,1H17a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1Z"]
  };
  
  var carPolice = {
    prefix: 'axis',
    iconName: 'carPolice',
    icon: [24, 24, [], "f0000", "M20.85,12.46l-1.44-5A2,2,0,0,0,17.49,6h-11A2,2,0,0,0,4.59,7.45l-1.44,5A4.11,4.11,0,0,0,3,13.56V21a1,1,0,0,0,1,1H5a1,1,0,0,0,1-1V20H18v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V13.56A4.11,4.11,0,0,0,20.85,12.46ZM6.27,7.93a.25.25,0,0,1,.24-.18h11a.25.25,0,0,1,.24.18L18.89,12H5.11ZM8,16a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1H7a1,1,0,0,1,1,1Zm11,0a1,1,0,0,1-1,1H17a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1ZM11,2.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5V4h4Zm6,0a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5V4h4Z"]
  };
  
  var departure = {
    prefix: 'axis',
    iconName: 'departure',
    icon: [24, 24, [], "f0000", "M22,19.5v1a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h19A.5.5,0,0,1,22,19.5ZM3.9,14.64a1,1,0,0,0,.87.35l4.49-.46a6.91,6.91,0,0,0,1.43-.33l10.1-3.68a2,2,0,0,0,1.13-1l0-.08a.5.5,0,0,0-.24-.67l-1-.46a3.05,3.05,0,0,0-2.3-.1L14.65,9.56,6.8,5.13A1,1,0,0,0,6,5.06l-.63.23a.49.49,0,0,0-.21.79l4.46,5.33L5.89,12.75h0L3.8,11.57A1,1,0,0,0,3,11.5l-.63.23a.49.49,0,0,0-.21.79Z"]
  };
  
  var flight = {
    prefix: 'axis',
    iconName: 'flight',
    icon: [24, 24, [], "f0000", "M22.94,2.86l-.28.77a4,4,0,0,1-.93,1.47L17.41,9.42l2.05,10.23a2.58,2.58,0,0,1,0,.38,1.89,1.89,0,0,1-.57,1.36l-.17.17a.44.44,0,0,1-.34.14.48.48,0,0,1-.41-.23L13.82,13,9.67,16.45l.44,5.2a1,1,0,0,1-.28.68l-.53.53a.48.48,0,0,1-.77-.13L6.11,17.89,1.27,15.47a.48.48,0,0,1-.13-.77l.53-.53a1,1,0,0,1,.68-.28l5.13.43L11,10.18,2.53,6a.48.48,0,0,1-.23-.41.44.44,0,0,1,.14-.34l.17-.17A1.89,1.89,0,0,1,4,4.5a2.58,2.58,0,0,1,.38,0L14.58,6.59,18.9,2.27a4,4,0,0,1,1.47-.93l.77-.28a1,1,0,0,1,1.05.23l.52.52A1,1,0,0,1,22.94,2.86Z"]
  };
  
  var flightCancelled = {
    prefix: 'axis',
    iconName: 'flightCancelled',
    icon: [24, 24, [], "f0000", "M22.94,2.86l-.28.77a4,4,0,0,1-.93,1.47L17.41,9.42l1.07,5.35L9.23,5.52l5.35,1.07L18.9,2.27a4,4,0,0,1,1.47-.93l.77-.28a1,1,0,0,1,1.05.23l.52.52A1,1,0,0,1,22.94,2.86ZM3.38,2.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L3.37,4.61a1.81,1.81,0,0,0-.76.46l-.17.17a.44.44,0,0,0-.14.34A.48.48,0,0,0,2.53,6l4.4,2.18,3.12,3.12-2.57,3-5.13-.43a1,1,0,0,0-.68.28l-.53.53a.48.48,0,0,0,.13.77l4.84,2.42,2.42,4.84a.48.48,0,0,0,.77.13l.53-.53a1,1,0,0,0,.28-.68l-.44-5.2,3-2.51,3.13,3.13L18,21.47a.48.48,0,0,0,.41.23.44.44,0,0,0,.34-.14l.17-.17a1.81,1.81,0,0,0,.46-.76l1.23,1.22a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7Z"]
  };
  
  var metro = {
    prefix: 'axis',
    iconName: 'metro',
    icon: [24, 24, [], "f0000", "M19.27,3.27l-.54-.54A2.49,2.49,0,0,0,17,2H7a2.49,2.49,0,0,0-1.77.73l-.54.54A2.49,2.49,0,0,0,4,5V17a2.49,2.49,0,0,0,.73,1.77l.54.54A2.49,2.49,0,0,0,7,20H8L7,21.62a.26.26,0,0,0,.22.38H8.69a.73.73,0,0,0,.65-.38L10.28,20h3.44l.94,1.62a.73.73,0,0,0,.65.38h1.44a.26.26,0,0,0,.22-.38L16,20H17a2.49,2.49,0,0,0,1.77-.73l.54-.54A2.49,2.49,0,0,0,20,17V5A2.49,2.49,0,0,0,19.27,3.27ZM10,16a2,2,0,1,1,2,2A2,2,0,0,1,10,16Zm8-4H6V6H18Z"]
  };
  
  var motocycle = {
    prefix: 'axis',
    iconName: 'motocycle',
    icon: [24, 24, [], "f0000", "M19,10h-1.4l-2.2-4.3c-0.5-1-1.5-1.7-2.7-1.7h-2.3C10.2,4,10,4.2,10,4.5v1C10,5.8,10.2,6,10.5,6h2.3c0.4,0,0.7,0.2,0.9,0.6l1.7,3.4H5c-2.8,0-5,2.2-5,5s2.2,5,5,5c2,0,3.8-1.2,4.6-3H7.2c-0.5,0.6-1.3,1-2.2,1c-1.7,0-3-1.3-3-3s1.3-3,3-3c1.3,0,2.4,0.8,2.8,2H4.5C4.2,14,4,14.2,4,14.5v1C4,15.8,4.2,16,4.5,16h3.3H9c0.3,0,0.6,0,0.9-0.1c0,0,0,0,0,0c1.8-0.4,3.1-2,3.1-3.9l2,0c-0.6,0.8-1,1.9-1,3c0,2.8,2.2,5,5,5s5-2.2,5-5S21.8,10,19,10z M19,18c-1.7,0-3-1.3-3-3c0-0.8,0.3-1.5,0.8-2.1l1,2c0.1,0.3,0.4,0.4,0.7,0.4h1.2c0.1,0,0.2-0.1,0.3-0.2s0.1-0.2,0-0.3L18.6,12c0.1,0,0.2,0,0.4,0c1.7,0,3,1.3,3,3S20.7,18,19,18z"]
  };
  
  var taxi = {
    prefix: 'axis',
    iconName: 'taxi',
    icon: [24, 24, [], "f0000", "M21,13.56a4.11,4.11,0,0,0-.15-1.1l-1.44-5A2,2,0,0,0,17.49,6h-11A2,2,0,0,0,4.59,7.45l-1.44,5A4.11,4.11,0,0,0,3,13.56V21a1,1,0,0,0,1,1H5a1,1,0,0,0,1-1V20H18v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1ZM6.27,7.93a.25.25,0,0,1,.24-.18h11a.25.25,0,0,1,.24.18L18.89,12H5.11ZM8,16a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1H7a1,1,0,0,1,1,1Zm11,0a1,1,0,0,1-1,1H17a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1ZM15,4H9V2.5A.5.5,0,0,1,9.5,2h5a.5.5,0,0,1,.5.5Z"]
  };
  
  var trafficLight = {
    prefix: 'axis',
    iconName: 'trafficLight',
    icon: [24, 24, [], "f0000", "M19,6V4.5a.5.5,0,0,0-.5-.5H17a2,2,0,0,0-2-2H9A2,2,0,0,0,7,4H5.5a.5.5,0,0,0-.5.5V6A2,2,0,0,0,7,8v2H5.5a.5.5,0,0,0-.5.5V12a2,2,0,0,0,2,2v2H5.5a.5.5,0,0,0-.5.5V18a2,2,0,0,0,2,2,2,2,0,0,0,2,2h6a2,2,0,0,0,2-2,2,2,0,0,0,2-2V16.5a.5.5,0,0,0-.5-.5H17V14a2,2,0,0,0,2-2V10.5a.5.5,0,0,0-.5-.5H17V8A2,2,0,0,0,19,6ZM12,20a2,2,0,1,1,2-2A2,2,0,0,1,12,20Zm0-6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Zm0-6a2,2,0,1,1,2-2A2,2,0,0,1,12,8Z"]
  };
  
  var train = {
    prefix: 'axis',
    iconName: 'train',
    icon: [24, 24, [], "f0000", "M19.27,3.27l-.54-.54A2.49,2.49,0,0,0,17,2H7a2.49,2.49,0,0,0-1.77.73l-.54.54A2.49,2.49,0,0,0,4,5V17a2.49,2.49,0,0,0,.73,1.77l.54.54A2.49,2.49,0,0,0,7,20H8L7,21.62a.26.26,0,0,0,.22.38H8.69a.73.73,0,0,0,.65-.38L10.28,20h3.44l.94,1.62a.73.73,0,0,0,.65.38h1.44a.26.26,0,0,0,.22-.38L16,20H17a2.49,2.49,0,0,0,1.77-.73l.54-.54A2.49,2.49,0,0,0,20,17V5A2.49,2.49,0,0,0,19.27,3.27ZM6,6h5v6H6ZM6,16.5V16a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1H7.5A1.5,1.5,0,0,1,6,16.5Zm12,0A1.5,1.5,0,0,1,16.5,18H16a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1ZM18,12H13V6h5Z"]
  };
  
  var tram = {
    prefix: 'axis',
    iconName: 'tram',
    icon: [24, 24, [], "f0000", "M19.27,3.27l-.54-.54A2.49,2.49,0,0,0,17,2H7a2.49,2.49,0,0,0-1.77.73l-.54.54A2.49,2.49,0,0,0,4,5V17a2.49,2.49,0,0,0,.73,1.77l.54.54A2.49,2.49,0,0,0,7,20H8L7,21.62a.26.26,0,0,0,.22.38H8.69a.73.73,0,0,0,.65-.38L10.28,20h3.44l.94,1.62a.73.73,0,0,0,.65.38h1.44a.26.26,0,0,0,.22-.38L16,20H17a2.49,2.49,0,0,0,1.77-.73l.54-.54A2.49,2.49,0,0,0,20,17V5A2.49,2.49,0,0,0,19.27,3.27ZM6,16.5V16a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1H7.5A1.5,1.5,0,0,1,6,16.5Zm12,0A1.5,1.5,0,0,1,16.5,18H16a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1ZM18,12H6V6H18Z"]
  };
  
  var truck = {
    prefix: 'axis',
    iconName: 'truck',
    icon: [24, 24, [], "f0000", "M19.27,7.27l-.54-.54A2.49,2.49,0,0,0,17,6H7a2.49,2.49,0,0,0-1.77.73l-.54.54A2.49,2.49,0,0,0,4,9V21a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1V20H17v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V9A2.49,2.49,0,0,0,19.27,7.27ZM9,17a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1Zm9,0a1,1,0,0,1-1,1H16a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1Zm0-5H6V9H18ZM17,3a1,1,0,0,0-1-1H8A1,1,0,0,0,7,3V4H17Z"]
  };
  
  var addEvent = {
    prefix: 'axis',
    iconName: 'addEvent',
    icon: [24, 24, [], "f0000", "M21,6a2,2,0,0,0-2-2H18V2.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V4H8V2.5A.5.5,0,0,0,7.5,2h-1a.5.5,0,0,0-.5.5V4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2ZM19,19H5V8H19Zm-4-5.62v-.76a.5.5,0,0,0-.5-.5H12.88V10.5a.5.5,0,0,0-.5-.5h-.76a.5.5,0,0,0-.5.5v1.62H9.5a.5.5,0,0,0-.5.5v.76a.5.5,0,0,0,.5.5h1.62V15.5a.5.5,0,0,0,.5.5h.76a.5.5,0,0,0,.5-.5V13.88H14.5A.5.5,0,0,0,15,13.38Z"]
  };
  
  var addToTrash = {
    prefix: 'axis',
    iconName: 'addToTrash',
    icon: [24, 24, [], "f0000", "M5,8l.87,12.14a2,2,0,0,0,2,1.86h8.28a2,2,0,0,0,2-1.86L19,8Zm11,7.5a.5.5,0,0,1-.5.5H13v2.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V16H8.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H11V11.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V14h2.5a.5.5,0,0,1,.5.5ZM19.5,4H15V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V4H4.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,19.5,4Z"]
  };
  
  var agendaView = {
    prefix: 'axis',
    iconName: 'agendaView',
    icon: [24, 24, [], "f0000", "M18,2H6A2,2,0,0,0,4,4V9a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V4A2,2,0,0,0,18,2Zm2,13v5a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2H18A2,2,0,0,1,20,15Z"]
  };
  
  var agendaViewOutlined = {
    prefix: 'axis',
    iconName: 'agendaViewOutlined',
    icon: [24, 24, [], "f0000", "M18,15v5H6V15H18m0-2H6a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V15a2,2,0,0,0-2-2Zm0-9V9H6V4H18m0-2H6A2,2,0,0,0,4,4V9a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z"]
  };
  
  var alarm = {
    prefix: 'axis',
    iconName: 'alarm',
    icon: [24, 24, [], "f0000", "M12,4a9,9,0,1,0,9,9A9,9,0,0,0,12,4Zm0,16a7,7,0,1,1,7-7A7,7,0,0,1,12,20ZM6.94,3.06A.24.24,0,0,0,7,2.88a.28.28,0,0,0-.09-.19A3,3,0,0,0,2.69,6.92.28.28,0,0,0,2.88,7a.24.24,0,0,0,.18-.07ZM19,2a3,3,0,0,0-1.92.69.28.28,0,0,0-.09.19.24.24,0,0,0,.07.18l3.88,3.88a.24.24,0,0,0,.18.07.28.28,0,0,0,.19-.09A3,3,0,0,0,19,2ZM12.88,12.64V8.5a.5.5,0,0,0-.5-.5h-.76a.5.5,0,0,0-.5.5v4.66a.53.53,0,0,0,.15.35l3.29,3.29a.5.5,0,0,0,.71,0l.53-.53a.5.5,0,0,0,0-.71Z"]
  };
  
  var alarmAdd = {
    prefix: 'axis',
    iconName: 'alarmAdd',
    icon: [24, 24, [], "f0000", "M12,4a9,9,0,1,0,9,9A9,9,0,0,0,12,4Zm0,16a7,7,0,1,1,7-7A7,7,0,0,1,12,20Zm3.5-8H13V9.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V12H8.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H11v2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V14h2.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,15.5,12ZM6.94,3.06A.24.24,0,0,0,7,2.88a.28.28,0,0,0-.09-.19A3,3,0,0,0,2.69,6.92.28.28,0,0,0,2.88,7a.24.24,0,0,0,.18-.07ZM19,2a3,3,0,0,0-1.92.69.28.28,0,0,0-.09.19.24.24,0,0,0,.07.18l3.88,3.88a.24.24,0,0,0,.18.07.28.28,0,0,0,.19-.09A3,3,0,0,0,19,2Z"]
  };
  
  var alarmAlert = {
    prefix: 'axis',
    iconName: 'alarmAlert',
    icon: [24, 24, [], "f0000", "M12,4a9,9,0,1,0,9,9A9,9,0,0,0,12,4Zm0,16a7,7,0,1,1,7-7A7,7,0,0,1,12,20Zm-.53-7h1.06a.25.25,0,0,0,.25-.22l.4-3.22a.5.5,0,0,0-.5-.56H11.32a.5.5,0,0,0-.5.56l.4,3.22A.25.25,0,0,0,11.47,13Zm1,2h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,12.5,15ZM19,2a3,3,0,0,0-1.92.69.28.28,0,0,0-.09.19.24.24,0,0,0,.07.18l3.88,3.88a.24.24,0,0,0,.18.07.28.28,0,0,0,.19-.09A3,3,0,0,0,19,2ZM6.92,2.69A3,3,0,0,0,2.69,6.92.28.28,0,0,0,2.88,7a.24.24,0,0,0,.18-.07L6.94,3.06A.24.24,0,0,0,7,2.88.28.28,0,0,0,6.92,2.69Z"]
  };
  
  var alarmOff = {
    prefix: 'axis',
    iconName: 'alarmOff',
    icon: [24, 24, [], "f0000", "M2.38,2.14a.51.51,0,0,0-.71,0l-.53.53a.51.51,0,0,0,0,.71l.94.94A3.08,3.08,0,0,0,2,5a3,3,0,0,0,.69,1.92A.28.28,0,0,0,2.88,7a.24.24,0,0,0,.18-.07l.82-.82L5.06,7.29A8.91,8.91,0,0,0,3,13a9,9,0,0,0,14.71,7l1.91,1.9a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM12,20A7,7,0,0,1,6.47,8.71l9.82,9.82A7,7,0,0,1,12,20ZM6.94,3.06A.24.24,0,0,0,7,2.88a.28.28,0,0,0-.09-.19A3,3,0,0,0,5,2a1.14,1.14,0,0,0-.26,0L6.36,3.64ZM19,2a3,3,0,0,0-1.92.69.28.28,0,0,0-.09.19.24.24,0,0,0,.07.18l3.88,3.88a.24.24,0,0,0,.18.07.28.28,0,0,0,.19-.09A3,3,0,0,0,19,2ZM12,4A8.87,8.87,0,0,0,7.77,5.06l1.5,1.49A7,7,0,0,1,19,13a6.9,6.9,0,0,1-.56,2.73l1.5,1.5A8.87,8.87,0,0,0,21,13,9,9,0,0,0,12,4Z"]
  };
  
  var alarmOn = {
    prefix: 'axis',
    iconName: 'alarmOn',
    icon: [24, 24, [], "f0000", "M12,4a9,9,0,1,0,9,9A9,9,0,0,0,12,4Zm0,16a7,7,0,1,1,7-7A7,7,0,0,1,12,20ZM6.94,3.06A.24.24,0,0,0,7,2.88a.28.28,0,0,0-.09-.19A3,3,0,0,0,2.69,6.92.28.28,0,0,0,2.88,7a.24.24,0,0,0,.18-.07ZM19,2a3,3,0,0,0-1.92.69.28.28,0,0,0-.09.19.24.24,0,0,0,.07.18l3.88,3.88a.24.24,0,0,0,.18.07.28.28,0,0,0,.19-.09A3,3,0,0,0,19,2ZM7.65,14a.5.5,0,0,1,0-.71l.53-.53a.48.48,0,0,1,.7,0l1.5,1.49,4.74-4.74a.5.5,0,0,1,.7,0l.53.53a.5.5,0,0,1,0,.71l-5.62,5.62a.48.48,0,0,1-.7,0Z"]
  };
  
  var album = {
    prefix: 'axis',
    iconName: 'album',
    icon: [24, 24, [], "f0000", "M18,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V4A2,2,0,0,0,18,2Zm-6,9.5a.5.5,0,0,1-.78.42l-1.94-1.3a.52.52,0,0,0-.56,0l-1.94,1.3A.5.5,0,0,1,6,11.5v-7A.5.5,0,0,1,6.5,4h5a.5.5,0,0,1,.5.5Z"]
  };
  
  var albums = {
    prefix: 'axis',
    iconName: 'albums',
    icon: [24, 24, [], "f0000", "M16,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V4A2,2,0,0,0,16,2Zm-6,9.5a.5.5,0,0,1-.78.42l-1.94-1.3a.52.52,0,0,0-.56,0l-1.94,1.3A.5.5,0,0,1,4,11.5v-7A.5.5,0,0,1,4.5,4h5a.5.5,0,0,1,.5.5ZM21,4H20V20h1a1,1,0,0,0,1-1V5A1,1,0,0,0,21,4Z"]
  };
  
  var allDone = {
    prefix: 'axis',
    iconName: 'allDone',
    icon: [24, 24, [], "f0000", "M2.56,11.05l5.75,5.74L7.25,17.85a.5.5,0,0,1-.71,0L1.15,12.46a.5.5,0,0,1,0-.71l.7-.7A.5.5,0,0,1,2.56,11.05ZM22.85,6.54l-.7-.71a.51.51,0,0,0-.71,0l-9.55,9.55L10.81,14.3l7-7a.5.5,0,0,0,0-.71l-.7-.71a.51.51,0,0,0-.71,0l-7,7.05L7.56,11.05a.5.5,0,0,0-.71,0l-.7.7a.5.5,0,0,0,0,.71l5.39,5.39a.5.5,0,0,0,.71,0l10.6-10.6A.5.5,0,0,0,22.85,6.54Z"]
  };
  
  var apps = {
    prefix: 'axis',
    iconName: 'apps',
    icon: [24, 24, [], "f0000", "M8,4.5v3a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,4,7.5v-3A.5.5,0,0,1,4.5,4h3A.5.5,0,0,1,8,4.5ZM13.5,4h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,13.5,4Zm6,0h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,19.5,4Zm-12,6h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,7.5,10Zm6,0h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,13.5,10Zm6,0h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,19.5,10Zm-12,6h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,7.5,16Zm6,0h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,13.5,16Zm6,0h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,19.5,16Z"]
  };
  
  var attachment = {
    prefix: 'axis',
    iconName: 'attachment',
    icon: [24, 24, [], "f0000", "M18,9.5V17A6,6,0,0,1,6,17V5.5a4.5,4.5,0,0,1,9,0V16a3,3,0,0,1-6,0V9.5A.5.5,0,0,1,9.5,9h.75a.5.5,0,0,1,.5.5V16a1.25,1.25,0,0,0,2.5,0V5.5a2.75,2.75,0,0,0-5.5,0V17a4.25,4.25,0,0,0,8.5,0V9.5a.5.5,0,0,1,.5-.5h.75A.5.5,0,0,1,18,9.5Z"]
  };
  
  var attachmentDiagonal = {
    prefix: 'axis',
    iconName: 'attachmentDiagonal',
    icon: [24, 24, [], "f0000", "M13.31,20.24a6.05,6.05,0,0,1-8.54,0,6,6,0,0,1,0-8.48l8.49-8.44a4.55,4.55,0,0,1,6.41,0,4.47,4.47,0,0,1,0,6.36l-7.79,7.74a3,3,0,0,1-4.27,0,3,3,0,0,1,0-4.25l4.94-4.9a.5.5,0,0,1,.71,0l.54.53a.5.5,0,0,1,0,.71l-4.94,4.9a1.26,1.26,0,0,0,1.78,1.77l7.79-7.73a2.74,2.74,0,0,0,0-3.89,2.78,2.78,0,0,0-3.92,0L6,13a4.25,4.25,0,0,0,0,6,4.32,4.32,0,0,0,6.05,0l5.65-5.61a.51.51,0,0,1,.72,0l.53.53a.48.48,0,0,1,0,.7Z"]
  };
  
  var blocked = {
    prefix: 'axis',
    iconName: 'blocked',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm8,10a7.92,7.92,0,0,1-1.69,4.9L7.1,5.69A7.92,7.92,0,0,1,12,4,8,8,0,0,1,20,12ZM4,12A7.92,7.92,0,0,1,5.69,7.1L16.9,18.31A7.92,7.92,0,0,1,12,20,8,8,0,0,1,4,12Z"]
  };
  
  var category = {
    prefix: 'axis',
    iconName: 'category',
    icon: [24, 24, [], "f0000", "M21,16a1,1,0,0,0-1-1H18V13a2,2,0,0,0-2-2H13V9h2a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H9A1,1,0,0,0,8,4V8A1,1,0,0,0,9,9h2v2H8a2,2,0,0,0-2,2v2H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V16a1,1,0,0,0-1-1H8V13h8v2H14a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1Z"]
  };
  
  var categoryOutlined = {
    prefix: 'axis',
    iconName: 'categoryOutlined',
    icon: [24, 24, [], "f0000", "M20,15H18V13a2,2,0,0,0-2-2H13V9h2a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H9A1,1,0,0,0,8,4V8A1,1,0,0,0,9,9h2v2H8a2,2,0,0,0-2,2v2H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V16a1,1,0,0,0-1-1H8V13h8v2H14a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V16A1,1,0,0,0,20,15ZM10,5h4V7H10ZM9,19H5V17H9Zm10,0H15V17h4Z"]
  };
  
  var clock = {
    prefix: 'axis',
    iconName: 'clock',
    icon: [24, 24, [], "f0000", "M5.5,18.65a.5.5,0,0,1-.09.69l-.57.46a.9.9,0,0,1-.57.2.51.51,0,0,1-.41-.21,10.06,10.06,0,0,1-1.73-4.21.48.48,0,0,1,.12-.4A.46.46,0,0,1,2.63,15h1a.5.5,0,0,1,.49.41A7.82,7.82,0,0,0,5.5,18.65ZM2.62,13h1a.49.49,0,0,0,.49-.41,8.07,8.07,0,0,1,6.47-6.47A.49.49,0,0,0,11,5.63v-1a.46.46,0,0,0-.18-.38.48.48,0,0,0-.4-.12,10,10,0,0,0-8.3,8.3.48.48,0,0,0,.12.4A.46.46,0,0,0,2.62,13ZM11,9.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5ZM7.5,13h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,7.5,13Zm6.08-8.88a.48.48,0,0,0-.4.12.46.46,0,0,0-.18.38v1a.49.49,0,0,0,.41.49A8,8,0,0,1,18.5,18.65a.5.5,0,0,0,.09.69l.57.46a.9.9,0,0,0,.57.2.51.51,0,0,0,.41-.21A10,10,0,0,0,13.58,4.12ZM17.5,13h-1a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,17.5,13Zm-1.05-3L16,9.55a.49.49,0,0,0-.67,0l-5,4.13a1,1,0,0,0-.07,1.48l.57.57a1,1,0,0,0,1.48-.07l4.13-5A.49.49,0,0,0,16.45,10Z"]
  };
  
  var dashboard = {
    prefix: 'axis',
    iconName: 'dashboard',
    icon: [24, 24, [], "f0000", "M11,4V8a1,1,0,0,1-1,1H4A1,1,0,0,1,3,8V4A1,1,0,0,1,4,3h6A1,1,0,0,1,11,4Zm-1,7H4a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V12A1,1,0,0,0,10,11Zm10,4H14a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V16A1,1,0,0,0,20,15ZM20,3H14a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3Z"]
  };
  
  var dashboardOutlined = {
    prefix: 'axis',
    iconName: 'dashboardOutlined',
    icon: [24, 24, [], "f0000", "M10,3H4A1,1,0,0,0,3,4V8A1,1,0,0,0,4,9h6a1,1,0,0,0,1-1V4A1,1,0,0,0,10,3ZM9,7H5V5H9Zm1,4H4a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V12A1,1,0,0,0,10,11ZM9,19H5V13H9Zm11-4H14a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V16A1,1,0,0,0,20,15Zm-1,4H15V17h4ZM20,3H14a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3Zm-1,8H15V5h4Z"]
  };
  
  var dashboardVs = {
    prefix: 'axis',
    iconName: 'dashboardVs',
    icon: [24, 24, [], "f0000", "M11,4V20a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3h6A1,1,0,0,1,11,4Zm3,5h6a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1V8A1,1,0,0,0,14,9Zm0,12h6a1,1,0,0,0,1-1V12a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v8A1,1,0,0,0,14,21Z"]
  };
  
  var dashboardVsOutlined = {
    prefix: 'axis',
    iconName: 'dashboardVsOutlined',
    icon: [24, 24, [], "f0000", "M9,5V19H5V5H9m1-2H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1Zm9,2V7H15V5h4m1-2H14a1,1,0,0,0-1,1V8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1ZM19,13v6H15V13h4m1-2H14a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V12a1,1,0,0,0-1-1Z"]
  };
  
  var download = {
    prefix: 'axis',
    iconName: 'download',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3.85,12.64-3.13,3.14a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L8.15,14.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L11,14.67V6.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v8.17l1.44-1.45a.5.5,0,0,1,.71,0l.7.71A.5.5,0,0,1,15.85,14.64Z"]
  };
  
  var downloadOutlined = {
    prefix: 'axis',
    iconName: 'downloadOutlined',
    icon: [24, 24, [], "f0000", "M12,22A10,10,0,1,0,2,12,10,10,0,0,0,12,22ZM12,4a8,8,0,1,1-8,8A8,8,0,0,1,12,4Zm-.72,13.78a.77.77,0,0,0,.53.22h.38a.75.75,0,0,0,.53-.22l3.13-3.14a.5.5,0,0,0,0-.71l-.7-.71a.5.5,0,0,0-.71,0L13,14.67V6.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5v8.17L9.56,13.23a.49.49,0,0,0-.7,0l-.71.71a.5.5,0,0,0,0,.71Z"]
  };
  
  var downloadTo = {
    prefix: 'axis',
    iconName: 'downloadTo',
    icon: [24, 24, [], "f0000", "M19,18.5v1a.5.5,0,0,1-.5.5H5.5a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13A.5.5,0,0,1,19,18.5Zm-7.35-2.65a.48.48,0,0,0,.7,0l5.79-5.79a.5.5,0,0,0,0-.71l-.2-.2A.49.49,0,0,0,17.58,9H15V3.5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5V9H6.42a.49.49,0,0,0-.36.15l-.2.2a.5.5,0,0,0,0,.71Z"]
  };
  
  var edit = {
    prefix: 'axis',
    iconName: 'edit',
    icon: [24, 24, [], "f0000", "M16.81,10a.5.5,0,0,1,0,.7L8.75,18.79a2,2,0,0,1-.68.45L3.73,21a.5.5,0,0,1-.54-.11l0,0A.5.5,0,0,1,3,20.27l1.72-4.34a2,2,0,0,1,.45-.68l8.07-8.07a.5.5,0,0,1,.71,0ZM20.56,4.1l-.66-.66A1.5,1.5,0,0,0,18.84,3h-.76A1.5,1.5,0,0,0,17,3.44L15.19,5.27a.5.5,0,0,0,0,.7L18,8.82a.5.5,0,0,0,.71,0L20.56,7A1.5,1.5,0,0,0,21,5.92V5.16A1.5,1.5,0,0,0,20.56,4.1Z"]
  };
  
  var emptyTrash = {
    prefix: 'axis',
    iconName: 'emptyTrash',
    icon: [24, 24, [], "f0000", "M20,4.5v1a.5.5,0,0,1-.5.5H4.5A.5.5,0,0,1,4,5.5v-1A.5.5,0,0,1,4.5,4H9V3a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V4h4.5A.5.5,0,0,1,20,4.5ZM16.28,18H7.72L7,8H5l.87,12.14a2,2,0,0,0,2,1.86h8.28a2,2,0,0,0,2-1.86L19,8H17Z"]
  };
  
  var envelope = {
    prefix: 'axis',
    iconName: 'envelope',
    icon: [24, 24, [], "f0000", "M18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM18 7L11.65 11.45C11.1662 11.7882 10.5902 11.9695 10 11.9695C9.40976 11.9695 8.83377 11.7882 8.35 11.45L2 7V4.9L9.35 10.05C9.54087 10.1825 9.76766 10.2535 10 10.2535C10.2323 10.2535 10.4591 10.1825 10.65 10.05L18 4.9V7Z"]
  };
  
  var explore = {
    prefix: 'axis',
    iconName: 'explore',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm4.47,6.42-2,4.93a2,2,0,0,1-1.09,1.09l-4.93,2a.49.49,0,0,1-.54-.11l-.24-.24a.49.49,0,0,1-.11-.54l2-4.93a2,2,0,0,1,1.09-1.09l4.93-2a.49.49,0,0,1,.54.11l.24.24A.49.49,0,0,1,16.47,8.42Z"]
  };
  
  var exploreOff = {
    prefix: 'axis',
    iconName: 'exploreOff',
    icon: [24, 24, [], "f0000", "M4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7l1.19,1.2A10,10,0,0,0,18.42,19.66l1.2,1.19a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7Zm4,13.32a.49.49,0,0,1-.54-.11l-.24-.24a.49.49,0,0,1-.11-.54l2-4.82,3.72,3.72Zm7.16-8.94a.49.49,0,0,1,.54.11l.24.24a.49.49,0,0,1,.11.54L15.2,11.49,20.67,17A10,10,0,0,0,7,3.33L12.51,8.8Z"]
  };
  
  var exploreOffOutlined = {
    prefix: 'axis',
    iconName: 'exploreOffOutlined',
    icon: [24, 24, [], "f0000", "M4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7l1.19,1.2A10,10,0,0,0,18.42,19.66l1.2,1.19a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM12,20A8,8,0,0,1,5.77,7l3.75,3.74-2,4.83a.49.49,0,0,0,.11.54l.24.24a.49.49,0,0,0,.54.11l4.83-2L17,18.23A7.94,7.94,0,0,1,12,20ZM12,4a8,8,0,0,1,7.2,11.49L20.68,17A10,10,0,0,0,7,3.32L8.51,4.8A8,8,0,0,1,12,4Zm3.58,3.53L12.51,8.8l2.69,2.69,1.27-3.07a.49.49,0,0,0-.11-.54l-.24-.24A.49.49,0,0,0,15.58,7.53Z"]
  };
  
  var exploreOutlined = {
    prefix: 'axis',
    iconName: 'exploreOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM16.12,7.64a.49.49,0,0,0-.54-.11l-4.93,2a2,2,0,0,0-1.09,1.09l-2,4.93a.49.49,0,0,0,.11.54l.24.24a.49.49,0,0,0,.54.11l4.93-2a2,2,0,0,0,1.09-1.09l2-4.93a.49.49,0,0,0-.11-.54Z"]
  };
  
  var feed = {
    prefix: 'axis',
    iconName: 'feed',
    icon: [24, 24, [], "f0000", "M21.5,6h-1a.5.5,0,0,0-.5.5V17a1,1,0,0,1-2,0V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6.5A.5.5,0,0,0,21.5,6ZM15,15.5a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5Zm0-4a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,5.5,8h9a.5.5,0,0,1,.5.5Z"]
  };
  
  var feedOutlined = {
    prefix: 'axis',
    iconName: 'feedOutlined',
    icon: [24, 24, [], "f0000", "M21.5,6h-1a.5.5,0,0,0-.5.5V17a1,1,0,0,1-2,0V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6.5A.5.5,0,0,0,21.5,6ZM5,18a1,1,0,0,1-1-1V6H16V17a3,3,0,0,0,.18,1ZM13.5,8h-7a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,13.5,8Zm0,6h-7a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,13.5,14Z"]
  };
  
  var filter = {
    prefix: 'axis',
    iconName: 'filter',
    icon: [24, 24, [], "f0000", "M10,13.83a2,2,0,0,0-.59-1.42L3.59,6.59A2,2,0,0,1,3,5.17V4A1,1,0,0,1,4,3H20a1,1,0,0,1,1,1V5.17a2,2,0,0,1-.59,1.42l-5.82,5.82A2,2,0,0,0,14,13.83V17.5a2,2,0,0,1-.8,1.6l-2.4,1.8a.5.5,0,0,1-.8-.4Z"]
  };
  
  var filterList = {
    prefix: 'axis',
    iconName: 'filterList',
    icon: [24, 24, [], "f0000", "M20.5,7H3.5A.5.5,0,0,1,3,6.5v-1A.5.5,0,0,1,3.5,5h17a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,20.5,7ZM18,12.5v-1a.5.5,0,0,0-.5-.5H6.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h11A.5.5,0,0,0,18,12.5Zm-3,6v-1a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,15,18.5Z"]
  };
  
  var filterOptions = {
    prefix: 'axis',
    iconName: 'filterOptions',
    icon: [24, 24, [], "f0000", "M5 19H7V20.5C7 20.6326 6.94732 20.7598 6.85355 20.8536C6.75979 20.9473 6.63261 21 6.5 21H5.5C5.36739 21 5.24021 20.9473 5.14645 20.8536C5.05268 20.7598 5 20.6326 5 20.5V19ZM11 20.5C11 20.6326 11.0527 20.7598 11.1464 20.8536C11.2402 20.9473 11.3674 21 11.5 21H12.5C12.6326 21 12.7598 20.9473 12.8536 20.8536C12.9473 20.7598 13 20.6326 13 20.5V9H11V20.5ZM17 20.5C17 20.6326 17.0527 20.7598 17.1464 20.8536C17.2402 20.9473 17.3674 21 17.5 21H18.5C18.6326 21 18.7598 20.9473 18.8536 20.8536C18.9473 20.7598 19 20.6326 19 20.5V15H17V20.5ZM8.5 15H7V3.5C7 3.36739 6.94732 3.24021 6.85355 3.14645C6.75979 3.05268 6.63261 3 6.5 3H5.5C5.36739 3 5.24021 3.05268 5.14645 3.14645C5.05268 3.24021 5 3.36739 5 3.5V15H3.5C3.36739 15 3.24021 15.0527 3.14645 15.1464C3.05268 15.2402 3 15.3674 3 15.5V16.5C3 16.6326 3.05268 16.7598 3.14645 16.8536C3.24021 16.9473 3.36739 17 3.5 17H8.5C8.63261 17 8.75979 16.9473 8.85355 16.8536C8.94732 16.7598 9 16.6326 9 16.5V15.5C9 15.3674 8.94732 15.2402 8.85355 15.1464C8.75979 15.0527 8.63261 15 8.5 15ZM15 5.5C15 5.36739 14.9473 5.24021 14.8536 5.14645C14.7598 5.05268 14.6326 5 14.5 5H13V3.5C13 3.36739 12.9473 3.24021 12.8536 3.14645C12.7598 3.05268 12.6326 3 12.5 3H11.5C11.3674 3 11.2402 3.05268 11.1464 3.14645C11.0527 3.24021 11 3.36739 11 3.5V5H9.5C9.36739 5 9.24021 5.05268 9.14645 5.14645C9.05268 5.24021 9 5.36739 9 5.5V6.5C9 6.63261 9.05268 6.75979 9.14645 6.85355C9.24021 6.94732 9.36739 7 9.5 7H14.5C14.6326 7 14.7598 6.94732 14.8536 6.85355C14.9473 6.75979 15 6.63261 15 6.5V5.5ZM20.5 11H19V3.5C19 3.36739 18.9473 3.24021 18.8536 3.14645C18.7598 3.05268 18.6326 3 18.5 3H17.5C17.3674 3 17.2402 3.05268 17.1464 3.14645C17.0527 3.24021 17 3.36739 17 3.5V11H15.5C15.3674 11 15.2402 11.0527 15.1464 11.1464C15.0527 11.2402 15 11.3674 15 11.5V12.5C15 12.6326 15.0527 12.7598 15.1464 12.8536C15.2402 12.9473 15.3674 13 15.5 13H20.5C20.6326 13 20.7598 12.9473 20.8536 12.8536C20.9473 12.7598 21 12.6326 21 12.5V11.5C21 11.3674 20.9473 11.2402 20.8536 11.1464C20.7598 11.0527 20.6326 11 20.5 11Z"]
  };
  
  var filterOutlined = {
    prefix: 'axis',
    iconName: 'filterOutlined',
    icon: [24, 24, [], "f0000", "M20,3H4A1,1,0,0,0,3,4V5.17a2,2,0,0,0,.59,1.42l5.82,5.82A2,2,0,0,1,10,13.83V20.5a.5.5,0,0,0,.8.4l2.4-1.8a2,2,0,0,0,.8-1.6V13.83a2,2,0,0,1,.59-1.42l5.82-5.82A2,2,0,0,0,21,5.17V4A1,1,0,0,0,20,3ZM19,5.17,16.17,8H7.83L5,5.17V5H19Z"]
  };
  
  var formatBullets = {
    prefix: 'axis',
    iconName: 'formatBullets',
    icon: [24, 24, [], "f0000", "M21,5.5v1a.5.5,0,0,1-.5.5H9.5A.5.5,0,0,1,9,6.5v-1A.5.5,0,0,1,9.5,5h11A.5.5,0,0,1,21,5.5ZM20.5,11H9.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h11a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,11Zm0,6H9.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h11a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,17ZM5,4A2,2,0,1,0,7,6,2,2,0,0,0,5,4Zm0,6a2,2,0,1,0,2,2A2,2,0,0,0,5,10Zm0,6a2,2,0,1,0,2,2A2,2,0,0,0,5,16Z"]
  };
  
  var formatPoints = {
    prefix: 'axis',
    iconName: 'formatPoints',
    icon: [24, 24, [], "f0000", "M3.5,5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,3,6.5v-1A.5.5,0,0,1,3.5,5Zm17,0H7.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,5ZM3,11.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1A.5.5,0,0,0,3,11.5ZM20.5,11H7.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,11ZM3,17.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1A.5.5,0,0,0,3,17.5ZM20.5,17H7.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,20.5,17Z"]
  };
  
  var hidden = {
    prefix: 'axis',
    iconName: 'hidden',
    icon: [24, 24, [], "f0000", "M4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L5.75,7a9.66,9.66,0,0,0-3.69,4.68h0A1,1,0,0,0,2,12a.81.81,0,0,0,.06.31h0A10.65,10.65,0,0,0,12,19a11,11,0,0,0,4.67-1.09l2.95,2.94a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM12,15a3,3,0,0,1-3-3,2.89,2.89,0,0,1,.37-1.4l4,4A2.89,2.89,0,0,1,12,15Zm10-3.3v0A10.67,10.67,0,0,0,9.12,5.41L19.61,15.9a9.41,9.41,0,0,0,2.33-3.57h0A.81.81,0,0,0,22,12v0A.93.93,0,0,0,22,11.7Z"]
  };
  
  var hiddenOutlined = {
    prefix: 'axis',
    iconName: 'hiddenOutlined',
    icon: [24, 24, [], "f0000", "M4.38,3.15a.48.48,0,0,0-.7,0l-.53.53a.48.48,0,0,0,0,.7L5.75,7a9.66,9.66,0,0,0-3.69,4.68h0A1,1,0,0,0,2,12a.81.81,0,0,0,.06.31h0A10.65,10.65,0,0,0,12,19a10.82,10.82,0,0,0,4.67-1.09l2.95,2.94a.48.48,0,0,0,.7,0l.53-.53a.48.48,0,0,0,0-.7ZM12,17a8.82,8.82,0,0,1-7.93-5A8.11,8.11,0,0,1,7.2,8.44L9.36,10.6a3,3,0,0,0,4,4l1.76,1.76A9,9,0,0,1,12,17Zm10-5.3v0A10.71,10.71,0,0,0,9.12,5.4l1.69,1.69A8,8,0,0,1,12,7a8.82,8.82,0,0,1,7.93,5,7.26,7.26,0,0,1-1.74,2.47l1.42,1.42a9.11,9.11,0,0,0,2.33-3.56h0A.81.81,0,0,0,22,12v0A.93.93,0,0,0,22,11.7Z"]
  };
  
  var home = {
    prefix: 'axis',
    iconName: 'home',
    icon: [24, 24, [], "f0000", "M21,12.24V20a1,1,0,0,1-1,1H16a1,1,0,0,1-1-1V14.5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5V20a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V12.24a3,3,0,0,1,.88-2.12l6.83-6.83a1,1,0,0,1,.7-.29h1.18a1,1,0,0,1,.7.29l6.83,6.83A3,3,0,0,1,21,12.24Z"]
  };
  
  var homeOutlined = {
    prefix: 'axis',
    iconName: 'homeOutlined',
    icon: [24, 24, [], "f0000", "M12.17,5l6.54,6.54a1,1,0,0,1,.29.7V19H16V13a1,1,0,0,0-1-1H9a1,1,0,0,0-1,1v6H5V12.24a1,1,0,0,1,.29-.7L11.83,5h.34m.42-2H11.41a1,1,0,0,0-.7.29L3.88,10.12A3,3,0,0,0,3,12.24V20a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V14.25a.25.25,0,0,1,.25-.25h3.5a.25.25,0,0,1,.25.25V20a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V12.24a3,3,0,0,0-.88-2.12L13.29,3.29a1,1,0,0,0-.7-.29Z"]
  };
  
  var homeVs = {
    prefix: 'axis',
    iconName: 'homeVs',
    icon: [24, 24, [], "f0000", "M21.71,10.71,14.29,3.29a1,1,0,0,0-.7-.29H10.41a1,1,0,0,0-.7.29L2.29,10.71a1,1,0,0,0-.29.7V12.5a.5.5,0,0,0,.5.5H4v7a1,1,0,0,0,1,1H8a1,1,0,0,0,1-1V14.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5V20a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V13h1.5a.5.5,0,0,0,.5-.5V11.41A1,1,0,0,0,21.71,10.71Z"]
  };
  
  var homeVs1Outlined = {
    prefix: 'axis',
    iconName: 'homeVs1Outlined',
    icon: [24, 24, [], "f0000", "M2,13.5a.5.5,0,0,0,.5.5H4v6a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V15.25a.25.25,0,0,1,.25-.25h1.5a.25.25,0,0,1,.25.25V20a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V14h1.5a.5.5,0,0,0,.5-.5V11.41a1,1,0,0,0-.29-.7L14.29,3.29a1,1,0,0,0-.7-.29H10.41a1,1,0,0,0-.7.29L2.29,10.71a1,1,0,0,0-.29.7ZM15,19V14a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1v5H6V12.5a.5.5,0,0,0-.5-.5H4.05a.89.89,0,0,1,.24-.46L10.83,5h2.34l6.54,6.54A.89.89,0,0,1,20,12H18.5a.5.5,0,0,0-.5.5V19Z"]
  };
  
  var homeVs2Outlined = {
    prefix: 'axis',
    iconName: 'homeVs2Outlined',
    icon: [24, 24, [], "f0000", "M21.71,10.71,14.29,3.29a1,1,0,0,0-.7-.29H10.41a1,1,0,0,0-.7.29L2.29,10.71a1,1,0,0,0-.29.7V12.5a.5.5,0,0,0,.5.5H4v7a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V15.25a.25.25,0,0,1,.25-.25h1.5a.25.25,0,0,1,.25.25V20a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V13h1.5a.5.5,0,0,0,.5-.5V11.41A1,1,0,0,0,21.71,10.71ZM18,19H15V14a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1v5H6V9.83L10.83,5h2.34L18,9.83Z"]
  };
  
  var hot = {
    prefix: 'axis',
    iconName: 'hot',
    icon: [24, 24, [], "f0000", "M12.13,2.15A1,1,0,0,0,11.6,2h-.1a.5.5,0,0,0-.5.5V7.12a.5.5,0,0,1-.92.27A7.17,7.17,0,0,0,7.64,5.64a.47.47,0,0,0-.43,0A.49.49,0,0,0,7,6.05c-.31,2.83-3,4-3,8a8,8,0,0,0,16,0C20,7.77,14.54,3.66,12.13,2.15ZM12,20a4,4,0,0,1-4-4c0-2.7,2.72-4.26,3-5.78a.25.25,0,0,1,.28-.2A6.59,6.59,0,0,1,16,16,4,4,0,0,1,12,20Z"]
  };
  
  var saveTo = {
    prefix: 'axis',
    iconName: 'saveTo',
    icon: [24, 24, [], "f0000", "M11.28,16.78a.75.75,0,0,0,.53.22h.38a.77.77,0,0,0,.53-.22l5.13-5.14a.5.5,0,0,0,0-.71l-.71-.71a.49.49,0,0,0-.7,0L13,13.67V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V13.67L7.56,10.22a.5.5,0,0,0-.71,0l-.7.71a.5.5,0,0,0,0,.71ZM12,14.67ZM21,19V15.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V19H5V15.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V19a2,2,0,0,0,2,2H19A2,2,0,0,0,21,19Z"]
  };
  
  var invisible = {
    prefix: 'axis',
    iconName: 'invisible',
    icon: [24, 24, [], "f0000", "M22,11.7v0A10.65,10.65,0,0,0,12,5a10.65,10.65,0,0,0-9.94,6.67h0A1,1,0,0,0,2,12a.81.81,0,0,0,.06.31h0A10.65,10.65,0,0,0,12,19a10.65,10.65,0,0,0,9.94-6.67h0A.81.81,0,0,0,22,12v0A.93.93,0,0,0,22,11.7ZM12,17a8.82,8.82,0,0,1-7.93-5,8.79,8.79,0,0,1,15.86,0A8.82,8.82,0,0,1,12,17Zm0-7a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z"]
  };
  
  var launch = {
    prefix: 'axis',
    iconName: 'launch',
    icon: [24, 24, [], "f0000", "M20.71,3.72l-.43-.43A1,1,0,0,0,19.39,3l-5.5,1a3.89,3.89,0,0,0-2.36,1.41L9.37,8.19A3,3,0,0,0,5.91,9.28l-2.82,4a.5.5,0,0,0,.12.69l.41.29a3,3,0,0,0,4.18-.74l.63-.89,2.91,2.91-.89.63a3,3,0,0,0-.74,4.18l.29.41a.5.5,0,0,0,.69.12l4-2.82a3,3,0,0,0,1.09-3.46l2.75-2.16A3.89,3.89,0,0,0,20,10.11l1-5.5A1,1,0,0,0,20.71,3.72ZM16.56,9.56a1.5,1.5,0,1,1,0-2.12A1.49,1.49,0,0,1,16.56,9.56ZM7.82,16.88a.5.5,0,0,1,0,.71L4.56,20.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71l3.26-3.26a.5.5,0,0,1,.71,0Z"]
  };
  
  var launchOutlined = {
    prefix: 'axis',
    iconName: 'launchOutlined',
    icon: [24, 24, [], "f0000", "M20.71,3.72l-.43-.43A1,1,0,0,0,19.39,3l-5.5,1a3.89,3.89,0,0,0-2.36,1.41L9.37,8.19A3,3,0,0,0,5.91,9.28l-2.82,4a.5.5,0,0,0,.12.69l.41.29a3,3,0,0,0,4.18-.74l.63-.89,2.91,2.91-.89.63a3,3,0,0,0-.74,4.18l.29.41a.5.5,0,0,0,.69.12l4-2.82a3,3,0,0,0,1.09-3.46l2.75-2.16A3.89,3.89,0,0,0,20,10.11l1-5.5A1,1,0,0,0,20.71,3.72ZM9.32,11.07,12.9,6.52a2.24,2.24,0,0,1,1.3-.78l1.53-.28,2.81,2.81L18.26,9.8a2.23,2.23,0,0,1-.77,1.29l-4.56,3.59Zm4.12-2.63a1.5,1.5,0,0,0,2.12,2.12,1.5,1.5,0,0,0-2.12-2.12ZM7.12,16.18a.5.5,0,0,0-.71,0L3.15,19.44a.5.5,0,0,0,0,.71l.7.7a.5.5,0,0,0,.71,0l3.26-3.26a.5.5,0,0,0,0-.71Z"]
  };
  
  var launchVs = {
    prefix: 'axis',
    iconName: 'launchVs',
    icon: [24, 24, [], "f0000", "M20.41,3.83l-.24-.24A2,2,0,0,0,18.76,3H17.24a8,8,0,0,0-5.65,2.34L10.37,6.56,10,7H8.2a2,2,0,0,0-1.6.8L3.1,12.47a.49.49,0,0,0,0,.65l1.36,1.36a1.5,1.5,0,0,0,2.21-.1l.09-.11,2.92,2.92-.11.09a1.5,1.5,0,0,0-.1,2.21l1.36,1.36a.49.49,0,0,0,.65,0l4.67-3.5a2,2,0,0,0,.8-1.6V14.05l.44-.42,1.22-1.22A8,8,0,0,0,21,6.76V5.24A2,2,0,0,0,20.41,3.83Zm-5,4.76a2,2,0,1,1-2.82,0A2,2,0,0,1,15.41,8.59ZM7.21,17.5a.48.48,0,0,1,0,.7L4.56,20.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71L5.8,16.79a.48.48,0,0,1,.7,0Z"]
  };
  
  var launchVsOutlined = {
    prefix: 'axis',
    iconName: 'launchVsOutlined',
    icon: [24, 24, [], "f0000", "M20.41,3.83l-.24-.24A2,2,0,0,0,18.76,3H17.24a8,8,0,0,0-5.65,2.34L10.37,6.56,10,7H8.2a2,2,0,0,0-1.6.8L3.1,12.47a.49.49,0,0,0,0,.65l1.36,1.36a1.5,1.5,0,0,0,2.21-.1l.09-.11,2.92,2.92-.11.09a1.5,1.5,0,0,0-.1,2.21l1.36,1.36a.49.49,0,0,0,.65,0l4.67-3.5a2,2,0,0,0,.8-1.6V14.05l.44-.42,1.22-1.22A8,8,0,0,0,21,6.76V5.24A2,2,0,0,0,20.41,3.83ZM17.24,11,16,12.21a28.11,28.11,0,0,1-4.27,3.5l-.4.27L8,12.64l.27-.4A28.11,28.11,0,0,1,11.79,8L13,6.76a6,6,0,0,1,1.29-1l3.93,3.93A6,6,0,0,1,17.24,11ZM14.56,9.44a1.5,1.5,0,1,1-2.12,0A1.49,1.49,0,0,1,14.56,9.44ZM7.21,17.5a.48.48,0,0,1,0,.7L4.56,20.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71L5.8,16.79a.48.48,0,0,1,.7,0Z"]
  };
  
  var lock = {
    prefix: 'axis',
    iconName: 'lock',
    icon: [24, 24, [], "f0000", "M18,10V8A6,6,0,0,0,6,8v2a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V12A2,2,0,0,0,18,10ZM8,8a4,4,0,0,1,8,0v2H8Zm6,9a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Z"]
  };
  
  var lockOpenOutlined = {
    prefix: 'axis',
    iconName: 'lockOpenOutlined',
    icon: [24, 24, [], "f0000", "M18,10H8V8a4,4,0,0,1,8,0h2A6,6,0,0,0,6,8v2a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V12A2,2,0,0,0,18,10Zm0,10H6V12H18Z"]
  };
  
  var lockOpened = {
    prefix: 'axis',
    iconName: 'lockOpened',
    icon: [24, 24, [], "f0000", "M18,10H8V8a4,4,0,0,1,8,0h2A6,6,0,0,0,6,8v2a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V12A2,2,0,0,0,18,10Zm-4,7a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Z"]
  };
  
  var lockOutlined = {
    prefix: 'axis',
    iconName: 'lockOutlined',
    icon: [24, 24, [], "f0000", "M18,12m0,0v8H6V12ZM12,2A6,6,0,0,0,6,8v2a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2V8a6,6,0,0,0-6-6ZM8,10V8a4,4,0,0,1,8,0v2Z"]
  };
  
  var menuHamburger = {
    prefix: 'axis',
    iconName: 'menuHamburger',
    icon: [24, 24, [], "f0000", "M20.5,7H3.5A.5.5,0,0,1,3,6.5v-1A.5.5,0,0,1,3.5,5h17a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,20.5,7Zm.5,5.5v-1a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17A.5.5,0,0,0,21,12.5Zm0,6v-1a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h17A.5.5,0,0,0,21,18.5Z"]
  };
  
  var menuLeft = {
    prefix: 'axis',
    iconName: 'menuLeft',
    icon: [24, 24, [], "f0000", "M20.5,7H3.5A.5.5,0,0,1,3,6.5v-1A.5.5,0,0,1,3.5,5h17a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,20.5,7ZM15,12.5v-1a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h11A.5.5,0,0,0,15,12.5Zm-6,6v-1a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,9,18.5Z"]
  };
  
  var menuLeftRight = {
    prefix: 'axis',
    iconName: 'menuLeftRight',
    icon: [24, 24, [], "f0000", "M20.5,7H3.5A.5.5,0,0,1,3,6.5v-1A.5.5,0,0,1,3.5,5h17a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,20.5,7Zm.5,5.5v-1a.5.5,0,0,0-.5-.5H9.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h11A.5.5,0,0,0,21,12.5Zm0,6v-1a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,21,18.5Z"]
  };
  
  var menuVs = {
    prefix: 'axis',
    iconName: 'menuVs',
    icon: [24, 24, [], "f0000", "M10,5V8a2,2,0,0,1-2,2H5A2,2,0,0,1,3,8V5A2,2,0,0,1,5,3H8A2,2,0,0,1,10,5Zm9-2H16a2,2,0,0,0-2,2V8a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM8,14H5a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H8a2,2,0,0,0,2-2V16A2,2,0,0,0,8,14Zm11,0H16a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V16A2,2,0,0,0,19,14Z"]
  };
  
  var menuVsOutlined = {
    prefix: 'axis',
    iconName: 'menuVsOutlined',
    icon: [24, 24, [], "f0000", "M8,3H5A2,2,0,0,0,3,5V8a2,2,0,0,0,2,2H8a2,2,0,0,0,2-2V5A2,2,0,0,0,8,3ZM8,8H5V5H8ZM19,3H16a2,2,0,0,0-2,2V8a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,5H16V5h3Zm-9,8a2,2,0,0,0-2-2H5a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2H8a2,2,0,0,0,2-2ZM8,19H5V16H8Zm11-5H16a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V16A2,2,0,0,0,19,14Zm0,5H16V16h3Z"]
  };
  
  var moreHorizontal = {
    prefix: 'axis',
    iconName: 'moreHorizontal',
    icon: [24, 24, [], "f0000", "M18,10a2,2,0,1,1-2,2A2,2,0,0,1,18,10Zm-4,2a2,2,0,1,0-2,2A2,2,0,0,0,14,12ZM8,12a2,2,0,1,0-2,2A2,2,0,0,0,8,12Z"]
  };
  
  var moreVertical = {
    prefix: 'axis',
    iconName: 'moreVertical',
    icon: [24, 24, [], "f0000", "M10,6a2,2,0,1,1,2,2A2,2,0,0,1,10,6Zm2,4a2,2,0,1,0,2,2A2,2,0,0,0,12,10Zm0,6a2,2,0,1,0,2,2A2,2,0,0,0,12,16Z"]
  };
  
  var newMessage = {
    prefix: 'axis',
    iconName: 'newMessage',
    icon: [24, 24, [], "f0000", "M21,11.5V19a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3h7.5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H5V19H19V11.5a.5.5,0,0,1,.5-.5h1A.5.5,0,0,1,21,11.5Zm-.29-7.79-.42-.42a1,1,0,0,0-.7-.29h-.3a1,1,0,0,0-.7.29l-1.8,1.8a.5.5,0,0,0,0,.7l1.42,1.42a.5.5,0,0,0,.7,0l1.8-1.8a1,1,0,0,0,.29-.7v-.3A1,1,0,0,0,20.71,3.71ZM7.83,14.29l-.79,2a.5.5,0,0,0,.11.54l0,0a.5.5,0,0,0,.54.11l2-.79a2,2,0,0,0,.68-.44L17,9.15a.5.5,0,0,0,0-.7L15.55,7a.5.5,0,0,0-.7,0L8.27,13.61A2,2,0,0,0,7.83,14.29Z"]
  };
  
  var password = {
    prefix: 'axis',
    iconName: 'password',
    icon: [24, 24, [], "f0000", "M18,10V8A6,6,0,0,0,6,8v2a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V12A2,2,0,0,0,18,10ZM8,8a4,4,0,0,1,8,0v2H8Zm7,7.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5Zm-4,0a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5Zm-4,1v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,7,16.5Z"]
  };
  
  var passwordOpen = {
    prefix: 'axis',
    iconName: 'passwordOpen',
    icon: [24, 24, [], "f0000", "M8,10V8a4,4,0,0,1,8,0h2A6,6,0,0,0,6,8v2a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Zm7,5.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5Zm-4,0a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5Zm-4,1v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,7,16.5Z"]
  };
  
  var removeFromTrash = {
    prefix: 'axis',
    iconName: 'removeFromTrash',
    icon: [24, 24, [], "f0000", "M5,8l.87,12.14a2,2,0,0,0,2,1.86h8.28a2,2,0,0,0,2-1.86L19,8Zm10.09,8.86a.48.48,0,0,1,0,.7l-.53.53a.48.48,0,0,1-.7,0L12,16.24l-1.86,1.85a.48.48,0,0,1-.7,0l-.53-.53a.48.48,0,0,1,0-.7L10.76,15,8.91,13.14a.48.48,0,0,1,0-.7l.53-.53a.48.48,0,0,1,.7,0L12,13.76l1.86-1.85a.48.48,0,0,1,.7,0l.53.53a.48.48,0,0,1,0,.7L13.24,15ZM19.5,4H15V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V4H4.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,19.5,4Z"]
  };
  
  var settings = {
    prefix: 'axis',
    iconName: 'settings',
    icon: [24, 24, [], "f0000", "M21,14.73l-.8-.66a2,2,0,0,1-.72-1.64c0-.14,0-.29,0-.43s0-.29,0-.43a2,2,0,0,1,.72-1.64l.8-.66A1,1,0,0,0,21.24,8L20.08,6a1,1,0,0,0-1.21-.43l-1,.36a2,2,0,0,1-1.78-.19,5.48,5.48,0,0,0-.74-.43,2,2,0,0,1-1.06-1.45l-.17-1a1,1,0,0,0-1-.84h-2.3a1,1,0,0,0-1,.84l-.17,1A2,2,0,0,1,8.63,5.31a5.48,5.48,0,0,0-.74.43,2,2,0,0,1-1.78.19l-1-.36A1,1,0,0,0,3.92,6L2.76,8A1,1,0,0,0,3,9.27l.8.66a2,2,0,0,1,.72,1.64c0,.14,0,.29,0,.43s0,.29,0,.43a2,2,0,0,1-.72,1.64l-.8.66A1,1,0,0,0,2.76,16l1.16,2a1,1,0,0,0,1.21.43l1-.36a2,2,0,0,1,1.78.19,5.48,5.48,0,0,0,.74.43,2,2,0,0,1,1.06,1.45l.17,1a1,1,0,0,0,1,.84h2.3a1,1,0,0,0,1-.84l.17-1a2,2,0,0,1,1.06-1.45,5.48,5.48,0,0,0,.74-.43,2,2,0,0,1,1.78-.19l1,.36A1,1,0,0,0,20.08,18l1.16-2A1,1,0,0,0,21,14.73ZM12,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"]
  };
  
  var settingsOutlined = {
    prefix: 'axis',
    iconName: 'settingsOutlined',
    icon: [24, 24, [], "f0000", "M20.21,14.07a2,2,0,0,1-.72-1.64c0-.14,0-.29,0-.43s0-.29,0-.43a2,2,0,0,1,.72-1.64l.8-.66A1,1,0,0,0,21.24,8L20.08,6a1,1,0,0,0-.86-.5.84.84,0,0,0-.35.07l-1,.36a1.89,1.89,0,0,1-.7.13,2,2,0,0,1-1.08-.32,5.48,5.48,0,0,0-.74-.43,2,2,0,0,1-1.06-1.45l-.17-1a1,1,0,0,0-1-.84h-2.3a1,1,0,0,0-1,.84l-.17,1A2,2,0,0,1,8.63,5.31a5.48,5.48,0,0,0-.74.43,2,2,0,0,1-1.08.32,1.89,1.89,0,0,1-.7-.13l-1-.36a.84.84,0,0,0-.35-.07,1,1,0,0,0-.86.5L2.76,8A1,1,0,0,0,3,9.27l.8.66a2,2,0,0,1,.72,1.64c0,.14,0,.29,0,.43s0,.29,0,.43a2,2,0,0,1-.72,1.64l-.8.66A1,1,0,0,0,2.76,16l1.16,2a1,1,0,0,0,.86.5.84.84,0,0,0,.35-.07l1-.36a1.89,1.89,0,0,1,.7-.13,2,2,0,0,1,1.08.32,5.48,5.48,0,0,0,.74.43,2,2,0,0,1,1.06,1.45l.17,1a1,1,0,0,0,1,.84h2.3a1,1,0,0,0,1-.84l.17-1a2,2,0,0,1,1.06-1.45,5.48,5.48,0,0,0,.74-.43,2,2,0,0,1,1.08-.32,1.89,1.89,0,0,1,.7.13l1,.36a.84.84,0,0,0,.35.07,1,1,0,0,0,.86-.5l1.16-2A1,1,0,0,0,21,14.73ZM12,17.5A5.5,5.5,0,1,1,17.5,12,5.5,5.5,0,0,1,12,17.5ZM12,10a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z"]
  };
  
  var settingsVs = {
    prefix: 'axis',
    iconName: 'settingsVs',
    icon: [24, 24, [], "f0000", "M21,10.06l-2.78-5A4,4,0,0,0,14.72,3H9.28a4,4,0,0,0-3.5,2.06L3,10.06a4,4,0,0,0,0,3.88l2.78,5A4,4,0,0,0,9.28,21h5.44a4,4,0,0,0,3.5-2.06l2.78-5A4,4,0,0,0,21,10.06ZM12,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"]
  };
  
  var settingsVsOutlined = {
    prefix: 'axis',
    iconName: 'settingsVsOutlined',
    icon: [24, 24, [], "f0000", "M21,10.1l-2.8-5c-0.7-1.3-2-2.1-3.5-2.1H9.3C7.8,3,6.5,3.8,5.8,5.1l-2.8,5c-0.7,1.2-0.7,2.7,0,3.9l2.8,5c0.7,1.3,2,2.1,3.5,2.1h5.4c1.5,0,2.8-0.8,3.5-2.1l2.8-5C21.7,12.7,21.7,11.3,21,10.1z M19.2,13l-2.8,5c-0.4,0.6-1,1-1.7,1H9.3c-0.7,0-1.4-0.4-1.7-1l-2.8-5c-0.3-0.6-0.3-1.3,0-1.9l2.8-5c0.4-0.6,1-1,1.7-1h5.4c0.7,0,1.4,0.4,1.7,1l2.8,5C19.6,11.6,19.6,12.4,19.2,13z M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.7,9,12,9z"]
  };
  
  var share = {
    prefix: 'axis',
    iconName: 'share',
    icon: [24, 24, [], "f0000", "M21,19a3,3,0,0,1-6,0,2.09,2.09,0,0,1,0-.25.51.51,0,0,0-.24-.48L8.22,14.45a.5.5,0,0,0-.54,0A2.94,2.94,0,0,1,6,15,3,3,0,0,1,6,9a2.94,2.94,0,0,1,1.68.53.5.5,0,0,0,.54,0l6.55-3.82A.51.51,0,0,0,15,5.25,2.09,2.09,0,0,1,15,5a3,3,0,1,1,1.07,2.28l-6.84,4a.51.51,0,0,0-.24.48,3.13,3.13,0,0,1,0,.5.51.51,0,0,0,.24.48l6.55,3.82a.5.5,0,0,0,.54,0A2.94,2.94,0,0,1,18,16,3,3,0,0,1,21,19Z"]
  };
  
  var shareVs = {
    prefix: 'axis',
    iconName: 'shareVs',
    icon: [24, 24, [], "f0000", "M14,14c-4.72,0-9.5,2-10,4.59a.5.5,0,0,1-.49.41h-.1a.46.46,0,0,1-.32-.13A.5.5,0,0,1,3,18.54,11.22,11.22,0,0,1,14,8V5.42a.49.49,0,0,1,.15-.36l.2-.2a.5.5,0,0,1,.71,0l5.79,5.79a.48.48,0,0,1,0,.7l-5.79,5.79a.5.5,0,0,1-.71,0l-.2-.2a.49.49,0,0,1-.15-.36Z"]
  };
  
  var signIn = {
    prefix: 'axis',
    iconName: 'signIn',
    icon: [24, 24, [], "f0000", "M17,12.19v-.38a.77.77,0,0,0-.22-.53L11.64,6.15a.5.5,0,0,0-.71,0l-.71.71a.49.49,0,0,0,0,.7L13.67,11H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H13.67l-3.45,3.44a.5.5,0,0,0,0,.71l.71.7a.5.5,0,0,0,.71,0l5.14-5.13A.75.75,0,0,0,17,12.19ZM14.67,12ZM19,3H13.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19V19H13.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Z"]
  };
  
  var signOut = {
    prefix: 'axis',
    iconName: 'signOut',
    icon: [24, 24, [], "f0000", "M20.78,11.28,15.64,6.15a.5.5,0,0,0-.71,0l-.71.71a.49.49,0,0,0,0,.7L17.67,11H7.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H17.67l-3.45,3.44a.5.5,0,0,0,0,.71l.71.7a.5.5,0,0,0,.71,0l5.14-5.13a.75.75,0,0,0,.22-.53v-.38A.77.77,0,0,0,20.78,11.28ZM18.67,12ZM10.5,19H5V5h5.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2h5.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,10.5,19Z"]
  };
  
  var supportVs = {
    prefix: 'axis',
    iconName: 'supportVs',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm8,10H17a5,5,0,0,0-2.51-4.31v0L16,5.08A8,8,0,0,1,20,12ZM9,12a3,3,0,1,1,3,3A3,3,0,0,1,9,12ZM8,5.08,9.5,7.67v0A5,5,0,0,0,7,12H4A8,8,0,0,1,8,5.08ZM8,18.92l1.5-2.59v0a4.84,4.84,0,0,0,5,0v0L16,18.92a7.95,7.95,0,0,1-8,0Z"]
  };
  
  var table = {
    prefix: 'axis',
    iconName: 'table',
    icon: [24, 24, [], "f0000", "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4ZM4,9V6H20V9Zm12,1.75h4V18H16Zm-6.25,0h4.5V18H9.75ZM4,10.75H8V18H4Z"]
  };
  
  var toggleOff = {
    prefix: 'axis',
    iconName: 'toggleOff',
    icon: [24, 24, [], "f0000", "M16,6H8A6,6,0,0,0,8,18h8A6,6,0,0,0,16,6ZM8,16a4,4,0,1,1,4-4A4,4,0,0,1,8,16Z"]
  };
  
  var toggleOn = {
    prefix: 'axis',
    iconName: 'toggleOn',
    icon: [24, 24, [], "f0000", "M16,6H8A6,6,0,0,0,8,18h8A6,6,0,0,0,16,6Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,16Z"]
  };
  
  var trash = {
    prefix: 'axis',
    iconName: 'trash',
    icon: [24, 24, [], "f0000", "M20,4.5v1a.5.5,0,0,1-.5.5H4.5A.5.5,0,0,1,4,5.5v-1A.5.5,0,0,1,4.5,4H9V3a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V4h4.5A.5.5,0,0,1,20,4.5ZM5.87,20.14a2,2,0,0,0,2,1.86h8.28a2,2,0,0,0,2-1.86L19,8H5Z"]
  };
  
  var upload = {
    prefix: 'axis',
    iconName: 'upload',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3.85,8.07-.71.71a.49.49,0,0,1-.7,0L13,9.33V17.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V9.33L9.56,10.78a.5.5,0,0,1-.71,0l-.7-.71a.5.5,0,0,1,0-.71l3.13-3.14A.75.75,0,0,1,11.81,6h.38a.77.77,0,0,1,.53.22l3.13,3.14A.5.5,0,0,1,15.85,10.07Z"]
  };
  
  var uploadOutlined = {
    prefix: 'axis',
    iconName: 'uploadOutlined',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.72-13.78A.77.77,0,0,0,12.19,6h-.38a.75.75,0,0,0-.53.22L8.15,9.36a.5.5,0,0,0,0,.71l.7.71a.5.5,0,0,0,.71,0L11,9.33V17.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V9.33l1.44,1.44a.49.49,0,0,0,.7,0l.71-.71a.5.5,0,0,0,0-.71Z"]
  };
  
  var visible = {
    prefix: 'axis',
    iconName: 'visible',
    icon: [24, 24, [], "f0000", "M22,11.7v0A10.65,10.65,0,0,0,12,5a10.65,10.65,0,0,0-9.94,6.67h0A1,1,0,0,0,2,12a.81.81,0,0,0,.06.31h0A10.65,10.65,0,0,0,12,19a10.65,10.65,0,0,0,9.94-6.67h0A.81.81,0,0,0,22,12v0A.93.93,0,0,0,22,11.7ZM12,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"]
  };
  
  var visibleOutlined = {
    prefix: 'axis',
    iconName: 'visibleOutlined',
    icon: [24, 24, [], "f0000", "M22,11.7v0A10.65,10.65,0,0,0,12,5a10.65,10.65,0,0,0-9.94,6.67h0A1,1,0,0,0,2,12a.81.81,0,0,0,.06.31h0A10.65,10.65,0,0,0,12,19a10.65,10.65,0,0,0,9.94-6.67h0A.81.81,0,0,0,22,12v0A.93.93,0,0,0,22,11.7ZM12,17a8.82,8.82,0,0,1-7.93-5,8.79,8.79,0,0,1,15.86,0A8.82,8.82,0,0,1,12,17Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,12,9Z"]
  };
  
  var accountCircle = {
    prefix: 'axis',
    iconName: 'accountCircle',
    icon: [24, 24, [], "f0000", "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,3A3,3,0,1,1,9,8,3,3,0,0,1,12,5Zm5.62,11.16a7,7,0,0,1-11.24,0,1,1,0,0,1-.07-1l.21-.44A3,3,0,0,1,9.23,13h5.54a3,3,0,0,1,2.69,1.68l.23.47A1,1,0,0,1,17.62,16.16Z"]
  };
  
  var accountSquare = {
    prefix: 'axis',
    iconName: 'accountSquare',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM12,6A3,3,0,1,1,9,9,3,3,0,0,1,12,6Zm5.25,12H6.75a.75.75,0,0,1-.67-1.09L7,15.1A2,2,0,0,1,8.78,14h6.44A2,2,0,0,1,17,15.1l.91,1.81A.75.75,0,0,1,17.25,18Z"]
  };
  
  var accountSquareOutlined = {
    prefix: 'axis',
    iconName: 'accountSquareOutlined',
    icon: [24, 24, [], "f0000", "M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V5H19Zm-7-7.75A2.25,2.25,0,1,0,9.75,9,2.24,2.24,0,0,0,12,11.25ZM7.75,17h8.5a.75.75,0,0,0,.67-1.09L16,14.1A2,2,0,0,0,14.23,13H9.77A2,2,0,0,0,8,14.1l-.9,1.81A.75.75,0,0,0,7.75,17Z"]
  };
  
  var groupAdd = {
    prefix: 'axis',
    iconName: 'groupAdd',
    icon: [24, 24, [], "f0000", "M11.89,16.55A1,1,0,0,1,11,18H1a1,1,0,0,1-.89-1.45l1-1.9A3,3,0,0,1,3.74,13H8.26a3,3,0,0,1,2.68,1.65ZM6,11A3,3,0,1,0,3,8,3,3,0,0,0,6,11Zm17.5-1H21V7.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V10H16.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19v2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V12h2.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,23.5,10ZM11,11a3,3,0,1,0-.9-5.86,5,5,0,0,1,0,5.72A3,3,0,0,0,11,11Zm4.94,3.65A3,3,0,0,0,13.26,13h-1a4.89,4.89,0,0,1,.48.76l.95,1.89A3,3,0,0,1,13.82,18H16a1,1,0,0,0,.89-1.45Z"]
  };
  
  var groupEqual = {
    prefix: 'axis',
    iconName: 'groupEqual',
    icon: [24, 24, [], "f0000", "M5,8a3,3,0,1,1,3,3A3,3,0,0,1,5,8Zm11,3a3,3,0,1,0-3-3A3,3,0,0,0,16,11Zm6.89,6.55-1.44-2.89A3,3,0,0,0,18.77,13h-4a4.89,4.89,0,0,1,.48.76l1.45,2.9A3,3,0,0,1,16.83,19H22A1,1,0,0,0,22.89,17.55Zm-9.44-2.89A3,3,0,0,0,10.76,13H5.24a3,3,0,0,0-2.69,1.66L1.11,17.55A1,1,0,0,0,2,19H14a1,1,0,0,0,.89-1.45Z"]
  };
  
  var groupJunior = {
    prefix: 'axis',
    iconName: 'groupJunior',
    icon: [24, 24, [], "f0000", "M16.5,12A2.5,2.5,0,1,0,14,9.5,2.49,2.49,0,0,0,16.5,12ZM9,11A3,3,0,1,0,6,8,3,3,0,0,0,9,11Zm2.76,2a4.91,4.91,0,0,0-1.49,1.76l-.95,1.89A3,3,0,0,0,9.18,19H3a1,1,0,0,1-.89-1.45l1.44-2.89A3,3,0,0,1,6.24,13ZM12,19a1,1,0,0,1-.89-1.45l1-1.9A3,3,0,0,1,14.74,14h3.52a3,3,0,0,1,2.68,1.65l.95,1.9A1,1,0,0,1,21,19Z"]
  };
  
  var groupSenior = {
    prefix: 'axis',
    iconName: 'groupSenior',
    icon: [24, 24, [], "f0000", "M14,9.5A2.5,2.5,0,1,1,16.5,12,2.5,2.5,0,0,1,14,9.5ZM9,11A3,3,0,1,0,6,8,3,3,0,0,0,9,11Zm5.45,3.66A3,3,0,0,0,11.76,13H6.24a3,3,0,0,0-2.69,1.66L2.11,17.55A1,1,0,0,0,3,19H15a1,1,0,0,0,.89-1.45Zm7.44,2.89-.95-1.9A3,3,0,0,0,18.26,14H16.35l1.33,2.66A3,3,0,0,1,17.83,19H21A1,1,0,0,0,21.89,17.55Z"]
  };
  
  var user = {
    prefix: 'axis',
    iconName: 'user',
    icon: [24, 24, [], "f0000", "M8,8a4,4,0,1,1,4,4A4,4,0,0,1,8,8ZM19.89,18.55l-1.44-2.89A3,3,0,0,0,15.76,14H8.24a3,3,0,0,0-2.69,1.66L4.11,18.55A1,1,0,0,0,5,20H19A1,1,0,0,0,19.89,18.55Z"]
  };
  
  var userAdd = {
    prefix: 'axis',
    iconName: 'userAdd',
    icon: [24, 24, [], "f0000", "M16.89,18.55A1,1,0,0,1,16,20H2a1,1,0,0,1-.89-1.45l1.44-2.89A3,3,0,0,1,5.24,14h7.52a3,3,0,0,1,2.69,1.66ZM9,12A4,4,0,1,0,5,8,4,4,0,0,0,9,12Zm13.5-2H20V7.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V10H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H18v2.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V12h2.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,22.5,10Z"]
  };
  
  var userBig = {
    prefix: 'axis',
    iconName: 'userBig',
    icon: [24, 24, [], "f0000", "M7,7a5,5,0,1,1,5,5A5,5,0,0,1,7,7ZM21.89,20.55,20,16.76A5,5,0,0,0,15.53,14H8.47A5,5,0,0,0,4,16.76L2.11,20.55A1,1,0,0,0,3,22H21A1,1,0,0,0,21.89,20.55Z"]
  };
  
  var userBigOutlined = {
    prefix: 'axis',
    iconName: 'userBigOutlined',
    icon: [24, 24, [], "f0000", "M12,12A5,5,0,1,0,7,7,5,5,0,0,0,12,12Zm0-8A3,3,0,1,1,9,7,3,3,0,0,1,12,4Zm9.89,16.55L20,16.76A5,5,0,0,0,15.53,14H8.47A5,5,0,0,0,4,16.76L2.11,20.55A1,1,0,0,0,3,22H21A1,1,0,0,0,21.89,20.55ZM4.62,20l1.17-2.34A3,3,0,0,1,8.47,16h7.06a3,3,0,0,1,2.68,1.66L19.38,20Z"]
  };
  
  var userOutlined = {
    prefix: 'axis',
    iconName: 'userOutlined',
    icon: [24, 24, [], "f0000", "M12,12A4,4,0,1,0,8,8,4,4,0,0,0,12,12Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,12,6Zm7.89,12.55L18,14.66A3,3,0,0,0,15.26,13H8.74a3,3,0,0,0-2.69,1.66L4.11,18.55A1,1,0,0,0,5,20H19A1,1,0,0,0,19.89,18.55ZM6.62,18l1.22-2.45a1,1,0,0,1,.9-.55h6.52a1,1,0,0,1,.9.55L17.38,18Z"]
  };
  
  var userSwitch = {
    prefix: 'axis',
    iconName: 'userSwitch',
    icon: [24, 24, [], "f0000", "M9,4a3,3,0,1,1,3,3A3,3,0,0,1,9,4ZM7,14H17a1,1,0,0,0,.89-1.45l-.95-1.9A3,3,0,0,0,14.26,9H9.74a3,3,0,0,0-2.68,1.65l-.95,1.9A1,1,0,0,0,7,14Zm11.5,2H14.61a.5.5,0,0,0-.35.85l1.46,1.47a5,5,0,0,1-8.53-2A.5.5,0,0,0,6.71,16h-1a.49.49,0,0,0-.39.19.53.53,0,0,0-.1.42,7,7,0,0,0,12,3.13l1,1a.49.49,0,0,0,.85-.35V16.5A.52.52,0,0,0,18.5,16Z"]
  };
  
  var usersSwitch = {
    prefix: 'axis',
    iconName: 'usersSwitch',
    icon: [24, 24, [], "f0000", "M6,4.5A2.5,2.5,0,1,1,8.5,7,2.5,2.5,0,0,1,6,4.5Zm7.89,8.05-1-1.9A3,3,0,0,0,10.26,9H6.74a3,3,0,0,0-2.68,1.65l-.95,1.9A1,1,0,0,0,4,14h9A1,1,0,0,0,13.89,12.55ZM15.5,7A2.5,2.5,0,1,0,13,4.5,2.49,2.49,0,0,0,15.5,7Zm5.39,5.55-.95-1.9A3,3,0,0,0,17.26,9h-3a4.89,4.89,0,0,1,.48.76l.95,1.89A3,3,0,0,1,15.82,14H20A1,1,0,0,0,20.89,12.55ZM17.5,16H13.61a.5.5,0,0,0-.35.85l1.46,1.47a5,5,0,0,1-8.53-2A.5.5,0,0,0,5.71,16h-1a.49.49,0,0,0-.39.19.53.53,0,0,0-.1.42,7,7,0,0,0,12,3.13l1,1a.49.49,0,0,0,.85-.35V16.5A.52.52,0,0,0,17.5,16Z"]
  };
  
export {add,
  addCircle,
  addCircleOutlined,
  addSquare,
  addSquareOutlined,
  appointment,
  appointmentCancelled,
  archive,
  autorenew,
  blockAds,
  bookmark,
  bookmarkOutlined,
  bookmarks,
  bookmarksOutlined,
  browserWindow,
  browserWindows,
  cached,
  calendar,
  calendarMonth,
  calendarNote,
  carouselHorizontal,
  carouselHorizontalOutlined,
  carouselVertical,
  carouselVerticalOutlined,
  checkmarkCircle,
  checkmarkCircleOutlined,
  checkmarkSquare,
  checkmarkSquareOutlined,
  clear,
  clearCircle,
  clearCircleOutlined,
  clearSquare,
  clearSquareOutlined,
  columnView,
  columnViewOutlined,
  command,
  commandOutlined,
  dateRange,
  done,
  drag,
  eject,
  ejectCircle,
  ejectCircleOutlined,
  event,
  exitFullscreen169,
  exitFullscreen11,
  exitFullscreen43,
  findReplace,
  firstPage,
  hashtag,
  heart,
  heartOutlined,
  help,
  helpOutlined,
  history,
  incognito,
  info,
  infoOutined,
  key,
  label,
  labelImportant,
  labelOff,
  labelOutlined,
  labels,
  labelsOutlined,
  lastPage,
  layout,
  movePage,
  multiDirection,
  multiDirectionDiagonal,
  notebookBookmarked,
  notice,
  noticeOutlined,
  openInNew,
  pages,
  pagesOutlined,
  publish,
  recordScreen,
  refresh,
  remainingTime,
  remove,
  removeCircle,
  removeCircleOutlined,
  removeSquare,
  removeSquareOutlined,
  restore,
  search,
  settingsBack,
  shoppingBasket,
  shoppingBasketAdd,
  shoppingBasketClear,
  shoppingBasketOutlined,
  shoppingBasketRemove,
  shoppingCart,
  shoppingCartAdd,
  shoppingCartOff,
  shoppingCartOutlined,
  shoppingCartRemove,
  snooze,
  snoozeNotification,
  sort,
  star,
  starHalf,
  starOutlined,
  subscribe,
  support,
  sync,
  syncOff,
  tab,
  tabs,
  time,
  time20S,
  time30S,
  time40S,
  timer,
  timer20S,
  timer30S,
  timer40S,
  timerOff,
  turnOff,
  unarchive,
  update,
  vibrations,
  vibrationsOff,
  watchLater,
  youtubeSearch,
  batteryAlert,
  error,
  errorOutlined,
  messageFailed,
  messageFailedOutlined,
  newRelease,
  newReleaseOutlined,
  notificationAdd,
  notifications,
  notificationsAlert,
  notificationsOff,
  notificationsOn,
  notificationsOnOutlined,
  notificationsOutlined,
  report,
  reportOutlined,
  securityWarning,
  securityWarningOutlined,
  warning,
  warningOutlined,
  arrowBackward,
  arrowDoublesidedHorizontal,
  arrowDoublesidedVertical,
  arrowDownward,
  arrowDropDownCircle,
  arrowDropDownCircleOutlined,
  arrowDropUpCircle,
  arrowDropUpCircleOutlined,
  arrowForward,
  arrowLargeBackward,
  arrowLargeBackwardOutlined,
  arrowLargeDownward,
  arrowLargeDownwardOutlined,
  arrowLargeForward,
  arrowLargeForwardOutlined,
  arrowLargeUpward,
  arrowLargeUpwardOutlined,
  arrowLeftCircle,
  arrowLeftCircleOutlined,
  arrowLongDown,
  arrowLongLeft,
  arrowLongRight,
  arrowLongUp,
  arrowRightCircle,
  arrowRightCircleOutlined,
  arrowUpward,
  backUi,
  arrowDropDown,
  arrowLeft,
  arrowRight,
  arrowDropUp,
  downKey,
  leftKey,
  rightKey,
  upKey,
  unfoldLess,
  doubleCaretHorizontal,
  doubleCaretVertical,
  caretLeft,
  caretRight,
  chevronLeft,
  chevronRight,
  downUi,
  unfoldMore,
  nextUi,
  pullRightLeft,
  subdirectoryLeft,
  subdirectoryRight,
  upUi,
  commentVsOutlined,
  foldersLabeled,
  document,
  documentOutlined,
  documentText,
  documentTextOutlined,
  documents,
  documentsOutlined,
  file,
  fileAdd,
  fileAddOutlined,
  fileOutlined,
  fileText,
  fileTextOutlined,
  files,
  fileLabeled,
  fileLabeledOutlined,
  filesOutlined,
  folder,
  folderAdd,
  fileBookmarked,
  folderLabeled,
  folderLabeledOutlined,
  folderOpened,
  folderOpenedLabeled,
  folderOutlined,
  folderPhoto,
  folderShared,
  folderSpecial,
  folders,
  pdf,
  clap,
  expressionless,
  faceFemale,
  faceMale,
  frowning,
  gestureHand1f,
  gestureHand2f,
  gestureHover1f,
  gestureScrollDown,
  gestureScrollDown2f,
  gestureScrollUp,
  gestureScrollUp2f,
  gestureScrollUpDown,
  gestureScrollUpDown2f,
  gestureSwipeLeft,
  gestureSwipeLeft2f,
  gestureSwipeLeftRight,
  gestureSwipeLeftRight2f,
  gestureSwipeRight,
  gestureSwipeRight2f,
  handBasic,
  handDraw,
  handMetalHorns,
  handMiddleFinger,
  handOk,
  handPiece,
  handWave,
  neutralFace,
  protection,
  sad,
  slap,
  slightlySmilling,
  smile,
  thumbsDown,
  thumbsUp,
  thumbsUpDown,
  wink,
  bloodTransfusion,
  coronaVirus,
  coronaVirusStop,
  coverSafetyGlasses,
  disinfectant,
  faceMask,
  faceMaskOutlined,
  glove,
  handDisinfection,
  lungs,
  microscope,
  quarantine,
  quarantineOutlined,
  respirator,
  saline,
  soap,
  thermometer,
  vaccine,
  washingHands,
  alt,
  backspace,
  backspaceOutlined,
  capsLock,
  commandKey,
  enter,
  keyboardBrightness1,
  keyboardBrightness2,
  spaceBar,
  tabKey,
  beijing,
  bratislava,
  broadleafTree,
  broadleafTreeOutlined,
  cafe,
  cafeOutlined,
  cairo,
  castl,
  city,
  clinic,
  company,
  conifer,
  coniferOutlined,
  direction,
  dubai,
  earthEast,
  earthWest,
  education,
  educationOutlined,
  factory,
  gasStation,
  globe,
  gym,
  hospital,
  hotel,
  locationOff,
  locationSearch,
  machuPicchu,
  map,
  map2d,
  map3d,
  mapOutlined,
  mapZoomOut,
  museum,
  myLocation,
  navigate,
  navigateOutlined,
  neighborhood,
  newYork,
  paris,
  parking,
  parkingOutlined,
  pharmacy,
  pharmacyOutlined,
  pin,
  pinOutlined,
  poi,
  poiAdd,
  poiAddOutlined,
  poiDelete,
  poiDeleteOutlined,
  poiOutlined,
  poiRemove,
  poiRemoveOutlined,
  poiUser,
  pyramid,
  restaurant,
  rome,
  rotate360,
  route,
  routeDashed,
  sanFrancisco,
  shop,
  shopOutlined,
  shopping,
  shoppingIcon,
  singapore,
  spa,
  spaOutlined,
  sydney,
  theatre,
  toilets,
  trencin,
  zoomIn,
  zoomOut,
  addPhoto,
  adjust,
  alignToBottom,
  alignToBottomOutlined,
  alignToBottomVs,
  alignToCenter,
  alignToCenterOutlined,
  alignToCenterVs,
  alignToLeft,
  alignToLeftOutlined,
  alignToLeftVs,
  alignToMiddle,
  alignToMiddleOutlined,
  alignToMiddleVs,
  alignToRight,
  alignToRightOutlined,
  alignToRightVs,
  alignToTop,
  alignToTopOutlined,
  alignToTopVs,
  artboard,
  artboardOutlined,
  blackWhite,
  blendTool,
  bold,
  brightness1,
  brightness1Outlined,
  brightness2,
  brightness2Outlined,
  brightness3,
  bringForward,
  bringToFront,
  brush,
  cameraEnhance,
  cameraRoll,
  canvas,
  canvasGraphics,
  canvasText,
  color,
  colorOff,
  colorOffOutlined,
  colorOutlined,
  colorPicker,
  colorPickerEmpty,
  colorPickerPoint,
  copy,
  crop,
  cut,
  cutInHalf,
  difference,
  eraser,
  exposure,
  flare,
  flash,
  flashOff,
  focus,
  format169,
  format11,
  format43,
  formats,
  freeTransform,
  fullscreen169,
  fullscreen11,
  fullscreen43,
  gesture,
  gradient,
  grid,
  image,
  imageRotateLeft,
  imageRotateRight,
  intersect,
  invert,
  invertColors,
  invertColorsOff,
  italic,
  keyframeBezierIn,
  keyframeBezierOut,
  keyframeContBezier,
  keyframeLinear,
  keyframeLinearIn,
  keyframeLinearOut,
  knife,
  lasso,
  layers,
  layersOff,
  layersOutlined,
  ligature,
  macro,
  macroOutlined,
  magicWand,
  marker,
  markerOutlined,
  mask,
  maskVs,
  material,
  mediaPhoto,
  meshGrid,
  mouseCursor,
  mouseCursorOutlined,
  opacity,
  paint,
  paintBucket,
  paintOutlined,
  palette,
  paletteOutlined,
  panTool,
  panorama,
  panoramaImage,
  panoramaOutlined,
  panoramaVs,
  panoramaVsOutlined,
  paste,
  pattern,
  pen,
  photoAlbum,
  photoFilter,
  photoGallery,
  photoGalleryOutlined,
  photoLandscape,
  photoLandscapeOutlined,
  photoSquare,
  photoSquareOutlined,
  podcast,
  print,
  printDisabled,
  redo,
  reflectHorizontal,
  reflectVertical,
  roundedCorner,
  ruler,
  save,
  saveOutlined,
  scanDocument,
  scanDocumentIcon,
  selection,
  sendBackward,
  sendToBack,
  sharpness,
  shear,
  shutter,
  shutterOutlined,
  slideshow,
  slideshowOutlined,
  smallCaps,
  snapTo,
  spiral,
  stamp,
  strikethrough,
  strokeWeight,
  substract,
  switchCamera,
  switchVideo,
  text,
  textCenter,
  textLeft,
  textRight,
  texture,
  tools,
  transform,
  transformArtboard,
  underline,
  undo,
  union,
  vector,
  verticalAlignBottom,
  verticalAlignMiddle,
  verticalAlignTop,
  videoAdd,
  videoGallery,
  videoGalleryOutlined,
  videoHorizontal,
  videoHorizontalOutlined,
  videoVertical,
  videoVerticalOutlined,
  americanFootball,
  anchor,
  armchair,
  baseball,
  basketball,
  birthday,
  birthdayOutlined,
  block,
  book,
  bookBookmarked,
  bookOpened,
  bookOutlined,
  brain,
  brickWall,
  briefcase,
  briefcaseNotAccessible,
  briefcaseOutlined,
  chair,
  circle,
  circleOutlined,
  cricket,
  crossfit,
  cube,
  diningTable,
  diningTableOutlined,
  diving,
  door,
  flag,
  flagCross1,
  flagCross2,
  flagHalf1,
  flagHalf2,
  flagOutlined,
  flagQuarter1,
  flagQuarter2,
  flask,
  flower,
  footPrint,
  gift,
  glasses,
  glassesOutlined,
  hourglass,
  hourglassHalf,
  hourglassOutlined,
  hourglassQuarter,
  iceHockey,
  infinity,
  justice,
  lab,
  leaf,
  leafDiagonal,
  lightOn,
  lightbulb,
  medicaments,
  mma,
  moon,
  moonOutlined,
  moonVs,
  moonVsOutlined,
  movie,
  node,
  nodeMultiple,
  nodeMultipleOutlined,
  nodeOutlined,
  pet,
  pill,
  puzzle,
  quotes,
  recycling,
  rugby,
  seat,
  seatOutlined,
  shoePrint,
  shoePrintOutlined,
  shower,
  signMan,
  signWoman,
  skull,
  smokeFree,
  smoking,
  snowflake,
  sport,
  square,
  squareOutlined,
  stairsDown,
  stairsUp,
  survey,
  tShirt,
  tableTennis,
  temperature,
  tennis,
  testTube,
  ticket,
  triangle,
  triangleOutlined,
  umbrella,
  umbrellaOutlined,
  volleyball,
  weight,
  weightOutlined,
  wishlist,
  wishlistOutlined,
  wrench,
  americanExpress,
  atm,
  atmOutlined,
  bitcoin,
  bitcoinOutlined,
  coin,
  creditCard,
  creditCardAdd,
  creditCardOutlined,
  creditCardRemove,
  creditCards,
  discover,
  dollar,
  dollarOutlined,
  ethereum,
  ethereumOutlined,
  euro,
  euroOutlined,
  insurance,
  litecoin,
  litecoinOutlined,
  maestro,
  money,
  moneyVs,
  paypal,
  pound,
  poundOutlined,
  receipt,
  receiptOutlined,
  saving,
  savingOutlined,
  savings,
  visa,
  wallet,
  walletOutlined,
  accessibility,
  accessibilityVs,
  accessible,
  accessibleForward,
  hiking,
  man,
  pregnancy,
  running,
  standing,
  swimming,
  walking,
  woman,
  award,
  awardOutlined,
  boost,
  crown,
  crownOutlined,
  diamond,
  diamondOutlined,
  dnaSpiral,
  luck,
  medal,
  planet,
  premium,
  premiumOutlined,
  robot,
  sticker,
  stickerOutlined,
  topSecurity,
  topSecurityOutlined,
  verified,
  verifiedOutlined,
  appstore,
  behance,
  dribbble,
  dropbox,
  facebook,
  facebookSquare,
  github,
  gmail,
  gmailOutlined,
  google,
  googleDrive,
  googlePlay,
  hangouts,
  hangoutsOutlined,
  instagram,
  linkedin,
  linkedinSquare,
  medium,
  mediumSquare,
  messenger,
  messengerOutlined,
  pinterest,
  pinterestCircle,
  reddit,
  rss,
  skype,
  slack,
  snapchat,
  snapchatOutlined,
  steam,
  telegram,
  tikTok,
  twitch,
  twitter,
  viber,
  viberOutlined,
  arrowLongLeftDiagonal,
  vimeoSquare,
  vkontakte,
  whatsapp,
  whatsappOutlined,
  youtube,
  youtubeOutlined,
  airdrop,
  airplay,
  android,
  apple,
  appleOutlined,
  augmentedReality,
  barcode,
  bluetooth,
  bluetoothConnect,
  bluetoothOff,
  bluetoothSearch,
  chartBar1,
  chartBar2,
  chartBar3,
  chartBar4,
  chartBubble,
  chartDonut1,
  chartDonut2,
  chartLineDown,
  chartLineUp,
  chartPie1,
  chartPie2,
  cloud,
  cloudDisabled,
  cloudOff,
  cloudOffOutlined,
  cloudOn,
  cloudOutlined,
  code,
  dataSharing,
  downloadFromCloud,
  faceId,
  fingerprint,
  link,
  linkOff,
  memoryChip,
  mobileData,
  mobileDataLow,
  online,
  plugin,
  pluginOutlined,
  poll,
  qrCode,
  scan,
  security,
  securityOff,
  securityOffOutlined,
  securityOn,
  securityOnOutlined,
  touchId,
  trendingDown,
  trendingUp,
  uploadOnCloud,
  usb,
  virtualReality,
  virtualRealityOutlined,
  website,
  wifi,
  wifiOff,
  windows,
  arrival,
  bike,
  boat,
  bus,
  car,
  carPolice,
  departure,
  flight,
  flightCancelled,
  metro,
  motocycle,
  taxi,
  trafficLight,
  train,
  tram,
  truck,
  addEvent,
  addToTrash,
  agendaView,
  agendaViewOutlined,
  alarm,
  alarmAdd,
  alarmAlert,
  alarmOff,
  alarmOn,
  album,
  albums,
  allDone,
  apps,
  attachment,
  attachmentDiagonal,
  blocked,
  category,
  categoryOutlined,
  clock,
  dashboard,
  dashboardOutlined,
  dashboardVs,
  dashboardVsOutlined,
  download,
  downloadOutlined,
  downloadTo,
  edit,
  emptyTrash,
  envelope,
  explore,
  exploreOff,
  exploreOffOutlined,
  exploreOutlined,
  feed,
  feedOutlined,
  filter,
  filterList,
  filterOptions,
  filterOutlined,
  formatBullets,
  formatPoints,
  hidden,
  hiddenOutlined,
  home,
  homeOutlined,
  homeVs,
  homeVs1Outlined,
  homeVs2Outlined,
  hot,
  saveTo,
  invisible,
  launch,
  launchOutlined,
  launchVs,
  launchVsOutlined,
  lock,
  lockOpenOutlined,
  lockOpened,
  lockOutlined,
  menuHamburger,
  menuLeft,
  menuLeftRight,
  menuVs,
  menuVsOutlined,
  moreHorizontal,
  moreVertical,
  newMessage,
  password,
  passwordOpen,
  removeFromTrash,
  settings,
  settingsOutlined,
  settingsVs,
  settingsVsOutlined,
  share,
  shareVs,
  signIn,
  signOut,
  supportVs,
  table,
  toggleOff,
  toggleOn,
  trash,
  upload,
  uploadOutlined,
  visible,
  visibleOutlined,
  accountCircle,
  accountSquare,
  accountSquareOutlined,
  groupAdd,
  groupEqual,
  groupJunior,
  groupSenior,
  user,
  userAdd,
  userBig,
  userBigOutlined,
  userOutlined,
  userSwitch,
  usersSwitch}
  